import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export enum Acl {
  Public = 'PUBLIC',
  Secure = 'SECURE'
}

export enum ActorRole {
  AssessorOrInterviewer = 'ASSESSOR_OR_INTERVIEWER',
  EarlyCareerTeamMember = 'EARLY_CAREER_TEAM_MEMBER',
  HeadOfPeopleOrTalent = 'HEAD_OF_PEOPLE_OR_TALENT',
  HiringManager = 'HIRING_MANAGER',
  Interviewer = 'INTERVIEWER',
  LineManager = 'LINE_MANAGER',
  RecruiterOrTalentAcquisitionPartner = 'RECRUITER_OR_TALENT_ACQUISITION_PARTNER',
  ReskillingTeamMember = 'RESKILLING_TEAM_MEMBER'
}

export enum AdditionalAssessmentType {
  Coding = 'CODING',
  English = 'ENGLISH'
}

export enum AdjustmentQuestionnaireResponse {
  AssistiveTechnology = 'ASSISTIVE_TECHNOLOGY',
  AuditoryProcessing = 'AUDITORY_PROCESSING',
  DifficultyMaintainingFocus = 'DIFFICULTY_MAINTAINING_FOCUS',
  DifficultyManagingAnxiety = 'DIFFICULTY_MANAGING_ANXIETY',
  DifficultyManagingFatigue = 'DIFFICULTY_MANAGING_FATIGUE',
  DifficultyProcessingInformation = 'DIFFICULTY_PROCESSING_INFORMATION',
  DifficultySpokenCommunication = 'DIFFICULTY_SPOKEN_COMMUNICATION',
  PhysicalChallenges = 'PHYSICAL_CHALLENGES'
}

export enum AdminResultsExportLevel {
  AllData = 'ALL_DATA',
  SummaryAndScoreDetails = 'SUMMARY_AND_SCORE_DETAILS',
  SummaryOfScores = 'SUMMARY_OF_SCORES'
}

export type AdminResultsExportRunnerArgs = {
  __typename?: 'AdminResultsExportRunnerArgs';
  exportLevel?: Maybe<AdminResultsExportLevel>;
  includeDeiData?: Maybe<Scalars['Boolean']['output']>;
  includeFormsData?: Maybe<Scalars['Boolean']['output']>;
  lastDateOfCandidateActionFrom?: Maybe<Scalars['Date']['output']>;
  lastDateOfCandidateActionTo?: Maybe<Scalars['Date']['output']>;
  scoreType?: Maybe<AdminResultsExportScoreType>;
  stageIds: Array<Scalars['Int']['output']>;
};

export enum AdminResultsExportScoreType {
  Grade = 'GRADE',
  Percentile = 'PERCENTILE',
  StenScore = 'STEN_SCORE',
  ZScore = 'Z_SCORE'
}

export type AiInterviewAssessmentStageAction = {
  __typename?: 'AiInterviewAssessmentStageAction';
  createdAt: Scalars['Date']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isAvatarEnabled: Scalars['Boolean']['output'];
  isTimingAgentEnabled: Scalars['Boolean']['output'];
  knowledgeBase?: Maybe<Scalars['String']['output']>;
  livekitAgentName: LivekitAgentName;
  name: Scalars['String']['output'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int']['output'];
  supportedLocales: Array<SupportedLocale>;
  updatedAt: Scalars['Date']['output'];
};

export type AiInterviewAssessmentStageActionCandidate = {
  __typename?: 'AiInterviewAssessmentStageActionCandidate';
  /** The hiring team's note on the interview. Null for candidates. */
  candidateNote?: Maybe<Scalars['String']['output']>;
  /** Every saved version of the hiring team's note, newest first. The first one is the current note. Empty for candidates. */
  candidateNoteHistory: Array<AiInterviewCandidateNoteVersion>;
  conference?: Maybe<Conference>;
  /** The consent gate for this interview: whether it applies, the candidate's standing, and the text to show. */
  consent: AiInterviewConsent;
  createdAt: Scalars['Date']['output'];
  estimatedDurationMinutes: Scalars['Int']['output'];
  /** Whether the hiring team wrote a note on the interview. False for candidates. */
  hasCandidateNote: Scalars['Boolean']['output'];
  /** Whether a reviewer annotated at least one score of the interview. False for candidates. */
  hasScoreAnnotations: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  /** Whether consent is required and the candidate has declined it. Shown as "Consent declined" to recruiters. */
  isConsentDeclined: Scalars['Boolean']['output'];
  /** @deprecated This information is encompassed in the result property. */
  resultStatus: AiInterviewAssessmentStageActionCandidateResultStatus;
  results: AiInterviewAssessmentStageActionCandidateResult;
  stageAction: AiInterviewAssessmentStageActionNested;
  stageCandidate: SmStageCandidateModel;
  status: AiInterviewAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AiInterviewAssessmentStageActionCandidateResult = AiInterviewAssessmentStageActionCandidateResultNotReady | AiInterviewAssessmentStageActionCandidateResultReady;

export type AiInterviewAssessmentStageActionCandidateResultNotReady = {
  __typename?: 'AiInterviewAssessmentStageActionCandidateResultNotReady';
  status: AiInterviewAssessmentStageActionCandidateResultStatusNotReady;
};

export type AiInterviewAssessmentStageActionCandidateResultReady = {
  __typename?: 'AiInterviewAssessmentStageActionCandidateResultReady';
  evidence: Array<AiInterviewSkillEvidence>;
  resultSummary?: Maybe<Scalars['String']['output']>;
  scores: Array<AiInterviewScore>;
  summaryScore?: Maybe<Scalars['Float']['output']>;
};

export enum AiInterviewAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum AiInterviewAssessmentStageActionCandidateResultStatusNotReady {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AiInterviewAssessmentStageActionCandidateRoleStage = {
  __typename?: 'AiInterviewAssessmentStageActionCandidateRoleStage';
  roleId: Scalars['ID']['output'];
  stageId: Scalars['ID']['output'];
};

export enum AiInterviewAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Ready = 'READY'
}

export type AiInterviewAssessmentStageActionNested = {
  __typename?: 'AiInterviewAssessmentStageActionNested';
  createdAt: Scalars['Date']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isAvatarEnabled: Scalars['Boolean']['output'];
  isTimingAgentEnabled: Scalars['Boolean']['output'];
  knowledgeBase?: Maybe<Scalars['String']['output']>;
  livekitAgentName: LivekitAgentName;
  name: Scalars['String']['output'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type AiInterviewAssessmentStageActionUpdateInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  knowledgeBase?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  selectedLocales?: InputMaybe<Array<SupportedLocale>>;
};

/** One saved version of the hiring team's note on an AI interview. */
export type AiInterviewCandidateNoteVersion = {
  __typename?: 'AiInterviewCandidateNoteVersion';
  /** Who saved it. Null when that user no longer exists. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** The note as saved. Null when the save cleared it. */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

export type AiInterviewConsent = {
  __typename?: 'AiInterviewConsent';
  consentText: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  status: AiInterviewConsentStatus;
};

export enum AiInterviewConsentStatus {
  Declined = 'DECLINED',
  Given = 'GIVEN',
  NotDecided = 'NOT_DECIDED'
}

export type AiInterviewScore = {
  __typename?: 'AiInterviewScore';
  /** The reviewer's current annotation on this score. Null when there is none, and for candidates. */
  annotation?: Maybe<AiInterviewScoreAnnotationVersion>;
  /** Every saved version of the annotation, newest first. The first one is the current annotation. Empty for candidates. */
  annotationHistory: Array<AiInterviewScoreAnnotationVersion>;
  createdAt: Scalars['Date']['output'];
  evidence: Array<AiInterviewScoreEvidence>;
  flags: Array<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  indicator: Scalars['String']['output'];
  justification?: Maybe<Scalars['JSONObject']['output']>;
  score: Scalars['Int']['output'];
  softSkill: SoftSkill;
  softSkillId: Scalars['Int']['output'];
};

/** A reviewer's annotation on one AI interview score (skill–indicator line). */
export type AiInterviewScoreAnnotationInput = {
  /** Optional when the score matches the AI score, required when it differs. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The reviewer's own score, 1 to 5. */
  score: Scalars['Int']['input'];
};

/** One saved version of a reviewer's annotation on an AI interview score. Newest first in a history; the first one is the current annotation. */
export type AiInterviewScoreAnnotationVersion = {
  __typename?: 'AiInterviewScoreAnnotationVersion';
  /** Who saved it. Null when that user no longer exists. */
  authorName?: Maybe<Scalars['String']['output']>;
  /** Timestamps in it ("1:12") are the transcript moments the reviewer linked. */
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** The reviewer's own score, 1 to 5. */
  score: Scalars['Int']['output'];
};

export type AiInterviewScoreEvidence = {
  __typename?: 'AiInterviewScoreEvidence';
  from: Scalars['Int']['output'];
  sentiment: Scalars['String']['output'];
  text: Scalars['String']['output'];
  to: Scalars['Int']['output'];
};

export type AiInterviewSkillEvidence = {
  __typename?: 'AiInterviewSkillEvidence';
  evidence: Array<AiInterviewScoreEvidence>;
  softSkill: SoftSkill;
  summaryScore?: Maybe<Scalars['Float']['output']>;
};

export type AmApiKeyModel = {
  __typename?: 'AmApiKeyModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hasClientSecret: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: ApiKeyOwnerType;
  puppetUserId: Scalars['Int']['output'];
  role?: Maybe<IdentityPermissionRole>;
  updatedAt: Scalars['Date']['output'];
  usageRecord: Array<ApiKeyUsageRecordModel>;
};

export type Answer = {
  __typename?: 'Answer';
  field?: Maybe<Field>;
  fieldId?: Maybe<Scalars['Int']['output']>;
  form?: Maybe<Form>;
  formId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  respondantId: Scalars['Int']['output'];
  response?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType;
};

export enum ApiKeyOwnerType {
  Company = 'COMPANY',
  User = 'USER'
}

export type ApiKeyUsageRecordModel = {
  __typename?: 'ApiKeyUsageRecordModel';
  count: Scalars['Int']['output'];
  route: Scalars['String']['output'];
};

export type ApiUserModel = {
  __typename?: 'ApiUserModel';
  clientId: Scalars['String']['output'];
  clientSecret?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hasClientSecret: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: ApiUserOwnerType;
  puppetUserId: Scalars['Int']['output'];
  role?: Maybe<IdentityPermissionRole>;
  updatedAt: Scalars['Date']['output'];
};

export enum ApiUserOwnerType {
  Company = 'COMPANY',
  User = 'USER'
}

export enum ApplicationQuestionAnswerPreference {
  NotPreferred = 'NOT_PREFERRED',
  Preferred = 'PREFERRED'
}

/** The answer's shape follows the question's type, which GraphQL cannot express as a union of scalars. Each shape gets its own field instead, and `type` names the one that is set. */
export type ApplicationQuestionAnswerValue = {
  __typename?: 'ApplicationQuestionAnswerValue';
  /** BOOLEAN questions. */
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /** DATE questions, as an ISO-8601 string. */
  date?: Maybe<Scalars['String']['output']>;
  /** NUMBER questions. */
  number?: Maybe<Scalars['Float']['output']>;
  /** SINGLE_SELECT (exactly one) and MULTI_SELECT questions, as the option names the candidate saw. Names rather than ids: the ATS identifies an option by its display text in answers, and only by id on the question. */
  optionNames?: Maybe<Array<Scalars['String']['output']>>;
  /** TEXT questions. */
  text?: Maybe<Scalars['String']['output']>;
  type: RoleApplicationQuestionType;
};

export type ApplicationQuestionDateRange = {
  __typename?: 'ApplicationQuestionDateRange';
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type ApplicationQuestionNumberRange = {
  __typename?: 'ApplicationQuestionNumberRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export enum ApplicationQuestionOptionMatch {
  All = 'ALL',
  Any = 'ANY'
}

export type ApplicationQuestionPreferredAnswer = {
  __typename?: 'ApplicationQuestionPreferredAnswer';
  /** BOOLEAN questions. */
  boolean?: Maybe<Scalars['Boolean']['output']>;
  /** DATE questions, as an ISO-8601 string. */
  date?: Maybe<Scalars['String']['output']>;
  /** DATE questions, as a range. */
  dateRange?: Maybe<ApplicationQuestionDateRange>;
  /** NUMBER questions. */
  number?: Maybe<Scalars['Float']['output']>;
  /** NUMBER questions, as a range. */
  numberRange?: Maybe<ApplicationQuestionNumberRange>;
  /** SINGLE_SELECT / MULTI_SELECT questions, as question option ids. */
  optionIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** MULTI_SELECT questions: ANY prefers a candidate who picked at least one of optionIds, ALL one who picked every one of them. Null when no strategy was chosen, which is judged as ANY; always null for other question types. */
  optionMatch?: Maybe<ApplicationQuestionOptionMatch>;
  /** TEXT questions. */
  text?: Maybe<Scalars['String']['output']>;
};

export type ApplicationQuestionPreferredAnswerInput = {
  /** BOOLEAN questions. */
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  /** DATE questions, as an ISO-8601 string. */
  date?: InputMaybe<Scalars['String']['input']>;
  /** DATE questions, as a range. */
  dateRange?: InputMaybe<DateRangeInput>;
  /** NUMBER questions. */
  number?: InputMaybe<Scalars['Float']['input']>;
  /** NUMBER questions, as a range. */
  numberRange?: InputMaybe<NumericRangeInput>;
  /** SINGLE_SELECT (exactly one) and MULTI_SELECT questions, as ids of the question options. */
  optionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** MULTI_SELECT questions: whether the candidate must pick any or all of optionIds. */
  optionMatch?: InputMaybe<ApplicationQuestionOptionMatch>;
  /** TEXT questions. */
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum AssessmentBrowserSwitchCandidateTrackingEvent {
  AssessmentTabSwitchEndCandidateTrackingEvent = 'AssessmentTabSwitchEndCandidateTrackingEvent',
  AssessmentTabSwitchStartCandidateTrackingEvent = 'AssessmentTabSwitchStartCandidateTrackingEvent',
  AssessmentWindowOutOfFocusEndCandidateTrackingEvent = 'AssessmentWindowOutOfFocusEndCandidateTrackingEvent',
  AssessmentWindowOutOfFocusStartCandidateTrackingEvent = 'AssessmentWindowOutOfFocusStartCandidateTrackingEvent'
}

export type AssessmentCandidateBrowserSwitchTrackingEventModel = {
  __typename?: 'AssessmentCandidateBrowserSwitchTrackingEventModel';
  assessment: AssessmentDataModel;
  assessmentId: Scalars['Int']['output'];
  assessmentTimeSeconds?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  invokedAt: Scalars['Date']['output'];
  subId: Scalars['String']['output'];
  type: AssessmentBrowserSwitchCandidateTrackingEvent;
  updatedAt: Scalars['Date']['output'];
};

export type AssessmentDataAnswerGqlModel = {
  optionSubId?: InputMaybe<Scalars['String']['input']>;
  questionSubId: Scalars['String']['input'];
};

export type AssessmentDataAnswerModel = {
  __typename?: 'AssessmentDataAnswerModel';
  inTime?: Maybe<Scalars['Boolean']['output']>;
  isCorrect: Scalars['Boolean']['output'];
  timestamp: Scalars['Date']['output'];
};

export type AssessmentDataModel = {
  __typename?: 'AssessmentDataModel';
  allowedTimePerSection?: Maybe<Scalars['Int']['output']>;
  answers: Array<Maybe<AssessmentDataAnswerModel>>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  manuallyCreated: Scalars['Boolean']['output'];
  nQuestionsPerTrait?: Maybe<Scalars['Int']['output']>;
  normGroupType: NormGroupType;
  questions: Array<Maybe<AssessmentDataQuestionModel>>;
  roleLevel?: Maybe<ContentRoleLevel>;
  startingAbilityLowerBound: Scalars['Float']['output'];
  startingAbilityUpperBound: Scalars['Float']['output'];
  startingQuestions?: Maybe<Array<Maybe<AssessmentDataQuestionModel>>>;
  subId: Scalars['String']['output'];
  testCandidateDoneBy?: Maybe<Scalars['Int']['output']>;
  testCandidateId?: Maybe<Scalars['Int']['output']>;
  testType?: Maybe<TestFullType>;
  traitIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  updatedAt: Scalars['Date']['output'];
};

export type AssessmentDataQuestionModel = {
  __typename?: 'AssessmentDataQuestionModel';
  questionSubId: Scalars['String']['output'];
  timestamp: Scalars['Date']['output'];
  traitId?: Maybe<Scalars['Int']['output']>;
};

export type AssessmentExpiryOption = {
  __typename?: 'AssessmentExpiryOption';
  duration: Scalars['Int']['output'];
  unit: AssessmentExpiryOptionUnit;
};

export type AssessmentExpiryOptionArgs = {
  duration: Scalars['Int']['input'];
  unit: AssessmentExpiryOptionUnit;
};

export enum AssessmentExpiryOptionUnit {
  Day = 'DAY'
}

export type AssessmentStage = {
  __typename?: 'AssessmentStage';
  actions: AssessmentStageActions;
  additionalAssessmentTypes: Array<AdditionalAssessmentType>;
  assessmentExpiryOption?: Maybe<AssessmentExpiryOption>;
  autoProgressionThreshold?: Maybe<Scalars['Int']['output']>;
  availableActions: Array<StageAvailableActionModel>;
  branding?: Maybe<StageBranding>;
  cognitiveMode: CognitiveMode;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  emailSettings: AssessmentStageEmailSettings;
  endTime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  interviewGuideBlueprints: Array<InterviewGuideBlueprintModel>;
  inviteUrl: Scalars['String']['output'];
  isAutoProgressionEnabled: Scalars['Boolean']['output'];
  isIntegrityMonitoringEnabled: Scalars['Boolean']['output'];
  kind: AssessmentStageKind;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  project: ProjectNested;
  softSkills: Array<SoftSkill>;
  stageId: Scalars['Int']['output'];
  startTime?: Maybe<Scalars['Date']['output']>;
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date']['output'];
};


export type AssessmentStageInviteUrlArgs = {
  locale: SupportedLocale;
};

export enum AssessmentStageActionKind {
  AiInterview = 'AI_INTERVIEW',
  Calibration = 'CALIBRATION',
  Coderbyte = 'CODERBYTE',
  CognitiveTestInductive = 'COGNITIVE_TEST_INDUCTIVE',
  CognitiveTestNumerical = 'COGNITIVE_TEST_NUMERICAL',
  CognitiveTestVerbal = 'COGNITIVE_TEST_VERBAL',
  DeiForm = 'DEI_FORM',
  EnglishProficiency = 'ENGLISH_PROFICIENCY',
  Form = 'FORM',
  ManagerReview = 'MANAGER_REVIEW',
  PersonalityTest = 'PERSONALITY_TEST',
  RssAssessmentSoft = 'RSS_ASSESSMENT_SOFT',
  RssAssessmentTechnical = 'RSS_ASSESSMENT_TECHNICAL'
}

export type AssessmentStageActionLocales = {
  kind: AssessmentStageActionKind;
  locales: Array<SupportedLocale>;
};

export type AssessmentStageActions = {
  __typename?: 'AssessmentStageActions';
  aiInterview?: Maybe<AiInterviewAssessmentStageAction>;
  coderbyte?: Maybe<CoderbyteAssessmentStageActionNested>;
  cognitiveTests: Array<CognitiveTestAssessmentStageActionNested>;
  dei?: Maybe<DeiStageActionModel>;
  englishProficiency?: Maybe<EnglishProficiencyAssessmentStageActionNested>;
  personalityTest?: Maybe<PersonalityTestAssessmentStageActionNested>;
  roleSkillSelfAssessments: Array<RssAssessmentModel>;
};

export type AssessmentStageEmailSettings = {
  __typename?: 'AssessmentStageEmailSettings';
  candidateReport?: Maybe<Report>;
  emailCandidateReport: Scalars['Boolean']['output'];
  managerReport?: Maybe<Report>;
  projectTeamEmailSettings: ProjectTeamEmailSettings;
};

export enum AssessmentStageKind {
  AiInterview = 'AI_INTERVIEW',
  Assessment = 'ASSESSMENT'
}

export type AssessmentStageResultsFilterArgs = {
  createdAtGte?: InputMaybe<Scalars['Date']['input']>;
  createdAtLte?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionGte?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionLte?: InputMaybe<Scalars['Date']['input']>;
  nameOrEmailContains?: InputMaybe<Scalars['String']['input']>;
  overallScorePercentileGte?: InputMaybe<Scalars['Float']['input']>;
  overallScorePercentileLte?: InputMaybe<Scalars['Float']['input']>;
  progressionStatusIn?: InputMaybe<Array<ProgressionStatus>>;
  stageProgressionStatusIn?: InputMaybe<Array<StageProgressionStatus>>;
  statusIn?: InputMaybe<Array<StageCandidateStatus>>;
};

export type AssessmentStageResultsOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<AssessmentStageResultsOrderField>;
};

export enum AssessmentStageResultsOrderField {
  CognitiveCombinedScore = 'CognitiveCombinedScore',
  CognitiveSummaryScore = 'CognitiveSummaryScore',
  CreatedAt = 'CreatedAt',
  EnglishProficiencyLevel = 'EnglishProficiencyLevel',
  IntegrityFlags = 'IntegrityFlags',
  LastDateOfCandidateAction = 'LastDateOfCandidateAction',
  Name = 'Name',
  OverallScore = 'OverallScore',
  RightForTheFutureScore = 'RightForTheFutureScore',
  RightForTheRoleScore = 'RightForTheRoleScore',
  RightForUsScore = 'RightForUsScore',
  Status = 'Status',
  TechnicalChallengesScore = 'TechnicalChallengesScore',
  TechnicalOverallScore = 'TechnicalOverallScore',
  TechnicalQuestionsScore = 'TechnicalQuestionsScore'
}

export type AssessmentStageResultsOutput = {
  __typename?: 'AssessmentStageResultsOutput';
  page: Pageinfo;
  stage: SmStageModel;
  stageCandidatesStatistics: Array<StageCandidateStatisticsModel>;
};

export type AssignmentStatus = {
  __typename?: 'AssignmentStatus';
  asGroupMember?: Maybe<Scalars['Boolean']['output']>;
  asIndividual?: Maybe<Scalars['Boolean']['output']>;
};

export enum AtsCandidatePullMode {
  All = 'ALL',
  MappedStages = 'MAPPED_STAGES'
}

/** Why mirroring a stage move to the ATS failed. TRANSIENT means the push never reached the ATS and moving the candidate again later retries it. PERMANENT means the ATS refused the stage change, or the target ATS stage could not be resolved on the linked job, so the stages stay out of sync until an admin fixes the integration mapping. The Spotted Zebra move stands in both cases. */
export enum AtsProgressionFailureType {
  Permanent = 'PERMANENT',
  Transient = 'TRANSIENT'
}

export type AtsProgressionWritebackFailure = {
  __typename?: 'AtsProgressionWritebackFailure';
  message?: Maybe<Scalars['String']['output']>;
  status: AtsProgressionFailureType;
  subId: Scalars['ID']['output'];
};

export type AtsProgressionWritebackSuccess = {
  __typename?: 'AtsProgressionWritebackSuccess';
  atsStageName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type AtsResultPushConfigGqlModel = {
  __typename?: 'AtsResultPushConfigGQLModel';
  /** ATS stage this result type moves a completed application to. Null when unconfigured, and always null for AI Shortlist and interview evaluations. */
  completionStageRef?: Maybe<Scalars['String']['output']>;
  fieldAliases: AtsWorkdayFieldAliasesGqlModel;
  fieldIds: AtsResultPushFieldIdsGqlModel;
  /** Workday custom object alias the result is written to. Empty when unconfigured. */
  objectAlias: Scalars['String']['output'];
  resultType: AtsResultType;
  sendAssessmentOrder: Scalars['Boolean']['output'];
  sendResultLink: Scalars['Boolean']['output'];
  sendToAtsFields: Scalars['Boolean']['output'];
  sendToWorkdayObjects: Scalars['Boolean']['output'];
};

export type AtsResultPushConfigInput = {
  /** Send null or blank to clear the completion stage. Rejected for AI Shortlist and interview evaluations, and rejected when it names a stage already in the stage map. */
  completionStageRef?: InputMaybe<Scalars['String']['input']>;
  fieldAliases?: InputMaybe<AtsWorkdayFieldAliasesInput>;
  fieldIds?: InputMaybe<AtsResultPushFieldIdsInput>;
  objectAlias?: InputMaybe<Scalars['String']['input']>;
  resultType: AtsResultType;
  sendAssessmentOrder?: InputMaybe<Scalars['Boolean']['input']>;
  sendResultLink?: InputMaybe<Scalars['Boolean']['input']>;
  sendToAtsFields?: InputMaybe<Scalars['Boolean']['input']>;
  sendToWorkdayObjects?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AtsResultPushFieldIdsGqlModel = {
  __typename?: 'AtsResultPushFieldIdsGQLModel';
  completionDate?: Maybe<Scalars['String']['output']>;
  integrityRisk?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
};

export type AtsResultPushFieldIdsInput = {
  completionDate?: InputMaybe<Scalars['String']['input']>;
  integrityRisk?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<Scalars['String']['input']>;
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
};

export enum AtsResultType {
  AiInterview = 'AI_INTERVIEW',
  AiShortlist = 'AI_SHORTLIST',
  Assessment = 'ASSESSMENT',
  InterviewEvaluation = 'INTERVIEW_EVALUATION'
}

export type AtsSettingsGqlModel = {
  __typename?: 'AtsSettingsGQLModel';
  aiInterviewResultsEnabled: Scalars['Boolean']['output'];
  aiShortlistResultsEnabled: Scalars['Boolean']['output'];
  /** Allowlist of rejection-reason ids recruiters may pick in the reject modal. Null = no filtering (every reason allowed). */
  allowedRejectionReasonIds?: Maybe<Array<Scalars['String']['output']>>;
  applicationTrackingEnabled: Scalars['Boolean']['output'];
  assessmentResultsEnabled: Scalars['Boolean']['output'];
  candidatePullMode: AtsCandidatePullMode;
  companyId: Scalars['Int']['output'];
  /** Whether the ATS hiring-team sync may grant SZ access: create accounts for unmatched members and add users of other companies to this one. When disabled, only members who are already users of this company are added to the role team; everyone else is skipped and logged, and gets added by a later sync once an admin makes them a company user. Defaults to enabled. */
  hiringTeamUserProvisioningEnabled: Scalars['Boolean']['output'];
  interviewEvaluationResultsEnabled: Scalars['Boolean']['output'];
  /** Rejection write-back: SZ rejections are mirrored to the ATS. */
  progressionEnabled: Scalars['Boolean']['output'];
  /** Remote ID of the ATS user outbound rejections are performed on behalf of. Workable-only at send time (sent as remote_fields.workable.on_behalf_of_user_remote_id on Kombo reject calls). Null = not configured, field omitted. */
  rejectOnBehalfOfUserRemoteId?: Maybe<Scalars['String']['output']>;
  resultPush: Array<AtsResultPushConfigGqlModel>;
  /** Per-tenant map from SZ stage types to provider-native ATS stage refs. Empty when unconfigured. */
  stageMap: Array<AtsStageMapEntryGqlModel>;
  /** Progression write-back: SZ stage moves into mapped stage types are mirrored to the ATS. */
  stagePushEnabled: Scalars['Boolean']['output'];
  /** Workday only: the rejection reasons valid at each Workday stage, used to narrow the reasons offered when rejecting. Empty when unconfigured and for non-Workday integrations. */
  stageRejectionReasons: Array<AtsStageRejectionReasonsEntryGqlModel>;
};

export type AtsStageCatalogueEntryGqlModel = {
  __typename?: 'AtsStageCatalogueEntryGQLModel';
  atsStageRef: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AtsStageCatalogueGqlModel = {
  __typename?: 'AtsStageCatalogueGQLModel';
  companyId: Scalars['Int']['output'];
  missingRefCount: Scalars['Int']['output'];
  stages: Array<AtsStageCatalogueEntryGqlModel>;
};

export type AtsStageMapEntryGqlModel = {
  __typename?: 'AtsStageMapEntryGQLModel';
  atsStageRef: Scalars['String']['output'];
  szStageType: SzMappedStageType;
  /** @deprecated Use workdayStepIds; holds only its first entry. */
  workdayStepId?: Maybe<Scalars['String']['output']>;
  workdayStepIds: Array<Scalars['String']['output']>;
};

export type AtsStageMapEntryInput = {
  atsStageRef: Scalars['String']['input'];
  szStageType: SzMappedStageType;
  /** @deprecated Use workdayStepIds; ignored when that is provided. */
  workdayStepId?: InputMaybe<Scalars['String']['input']>;
  workdayStepIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AtsStageRejectionReasonsEntryGqlModel = {
  __typename?: 'AtsStageRejectionReasonsEntryGQLModel';
  atsStageRef: Scalars['String']['output'];
  /** Reserved for automated rejection; not used yet. */
  defaultAutoRejectReasonId?: Maybe<Scalars['String']['output']>;
  rejectionReasonIds: Array<Scalars['String']['output']>;
};

export type AtsStageRejectionReasonsEntryInput = {
  atsStageRef: Scalars['String']['input'];
  defaultAutoRejectReasonId?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonIds: Array<Scalars['String']['input']>;
};

export type AtsWorkdayFieldAliasesGqlModel = {
  __typename?: 'AtsWorkdayFieldAliasesGQLModel';
  completionDate?: Maybe<Scalars['String']['output']>;
  evaluationId?: Maybe<Scalars['String']['output']>;
  evaluatorName?: Maybe<Scalars['String']['output']>;
  interviewName?: Maybe<Scalars['String']['output']>;
  orderStatus?: Maybe<Scalars['String']['output']>;
  recommendedDecision?: Maybe<Scalars['String']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
};

export type AtsWorkdayFieldAliasesInput = {
  completionDate?: InputMaybe<Scalars['String']['input']>;
  evaluationId?: InputMaybe<Scalars['String']['input']>;
  evaluatorName?: InputMaybe<Scalars['String']['input']>;
  interviewName?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<Scalars['String']['input']>;
  recommendedDecision?: InputMaybe<Scalars['String']['input']>;
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
};

export type AtsWritebackFailure = {
  __typename?: 'AtsWritebackFailure';
  message?: Maybe<Scalars['String']['output']>;
  status: AtsWritebackFailureType;
  subId: Scalars['ID']['output'];
};

/** Why mirroring a rejection to the ATS failed. VALIDATION_REFUSED means the ATS rejected the input (e.g. the reason is not reachable from the candidate’s current stage) and the SZ-side rejection was NOT applied. SYNC_FAILED means the rejection stands in SZ but did not reach the ATS. */
export enum AtsWritebackFailureType {
  SyncFailed = 'SYNC_FAILED',
  ValidationRefused = 'VALIDATION_REFUSED'
}

export type Attendee = {
  email: Scalars['String']['input'];
  isOrganiser?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AttendeeModel = {
  __typename?: 'AttendeeModel';
  email: Scalars['String']['output'];
  isOrganiser: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type AuthCodeResult = {
  __typename?: 'AuthCodeResult';
  authCode: Scalars['String']['output'];
};

export type AuthCodeResultCookie = {
  __typename?: 'AuthCodeResultCookie';
  authCode: Scalars['String']['output'];
  mfaCookie: Scalars['String']['output'];
};

export type AuthenticationMethodModel = {
  __typename?: 'AuthenticationMethodModel';
  authInfoSubId?: Maybe<Scalars['String']['output']>;
  identityProvider?: Maybe<IdentityProviderModel>;
  type: AuthenticationMethodType;
};

export enum AuthenticationMethodType {
  EmailPassword = 'EMAIL_PASSWORD',
  Saml = 'SAML'
}

export type AuthenticationResult = {
  __typename?: 'AuthenticationResult';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthenticationResultCookie = {
  __typename?: 'AuthenticationResultCookie';
  accessToken: Scalars['String']['output'];
  mfaCookie: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AuthenticationResultE2eCookie = {
  __typename?: 'AuthenticationResultE2eCookie';
  mfaCookie: Scalars['String']['output'];
};

/** How far one interviewer's availability can be trusted */
export enum AvailabilityConfidence {
  High = 'high',
  Low = 'low'
}

/** Why one interviewer's availability cannot be trusted */
export enum AvailabilityLowConfidenceReason {
  CompanyDefaultTimezone = 'companyDefaultTimezone',
  NoCalendarAccess = 'noCalendarAccess',
  StaleSync = 'staleSync',
  UnsyncedWindow = 'unsyncedWindow'
}

/** Interviewer availability over a requested window */
export type AvailabilityPreviewModel = {
  __typename?: 'AvailabilityPreviewModel';
  /** The company's working hours, in the company's zone */
  companyWorkingWindow: FallbackWorkingWindowModel;
  /** Start of the window answered for */
  from: Scalars['DateTime']['output'];
  /** One entry per requested interviewer, in request order */
  interviewers: Array<InterviewerAvailabilityModel>;
  /** End of the window answered for */
  to: Scalars['DateTime']['output'];
};

export enum Avatar {
  Avatar_1 = 'AVATAR_1',
  Avatar_2 = 'AVATAR_2',
  Avatar_3 = 'AVATAR_3',
  Avatar_4 = 'AVATAR_4',
  Avatar_5 = 'AVATAR_5',
  Spot = 'SPOT'
}

export type BackfillAtsApplicationIdsForAllIntegratedCompaniesResultModel = {
  __typename?: 'BackfillAtsApplicationIdsForAllIntegratedCompaniesResultModel';
  /** PCs that would have been persisted (dry-run) or were persisted (execution). */
  backfilled: Scalars['Int']['output'];
  /** Number of Kombo-integrated companies enumerated via sdk.integrations.list(). */
  companiesConsidered: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean']['output'];
  /** Per-PC DB write failures during execution; always 0 on dry-run. See logs for context. */
  failed: Scalars['Int']['output'];
  /** PCs with no matching ATS application — e.g., upstream application was deleted, or email differs between ATS and SZ. */
  noAtsMatch: Scalars['Int']['output'];
  /** Per-company breakdown for ops debugging — one entry per integrated company in the order returned by sdk.integrations.list(). */
  perCompany: Array<BackfillAtsApplicationIdsPerCompanyEntryModel>;
  /** Total project candidates examined across all considered projects. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** Projects on this company that had at least one PC missing ats_application_id (and so were walked). */
  projectsConsidered: Scalars['Int']['output'];
};

export type BackfillAtsApplicationIdsForCompanyResultModel = {
  __typename?: 'BackfillAtsApplicationIdsForCompanyResultModel';
  /** PCs that would have been persisted (dry-run) or were persisted (execution). */
  backfilled: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean']['output'];
  /** Per-PC DB write failures during execution; always 0 on dry-run. See logs for context. */
  failed: Scalars['Int']['output'];
  /** PCs with no matching ATS application — e.g., upstream application was deleted, or email differs between ATS and SZ. */
  noAtsMatch: Scalars['Int']['output'];
  /** Total project candidates examined across all considered projects. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** Projects on this company that had at least one PC missing ats_application_id (and so were walked). */
  projectsConsidered: Scalars['Int']['output'];
};

export type BackfillAtsApplicationIdsPerCompanyEntryModel = {
  __typename?: 'BackfillAtsApplicationIdsPerCompanyEntryModel';
  /** PCs that would have been persisted (dry-run) or were persisted (execution). */
  backfilled: Scalars['Int']['output'];
  /** Owning company id for this breakdown row. */
  companyId: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean']['output'];
  /** Per-PC DB write failures during execution; always 0 on dry-run. See logs for context. */
  failed: Scalars['Int']['output'];
  /** PCs with no matching ATS application — e.g., upstream application was deleted, or email differs between ATS and SZ. */
  noAtsMatch: Scalars['Int']['output'];
  /** Total project candidates examined across all considered projects. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** Projects on this company that had at least one PC missing ats_application_id (and so were walked). */
  projectsConsidered: Scalars['Int']['output'];
};

export type BackfillAtsAssessmentStageCandidatesResultModel = {
  __typename?: 'BackfillAtsAssessmentStageCandidatesResultModel';
  /** Project candidates that already had a `sm_stage_candidate` row; the call was a no-op for these. */
  alreadyExisted: Scalars['Int']['output'];
  /** New `sm_stage_candidate` rows persisted by this call. */
  created: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows were written). */
  dryRun: Scalars['Boolean']['output'];
  /** Project candidates for which the upsert threw an unexpected error; see the gateway logs. */
  failed: Scalars['Int']['output'];
  /** Number of project candidates whose current stage is an assessment stage and were considered for the backfill. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** Project candidates whose stage could not be resolved (e.g., missing current stage id, or the stage no longer exists). */
  skipped: Scalars['Int']['output'];
};

export type BackfillAtsRejectionReasonsForAllIntegratedCompaniesResultModel = {
  __typename?: 'BackfillAtsRejectionReasonsForAllIntegratedCompaniesResultModel';
  /** PCs already carrying the reason the ATS holds — no write needed. High on a re-run, which is expected: the backfill is idempotent. */
  alreadyMirrored: Scalars['Int']['output'];
  /** PCs that would have been stamped (dry-run) or were stamped (execution). */
  backfilled: Scalars['Int']['output'];
  /** Number of Kombo-integrated companies enumerated via sdk.integrations.list(). */
  companiesConsidered: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean']['output'];
  /** Per-PC RPC or DB failures; the run continues past them. See logs for context. */
  failed: Scalars['Int']['output'];
  /** Upper bound on rejected rows this backfill cannot see: every rejected PC with no ats_application_id, so it was not walked at all. Mostly manually-invited candidates that never had an ATS application, which nothing can repair — it will not reach zero, so do not treat it as a precondition. If the walked count looks low, run backfillAtsApplicationIdsForCompany once and compare this number before and after. */
  noApplicationId: Scalars['Int']['output'];
  /** PCs whose ATS application is declined but carries no rejection reason. */
  noReason: Scalars['Int']['output'];
  /** PCs rejected in SZ whose ATS application is not declined — typically a failed rejection write-back. Skipped deliberately: the gateway never clears a reason once set, so mirroring one here would attribute a stale reason to the wrong rejection. */
  notDeclinedInAts: Scalars['Int']['output'];
  /** Per-company breakdown for ops debugging — one entry per integrated company in the order returned by sdk.integrations.list(). */
  perCompany: Array<BackfillAtsRejectionReasonsPerCompanyEntryModel>;
  /** Rejected project candidates on this company carrying an ats_application_id — the rows the backfill walked. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** PCs whose ats_application_id the ATS could not resolve at all — usually a stale or wrong id. */
  unresolvedApplication: Scalars['Int']['output'];
};

export type BackfillAtsRejectionReasonsForCompanyResultModel = {
  __typename?: 'BackfillAtsRejectionReasonsForCompanyResultModel';
  /** PCs already carrying the reason the ATS holds — no write needed. High on a re-run, which is expected: the backfill is idempotent. */
  alreadyMirrored: Scalars['Int']['output'];
  /** PCs that would have been stamped (dry-run) or were stamped (execution). */
  backfilled: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean']['output'];
  /** Per-PC RPC or DB failures; the run continues past them. See logs for context. */
  failed: Scalars['Int']['output'];
  /** Upper bound on rejected rows this backfill cannot see: every rejected PC with no ats_application_id, so it was not walked at all. Mostly manually-invited candidates that never had an ATS application, which nothing can repair — it will not reach zero, so do not treat it as a precondition. If the walked count looks low, run backfillAtsApplicationIdsForCompany once and compare this number before and after. */
  noApplicationId: Scalars['Int']['output'];
  /** PCs whose ATS application is declined but carries no rejection reason. */
  noReason: Scalars['Int']['output'];
  /** PCs rejected in SZ whose ATS application is not declined — typically a failed rejection write-back. Skipped deliberately: the gateway never clears a reason once set, so mirroring one here would attribute a stale reason to the wrong rejection. */
  notDeclinedInAts: Scalars['Int']['output'];
  /** Rejected project candidates on this company carrying an ats_application_id — the rows the backfill walked. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** PCs whose ats_application_id the ATS could not resolve at all — usually a stale or wrong id. */
  unresolvedApplication: Scalars['Int']['output'];
};

export type BackfillAtsRejectionReasonsPerCompanyEntryModel = {
  __typename?: 'BackfillAtsRejectionReasonsPerCompanyEntryModel';
  /** PCs already carrying the reason the ATS holds — no write needed. High on a re-run, which is expected: the backfill is idempotent. */
  alreadyMirrored: Scalars['Int']['output'];
  /** PCs that would have been stamped (dry-run) or were stamped (execution). */
  backfilled: Scalars['Int']['output'];
  /** Owning company id for this breakdown row. */
  companyId: Scalars['Int']['output'];
  /** True when the call ran in dry-run mode (no rows written). */
  dryRun: Scalars['Boolean']['output'];
  /** Per-PC RPC or DB failures; the run continues past them. See logs for context. */
  failed: Scalars['Int']['output'];
  /** Upper bound on rejected rows this backfill cannot see: every rejected PC with no ats_application_id, so it was not walked at all. Mostly manually-invited candidates that never had an ATS application, which nothing can repair — it will not reach zero, so do not treat it as a precondition. If the walked count looks low, run backfillAtsApplicationIdsForCompany once and compare this number before and after. */
  noApplicationId: Scalars['Int']['output'];
  /** PCs whose ATS application is declined but carries no rejection reason. */
  noReason: Scalars['Int']['output'];
  /** PCs rejected in SZ whose ATS application is not declined — typically a failed rejection write-back. Skipped deliberately: the gateway never clears a reason once set, so mirroring one here would attribute a stale reason to the wrong rejection. */
  notDeclinedInAts: Scalars['Int']['output'];
  /** Rejected project candidates on this company carrying an ats_application_id — the rows the backfill walked. */
  projectCandidatesConsidered: Scalars['Int']['output'];
  /** PCs whose ats_application_id the ATS could not resolve at all — usually a stale or wrong id. */
  unresolvedApplication: Scalars['Int']['output'];
};

export type BackfillCandidateInterviewGuideModel = {
  __typename?: 'BackfillCandidateInterviewGuideModel';
  /** Number of CIGs within the scope identified as potentially orphaned (lacking both interview and stage candidates). */
  cigsCheckedForOrphanDelete: Scalars['Int']['output'];
  /** Number of orphaned CIGs actually deleted (0 in dry-run). */
  cigsDeleted: Scalars['Int']['output'];
  /** Number of CIGs within the scope identified as needing their interview_stage_candidate_id backfilled. */
  cigsNeedUpdateCount: Scalars['Int']['output'];
  /** Number of CIGs that were actually updated with the correct interview_stage_candidate_id (0 in dry-run). */
  cigsUpdatedCount: Scalars['Int']['output'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean']['output'];
  /** Total number of CIGs considered within the specified scope (all relevant or filtered by ID). */
  processedCigCount: Scalars['Int']['output'];
  /** Array of specific CIG IDs processed (empty if filtered IDs were not found or if scope was all relevant CIGs without matches). */
  processedCigIds: Array<Scalars['Int']['output']>;
  /** Number of unique Interview Stage Candidate (ISC) records involved in linking CIGs. */
  relevantIscCount: Scalars['Int']['output'];
};

export type BackfillKomboApplicationsForProjectResultModel = {
  __typename?: 'BackfillKomboApplicationsForProjectResultModel';
  /** Gateway-side `kombo_sync_run` id when the gateway accepted the trigger and a sync run was created. Caller can correlate downstream gateway logs by this id. `null` when `triggered` is false. */
  runId?: Maybe<Scalars['String']['output']>;
  /** One of: `project-not-found`, `project-not-published`, `no-kombo-link`, `integration-disabled`. Present only when `triggered` is false. */
  skippedReason?: Maybe<Scalars['String']['output']>;
  /** True when the gateway accepted the trigger and a sync run was created. False means the gateway declined for one of the structured reasons in `skippedReason`. */
  triggered: Scalars['Boolean']['output'];
};

/** Result of admin backfill participant user IDs operation */
export type BackfillUserIdsResult = {
  __typename?: 'BackfillUserIdsResult';
  /** Total distinct emails with null userId found */
  totalProcessed: Scalars['Int']['output'];
  /** Total participant rows updated with resolved userId */
  totalUpdated: Scalars['Int']['output'];
};

export type BasicBroadSoftSkill = SoftSkill & {
  __typename?: 'BasicBroadSoftSkill';
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples: Array<Scalars['String']['output']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID']['output'];
  taxonomyVersion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BasicFocusedSoftSkill = SoftSkill & {
  __typename?: 'BasicFocusedSoftSkill';
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples: Array<Scalars['String']['output']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID']['output'];
  taxonomyVersion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BasicProjectCandidate = {
  __typename?: 'BasicProjectCandidate';
  assessmentStageCandidates: Array<SmStageCandidateModel>;
  atsStage?: Maybe<Scalars['String']['output']>;
  contentStageCandidates: Array<ContentStageCandidateModel>;
  createdAt: Scalars['Date']['output'];
  currentStageId?: Maybe<Scalars['Int']['output']>;
  currentStageType?: Maybe<StageType>;
  deadlineAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  interviewStageCandidates: Array<InterviewStageCandidate>;
  isExpired: Scalars['Boolean']['output'];
  offerStageCandidate?: Maybe<OfferStageCandidateModel>;
  progressionStatus: ProgressionStatus;
  shortlistStageCandidates: Array<ShortlistStageCandidate>;
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BehaviourContentModel = {
  __typename?: 'BehaviourContentModel';
  behaviourId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  negativeSummary: Scalars['String']['output'];
  positiveSummary: Scalars['String']['output'];
  roleLevel?: Maybe<ContentRoleLevel>;
};

export type BehaviourFromCsvRowsCreateManyArgs = {
  internalName: Scalars['String']['input'];
  level: Scalars['String']['input'];
  negativeSummary: Scalars['String']['input'];
  positiveSummary: Scalars['String']['input'];
  softSkillId: Scalars['String']['input'];
  traitId: Scalars['String']['input'];
};

export type BehaviourModel = {
  __typename?: 'BehaviourModel';
  content?: Maybe<BehaviourContentModel>;
  contents: Array<BehaviourContentModel>;
  contexts: Array<TraitSoftSkillContextModel>;
  id: Scalars['Int']['output'];
  internalName: Scalars['String']['output'];
};

/** Bot session metadata including platform details, meeting URL, recording location, and logs */
export type BotSessionMetadataModel = {
  __typename?: 'BotSessionMetadataModel';
  /** Additional logs and diagnostic information from the bot provider */
  logs?: Maybe<Scalars['JSON']['output']>;
  /** Meeting URL where the bot attempted to join */
  meetingUrl?: Maybe<Scalars['String']['output']>;
  /** Meeting platform where the bot joined (e.g., zoom, google_meet, microsoft_teams) */
  platform?: Maybe<Scalars['String']['output']>;
  /** URL to the recording file if available from the provider */
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** The date when bot is scheduled to join */
  scheduledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BroadSoftSkill = SoftSkill & {
  __typename?: 'BroadSoftSkill';
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples: Array<Scalars['String']['output']>;
  focusedSoftSkills: Array<BasicFocusedSoftSkill>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  similarSoftSkills: Array<BasicBroadSoftSkill>;
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID']['output'];
  taxonomyVersion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type BulkUpdateSoftSkillTraitArgsSingle = {
  addEmptyContent?: InputMaybe<Scalars['Boolean']['input']>;
  isAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  orientation: Orientation;
  softSkillId: Scalars['Int']['input'];
  traitId: Scalars['Int']['input'];
  weight: Scalars['Float']['input'];
};

/** One masked interval of an interviewer's busy time */
export type BusyBlockModel = {
  __typename?: 'BusyBlockModel';
  /** How the provider classified the interval */
  busyType: SchedulingBusyType;
  endsAt: Scalars['DateTime']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export enum CalculationMethod {
  PercentileWeightedAverage = 'PERCENTILE_WEIGHTED_AVERAGE',
  RoleSkillsProfile = 'ROLE_SKILLS_PROFILE',
  StenWeightedAverage = 'STEN_WEIGHTED_AVERAGE',
  StenWeightedAverageWithAdjustemt = 'STEN_WEIGHTED_AVERAGE_WITH_ADJUSTEMT',
  TrCustomCalculator = 'TR_CUSTOM_CALCULATOR',
  ZWeightedAverageWithAdjustment = 'Z_WEIGHTED_AVERAGE_WITH_ADJUSTMENT',
  ZWeightedAverageWithSmarterAdjustment = 'Z_WEIGHTED_AVERAGE_WITH_SMARTER_ADJUSTMENT',
  ZWeightedAverageWithSmarterAdjustmentAndLimit = 'Z_WEIGHTED_AVERAGE_WITH_SMARTER_ADJUSTMENT_AND_LIMIT'
}

/** What calendar access resolved for one interviewer */
export enum CalendarAccessState {
  Accessible = 'accessible',
  Frozen = 'frozen',
  OptedOut = 'optedOut',
  Unavailable = 'unavailable',
  Unresolved = 'unresolved'
}

/** An attendee/participant in a calendar event */
export type CalendarAttendeeModel = {
  __typename?: 'CalendarAttendeeModel';
  /** Email address of the attendee */
  email: Scalars['String']['output'];
  /** Whether this attendee is the organizer of the event */
  isOrganizer?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the attendee */
  name?: Maybe<Scalars['String']['output']>;
  /** RSVP status (provider-native: needsAction, accepted, declined, tentative) */
  rsvp?: Maybe<Scalars['String']['output']>;
  /** Internal user ID if the attendee is a registered user */
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum CalendarProviderV2 {
  Google = 'google',
  Microsoft = 'microsoft'
}

export type CalibrationAnswersInput = {
  adjacentDomain?: InputMaybe<ShortlistCalibrationAnswer>;
  adjacentExperience?: InputMaybe<ShortlistCalibrationAnswer>;
  nearMatch?: InputMaybe<ShortlistCalibrationAnswer>;
  secondaryCapacity?: InputMaybe<ShortlistCalibrationAnswer>;
  stronglyImpliedExperience?: InputMaybe<ShortlistCalibrationAnswer>;
};

export type CalibrationConfigExtendedModel = {
  __typename?: 'CalibrationConfigExtendedModel';
  gradeBands: Array<GradeBandUnion>;
  softSkillEntries: Array<CalibrationConfigSoftSkillEntryModel>;
  technicalSkillEntries: Array<CalibrationConfigTechnicalSkillEntryModel>;
  totalEntry: CalibrationConfigTotalEntryModel;
};

export type CalibrationConfigModel = {
  __typename?: 'CalibrationConfigModel';
  gradeBands: Array<GradeBandUnion>;
  softSkillIds: Array<Scalars['Int']['output']>;
  successProfileId: Scalars['Int']['output'];
};

export type CalibrationConfigSoftSkillEntryModel = {
  __typename?: 'CalibrationConfigSoftSkillEntryModel';
  latestResult?: Maybe<ResultModel>;
  originalResult?: Maybe<ResultModel>;
  softSkill: SoftSkill;
  softSkillId: Scalars['Int']['output'];
};

export type CalibrationConfigTechnicalSkillEntryModel = {
  __typename?: 'CalibrationConfigTechnicalSkillEntryModel';
  latestResult?: Maybe<ResultModel>;
  originalResult?: Maybe<ResultModel>;
  technicalSkill: TechnicalSkill;
  technicalSkillId: Scalars['Int']['output'];
};

export type CalibrationConfigTotalEntryModel = {
  __typename?: 'CalibrationConfigTotalEntryModel';
  latestResult?: Maybe<ResultModel>;
  originalResult?: Maybe<ResultModel>;
  successProfileId: Scalars['Int']['output'];
};

export type CalibrationFileUploadArgs = {
  projectId: Scalars['Int']['input'];
  signOff: Scalars['Boolean']['input'];
};

export type CalibrationFileUploadLineModel = {
  __typename?: 'CalibrationFileUploadLineModel';
  directReportEmployeeId: Scalars['String']['output'];
  directReportName: Scalars['String']['output'];
  managerEmployeeId: Scalars['String']['output'];
  managerName: Scalars['String']['output'];
  overallResult: TrCustomEvaluation;
  overallResultAdjustment: TrCustomEvaluation;
  overallResultId: Scalars['Int']['output'];
  softSkillResult1: TrCustomEvaluation;
  softSkillResult1Adjustment: TrCustomEvaluation;
  softSkillResult1PreviousId: Scalars['Int']['output'];
  softSkillResult2: TrCustomEvaluation;
  softSkillResult2Adjustment: TrCustomEvaluation;
  softSkillResult2PreviousId: Scalars['Int']['output'];
  softSkillResult3: TrCustomEvaluation;
  softSkillResult3Adjustment: TrCustomEvaluation;
  softSkillResult3PreviousId: Scalars['Int']['output'];
  stageCandidateId: Scalars['Int']['output'];
};

export type CalibrationFileUploadModel = {
  __typename?: 'CalibrationFileUploadModel';
  apply: Scalars['Boolean']['output'];
  creates?: Maybe<Array<CalibrationFileUploadLineModel>>;
  deletes?: Maybe<Array<CalibrationFileUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<CalibrationFileUploadLineModel>>;
  noChanges?: Maybe<Array<CalibrationFileUploadLineModel>>;
  projectId: Scalars['Int']['output'];
  signOff: Scalars['Boolean']['output'];
  updates?: Maybe<Array<CalibrationFileUploadLineModel>>;
};

export type CandidateAcceptIndirectInvitationResult = {
  __typename?: 'CandidateAcceptIndirectInvitationResult';
  role: MyRole;
  stageId: Scalars['ID']['output'];
};

export type CandidateApplication = {
  __typename?: 'CandidateApplication';
  isMine: Scalars['Boolean']['output'];
  projectCandidateSubId: Scalars['ID']['output'];
  projectId: Scalars['Int']['output'];
  projectSubId: Scalars['ID']['output'];
  requisitionCode?: Maybe<Scalars['String']['output']>;
  requisitionLocation?: Maybe<RequisitionLocationModel>;
  roleCreatedAt: Scalars['DateTime']['output'];
  roleName: Scalars['String']['output'];
  roleStatus: ProjectStatus;
};

export type CandidateFeedbackEventPayload = {
  __typename?: 'CandidateFeedbackEventPayload';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewEvaluationId: Scalars['String']['output'];
  isRegenerationAllowed: Scalars['Boolean']['output'];
  needsRegeneration: Scalars['Boolean']['output'];
  requestId?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  status: InterviewCandidateFeedbackStatus;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateFeedbackModelV2 = {
  __typename?: 'CandidateFeedbackModelV2';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewEvaluation?: Maybe<InterviewEvaluationModel>;
  interviewEvaluationId: Scalars['String']['output'];
  isRegenerationAllowed: Scalars['Boolean']['output'];
  needsRegeneration: Scalars['Boolean']['output'];
  src?: Maybe<Scalars['String']['output']>;
  status: InterviewCandidateFeedbackStatus;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateHit = {
  __typename?: 'CandidateHit';
  applications: Array<CandidateApplication>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  match: SearchMatch;
  primaryApplication: CandidateApplication;
  userSubId: Scalars['ID']['output'];
};

export type CandidateInterviewGuideEventPayload = {
  __typename?: 'CandidateInterviewGuideEventPayload';
  companyId: Scalars['Int']['output'];
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  confirmedBy?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Int']['output'];
  estimatedDuration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interviewGuideBlueprintId: Scalars['Int']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  isQuestionListModified?: Maybe<Scalars['Boolean']['output']>;
  isQuestionsEdited: Scalars['Boolean']['output'];
  lastUpdatedAt: Scalars['Date']['output'];
  lastUpdatedById?: Maybe<Scalars['Int']['output']>;
  questions: Array<CandidateInterviewGuideQuestionEventPayload>;
  stageCandidateId?: Maybe<Scalars['Int']['output']>;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CandidateInterviewGuideModel = {
  __typename?: 'CandidateInterviewGuideModel';
  assessmentStageCandidate?: Maybe<SmStageCandidateModel>;
  assessmentStageCandidateId?: Maybe<Scalars['Int']['output']>;
  cachedLocales: Array<SupportedLocale>;
  candidateUser?: Maybe<User>;
  companyId: Scalars['Int']['output'];
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  confirmedBy?: Maybe<Scalars['Int']['output']>;
  confirmedByUser?: Maybe<User>;
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Int']['output'];
  estimatedDuration: Scalars['Int']['output'];
  /** True while candidates have not yet finished this guide's AI interview stage. The guide cannot be edited then, except by SZ admins. Always false for human interview stages. */
  hasPendingAiInterviewCandidates: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interviewGuideBlueprint: InterviewGuideBlueprintModel;
  interviewGuideBlueprintId: Scalars['Int']['output'];
  interviewStageCandidate?: Maybe<InterviewStageCandidate>;
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  /** True when the company has AI interviews switched off, so only Spotted Zebra users may change this guide. Always false for human interview stages. */
  isAiInterviewSelfServeDisabled: Scalars['Boolean']['output'];
  isQuestionListModified: Scalars['Boolean']['output'];
  isQuestionsEdited: Scalars['Boolean']['output'];
  lastUpdatedAt: Scalars['Date']['output'];
  lastUpdatedById?: Maybe<Scalars['Int']['output']>;
  questions: Array<CandidateInterviewGuideQuestionModel>;
  stageCandidate?: Maybe<SmStageCandidateModel>;
  stageCandidateId?: Maybe<Scalars['Int']['output']>;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CandidateInterviewGuidePdfEventPayload = {
  __typename?: 'CandidateInterviewGuidePdfEventPayload';
  candidateInterviewGuideId: Scalars['ID']['output'];
  companyId: Scalars['Int']['output'];
  downloadRequestId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  status: PdfGenerationStatus;
  url?: Maybe<Scalars['String']['output']>;
};

/** Types of questions in the CandidateInterviewGuideQuestionCreate mutation */
export enum CandidateInterviewGuideQuestionCreateQuestionType {
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export type CandidateInterviewGuideQuestionEventPayload = {
  __typename?: 'CandidateInterviewGuideQuestionEventPayload';
  candidateInterviewGuideId: Scalars['Float']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Float']['output'];
  editingStartedAt?: Maybe<Scalars['Date']['output']>;
  editingUserId?: Maybe<Scalars['Float']['output']>;
  estimatedDuration: Scalars['Int']['output'];
  extraContent?: Maybe<Scalars['String']['output']>;
  generationStatus: InterviewGuideBlueprintQuestionGenerationStatus;
  id: Scalars['ID']['output'];
  interviewGuideBlueprintQuestionId?: Maybe<Scalars['Float']['output']>;
  isEditable: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  lastUpdatedById?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Float']['output'];
  softSkills?: Maybe<Array<SoftSkill>>;
  subId: Scalars['String']['output'];
  subtype?: Maybe<InterviewGuideBlueprintQuestionSubtype>;
  technicalSkills?: Maybe<Array<TechnicalSkill>>;
  type: CandidateInterviewGuideQuestionType;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateInterviewGuideQuestionModel = {
  __typename?: 'CandidateInterviewGuideQuestionModel';
  candidateInterviewGuide: CandidateInterviewGuideModel;
  candidateInterviewGuideId: Scalars['Float']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Float']['output'];
  editingStartedAt?: Maybe<Scalars['Date']['output']>;
  editingUserId?: Maybe<Scalars['Float']['output']>;
  extraContent?: Maybe<Scalars['String']['output']>;
  generationStatus: InterviewGuideBlueprintQuestionGenerationStatus;
  id: Scalars['ID']['output'];
  interviewGuideBlueprintQuestionId?: Maybe<Scalars['Float']['output']>;
  isEditable: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  lastUpdatedById?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Float']['output'];
  softSkillJunctions: Array<CandidateInterviewGuideQuestionSoftSkill>;
  softSkills?: Maybe<Array<SoftSkill>>;
  subId: Scalars['String']['output'];
  subtype?: Maybe<InterviewGuideBlueprintQuestionSubtype>;
  technicalSkills?: Maybe<Array<TechnicalSkill>>;
  type: CandidateInterviewGuideQuestionType;
  updatedAt: Scalars['Date']['output'];
};

export type CandidateInterviewGuideQuestionSoftSkill = {
  __typename?: 'CandidateInterviewGuideQuestionSoftSkill';
  indicators: Array<SoftSkillIndicator>;
  softSkill: SoftSkill;
};

/** Types of questions in the interview guide */
export enum CandidateInterviewGuideQuestionType {
  AiQuestion = 'AI_QUESTION',
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  CustomizedAiQuestion = 'CUSTOMIZED_AI_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export type CandidateInterviewGuideQuestionUpdateData = {
  content?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  extraContent?: InputMaybe<Scalars['String']['input']>;
};

export enum CandidateJourneyStageStatus {
  Completed = 'COMPLETED',
  Locked = 'LOCKED',
  Unlocked = 'UNLOCKED',
  Unsuccessful = 'UNSUCCESSFUL'
}

/** Whether a candidate has a report and a guide to link */
export type CandidateMaterialsAvailabilityModel = {
  __typename?: 'CandidateMaterialsAvailabilityModel';
  hasAssessmentReport: Scalars['Boolean']['output'];
  hasInterviewGuide: Scalars['Boolean']['output'];
  stageCandidateId: Scalars['Int']['output'];
};

export type CandidateOverviewStageResult = {
  __typename?: 'CandidateOverviewStageResult';
  aiInterviewSummaryScore?: Maybe<Scalars['Int']['output']>;
  assessmentStageKind?: Maybe<AssessmentStageKind>;
  codingFinalScore?: Maybe<Scalars['Int']['output']>;
  codingQualifyingScore?: Maybe<Scalars['Int']['output']>;
  cognitiveSummaryPercentile?: Maybe<Scalars['Int']['output']>;
  displayName: Scalars['String']['output'];
  englishCefrLevel?: Maybe<CefrLevel>;
  englishHasPassed?: Maybe<Scalars['Boolean']['output']>;
  hasEntered: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isCurrentStage: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  psychometricOverallPercentile?: Maybe<Scalars['Int']['output']>;
  shortlistCriteriaScore?: Maybe<Scalars['Int']['output']>;
  shortlistIsKnockedOut?: Maybe<Scalars['Boolean']['output']>;
  stageId: Scalars['Int']['output'];
  stageType: StageType;
};

export type CandidateProgressionData = {
  __typename?: 'CandidateProgressionData';
  latestHire?: Maybe<CandidateProgressionEntry>;
  latestHireCleared?: Maybe<CandidateProgressionEntry>;
  latestProgression?: Maybe<CandidateProgressionEntry>;
  latestRejection?: Maybe<CandidateProgressionEntry>;
  latestUnrejection?: Maybe<CandidateProgressionEntry>;
};

export type CandidateProgressionEntry = {
  __typename?: 'CandidateProgressionEntry';
  fromStageId?: Maybe<Scalars['Int']['output']>;
  fromStageName?: Maybe<Scalars['String']['output']>;
  fromStageType?: Maybe<StageType>;
  occurredAt?: Maybe<Scalars['Date']['output']>;
  performedBy?: Maybe<User>;
  performedByType?: Maybe<ProgressionEventPerformedByType>;
  toStageId?: Maybe<Scalars['Int']['output']>;
  toStageName?: Maybe<Scalars['String']['output']>;
  toStageType?: Maybe<StageType>;
};

export enum CandidateResultsExportLevel {
  AllData = 'ALL_DATA',
  SummaryAndScoreDetails = 'SUMMARY_AND_SCORE_DETAILS',
  SummaryOfScores = 'SUMMARY_OF_SCORES'
}

export type CandidateSearchPage = {
  __typename?: 'CandidateSearchPage';
  hasMore: Scalars['Boolean']['output'];
  hits: Array<CandidateHit>;
};

export enum CandidateSearchSort {
  LatestStageActivity = 'LATEST_STAGE_ACTIVITY',
  Name = 'NAME',
  Relevance = 'RELEVANCE'
}

export type CandidateStageInviteSettings = {
  deadlineInEmail?: InputMaybe<Scalars['Date']['input']>;
  stageSubId: Scalars['ID']['input'];
  stageType: StageType;
};

/** Score for a single skill category (e.g. Right for the Role) */
export type CategoryScoreModel = {
  __typename?: 'CategoryScoreModel';
  /** Average score across all skills in this category (0-100) */
  averageScore: Scalars['Float']['output'];
  /** Skill category */
  group: SkillsEvaluationSkillGroup;
  /** Number of skills in this category */
  skillCount: Scalars['Int']['output'];
};

/** A Common European Framework of Reference level. Ordinal: each is stronger than the one before. BELOW_A1 is a result a candidate can be given, but not a level a stage can require. */
export enum CefrLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  BelowA1 = 'BELOW_A1',
  C1 = 'C1',
  C2 = 'C2'
}

export type Citation = {
  __typename?: 'Citation';
  sourceField: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CleanupDuplicateBlueprintsResult = {
  __typename?: 'CleanupDuplicateBlueprintsResult';
  /** Total number of DRAFT blueprints checked */
  blueprintsChecked: Scalars['Int']['output'];
  /** Number of blueprints actually deleted (0 in dry-run mode) */
  blueprintsDeleted: Scalars['Int']['output'];
  /** Number of blueprints that will be/were soft-deleted */
  blueprintsToDelete: Scalars['Int']['output'];
  /** Detailed information about each duplicate group */
  duplicateGroups: Array<DuplicateBlueprintGroup>;
  /** Number of duplicate groups found (same stage/job role with multiple DRAFTs) */
  duplicateGroupsFound: Scalars['Int']['output'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean']['output'];
};

export type CleanupForbiddenSkillRelationsResult = {
  __typename?: 'CleanupForbiddenSkillRelationsResult';
  /** Number of blueprint soft skill relationships removed. */
  blueprintSoftSkillRelationsRemoved: Scalars['Int']['output'];
  /** Number of blueprint technical skill relationships removed. */
  blueprintTechnicalSkillRelationsRemoved: Scalars['Int']['output'];
  /** Number of candidate soft skill relationships removed. */
  candidateSoftSkillRelationsRemoved: Scalars['Int']['output'];
  /** Number of candidate technical skill relationships removed. */
  candidateTechnicalSkillRelationsRemoved: Scalars['Int']['output'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean']['output'];
  /** Total number of skill relationships removed across all tables. */
  totalRelationsRemoved: Scalars['Int']['output'];
};

export type CleanupResultModel = {
  __typename?: 'CleanupResultModel';
  blueprintQuestionsCleaned: Scalars['Float']['output'];
  candidateQuestionsCleaned: Scalars['Float']['output'];
  totalCleaned: Scalars['Float']['output'];
};

export enum ClientDomainType {
  AdminAppDomain = 'ADMIN_APP_DOMAIN',
  CandidateAppDomain = 'CANDIDATE_APP_DOMAIN',
  CompanyAppDomain = 'COMPANY_APP_DOMAIN',
  PdfAppDomain = 'PDF_APP_DOMAIN'
}

export enum ClientType {
  Admin = 'ADMIN',
  Candidate = 'CANDIDATE',
  Company = 'COMPANY',
  Pdf = 'PDF'
}

export type CoderbyteAssessmentResultChallenge = {
  __typename?: 'CoderbyteAssessmentResultChallenge';
  date?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  timeTakenMinutes?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type CoderbyteAssessmentResultCheatingDetails = {
  __typename?: 'CoderbyteAssessmentResultCheatingDetails';
  aiUsage?: Maybe<Scalars['Boolean']['output']>;
  pastedCode?: Maybe<Scalars['String']['output']>;
  plagiarism?: Maybe<Scalars['String']['output']>;
  suspiciousActivity?: Maybe<Scalars['Boolean']['output']>;
  tabLeavingCount?: Maybe<Scalars['Int']['output']>;
};

export type CoderbyteAssessmentResultMultipleChoiceQuestion = {
  __typename?: 'CoderbyteAssessmentResultMultipleChoiceQuestion';
  /** @deprecated Null on questions that take several picks. Use `answers`. */
  answer?: Maybe<Scalars['String']['output']>;
  answers: Array<Scalars['String']['output']>;
  correct: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type CoderbyteAssessmentResultOpenEndedQuestion = {
  __typename?: 'CoderbyteAssessmentResultOpenEndedQuestion';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type CoderbyteAssessmentStageAction = {
  __typename?: 'CoderbyteAssessmentStageAction';
  coderbyteTestId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  details: CoderbyteAssessmentStageActionDetails;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stageId: Scalars['Int']['output'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date']['output'];
};

export type CoderbyteAssessmentStageActionCandidate = {
  __typename?: 'CoderbyteAssessmentStageActionCandidate';
  action?: Maybe<CoderbyteAssessmentStageActionNested>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  result: CoderbyteAssessmentStageActionCandidateResult;
  /** @deprecated This information is encompassed in the result property. */
  resultStatus: CoderbyteAssessmentStageActionCandidateResultStatus;
  stageCandidateId: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: CoderbyteAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CoderbyteAssessmentStageActionCandidateResult = CoderbyteAssessmentStageActionCandidateResultNotReady | CoderbyteAssessmentStageActionCandidateResultReady;

export type CoderbyteAssessmentStageActionCandidateResultNotReady = {
  __typename?: 'CoderbyteAssessmentStageActionCandidateResultNotReady';
  status: CoderbyteAssessmentStageActionCandidateResultStatusNotReady;
};

export type CoderbyteAssessmentStageActionCandidateResultReady = {
  __typename?: 'CoderbyteAssessmentStageActionCandidateResultReady';
  challenges: Array<CoderbyteAssessmentResultChallenge>;
  cheatingDetails?: Maybe<CoderbyteAssessmentResultCheatingDetails>;
  cheatingFlag?: Maybe<Scalars['String']['output']>;
  codeScore?: Maybe<Scalars['Float']['output']>;
  finalScore?: Maybe<Scalars['Float']['output']>;
  integrityFlagsCount?: Maybe<Scalars['Int']['output']>;
  mcqScore?: Maybe<Scalars['Float']['output']>;
  multipleChoiceQuestions: Array<CoderbyteAssessmentResultMultipleChoiceQuestion>;
  openEndedQuestions: Array<CoderbyteAssessmentResultOpenEndedQuestion>;
  receivedAt?: Maybe<Scalars['Date']['output']>;
  reportLink?: Maybe<Scalars['String']['output']>;
  timeTakenMinutes?: Maybe<Scalars['Int']['output']>;
};

export enum CoderbyteAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum CoderbyteAssessmentStageActionCandidateResultStatusNotReady {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type CoderbyteAssessmentStageActionCandidateStart = {
  __typename?: 'CoderbyteAssessmentStageActionCandidateStart';
  inviteUrl: Scalars['String']['output'];
};

export enum CoderbyteAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type CoderbyteAssessmentStageActionDetails = {
  __typename?: 'CoderbyteAssessmentStageActionDetails';
  challengeCount?: Maybe<Scalars['Int']['output']>;
  isFrozen: Scalars['Boolean']['output'];
  multipleChoiceCount?: Maybe<Scalars['Int']['output']>;
  qualifyingScore?: Maybe<Scalars['Int']['output']>;
  timeLimitInMinutes?: Maybe<Scalars['Int']['output']>;
};

export type CoderbyteAssessmentStageActionNested = {
  __typename?: 'CoderbyteAssessmentStageActionNested';
  coderbyteTestId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  details: CoderbyteAssessmentStageActionDetails;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  stageId: Scalars['Int']['output'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date']['output'];
};

export type CoderbyteAvailableAssessment = {
  __typename?: 'CoderbyteAvailableAssessment';
  closed: Scalars['Boolean']['output'];
  coderbyteTestId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdByEmail?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  isFrozen: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CoderbyteResultRetry = {
  __typename?: 'CoderbyteResultRetry';
  message?: Maybe<Scalars['String']['output']>;
  outcome: CoderbyteResultRetryOutcome;
  stageCandidateId?: Maybe<Scalars['Int']['output']>;
  subId: Scalars['ID']['output'];
};

export enum CoderbyteResultRetryOutcome {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  NotReady = 'NOT_READY',
  Skipped = 'SKIPPED'
}

/** A single-use hand-off into a company Coderbyte workspace. Minted on demand and never stored server-side. */
export type CoderbyteSsoLink = {
  __typename?: 'CoderbyteSsoLink';
  /** Coderbyte SSO URL. Expires within seconds of being issued — navigate to it immediately. It must not be cached, retried, or rendered into a link's href, since it will be dead by the time anyone clicks it. */
  url: Scalars['String']['output'];
};

/** A company's Coderbyte organization. Coderbyte's API calls this an *organization*; `externalId` is their `organizationId`. */
export type CoderbyteWorkspace = {
  __typename?: 'CoderbyteWorkspace';
  /** Address the workspace's Coderbyte admin account is registered under. Sign in to Coderbyte with this plus the stored admin password — admin accounts cannot use SSO. */
  adminEmail: Scalars['String']['output'];
  /** When the Coderbyte admin password was last stored. Null means none has been recorded yet, which also keeps the workspace out of service. */
  adminPasswordSetAt?: Maybe<Scalars['Date']['output']>;
  companyId: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** Deep link into the workspace's Coderbyte dashboard. */
  dashboardUrl: Scalars['String']['output'];
  /** Coderbyte's organization id, e.g. `szfniq-a5rq8`. */
  externalId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** When the workspace API key was last entered. */
  keySetAt?: Maybe<Scalars['Date']['output']>;
  /** When that key was last confirmed to work against Coderbyte. */
  keyVerifiedAt?: Maybe<Scalars['Date']['output']>;
  status: CoderbyteWorkspaceStatus;
  updatedAt: Scalars['Date']['output'];
  /** Users with an account in this workspace, showing the mapping from their real address to the synthetic one Coderbyte knows them by. */
  users: Array<CoderbyteWorkspaceUser>;
  /** URL to register under "Edit webhooks" in this workspace's Coderbyte API settings. Coderbyte offers no API for this, so it has to be pasted in by hand; until it is, results are never delivered and nothing reports an error. */
  webhookUrl: Scalars['String']['output'];
};

/** Lifecycle of a company's Coderbyte workspace. */
export enum CoderbyteWorkspaceStatus {
  Active = 'ACTIVE',
  PendingSetup = 'PENDING_SETUP',
  Suspended = 'SUSPENDED'
}

/** A Spotted Zebra user's account inside a company's Coderbyte workspace. */
export type CoderbyteWorkspaceUser = {
  __typename?: 'CoderbyteWorkspaceUser';
  /** When we detected the account had materialised on Coderbyte. An upper bound on when the user actually followed their invitation — Coderbyte never tells us the moment itself. */
  activatedAt?: Maybe<Scalars['Date']['output']>;
  /** The synthetic address this user is registered under on Coderbyte. Coderbyte allows one account per organization, so a person working across several client companies gets a distinct address in each. */
  coderbyteEmail: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invitedAt?: Maybe<Scalars['Date']['output']>;
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  status: CoderbyteWorkspaceUserStatus;
  /** The user's real Spotted Zebra email address. */
  userEmail: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

/** Lifecycle of a user's account inside their company's Coderbyte workspace. */
export enum CoderbyteWorkspaceUserStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Revoked = 'REVOKED'
}

export enum CognitiveKind {
  Inductive = 'INDUCTIVE',
  Numerical = 'NUMERICAL',
  Verbal = 'VERBAL'
}

export enum CognitiveMode {
  InDepth = 'IN_DEPTH',
  Streamlined = 'STREAMLINED'
}

export type CognitiveTestAssessmentStageAction = {
  __typename?: 'CognitiveTestAssessmentStageAction';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: CognitiveKind;
  sectionCount: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CognitiveTestAssessmentStageActionCandidate = {
  __typename?: 'CognitiveTestAssessmentStageActionCandidate';
  action: CognitiveTestAssessmentStageActionNested;
  assessmentId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  resultStatus: CognitiveTestAssessmentStageActionCandidateResultStatus;
  stageCandidate: SmStageCandidateModel;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: CognitiveTestAssessmentStageActionCandidateStatus;
  timeModifierPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum CognitiveTestAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum CognitiveTestAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type CognitiveTestAssessmentStageActionNested = {
  __typename?: 'CognitiveTestAssessmentStageActionNested';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: CognitiveKind;
  sectionCount: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CognitiveTestPracticeAssessment = {
  __typename?: 'CognitiveTestPracticeAssessment';
  assessmentId: Scalars['String']['output'];
};

export type CollaborativeEditingForceStopArgs = {
  questionSubId: Scalars['String']['input'];
  questionType: QuestionType;
};

export type CollaborativeEditingGetInfoArgs = {
  questionSubId: Scalars['String']['input'];
  questionType: QuestionType;
};

export type CollaborativeEditingStartArgs = {
  questionSubId: Scalars['String']['input'];
  questionType: QuestionType;
};

export type CollaborativeEditingStopArgs = {
  questionSubId: Scalars['String']['input'];
  questionType: QuestionType;
};

export type CompaniesPaginatedFilters = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompaniesPaginatedGqlModel = {
  __typename?: 'CompaniesPaginatedGQLModel';
  data?: Maybe<Array<Company>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type Company = {
  __typename?: 'Company';
  aiInterviewConsentText?: Maybe<Scalars['String']['output']>;
  aiInterviewDefaultConsentText: Scalars['String']['output'];
  aiPrivateNetworking: Scalars['Boolean']['output'];
  allowedEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  alternativeSupportEmail?: Maybe<Scalars['String']['output']>;
  areCognitiveTestsBlocked: Scalars['Boolean']['output'];
  areMultiAssessmentStagesEnabled: Scalars['Boolean']['output'];
  areRffSoftSkillsDisabled: Scalars['Boolean']['output'];
  assessmentExpiryOption?: Maybe<AssessmentExpiryOption>;
  atsIdentifier?: Maybe<Scalars['String']['output']>;
  atsPullJobsFromDate: Scalars['Date']['output'];
  branding?: Maybe<CompanyBranding>;
  candidateReport?: Maybe<Report>;
  companyLifecycle: CompanyLifecycle;
  createdAt: Scalars['String']['output'];
  csmUser?: Maybe<User>;
  emailCandidateReport: Scalars['Boolean']['output'];
  enableCompanyCodingAssessments: Scalars['Boolean']['output'];
  generateCandidateReport: Scalars['Boolean']['output'];
  generateManagerReport: Scalars['Boolean']['output'];
  hideReports: Scalars['Boolean']['output'];
  hiringProcessTemplatesCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAiInterviewEnabled: Scalars['Boolean']['output'];
  isAlternativeSupportEmailEnabled: Scalars['Boolean']['output'];
  isApplicationAnswerEvidenceEnabled: Scalars['Boolean']['output'];
  isAssigneeManagedViaIntegration: Scalars['Boolean']['output'];
  isAtsIntegrated: Scalars['Boolean']['output'];
  isAtsProgressionEnabled: Scalars['Boolean']['output'];
  isAtsRoleCreationWithRequisitionEnabled: Scalars['Boolean']['output'];
  isAtsRoleCreationWithoutRequisitionEnabled: Scalars['Boolean']['output'];
  isConsentCaptureEnabled: Scalars['Boolean']['output'];
  isHiringTeamMemberAddedEmailEnabled: Scalars['Boolean']['output'];
  isIntegrityMonitoringAiInterviewDefaultEnabled: Scalars['Boolean']['output'];
  isIntegrityMonitoringAssessmentDefaultEnabled: Scalars['Boolean']['output'];
  isIntegrityMonitoringAvailable: Scalars['Boolean']['output'];
  isInterviewGuideConfirmationEnabled: Scalars['Boolean']['output'];
  isInterviewGuideScoresEnabled: Scalars['Boolean']['output'];
  isLegalAcknowledgementsEnabled: Scalars['Boolean']['output'];
  isLiveChatEnabled: Scalars['Boolean']['output'];
  isPersonalityTestMandatory: Scalars['Boolean']['output'];
  isRoleLiveEmailEnabled: Scalars['Boolean']['output'];
  isRoleRequirementsEnabled: Scalars['Boolean']['output'];
  isSchedulingEnabled: Scalars['Boolean']['output'];
  isShortlistingEnabled: Scalars['Boolean']['output'];
  isSkillsEvaluationScoreEnabled: Scalars['Boolean']['output'];
  isViewGuidanceEnabled: Scalars['Boolean']['output'];
  isWhitelabelingEnabled: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  managerReport?: Maybe<Report>;
  name: Scalars['String']['output'];
  projectTeamEmailSettings: ProjectTeamEmailSettings;
  reasonableAdjustmentsOption: ReasonableAdjustmentsOption;
  rfuModelType: CompanyRfuModelType;
  skillsProfileTemplatesCount: Scalars['Int']['output'];
  supportEmail: Scalars['String']['output'];
  usesBehaviouralLabel: Scalars['Boolean']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Access levels for company users */
export enum CompanyAccessLevel {
  FullAccess = 'FULL_ACCESS',
  LimitedAccess = 'LIMITED_ACCESS',
  StandardAccess = 'STANDARD_ACCESS'
}

export type CompanyBranding = {
  __typename?: 'CompanyBranding';
  accentColor1?: Maybe<Scalars['String']['output']>;
  accentColor2?: Maybe<Scalars['String']['output']>;
  careersLinkUrl?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  signInBackgroundUrl?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  websiteLinkUrl?: Maybe<Scalars['String']['output']>;
};

export type CompanyDefaultReports = {
  __typename?: 'CompanyDefaultReports';
  candidateReport: Report;
  managerReport: Report;
};

export type CompanyEmployeeFileUploadArgs = {
  companyId: Scalars['Int']['input'];
};

export type CompanyEmployeeFileUploadLineModel = {
  __typename?: 'CompanyEmployeeFileUploadLineModel';
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hrManagerEmployeeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  szUserId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CompanyEmployeeFileUploadModel = {
  __typename?: 'CompanyEmployeeFileUploadModel';
  apply: Scalars['Boolean']['output'];
  companyId: Scalars['Int']['output'];
  creates?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  deletes?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  noChanges?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
  updates?: Maybe<Array<CompanyEmployeeFileUploadLineModel>>;
};

export type CompanyEmployeeModel = {
  __typename?: 'CompanyEmployeeModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employeeId: Scalars['String']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName: Scalars['String']['output'];
  hrManagerEmployeeId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  szUserId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type CompanyEmployeeModelPaginated = {
  __typename?: 'CompanyEmployeeModelPaginated';
  data?: Maybe<Array<CompanyEmployeeModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type CompanyEmployeeOrderByArgs = {
  email?: InputMaybe<OrderByArgs>;
  employeeId?: InputMaybe<OrderByArgs>;
  endDate?: InputMaybe<OrderByArgs>;
  firstName?: InputMaybe<OrderByArgs>;
  lastName?: InputMaybe<OrderByArgs>;
  startDate?: InputMaybe<OrderByArgs>;
  szUserId?: InputMaybe<OrderByArgs>;
};

export type CompanyEmployeeSelectField = Field & {
  __typename?: 'CompanyEmployeeSelectField';
  dynamicSelectOptions?: Maybe<Scalars['String']['output']>;
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isFreetextField?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export enum CompanyLifecycle {
  Churned = 'CHURNED',
  Demo = 'DEMO',
  Internal = 'INTERNAL',
  Live = 'LIVE',
  Poc = 'POC'
}

export type CompanyMaybeUserEmployeeModel = {
  __typename?: 'CompanyMaybeUserEmployeeModel';
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  isCompanyEmployee: Scalars['Boolean']['output'];
  isUser: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type CompanyMeetingConfigurationModel = {
  __typename?: 'CompanyMeetingConfigurationModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<MeetingMetadataModel>;
  updatedAt: Scalars['Date']['output'];
};

export type CompanyProjects = {
  __typename?: 'CompanyProjects';
  company: Company;
  id: Scalars['Int']['output'];
  numberOfCompletedInTimeFrameStageCandidates: Scalars['Int']['output'];
  numberOfStageCandidates: Scalars['Int']['output'];
  percentageOfCompletedStageCandidates: Scalars['Float']['output'];
  projects: Array<ProjectWithStageCandidates>;
};

export enum CompanyRfuModelType {
  BehaviourBased = 'BEHAVIOUR_BASED',
  ValueBased = 'VALUE_BASED'
}

export type CompanyRole = {
  __typename?: 'CompanyRole';
  companyId: Scalars['Int']['output'];
  companyUuid: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPasswordDisabled?: Maybe<Scalars['Boolean']['output']>;
  role: Role;
  roleId: Scalars['Int']['output'];
  samlAuthInfos?: Maybe<Array<SamlAuthInfoModel>>;
  twoFactorEnabled: Scalars['Boolean']['output'];
};

/** Everything that replaces one company's scheduling preferences */
export type CompanySchedulingSettingsInput = {
  /** How many minutes before an interview starts a candidate may still cancel or reschedule it. Omit to keep the stored value */
  candidateActionCutoffMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the Spotted Zebra note taker joins new interviews by default */
  includeSpot: Scalars['Boolean']['input'];
  /** How long a new interview runs, in minutes */
  interviewDurationMinutes: Scalars['Int']['input'];
  /** How long a new candidate booking link stays valid for */
  linkExpiryDays: SchedulingLinkExpiryDays;
  /** The IANA timezone name the working hours are read in; a UTC offset is refused */
  timezone: Scalars['String']['input'];
  workingHours: CompanyWorkingHoursInput;
};

/** One company's scheduling preferences */
export type CompanySchedulingSettingsModel = {
  __typename?: 'CompanySchedulingSettingsModel';
  /** How many minutes before an interview starts a candidate may still cancel or reschedule it */
  candidateActionCutoffMinutes: Scalars['Int']['output'];
  /** Whether the Spotted Zebra note taker joins new interviews by default */
  includeSpot: Scalars['Boolean']['output'];
  /** How long a new interview runs, in minutes */
  interviewDurationMinutes: Scalars['Int']['output'];
  /** How long a new candidate booking link stays valid for */
  linkExpiryDays: SchedulingLinkExpiryDays;
  /** The IANA timezone name the working hours are read in */
  timezone: Scalars['String']['output'];
  workingHours: CompanyWorkingHoursModel;
};

export type CompanySettingChangeModel = {
  __typename?: 'CompanySettingChangeModel';
  changedByDisplay?: Maybe<Scalars['String']['output']>;
  changedById?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  mutationName: Scalars['String']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  oldValue?: Maybe<Scalars['String']['output']>;
  setting: Scalars['String']['output'];
  source: CompanySettingChangeSource;
};

export type CompanySettingChangeOrderArgs = {
  direction?: SortOption;
  field?: CompanySettingChangeOrderField;
};

export enum CompanySettingChangeOrderField {
  ChangedBy = 'CHANGED_BY',
  OccurredAt = 'OCCURRED_AT',
  Setting = 'SETTING'
}

export enum CompanySettingChangeSource {
  AtsIntegration = 'ATS_INTEGRATION',
  Company = 'COMPANY'
}

export type CompanySignatureModel = {
  __typename?: 'CompanySignatureModel';
  company?: Maybe<Company>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  signature: Scalars['String']['output'];
  signatureEmail: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CompanyUser = {
  __typename?: 'CompanyUser';
  /** User's current access level for this workspace */
  accessLevel?: Maybe<IdentityPermissionRole>;
  /** Timestamp when the user was first added to this workspace (company role created_at) */
  addedAt?: Maybe<Scalars['DateTime']['output']>;
  group?: Maybe<UserGroupModel>;
  /** True if user has logged in (accepted invitation), false if still pending. Derived from user.password IS NOT NULL. */
  hasAcceptedInvitation?: Maybe<Scalars['Boolean']['output']>;
  inProjectTeam?: Maybe<AssignmentStatus>;
  inStageCandidate?: Maybe<AssignmentStatus>;
  inUserGroup?: Maybe<AssignmentStatus>;
  /** Timestamp of user's last access to this workspace */
  lastAccessedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type CompanyUserInfo = {
  __typename?: 'CompanyUserInfo';
  company: Company;
  companyUserAcrossAllRoles: CompanyUsersCount;
  companyUserAcrossEachRole: Array<CompanyUsersWithRolesCount>;
};

export type CompanyUserInfoPaginated = {
  __typename?: 'CompanyUserInfoPaginated';
  companyUserInfo: Array<CompanyUserInfo>;
  total: Scalars['Int']['output'];
};

export type CompanyUserModelPaginated = {
  __typename?: 'CompanyUserModelPaginated';
  data?: Maybe<Array<CompanyUser>>;
  pageInfo?: Maybe<Pageinfo>;
};

export enum CompanyUserType {
  Group = 'GROUP',
  User = 'USER'
}

export type CompanyUsersArgs = {
  /** Filter users by access level(s). Returns users matching any of the specified levels. */
  accessLevels?: InputMaybe<Array<CompanyAccessLevel>>;
  /** The company id */
  companyId: Scalars['Int']['input'];
  /** Exclude specific users from results by email or user ID. */
  exclude?: InputMaybe<CompanyUsersExcludeFilter>;
  membersPreviewCount?: InputMaybe<Scalars['Int']['input']>;
  /** Optional project id for filtering */
  projectId?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Optional stage candidate id for filtering */
  stageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  /** Optional user group id for filtering */
  userGroupId?: InputMaybe<Scalars['Int']['input']>;
  userType?: InputMaybe<CompanyUserType>;
};

export type CompanyUsersCount = {
  __typename?: 'CompanyUsersCount';
  companyId: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  totalUsersWithPassword: Scalars['Int']['output'];
};

export type CompanyUsersExcludeFilter = {
  /** Emails of users to exclude from results */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IDs of users to exclude from results */
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Fields available for sorting company users */
export enum CompanyUsersOrderField {
  AccessLevel = 'ACCESS_LEVEL',
  AddedAt = 'ADDED_AT',
  Email = 'EMAIL',
  LastAccessedAt = 'LAST_ACCESSED_AT',
  Name = 'NAME'
}

export type CompanyUsersOrderOptions = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<CompanyUsersOrderField>;
};

export type CompanyUsersWithRolesCount = {
  __typename?: 'CompanyUsersWithRolesCount';
  companyId: Scalars['Int']['output'];
  roleName: IdentityPermissionRole;
  totalUsers: Scalars['Int']['output'];
  totalUsersWithPassword: Scalars['Int']['output'];
};

/** The working day interview slots are offered in, in the company's timezone */
export type CompanyWorkingHoursInput = {
  /** Wall-clock end of the day, as HH:mm */
  end: Scalars['String']['input'];
  /** Wall-clock start of the day, as HH:mm */
  start: Scalars['String']['input'];
};

/** The working day interview slots are offered in, in the company's timezone */
export type CompanyWorkingHoursModel = {
  __typename?: 'CompanyWorkingHoursModel';
  /** Wall-clock end of the day, as HH:mm */
  end: Scalars['String']['output'];
  /** Wall-clock start of the day, as HH:mm */
  start: Scalars['String']['output'];
};

export type Conference = {
  __typename?: 'Conference';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['Int']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Grammatical form chosen by the candidate for gendered locales; null for other locales. */
  grammaticalGender?: Maybe<GrammaticalGender>;
  id: Scalars['ID']['output'];
  livekitConfig: LivekitConfig;
  /** Locale chosen by the candidate when joining (CR-224). */
  locale?: Maybe<SupportedLocale>;
  recording?: Maybe<RecordingInfo>;
  /** Number of demo sessions remaining for this conference */
  remainingDemoCount: Scalars['Int']['output'];
  transcript: ConferenceTranscript;
  updatedAt: Scalars['DateTime']['output'];
};

export type ConferenceToken = {
  __typename?: 'ConferenceToken';
  token: Scalars['String']['output'];
};

export type ConferenceTranscript = {
  __typename?: 'ConferenceTranscript';
  utterances: Array<TranscriptUtterance>;
};

export enum ContentClassification {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export enum ContentRoleLevel {
  Apprentice = 'APPRENTICE',
  IndividualContributor = 'INDIVIDUAL_CONTRIBUTOR',
  Leader = 'LEADER',
  Manager = 'MANAGER',
  ManagerOfManagers = 'MANAGER_OF_MANAGERS',
  TechnicalExpert = 'TECHNICAL_EXPERT'
}

export type ContentStageBlockInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  kind: ContentStageBlockKind;
  paragraph?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum ContentStageBlockKind {
  Image = 'IMAGE',
  Text = 'TEXT',
  Video = 'VIDEO'
}

export type ContentStageBlockModel = {
  __typename?: 'ContentStageBlockModel';
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: ContentStageBlockKind;
  paragraph?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};

export type ContentStageCandidateModel = {
  __typename?: 'ContentStageCandidateModel';
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  kind: GenericStageKind;
  projectCandidate: ProjectCandidate;
  projectCandidateId: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
  status: ContentStageCandidateStatus;
  subId: Scalars['ID']['output'];
};

export enum ContentStageCandidateStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED'
}

export type ContentStageModel = {
  __typename?: 'ContentStageModel';
  blocks: Array<ContentStageBlockModel>;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  estimatedDurationMinutes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  kind: GenericStageKind;
  name: Scalars['String']['output'];
  project: Project;
  projectId: Scalars['Int']['output'];
  subId: Scalars['ID']['output'];
};

export type ContentValidatiorPieceModel = {
  __typename?: 'ContentValidatiorPieceModel';
  numOfIqContent: Scalars['String']['output'];
  numOfSsContent: Scalars['String']['output'];
  numOfSsSpContent: Scalars['String']['output'];
  numOfTraitContent: Scalars['String']['output'];
  softSkillId?: Maybe<Scalars['Int']['output']>;
  softSkillName?: Maybe<Scalars['String']['output']>;
  traitId?: Maybe<Scalars['Int']['output']>;
  traitName?: Maybe<Scalars['String']['output']>;
};

export type ContentValidator = {
  __typename?: 'ContentValidator';
  content: Array<ContentValidatiorPieceModel>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type ContentViewerViewStageCandidateManagerReportModel = {
  __typename?: 'ContentViewerViewStageCandidateManagerReportModel';
  pollingStatus?: Maybe<PollingStatus>;
  pollingStatusMessage?: Maybe<Scalars['String']['output']>;
  pollingSubStatus?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentViewerViewStageCandidateProjectJobRoleModel = {
  __typename?: 'ContentViewerViewStageCandidateProjectJobRoleModel';
  id: Scalars['Int']['output'];
  jobRoleId: Scalars['Int']['output'];
  jobRoleName: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  reports: Array<ContentViewerViewStageCandidateProjectJobRoleReportModel>;
  skillsProfileId: Scalars['Int']['output'];
};

export type ContentViewerViewStageCandidateProjectJobRoleReportModel = {
  __typename?: 'ContentViewerViewStageCandidateProjectJobRoleReportModel';
  subType?: Maybe<ReportSubType>;
  type: ReportType;
  url: Scalars['String']['output'];
};

export type ContentViewerViewStageCandidateReportModel = {
  __typename?: 'ContentViewerViewStageCandidateReportModel';
  pollingStatus?: Maybe<PollingStatus>;
  pollingStatusMessage?: Maybe<Scalars['String']['output']>;
  pollingSubStatus?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ContextualScorePositionType {
  Strength = 'STRENGTH',
  Weakness = 'WEAKNESS'
}

export type CreateFormFieldByFieldIdArgs = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  fieldId: Scalars['Int']['input'];
  isOptional: Scalars['Boolean']['input'];
};

export type CreateMeetingAttendeeArgs = {
  email: Scalars['String']['input'];
  isOrganiser: Scalars['Boolean']['input'];
  name?: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProjectManagerInput = {
  actorRole?: InputMaybe<ActorRole>;
  userId: Scalars['Int']['input'];
};

export enum DataSourceType {
  EmployeeAssessment = 'EMPLOYEE_ASSESSMENT',
  EmployeeSurvey = 'EMPLOYEE_SURVEY',
  Industry = 'INDUSTRY',
  JdReview = 'JD_REVIEW',
  ManagerSurvey = 'MANAGER_SURVEY'
}

export type DateField = Field & {
  __typename?: 'DateField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export type DateFilter = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Outcome of one scheduling dead-letter replay run: how many messages were requested, how many were actually republished, and how many remain on the dead-letter queue afterwards. */
export type DeadLetterReplayReport = {
  __typename?: 'DeadLetterReplayReport';
  /** The dead-letter queue ready depth after this run, via `channel.checkQueue` (excludes messages checked out but not yet acked or nacked). */
  remaining: Scalars['Int']['output'];
  /** The number of dead letters actually republished. */
  replayed: Scalars['Int']['output'];
  /** The requested replay limit for this run. */
  requested: Scalars['Int']['output'];
};

export enum DeiAgeRange {
  N18_30 = 'N18_30',
  N31_40 = 'N31_40',
  N41_50 = 'N41_50',
  N51_65 = 'N51_65',
  N65Plus = 'N65_PLUS',
  NLessthan_18 = 'N_LESSTHAN_18',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type DeiConsentEventModel = {
  __typename?: 'DeiConsentEventModel';
  actorUserId?: Maybe<Scalars['Int']['output']>;
  event: DeiConsentEventType;
  occurredAt: Scalars['Date']['output'];
};

export enum DeiConsentEventType {
  Declined = 'DECLINED',
  Given = 'GIVEN',
  Reopened = 'REOPENED',
  Revoked = 'REVOKED'
}

export enum DeiDisabilityIdentify {
  ChronicIllness = 'CHRONIC_ILLNESS',
  IntellectualDisability = 'INTELLECTUAL_DISABILITY',
  MentalHealthCondition = 'MENTAL_HEALTH_CONDITION',
  NeurodivergentCondition = 'NEURODIVERGENT_CONDITION',
  None = 'NONE',
  Other = 'OTHER',
  PhysicalImpairment = 'PHYSICAL_IMPAIRMENT',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  SensoryImpairment = 'SENSORY_IMPAIRMENT',
  SpeechImpairment = 'SPEECH_IMPAIRMENT'
}

export enum DeiEthnicity {
  Asian = 'ASIAN',
  Black = 'BLACK',
  Hispanic = 'HISPANIC',
  IndigenousPeoples = 'INDIGENOUS_PEOPLES',
  MiddleEasternNorthAfrican = 'MIDDLE_EASTERN_NORTH_AFRICAN',
  Mixed = 'MIXED',
  Other = 'OTHER',
  PacificIslander = 'PACIFIC_ISLANDER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  White = 'WHITE'
}

export enum DeiFreeSchoolMeals {
  No = 'NO',
  NotApplicable = 'NOT_APPLICABLE',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Yes = 'YES'
}

export enum DeiGender {
  Female = 'FEMALE',
  GenderQueer = 'GENDER_QUEER',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export enum DeiNeurodivergenceIdentify {
  Adhd = 'ADHD',
  Autism = 'AUTISM',
  Dyscalculia = 'DYSCALCULIA',
  Dyslexia = 'DYSLEXIA',
  Dyspraxia = 'DYSPRAXIA',
  None = 'NONE',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Tourette = 'TOURETTE'
}

export enum DeiReligiousBelief {
  Agnosticism = 'AGNOSTICISM',
  Buddhism = 'BUDDHISM',
  Christianity = 'CHRISTIANITY',
  Hinduism = 'HINDUISM',
  Islam = 'ISLAM',
  Judaism = 'JUDAISM',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Secular = 'SECULAR',
  Sikhism = 'SIKHISM',
  Spiritual = 'SPIRITUAL'
}

export enum DeiSexualOrientation {
  Asexual = 'ASEXUAL',
  Bisexual = 'BISEXUAL',
  Gay = 'GAY',
  Lesbian = 'LESBIAN',
  Other = 'OTHER',
  Pansexual = 'PANSEXUAL',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Queer = 'QUEER',
  Straight = 'STRAIGHT'
}

export type DeiStageActionCandidateModel = {
  __typename?: 'DeiStageActionCandidateModel';
  consentEvents: Array<DeiConsentEventModel>;
  createdAt: Scalars['Date']['output'];
  hasActiveConsent: Scalars['Boolean']['output'];
  pastResponses?: Maybe<DeiStageActionCandidateResponsesModel>;
  responses: DeiStageActionCandidateResponsesModel;
  stageAction: DeiStageActionModel;
  stageCandidate: SmStageCandidateModel;
  status: DeiStageActionCandidateStatus;
  updatedAt: Scalars['Date']['output'];
};

export type DeiStageActionCandidateResponsesInput = {
  ageRange?: InputMaybe<DeiAgeRange>;
  disabilityIdentify?: InputMaybe<Array<DeiDisabilityIdentify>>;
  disabilityIdentifyOther?: InputMaybe<Scalars['String']['input']>;
  ethnicity?: InputMaybe<DeiEthnicity>;
  freeSchoolMeals?: InputMaybe<DeiFreeSchoolMeals>;
  genderIdentity?: InputMaybe<DeiGender>;
  hasDisability?: InputMaybe<DeiYesNo>;
  hasNeurodiversity?: InputMaybe<DeiYesNo>;
  hasTransgenderIdentity?: InputMaybe<DeiYesNo>;
  neurodivergenceIdentify?: InputMaybe<Array<DeiNeurodivergenceIdentify>>;
  neurodivergenceIdentifyOther?: InputMaybe<Scalars['String']['input']>;
  religiousBelief?: InputMaybe<DeiReligiousBelief>;
  sexualOrientation?: InputMaybe<DeiSexualOrientation>;
};

export type DeiStageActionCandidateResponsesModel = {
  __typename?: 'DeiStageActionCandidateResponsesModel';
  ageRange?: Maybe<DeiAgeRange>;
  disabilityIdentify?: Maybe<Array<DeiDisabilityIdentify>>;
  disabilityIdentifyOther?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<DeiEthnicity>;
  freeSchoolMeals?: Maybe<DeiFreeSchoolMeals>;
  genderIdentity?: Maybe<DeiGender>;
  hasDisability?: Maybe<DeiYesNo>;
  hasNeurodiversity?: Maybe<DeiYesNo>;
  hasTransgenderIdentity?: Maybe<DeiYesNo>;
  neurodivergenceIdentify?: Maybe<Array<DeiNeurodivergenceIdentify>>;
  neurodivergenceIdentifyOther?: Maybe<Scalars['String']['output']>;
  religiousBelief?: Maybe<DeiReligiousBelief>;
  sexualOrientation?: Maybe<DeiSexualOrientation>;
};

export enum DeiStageActionCandidateStatus {
  Declined = 'DECLINED',
  Editable = 'EDITABLE',
  Submitted = 'SUBMITTED'
}

export type DeiStageActionFieldsInput = {
  hasAgeRangeField: Scalars['Boolean']['input'];
  hasDisabilityField: Scalars['Boolean']['input'];
  hasDisabilityIdentifyField: Scalars['Boolean']['input'];
  hasEthnicityField: Scalars['Boolean']['input'];
  hasFreeSchoolMealsField: Scalars['Boolean']['input'];
  hasGenderIdentityField: Scalars['Boolean']['input'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean']['input'];
  hasNeurodiversityField: Scalars['Boolean']['input'];
  hasReligiousBeliefsField: Scalars['Boolean']['input'];
  hasSexualOrientationField: Scalars['Boolean']['input'];
};

export type DeiStageActionFieldsModel = {
  __typename?: 'DeiStageActionFieldsModel';
  hasAgeRangeField: Scalars['Boolean']['output'];
  hasDisabilityField: Scalars['Boolean']['output'];
  hasDisabilityIdentifyField: Scalars['Boolean']['output'];
  hasEthnicityField: Scalars['Boolean']['output'];
  hasFreeSchoolMealsField: Scalars['Boolean']['output'];
  hasGenderIdentityField: Scalars['Boolean']['output'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean']['output'];
  hasNeurodiversityField: Scalars['Boolean']['output'];
  hasReligiousBeliefsField: Scalars['Boolean']['output'];
  hasSexualOrientationField: Scalars['Boolean']['output'];
};

export type DeiStageActionModel = {
  __typename?: 'DeiStageActionModel';
  completedCount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fields: DeiStageActionFieldsModel;
  stageId: Scalars['Int']['output'];
  submittedCount: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type DeiStageActionTemplateFieldsInput = {
  hasAgeRangeField: Scalars['Boolean']['input'];
  hasDisabilityField: Scalars['Boolean']['input'];
  hasDisabilityIdentifyField: Scalars['Boolean']['input'];
  hasEthnicityField: Scalars['Boolean']['input'];
  hasFreeSchoolMealsField: Scalars['Boolean']['input'];
  hasGenderIdentityField: Scalars['Boolean']['input'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean']['input'];
  hasNeurodiversityField: Scalars['Boolean']['input'];
  hasReligiousBeliefsField: Scalars['Boolean']['input'];
  hasSexualOrientationField: Scalars['Boolean']['input'];
};

export type DeiStageActionTemplateFieldsModel = {
  __typename?: 'DeiStageActionTemplateFieldsModel';
  hasAgeRangeField: Scalars['Boolean']['output'];
  hasDisabilityField: Scalars['Boolean']['output'];
  hasDisabilityIdentifyField: Scalars['Boolean']['output'];
  hasEthnicityField: Scalars['Boolean']['output'];
  hasFreeSchoolMealsField: Scalars['Boolean']['output'];
  hasGenderIdentityField: Scalars['Boolean']['output'];
  hasNeurodivergenceIdentifyField: Scalars['Boolean']['output'];
  hasNeurodiversityField: Scalars['Boolean']['output'];
  hasReligiousBeliefsField: Scalars['Boolean']['output'];
  hasSexualOrientationField: Scalars['Boolean']['output'];
};

export type DeiStageActionTemplateModel = {
  __typename?: 'DeiStageActionTemplateModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  fields: DeiStageActionTemplateFieldsModel;
  updatedAt: Scalars['Date']['output'];
};

export enum DeiYesNo {
  No = 'NO',
  PreferNotToSay = 'PREFER_NOT_TO_SAY',
  Yes = 'YES'
}

export type DeleteByIdArgs = {
  id: Scalars['Int']['input'];
};

export type DeleteFormFieldByFieldIdArgs = {
  fieldId: Scalars['Int']['input'];
};

export type DeleteResult = {
  __typename?: 'DeleteResult';
  affected?: Maybe<Scalars['Int']['output']>;
};

export type DeleteResultModel = {
  __typename?: 'DeleteResultModel';
  affected?: Maybe<Scalars['Int']['output']>;
};

export type DemoConferenceToken = {
  __typename?: 'DemoConferenceToken';
  /** Number of demo sessions remaining for this conference */
  remainingDemos: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

export type DirectAccessInfo = {
  __typename?: 'DirectAccessInfo';
  actorRole?: Maybe<ActorRole>;
  hasAccess: Scalars['Boolean']['output'];
};

export type DispatchEligibilityInviteForShortlistStageCandidateResultModel = {
  __typename?: 'DispatchEligibilityInviteForShortlistStageCandidateResultModel';
  /** One of: `SENT`, `SKIPPED_PORTAL_DISABLED`, `SKIPPED_NO_QUESTIONNAIRE`, `SKIPPED_NOT_ON_STAGE`, `SKIPPED_ALREADY_INVITED`. The SKIPPED_* outcomes are deliberate no-sends; a dispatch failure surfaces as a GraphQL error instead and releases the idempotency claim, so the call is safe to repeat. */
  outcome: Scalars['String']['output'];
  /** True when the eligibility-questions invite email was sent. */
  sent: Scalars['Boolean']['output'];
  /** The shortlist stage candidate subId that was processed. */
  shortlistStageCandidateSubId: Scalars['String']['output'];
};

export enum DisplayScoreType {
  Grade = 'GRADE',
  None = 'NONE',
  Percentile = 'PERCENTILE',
  StenScore = 'STEN_SCORE',
  ZScore = 'Z_SCORE'
}

export type DlxRejectedEvent = {
  __typename?: 'DlxRejectedEvent';
  createdAt: Scalars['String']['output'];
  deathQueue: Scalars['String']['output'];
  deletedAt: Scalars['String']['output'];
  event: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rejectedCount: Scalars['Int']['output'];
  rejectedStatus: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type DuplicateBlueprintGroup = {
  __typename?: 'DuplicateBlueprintGroup';
  /** Assessment Stage ID (null for interview stage blueprints) */
  assessmentStageId?: Maybe<Scalars['Int']['output']>;
  /** The blueprint that will be kept (has best generation status) */
  blueprintToKeep: DuplicateBlueprintInfo;
  /** All blueprints in this duplicate group */
  blueprints: Array<DuplicateBlueprintInfo>;
  /** Blueprints that will be soft-deleted */
  blueprintsToDelete: Array<DuplicateBlueprintInfo>;
  /** Interview Stage ID (null for assessment stage blueprints) */
  interviewStageId?: Maybe<Scalars['Int']['output']>;
  /** Project Job Role ID */
  projectJobRoleId: Scalars['Int']['output'];
};

export type DuplicateBlueprintInfo = {
  __typename?: 'DuplicateBlueprintInfo';
  /** Assessment Stage ID (null for interview stage blueprints) */
  assessmentStageId?: Maybe<Scalars['Int']['output']>;
  /** When the blueprint was created */
  createdAt: Scalars['DateTime']['output'];
  /** Generation status of the blueprint */
  generationStatus: Scalars['String']['output'];
  /** Blueprint ID */
  id: Scalars['Int']['output'];
  /** Interview Stage ID (null for assessment stage blueprints) */
  interviewStageId?: Maybe<Scalars['Int']['output']>;
  /** Whether this blueprint is part of a valid version chain (has previousVersionId pointing to existing blueprint) */
  isPartOfChain: Scalars['Boolean']['output'];
  /** Job role name */
  jobRoleName?: Maybe<Scalars['String']['output']>;
  /** ID of the next version in the chain (null if head/latest) */
  nextVersionId?: Maybe<Scalars['Int']['output']>;
  /** ID of the previous version in the chain (null if first version) */
  previousVersionId?: Maybe<Scalars['Int']['output']>;
  /** Status of the previous version if exists (DRAFT, PUBLISHED, ARCHIVED) */
  previousVersionStatus?: Maybe<Scalars['String']['output']>;
  /** Project Job Role ID */
  projectJobRoleId: Scalars['Int']['output'];
  /** Project name */
  projectName?: Maybe<Scalars['String']['output']>;
  /** Stage name */
  stageName?: Maybe<Scalars['String']['output']>;
  /** Blueprint status (DRAFT, PUBLISHED, ARCHIVED) */
  status: Scalars['String']['output'];
  /** Blueprint SubID (UUID) */
  subId: Scalars['String']['output'];
  /** Version number of the blueprint */
  version: Scalars['Int']['output'];
  /** Whether this blueprint will be deleted in the cleanup */
  willBeDeleted: Scalars['Boolean']['output'];
};

export type DurationArgs = {
  unit: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type DurationModel = {
  __typename?: 'DurationModel';
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type EditingInfoModel = {
  __typename?: 'EditingInfoModel';
  editingStartedAt: Scalars['Date']['output'];
  editingUserId: Scalars['Float']['output'];
};

export type EditingResultModel = {
  __typename?: 'EditingResultModel';
  editingInfo?: Maybe<EditingInfoModel>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type EmploymentGap = {
  __typename?: 'EmploymentGap';
  from: Scalars['String']['output'];
  months: Scalars['Int']['output'];
  to: Scalars['String']['output'];
};

export type EnglishProficiencyAnswerOption = {
  __typename?: 'EnglishProficiencyAnswerOption';
  index: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type EnglishProficiencyAssessment = {
  __typename?: 'EnglishProficiencyAssessment';
  id: Scalars['ID']['output'];
  questions: Array<EnglishProficiencyQuestion>;
  remainingSeconds: Scalars['Int']['output'];
  responses: Array<EnglishProficiencyResponse>;
  submittedAt?: Maybe<Scalars['Date']['output']>;
};

export type EnglishProficiencyAssessmentStageAction = {
  __typename?: 'EnglishProficiencyAssessmentStageAction';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  requiredCefrLevel: CefrLevel;
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type EnglishProficiencyAssessmentStageActionCandidate = {
  __typename?: 'EnglishProficiencyAssessmentStageActionCandidate';
  action: EnglishProficiencyAssessmentStageActionNested;
  assessmentId?: Maybe<Scalars['String']['output']>;
  cefrLevel?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  hasPassed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  rawScore?: Maybe<Scalars['Int']['output']>;
  responses: Array<EnglishProficiencyReportResponse>;
  stageCandidate: SmStageCandidateModel;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: EnglishProficiencyAssessmentStageActionCandidateStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum EnglishProficiencyAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type EnglishProficiencyAssessmentStageActionNested = {
  __typename?: 'EnglishProficiencyAssessmentStageActionNested';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  requiredCefrLevel: CefrLevel;
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type EnglishProficiencyAsset = {
  __typename?: 'EnglishProficiencyAsset';
  kind: EnglishProficiencyAssetKind;
  url: Scalars['String']['output'];
};

export enum EnglishProficiencyAssetKind {
  Audio = 'AUDIO',
  Image = 'IMAGE'
}

export type EnglishProficiencyMultipleChoiceQuestion = EnglishProficiencyQuestion & {
  __typename?: 'EnglishProficiencyMultipleChoiceQuestion';
  answers: Array<EnglishProficiencyAnswerOption>;
  asset?: Maybe<EnglishProficiencyAsset>;
  category: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  kind: EnglishProficiencyQuestionKind;
  passage?: Maybe<EnglishProficiencyPassage>;
  tags: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type EnglishProficiencyPassage = {
  __typename?: 'EnglishProficiencyPassage';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type EnglishProficiencyQuestion = {
  asset?: Maybe<EnglishProficiencyAsset>;
  category: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  kind: EnglishProficiencyQuestionKind;
  passage?: Maybe<EnglishProficiencyPassage>;
  tags: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export enum EnglishProficiencyQuestionKind {
  MultipleChoice = 'MULTIPLE_CHOICE',
  ShortAnswer = 'SHORT_ANSWER'
}

export type EnglishProficiencyReportResponse = {
  __typename?: 'EnglishProficiencyReportResponse';
  blankAnswers?: Maybe<Array<Scalars['String']['output']>>;
  category: Scalars['String']['output'];
  isCorrect: Scalars['Boolean']['output'];
  questionIndex: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  selectedAnswerText?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type EnglishProficiencyResponse = {
  __typename?: 'EnglishProficiencyResponse';
  blankAnswers?: Maybe<Array<Scalars['String']['output']>>;
  questionIndex: Scalars['Int']['output'];
  selectedAnswerIndex?: Maybe<Scalars['Int']['output']>;
  selectedAnswerText?: Maybe<Scalars['String']['output']>;
};

export type EnglishProficiencySavedResponse = {
  __typename?: 'EnglishProficiencySavedResponse';
  remainingSeconds: Scalars['Int']['output'];
  saved: Scalars['Boolean']['output'];
};

export type EnglishProficiencyShortAnswerQuestion = EnglishProficiencyQuestion & {
  __typename?: 'EnglishProficiencyShortAnswerQuestion';
  asset?: Maybe<EnglishProficiencyAsset>;
  blankCount: Scalars['Int']['output'];
  category: Scalars['String']['output'];
  clue: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  kind: EnglishProficiencyQuestionKind;
  passage?: Maybe<EnglishProficiencyPassage>;
  tags: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type EnsureIscResultModel = {
  __typename?: 'EnsureIscResultModel';
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** Number of required (Stage, Candidate) pairs that already existed. */
  existingIscCount: Scalars['Int']['output'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean']['output'];
  /** Number of missing (Stage, Candidate) pairs that were actually created (0 in dry-run). */
  iscsCreatedCount: Scalars['Int']['output'];
  /** Number of (Stage, Candidate) pairs that were identified as missing. */
  iscsToCreateCount: Scalars['Int']['output'];
  /** Number of unique, active projects processed. */
  processedProjectCount: Scalars['Int']['output'];
  /** Array of unique IDs of the active projects processed. */
  processedProjectIds: Array<Scalars['Int']['output']>;
  /** Total number of active interview stages processed within the relevant projects. */
  processedStageCount: Scalars['Int']['output'];
  /** Number of unique project candidates associated with the processed projects. */
  relevantCandidateCount: Scalars['Int']['output'];
  /** Total number of (Stage, Candidate) pairs that should exist for processed stages/candidates. */
  requiredIscPairCount: Scalars['Int']['output'];
};

export type EntityLanguageModel = {
  __typename?: 'EntityLanguageModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  entityId: Scalars['Int']['output'];
  entityType: EntityType;
  id: Scalars['Int']['output'];
  language: Language;
  updatedAt: Scalars['Date']['output'];
};

export enum EntityType {
  Project = 'PROJECT'
}

/** Summary of evaluation results including RSP skill count and category-level scores */
export type EvaluationResultsSummaryModel = {
  __typename?: 'EvaluationResultsSummaryModel';
  /** Average scores grouped by skill category */
  categoryScores: Array<CategoryScoreModel>;
  /** Total number of unique skills from evaluations using the RSP */
  totalSkillsInRsp: Scalars['Int']['output'];
};

/** Candidate feedback summary submitted by an evaluator */
export type EvaluatorCandidateFeedbackModel = {
  __typename?: 'EvaluatorCandidateFeedbackModel';
  /** Feedback text content (HTML) */
  content: Scalars['String']['output'];
  status: InterviewCandidateFeedbackStatus;
};

/** Individual evaluator info and their evaluation status */
export type EvaluatorResultModel = {
  __typename?: 'EvaluatorResultModel';
  /** Candidate feedback submitted by this evaluator. Null if the evaluator skipped or did not submit feedback. */
  candidateFeedback?: Maybe<EvaluatorCandidateFeedbackModel>;
  /** InterviewEvaluation UUID */
  evaluationId: Scalars['String']['output'];
  /** InterviewEvaluator UUID */
  evaluatorId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** Recommended hiring decision. Null if not yet decided. */
  recommendedDecision?: Maybe<InterviewRecommendedDecision>;
  /** Evaluation status for this role (PENDING, COMPLETED, or SKIPPED) */
  status: InterviewEvaluationStatus;
  /** When the evaluation was submitted or skipped. Null while PENDING. */
  statusChangedAt?: Maybe<Scalars['Date']['output']>;
  /** User ID of the evaluator */
  userId: Scalars['Int']['output'];
};

/** Individual evaluator's score for a specific skill */
export type EvaluatorSkillScoreModel = {
  __typename?: 'EvaluatorSkillScoreModel';
  /** InterviewEvaluation UUID */
  evaluationId: Scalars['String']['output'];
  /** InterviewEvaluator UUID */
  evaluatorId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /** Whether this score was generated by AI */
  isAIScored: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  /** Score given by this evaluator (0-100) */
  score: Scalars['Int']['output'];
  /** User ID of the evaluator */
  userId: Scalars['Int']['output'];
};

export type ExperienceSummaryEntry = {
  __typename?: 'ExperienceSummaryEntry';
  company: Scalars['String']['output'];
  directReports?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  teamSize?: Maybe<Scalars['Int']['output']>;
  tenureMonths?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type ExternalAssessmentCodeScoreModel = {
  __typename?: 'ExternalAssessmentCodeScoreModel';
  /** Candidates coding challenge score from the raw platform data in percentage (if available) */
  codeScorePercentage: Scalars['Float']['output'];
  /** Platform type where this assessment was taken */
  externalPlatformType: ExternalPlatformType;
  /** Name of the assessment candidate took */
  name: Scalars['String']['output'];
  /** Report URL with the detailed results of the assessment (if platform supports it) */
  reportUrl: Scalars['String']['output'];
  /** Amount of time the candidate took to complete the challenge based on the data from the platform (if available) */
  timeTakenMinutes: Scalars['Int']['output'];
};

export type ExternalAssessmentFinalScoreModel = {
  __typename?: 'ExternalAssessmentFinalScoreModel';
  /** Platform type where this assessment was taken */
  externalPlatformType: ExternalPlatformType;
  /** Candidates final score from the raw platform data in percentage */
  finalScorePercentage: Scalars['Float']['output'];
  /** Name of the assessment candidate took */
  name: Scalars['String']['output'];
  /** Report URL with the detailed results of the assessment (if platform supports it) */
  reportUrl: Scalars['String']['output'];
  /** Amount of time the candidate took to complete the challenge based on the data from the platform (if available) */
  timeTakenMinutes: Scalars['Int']['output'];
};

export type ExternalAssessmentMcqScoreModel = {
  __typename?: 'ExternalAssessmentMcqScoreModel';
  /** Platform type where this assessment was taken */
  externalPlatformType: ExternalPlatformType;
  /** Candidates multi-choice questions score from the raw platform data in percentage (if available) */
  mcqScorePercentage: Scalars['Float']['output'];
  /** Name of the assessment candidate took */
  name: Scalars['String']['output'];
  /** Report URL with the detailed results of the assessment (if platform supports it) */
  reportUrl: Scalars['String']['output'];
  /** Amount of time the candidate took to complete the challenge based on the data from the platform (if available) */
  timeTakenMinutes: Scalars['Int']['output'];
};

export enum ExternalPlatformType {
  Coderbyte = 'CODERBYTE'
}

/** A wall-clock working window in an IANA zone */
export type FallbackWorkingWindowModel = {
  __typename?: 'FallbackWorkingWindowModel';
  /** Wall-clock end of the day, as HH:mm */
  end: Scalars['String']['output'];
  /** Wall-clock start of the day, as HH:mm */
  start: Scalars['String']['output'];
  /** The IANA zone the window is read in */
  timezone: Scalars['String']['output'];
};

export type Field = {
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export enum FieldInstanceType {
  /** Multiple - Information is not shared between forms */
  Multiple = 'MULTIPLE',
  /** Singleton - All forms share the same information */
  Singleton = 'SINGLETON'
}

export enum FieldOwnerType {
  CompanyFieldOwner = 'COMPANY_FIELD_OWNER',
  SzFieldOwner = 'SZ_FIELD_OWNER'
}

export type FieldSettingsArgs = {
  allowFreeText?: InputMaybe<Scalars['Boolean']['input']>;
  searchable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldSettingsModel = {
  __typename?: 'FieldSettingsModel';
  allowFreeText?: Maybe<Scalars['Boolean']['output']>;
  searchable?: Maybe<Scalars['Boolean']['output']>;
};

export enum FieldType {
  CompanyEmployeeSelectField = 'COMPANY_EMPLOYEE_SELECT_FIELD',
  /** Date */
  DateField = 'DATE_FIELD',
  /** Long text */
  LongTextField = 'LONG_TEXT_FIELD',
  /** Multiple select */
  MultipleSelectField = 'MULTIPLE_SELECT_FIELD',
  /** Short text */
  ShortTextField = 'SHORT_TEXT_FIELD',
  /** Single select */
  SingleSelectField = 'SINGLE_SELECT_FIELD'
}

export type FileExportScheduledTask = ScheduledTask & {
  __typename?: 'FileExportScheduledTask';
  args: ScheduledTaskArgs;
  blob?: Maybe<MonolithBlobModel>;
  error?: Maybe<Scalars['String']['output']>;
  kind: ScheduledTaskKind;
  status: ScheduledTaskStatus;
  subId: Scalars['String']['output'];
};

export type FilterMomentRange = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type FindProjectCandidatesPaginatedAiInterviewStageFilterArgs = {
  /** True keeps only interviews the hiring team wrote a note on. Combines with the score range. */
  hasNote?: InputMaybe<Scalars['Boolean']['input']>;
  /** Keeps only candidates who interviewed on one of these interview guide blueprint versions (blueprint ids). Candidates who have not started have no version. */
  interviewGuideBlueprintIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  summaryScoreGte?: InputMaybe<Scalars['Float']['input']>;
  summaryScoreLte?: InputMaybe<Scalars['Float']['input']>;
};

export type FindProjectCandidatesPaginatedFilterArgs = {
  allAttempts?: Scalars['Boolean']['input'];
  assessmentStatus?: InputMaybe<Array<ProjectCandidateAssessmentStatusFilter>>;
  dateAdded?: InputMaybe<DateFilter>;
  dateInvited?: InputMaybe<DateFilter>;
  dateUpdated?: InputMaybe<DateFilter>;
  interviewStageCandidateIds?: InputMaybe<InterviewStageCandidateIdFilter>;
  nameOrEmailContains?: InputMaybe<Scalars['String']['input']>;
  overallScorePercentileGte?: InputMaybe<Scalars['Float']['input']>;
  overallScorePercentileLte?: InputMaybe<Scalars['Float']['input']>;
};

export type FindProjectCandidatesPaginatedOrderArgs = {
  direction?: SortOption;
  field?: FindProjectCandidatesPaginatedOrderField;
  fieldReferenceId?: InputMaybe<Scalars['ID']['input']>;
};

export enum FindProjectCandidatesPaginatedOrderField {
  AiInterviewGuideVersion = 'AI_INTERVIEW_GUIDE_VERSION',
  AiInterviewIntegrityFlags = 'AI_INTERVIEW_INTEGRITY_FLAGS',
  AiInterviewScore = 'AI_INTERVIEW_SCORE',
  AiInterviewStatus = 'AI_INTERVIEW_STATUS',
  AssessmentScore = 'ASSESSMENT_SCORE',
  AssessmentStatus = 'ASSESSMENT_STATUS',
  DateAdded = 'DATE_ADDED',
  DateInvited = 'DATE_INVITED',
  DateUpdated = 'DATE_UPDATED',
  Decision = 'DECISION',
  Name = 'NAME',
  ShortlistedStatus = 'SHORTLISTED_STATUS',
  ShortlistCriteriaScore = 'SHORTLIST_CRITERIA_SCORE',
  ShortlistCriterionResult = 'SHORTLIST_CRITERION_RESULT',
  Stage = 'STAGE',
  StageDateAdded = 'STAGE_DATE_ADDED'
}

export type FindProjectCandidatesPaginatedProgressionFilterArgs = {
  projectCandidateStatuses?: InputMaybe<Array<ProgressionStatus>>;
  stageFilters?: InputMaybe<FindProjectCandidatesPaginatedProgressionStageFilterArgs>;
};

export type FindProjectCandidatesPaginatedProgressionStageFilterArgs = {
  dateAdded?: InputMaybe<DateFilter>;
  stageIds: Array<Scalars['Int']['input']>;
  stageStatuses?: InputMaybe<Array<StageProgressionStatus>>;
  stageTypes: Array<StageType>;
};

export type FindProjectCandidatesPaginatedShortlistStageFilterArgs = {
  matchScoreGte?: InputMaybe<Scalars['Float']['input']>;
  matchScoreLte?: InputMaybe<Scalars['Float']['input']>;
  /** Splits candidates by their answers to the stage's application questions that are shown in the table and have a preferred answer. A skipped question counts as missed. */
  preferredAnswers?: InputMaybe<ProjectCandidatePreferredAnswersFilter>;
  shortlisted?: InputMaybe<ProjectCandidateShortlistedFilter>;
};

/** The time one candidate's interview is booked at */
export type FixedInterviewTimeInput = {
  /** The draft request the time is for */
  requestId: Scalars['ID']['input'];
  /** When the interview starts */
  startsAt: Scalars['DateTime']['input'];
};

export type FocusedSoftSkill = SoftSkill & {
  __typename?: 'FocusedSoftSkill';
  broadSoftSkills: Array<BasicBroadSoftSkill>;
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples: Array<Scalars['String']['output']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  similarSoftSkills: Array<BasicBroadSoftSkill>;
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID']['output'];
  taxonomyVersion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type Form = {
  __typename?: 'Form';
  formFields?: Maybe<Array<FormField>>;
  formManagerType: FormManagerType;
  formOwner: FormOwner;
  formOwnerName: Scalars['String']['output'];
  formType: FormType;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FormBuilder = {
  __typename?: 'FormBuilder';
  availableFields?: Maybe<Array<Field>>;
  form?: Maybe<Form>;
};

export type FormCandidateModel = {
  __typename?: 'FormCandidateModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  form: Form;
  formId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  stageCandidate?: Maybe<SmStageCandidateModel>;
  stageCandidateId: Scalars['Int']['output'];
  status: FormCandidateStatus;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum FormCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type FormField = {
  __typename?: 'FormField';
  displayOrder: Scalars['Int']['output'];
  field: Field;
  form: Form;
  id: Scalars['Int']['output'];
  isOptional: Scalars['Boolean']['output'];
};

export enum FormManagerType {
  Apprentice = 'APPRENTICE',
  /** Candidate Information */
  Ci = 'CI',
  /** Global - all forms can use this */
  Global = 'GLOBAL',
  /** Manager survey */
  ManagerSurvey = 'MANAGER_SURVEY',
  /** Quality of hire */
  QualityOfHire = 'QUALITY_OF_HIRE',
  Rs = 'RS',
  /** Talent reveiw */
  TalentReview = 'TALENT_REVIEW'
}

export type FormOwner = {
  __typename?: 'FormOwner';
  form: Form;
  formId: Scalars['Int']['output'];
  formOwnerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export type FormReportFormOwners = {
  __typename?: 'FormReportFormOwners';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FormReportIndividualQueries = {
  __typename?: 'FormReportIndividualQueries';
  associatedIds?: Maybe<Array<Scalars['Int']['output']>>;
  formManagerTypes?: Maybe<Array<FormManagerType>>;
  formTypes?: Maybe<Array<FormType>>;
};

export enum FormType {
  ApprenticeForm = 'APPRENTICE_FORM',
  AweApprenticeForm = 'AWE_APPRENTICE_FORM',
  AweDsus = 'AWE_DSUS',
  CdForm = 'CD_FORM',
  CiForm = 'CI_FORM',
  GradForm = 'GRAD_FORM',
  MsEmployeeForm = 'MS_EMPLOYEE_FORM',
  MsManagerForm = 'MS_MANAGER_FORM',
  RsForm = 'RS_FORM',
  TrForm = 'TR_FORM',
  UndergradForm = 'UNDERGRAD_FORM'
}

export type GenerateStageIndirectInvitationUrlModel = {
  __typename?: 'GenerateStageIndirectInvitationUrlModel';
  url: Scalars['String']['output'];
};

export enum GenericStageKind {
  ContentStage = 'CONTENT_STAGE',
  OfferStage = 'OFFER_STAGE'
}

export type GetHiringProcessTemplatesFilterArgs = {
  includeArchived?: Scalars['Boolean']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type GetHiringProcessTemplatesOrderArgs = {
  direction: SortOption;
  field: HiringProcessTemplateOrderField;
};

export enum GetOption {
  OrDefault = 'OR_DEFAULT',
  OrEmptyArray = 'OR_EMPTY_ARRAY',
  OrNull = 'OR_NULL',
  OrThrow = 'OR_THROW'
}

export type GetSkillsProfileTemplatesFilterArgs = {
  includeArchived?: Scalars['Boolean']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type GetSkillsProfileTemplatesOrderArgs = {
  direction: SortOption;
  field: SkillsProfileTemplateOrderField;
};

export enum Grade {
  A = 'A',
  APlus = 'A_PLUS',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type GradeBandUnion = IgBehaviourGradeBandModel | InterviewGuideCustomGradeBandModel | InterviewGuideFinalDecisionGradeBandModel | SoftSkillSelfAssessmentGradeBandModel | StatisticalGradeBandModel | TechnicalSkillSelfAssessmentGradeBandModel | TrCustomGradeBandModel;

export enum GradingMethod {
  Percentile = 'PERCENTILE',
  Sten = 'STEN'
}

export enum GrammaticalGender {
  Feminine = 'FEMININE',
  Masculine = 'MASCULINE'
}

export type GroupInfo = {
  __typename?: 'GroupInfo';
  actorRole: ActorRole;
  name: Scalars['String']['output'];
};

export type HiringManager = {
  externalId: Scalars['String']['input'];
};

export type HiringProcessDeadlineSettingsUpdatePayload = {
  __typename?: 'HiringProcessDeadlineSettingsUpdatePayload';
  extendedCandidatesCount: Scalars['Int']['output'];
  project: Project;
};

export enum HiringProcessDeadlineType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE'
}

export enum HiringProcessDeadlineUnit {
  Days = 'DAYS',
  Weeks = 'WEEKS'
}

export type HiringProcessTemplate = {
  __typename?: 'HiringProcessTemplate';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latestVersion?: Maybe<HiringProcessTemplateVersion>;
  name: Scalars['String']['output'];
  versions: Array<HiringProcessTemplateVersion>;
};

export enum HiringProcessTemplateInapplicabilityReason {
  AiInterviewNotEnabled = 'AI_INTERVIEW_NOT_ENABLED',
  MultiAssessmentStagesDisabled = 'MULTI_ASSESSMENT_STAGES_DISABLED',
  ShortlistingNotEnabled = 'SHORTLISTING_NOT_ENABLED',
  StageTypeLimitExceeded = 'STAGE_TYPE_LIMIT_EXCEEDED'
}

export type HiringProcessTemplateOption = {
  __typename?: 'HiringProcessTemplateOption';
  inapplicabilityReason?: Maybe<HiringProcessTemplateInapplicabilityReason>;
  isApplicable: Scalars['Boolean']['output'];
  stages: Array<HiringProcessTemplateVersionStage>;
  template: HiringProcessTemplate;
  version: HiringProcessTemplateVersion;
};

export enum HiringProcessTemplateOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  PublishedAt = 'PUBLISHED_AT'
}

export type HiringProcessTemplatePaginated = {
  __typename?: 'HiringProcessTemplatePaginated';
  archivedCount: Scalars['Int']['output'];
  page: Pageinfo;
  templates: Array<HiringProcessTemplate>;
};

export type HiringProcessTemplateStageInput = {
  isLocked?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  stageType: HiringProcessTemplateStageType;
};

export enum HiringProcessTemplateStageType {
  AiInterview = 'AI_INTERVIEW',
  Assessment = 'ASSESSMENT',
  Interview = 'INTERVIEW',
  Shortlist = 'SHORTLIST'
}

export type HiringProcessTemplateVersion = {
  __typename?: 'HiringProcessTemplateVersion';
  createdAt: Scalars['Date']['output'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  fixed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  stages: Array<HiringProcessTemplateVersionStage>;
  template: HiringProcessTemplate;
  templateId: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type HiringProcessTemplateVersionStage = {
  __typename?: 'HiringProcessTemplateVersionStage';
  id: Scalars['Int']['output'];
  isLocked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  stageType: HiringProcessTemplateStageType;
  templateVersionId: Scalars['Int']['output'];
  version: HiringProcessTemplateVersion;
};

export type HiringTeamUser = {
  __typename?: 'HiringTeamUser';
  companyId: Scalars['Int']['output'];
  companyName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export type IAssessmentDataQuestionModel = {
  questionSubId: Scalars['String']['input'];
  timestamp: Scalars['Date']['input'];
  traitId?: InputMaybe<Scalars['Int']['input']>;
};

export type IIgBehaviourResultScoreModel = {
  igEvaluation: IgBehaviourEvaluation;
};

export type IProjectRequestUserApprovalCreateOneArgs = {
  projectRequestUserId: Scalars['Int']['input'];
};

export type IProjectRequestUserApprovalUpdateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  id: Scalars['Int']['input'];
};

export type IProjectRequestUserCreateOneWithEmployeeCheckArgs = {
  approvalId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  projectRequestId: Scalars['Int']['input'];
  type: ProjectRequestUserType;
};

export type ISoftSkillSelfAssessmentScoreModel = {
  proficiency: SoftSkillSelfAssessmentProficiencyLevel;
};

export type IStatisticalResultScoreModel = {
  grade: Grade;
  percentile: Scalars['Float']['input'];
  stenScore: Scalars['Float']['input'];
  zScore: Scalars['Float']['input'];
};

export type ITechnicalSkillSelfAssessmentScoreModel = {
  technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel;
};

export enum IdentityPermissionRole {
  Admin = 'ADMIN',
  AdminE2ETest = 'ADMIN_E2E_TEST',
  ApiManager = 'API_MANAGER',
  Authenticator = 'AUTHENTICATOR',
  Authorizer = 'AUTHORIZER',
  Candidate = 'CANDIDATE',
  CompanyCandidate = 'COMPANY_CANDIDATE',
  FullAccess = 'FULL_ACCESS',
  LimitedAccess = 'LIMITED_ACCESS',
  Migrator = 'MIGRATOR',
  Scheduler = 'SCHEDULER',
  StandardAccess = 'STANDARD_ACCESS',
  SzApi = 'SZ_API',
  SzSuperAdmin = 'SZ_SUPER_ADMIN',
  WebhookHandler = 'WEBHOOK_HANDLER'
}

export type IdentityProviderModel = {
  __typename?: 'IdentityProviderModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum IgBehaviourEvaluation {
  Good = 'GOOD',
  Na = 'NA',
  Poor = 'POOR'
}

export type IgBehaviourGradeBandModel = {
  __typename?: 'IgBehaviourGradeBandModel';
  displayText: Scalars['String']['output'];
  igEvaluation: IgBehaviourEvaluation;
  position: Scalars['Int']['output'];
};

export type IgBehaviourResultScoreModel = {
  __typename?: 'IgBehaviourResultScoreModel';
  igEvaluation: IgBehaviourEvaluation;
};

export type IgCustomResultScoreModel = {
  __typename?: 'IgCustomResultScoreModel';
  igCustomEvaluation: InterviewGuideCustomEvaluation;
};

export type IgFinalDecisionResultScoreModel = {
  __typename?: 'IgFinalDecisionResultScoreModel';
  igFinalDecisionEvaluation: InterviewGuideFinalDecisionEvaluation;
};

export type InductiveItemModel = {
  __typename?: 'InductiveItemModel';
  isCompleted: Scalars['Boolean']['output'];
  question?: Maybe<InductiveQuestionModel>;
  remainingQuestions: Scalars['Int']['output'];
  remainingTime: Scalars['Int']['output'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  totalQuestions: Scalars['Int']['output'];
};

export type InductiveOptionModel = {
  __typename?: 'InductiveOptionModel';
  imageUrl: Scalars['String']['output'];
  key: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
};

export type InductiveQuestionModel = {
  __typename?: 'InductiveQuestionModel';
  difficulty: Scalars['Float']['output'];
  imageUrls: Array<Maybe<Scalars['String']['output']>>;
  options: Array<InductiveOptionModel>;
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timeLimit: Scalars['Int']['output'];
};

export type InputScoreModel = {
  customEvaluation?: InputMaybe<Scalars['String']['input']>;
  customScore?: InputMaybe<Scalars['Float']['input']>;
  grade?: InputMaybe<Grade>;
  percentile?: InputMaybe<Scalars['Float']['input']>;
  stenScore?: InputMaybe<Scalars['Float']['input']>;
  zScore?: InputMaybe<Scalars['Float']['input']>;
};

export type IntegrityEvent = {
  __typename?: 'IntegrityEvent';
  createdAt: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['Float']['output']>;
  eventType: IntegrityEventType;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  startedAt: Scalars['Float']['output'];
};

export type IntegrityEventInput = {
  endedAt?: InputMaybe<Scalars['Float']['input']>;
  eventType: IntegrityEventType;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  startedAt: Scalars['Float']['input'];
};

export enum IntegrityEventType {
  CameraDeviceSwitched = 'CAMERA_DEVICE_SWITCHED',
  CameraTurnedOff = 'CAMERA_TURNED_OFF',
  DeveloperConsoleOpened = 'DEVELOPER_CONSOLE_OPENED',
  MultipleFacesDetected = 'MULTIPLE_FACES_DETECTED',
  NoFaceDetected = 'NO_FACE_DETECTED',
  PastedFromExternalSources = 'PASTED_FROM_EXTERNAL_SOURCES',
  PhoneDetected = 'PHONE_DETECTED',
  TabSwitch = 'TAB_SWITCH',
  WindowResize = 'WINDOW_RESIZE'
}

export type IntegrityMonitoringSession = {
  __typename?: 'IntegrityMonitoringSession';
  browserVersion?: Maybe<Scalars['String']['output']>;
  deviceOs?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  events: Array<IntegrityEvent>;
  flagsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  screenIsExtended?: Maybe<Scalars['Boolean']['output']>;
  startedAt: Scalars['DateTime']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  verdict?: Maybe<IntegrityMonitoringSessionVerdict>;
};

export enum IntegrityMonitoringSessionVerdict {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type InterviewAutosuggestionEventPayload = {
  __typename?: 'InterviewAutosuggestionEventPayload';
  confidenceRating: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewId: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  skills: Array<SkillEventPayload>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date']['output'];
};

export type InterviewAutosuggestionModelV2 = {
  __typename?: 'InterviewAutosuggestionModelV2';
  confidenceRating: Scalars['Float']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewId: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  isAccepted?: Maybe<Scalars['Boolean']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  skills: Array<SkillModel>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date']['output'];
};

export enum InterviewCandidateFeedbackStatus {
  Error = 'ERROR',
  Generated = 'GENERATED',
  Generating = 'GENERATING',
  ModifiedByUser = 'MODIFIED_BY_USER'
}

export type InterviewDecisionModelV2 = {
  __typename?: 'InterviewDecisionModelV2';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewEvaluation?: Maybe<InterviewEvaluationModel>;
  interviewEvaluationId: Scalars['String']['output'];
  recommendedDecision?: Maybe<InterviewRecommendedDecision>;
  updatedAt: Scalars['Date']['output'];
};

/** Evaluation decision data for a single interview linked to a stage candidate */
export type InterviewEvaluationDecisionsModel = {
  __typename?: 'InterviewEvaluationDecisionsModel';
  /** When the interview was created */
  createdAt: Scalars['Date']['output'];
  /** All evaluators assigned to this interview with their decision data */
  evaluators: Array<EvaluatorResultModel>;
  /** Interview id */
  interviewId: Scalars['String']['output'];
  /** Interview name */
  interviewName: Scalars['String']['output'];
  /** True when the viewer is an evaluator who has not yet submitted */
  isResultsHidden: Scalars['Boolean']['output'];
  /** Meeting UUID linked to this interview */
  meetingId: Scalars['String']['output'];
};

export type InterviewEvaluationEventPayload = {
  __typename?: 'InterviewEvaluationEventPayload';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  evaluator?: Maybe<InterviewEvaluatorEventPayload>;
  id: Scalars['String']['output'];
  interviewEvaluatorId: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  skillsEvaluation?: Maybe<SkillsEvaluationEventPayload>;
  updatedAt: Scalars['Date']['output'];
};

export type InterviewEvaluationModel = {
  __typename?: 'InterviewEvaluationModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  evaluator?: Maybe<InterviewEvaluatorModel>;
  id: Scalars['String']['output'];
  interviewDecision?: Maybe<InterviewDecisionModelV2>;
  interviewEvaluatorId: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  skillsEvaluation?: Maybe<SkillsEvaluationModelV2>;
  /** Current status of this evaluation (PENDING, COMPLETED, or SKIPPED) */
  status: InterviewEvaluationStatus;
  /** Timestamp when the evaluation was submitted (COMPLETED) or skipped (SKIPPED). Null while PENDING. */
  statusChangedAt?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** Aggregated evaluation results for an interview scoped to a project job role */
export type InterviewEvaluationResultsModel = {
  __typename?: 'InterviewEvaluationResultsModel';
  /** All evaluators assigned to this interview, regardless of status */
  evaluators: Array<EvaluatorResultModel>;
  /** Interview UUID */
  interviewId: Scalars['String']['output'];
  /** Project job role ID */
  projectJobRoleId: Scalars['Int']['output'];
  /** Per-skill aggregated scores across all completed evaluations */
  skillResults: Array<SkillResultModel>;
  /** Summary with RSP skill count and category-level averages */
  summary: EvaluationResultsSummaryModel;
};

/** Status of an interview evaluation for a specific project job role. PENDING is the initial state; COMPLETED and SKIPPED are final. */
export enum InterviewEvaluationStatus {
  /** Evaluator has completed their evaluation for this role (final, irreversible) */
  Completed = 'COMPLETED',
  /** Evaluation has not yet been submitted or skipped */
  Pending = 'PENDING',
  /** Evaluator has chosen to skip this evaluation (final, irreversible) */
  Skipped = 'SKIPPED'
}

export type InterviewEvaluatorEventPayload = {
  __typename?: 'InterviewEvaluatorEventPayload';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export type InterviewEvaluatorModel = {
  __typename?: 'InterviewEvaluatorModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interview?: Maybe<InterviewV2Model>;
  interviewId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type InterviewEventPayload = {
  __typename?: 'InterviewEventPayload';
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  evaluators: Array<InterviewEvaluatorEventPayload>;
  id: Scalars['String']['output'];
  linkedInterviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  linkedProjectJobRoleId?: Maybe<Scalars['Int']['output']>;
  meetingId: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  projectCandidateSubId?: Maybe<Scalars['String']['output']>;
  status: InterviewV2Status;
  updatedAt: Scalars['Date']['output'];
};

export type InterviewGuideBlueprintEventPayload = {
  __typename?: 'InterviewGuideBlueprintEventPayload';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Int']['output'];
  editingStartedAt?: Maybe<Scalars['Date']['output']>;
  editingUserId?: Maybe<Scalars['Float']['output']>;
  estimatedDuration: Scalars['Int']['output'];
  generationStatus: InterviewGuideBlueprintGenerationStatus;
  id: Scalars['Int']['output'];
  interviewStageId?: Maybe<Scalars['Int']['output']>;
  isQuestionListModified: Scalars['Boolean']['output'];
  isQuestionsEdited: Scalars['Boolean']['output'];
  lastUpdatedAt: Scalars['Date']['output'];
  lastUpdatedById?: Maybe<Scalars['Int']['output']>;
  minorVersion: Scalars['Int']['output'];
  nextVersionId?: Maybe<Scalars['Int']['output']>;
  previousVersionId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedById?: Maybe<Scalars['Int']['output']>;
  questions: Array<InterviewGuideBlueprintQuestionModel>;
  questionsCompleted: Scalars['Int']['output'];
  questionsFailed: Scalars['Int']['output'];
  questionsGenerating: Scalars['Int']['output'];
  status: InterviewGuideBlueprintStatus;
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export enum InterviewGuideBlueprintGenerationStatus {
  Completed = 'COMPLETED',
  GeneratingQuestions = 'GENERATING_QUESTIONS',
  GeneratingSkeleton = 'GENERATING_SKELETON',
  GenerationFailed = 'GENERATION_FAILED',
  NotStarted = 'NOT_STARTED',
  SkeletonReady = 'SKELETON_READY'
}

export type InterviewGuideBlueprintModel = {
  __typename?: 'InterviewGuideBlueprintModel';
  assessmentStage?: Maybe<SmStageModel>;
  assessmentStageId?: Maybe<Scalars['Int']['output']>;
  cachedLocales: Array<SupportedLocale>;
  canPublish: Scalars['Boolean']['output'];
  canRetry: Scalars['Boolean']['output'];
  /** The number of candidate interview guides on this version. A regenerated guide counts towards the version it was regenerated onto, and guides soft-deleted on a retake are not counted. */
  candidatesAssessedCount: Scalars['Int']['output'];
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Int']['output'];
  estimatedDuration: Scalars['Int']['output'];
  generationStatus: InterviewGuideBlueprintGenerationStatus;
  /** True once any candidate has entered this AI interview stage, in any status, so a new major version would leave scores incomparable. Always false for human interview stages. */
  hasAiInterviewCandidates: Scalars['Boolean']['output'];
  /** True while candidates have not yet finished this AI interview stage, so an edit would give them different interviews. Always false for human interview stages. */
  hasPendingAiInterviewCandidates: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  interviewStage?: Maybe<InterviewStage>;
  interviewStageId?: Maybe<Scalars['Int']['output']>;
  /** True when the company has AI interviews switched off, so only Spotted Zebra users may change this guide. Always false for human interview stages. */
  isAiInterviewSelfServeDisabled: Scalars['Boolean']['output'];
  isQuestionListModified: Scalars['Boolean']['output'];
  isQuestionsEdited: Scalars['Boolean']['output'];
  lastPublishedinterviewGuideBlueprint: InterviewGuideBlueprintModel;
  lastUpdatedAt: Scalars['Date']['output'];
  lastUpdatedById?: Maybe<Scalars['Int']['output']>;
  minorVersion: Scalars['Int']['output'];
  nextVersion?: Maybe<InterviewGuideBlueprintModel>;
  nextVersionId?: Maybe<Scalars['Int']['output']>;
  originSubId?: Maybe<Scalars['String']['output']>;
  previousVersion?: Maybe<InterviewGuideBlueprintModel>;
  previousVersionId?: Maybe<Scalars['Int']['output']>;
  projectJobRole?: Maybe<ProjectJobRoleModel>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedById?: Maybe<Scalars['Int']['output']>;
  publishedByUser?: Maybe<User>;
  questions: Array<InterviewGuideBlueprintQuestionModel>;
  questionsCompleted: Scalars['Int']['output'];
  questionsFailed: Scalars['Int']['output'];
  questionsGenerating: Scalars['Int']['output'];
  status: InterviewGuideBlueprintStatus;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
  /** Every published version of this blueprint, including this one unless it is a draft, newest first. */
  versions: Array<InterviewGuideBlueprintModel>;
};

/** Types of questions in the InterviewGuideBlueprintQuestionCreate mutation */
export enum InterviewGuideBlueprintQuestionCreateQuestionType {
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export enum InterviewGuideBlueprintQuestionGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  NotApplicable = 'NOT_APPLICABLE',
  NotGenerated = 'NOT_GENERATED',
  Regenerating = 'REGENERATING'
}

export type InterviewGuideBlueprintQuestionModel = {
  __typename?: 'InterviewGuideBlueprintQuestionModel';
  blueprint: InterviewGuideBlueprintModel;
  blueprintId: Scalars['Float']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  duration: Scalars['Float']['output'];
  editingStartedAt?: Maybe<Scalars['Date']['output']>;
  editingUserId?: Maybe<Scalars['Float']['output']>;
  extraContent?: Maybe<Scalars['String']['output']>;
  generationError?: Maybe<Scalars['String']['output']>;
  generationStatus?: Maybe<InterviewGuideBlueprintQuestionGenerationStatus>;
  id: Scalars['ID']['output'];
  isEditable: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isPlaceholder: Scalars['Boolean']['output'];
  lastUpdatedById?: Maybe<Scalars['Float']['output']>;
  position: Scalars['Float']['output'];
  retryCount: Scalars['Int']['output'];
  skillCoverage?: Maybe<Array<Scalars['String']['output']>>;
  softSkillJunctions: Array<InterviewGuideBlueprintQuestionSoftSkill>;
  softSkills?: Maybe<Array<SoftSkill>>;
  starter?: Maybe<Scalars['String']['output']>;
  subId: Scalars['String']['output'];
  subtype?: Maybe<InterviewGuideBlueprintQuestionSubtype>;
  technicalSkills?: Maybe<Array<TechnicalSkill>>;
  topic?: Maybe<Scalars['String']['output']>;
  type: InterviewGuideBlueprintQuestionType;
  updatedAt: Scalars['Date']['output'];
};

export type InterviewGuideBlueprintQuestionSoftSkill = {
  __typename?: 'InterviewGuideBlueprintQuestionSoftSkill';
  indicators: Array<SoftSkillIndicator>;
  softSkill: SoftSkill;
};

export enum InterviewGuideBlueprintQuestionSubtype {
  Behavioral = 'BEHAVIORAL',
  Motivational = 'MOTIVATIONAL',
  Reflective = 'REFLECTIVE',
  SituationalJudgement = 'SITUATIONAL_JUDGEMENT'
}

/** Types of questions in the interview guide blueprint */
export enum InterviewGuideBlueprintQuestionType {
  AiQuestion = 'AI_QUESTION',
  AssessmentQuestion = 'ASSESSMENT_QUESTION',
  CustomizedAiQuestion = 'CUSTOMIZED_AI_QUESTION',
  NonQuestion = 'NON_QUESTION',
  UserQuestion = 'USER_QUESTION'
}

export type InterviewGuideBlueprintQuestionUpdateData = {
  content?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  extraContent?: InputMaybe<Scalars['String']['input']>;
};

export enum InterviewGuideBlueprintStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type InterviewGuideContentTemplateAffectedCountModel = {
  __typename?: 'InterviewGuideContentTemplateAffectedCountModel';
  cigCount: Scalars['Int']['output'];
  igbCount: Scalars['Int']['output'];
};

export type InterviewGuideContentTemplateModel = {
  __typename?: 'InterviewGuideContentTemplateModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  introContent?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  wrapUpContent?: Maybe<Scalars['String']['output']>;
};

export enum InterviewGuideCustomEvaluation {
  Exceptional = 'EXCEPTIONAL',
  Good = 'GOOD',
  Poor = 'POOR',
  Reasonable = 'REASONABLE',
  VeryGood = 'VERY_GOOD',
  VeryPoor = 'VERY_POOR'
}

export type InterviewGuideCustomGradeBandModel = {
  __typename?: 'InterviewGuideCustomGradeBandModel';
  displayText: Scalars['String']['output'];
  igCustomEvaluation: InterviewGuideCustomEvaluation;
  position: Scalars['Int']['output'];
};

export enum InterviewGuideFinalDecisionEvaluation {
  Hire = 'HIRE',
  Reject = 'REJECT',
  TalentPool = 'TALENT_POOL'
}

export type InterviewGuideFinalDecisionGradeBandModel = {
  __typename?: 'InterviewGuideFinalDecisionGradeBandModel';
  displayText: Scalars['String']['output'];
  igFinalDecisionEvaluation: InterviewGuideFinalDecisionEvaluation;
  position: Scalars['Int']['output'];
};

export type InterviewQuestionRoleLevel = {
  __typename?: 'InterviewQuestionRoleLevel';
  classification: ContentClassification;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mainQuestion?: Maybe<Scalars['String']['output']>;
  reasonForQuestion?: Maybe<Scalars['String']['output']>;
  roleLevel: ContentRoleLevel;
  softSkill: SoftSkill;
  softSkillId: Scalars['Float']['output'];
  subQuestions?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<Trait>;
  traitId: Scalars['Float']['output'];
};

export type InterviewQuestionRoleLevelContentUploadLineModel = {
  __typename?: 'InterviewQuestionRoleLevelContentUploadLineModel';
  classification: ContentClassification;
  feedback: Scalars['String']['output'];
  mainQuestion: Scalars['String']['output'];
  reasonForQuestion: Scalars['String']['output'];
  roleLevel: ContentRoleLevel;
  softSkillSlug: Scalars['String']['output'];
  subQuestion1: Scalars['String']['output'];
  subQuestion2: Scalars['String']['output'];
  subQuestion3: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  traitSlug: Scalars['String']['output'];
};

export type InterviewQuestionRoleLevelContentUploadModel = {
  __typename?: 'InterviewQuestionRoleLevelContentUploadModel';
  apply: Scalars['Boolean']['output'];
  creates?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  deletes?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  noChanges?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
  updates?: Maybe<Array<InterviewQuestionRoleLevelContentUploadLineModel>>;
};

export type InterviewQuestionRoleLevelPaginatedModel = {
  __typename?: 'InterviewQuestionRoleLevelPaginatedModel';
  count?: Maybe<Scalars['Float']['output']>;
  interviewQuestionContent?: Maybe<Array<InterviewQuestionRoleLevel>>;
};

export enum InterviewRecommendedDecision {
  No = 'NO',
  StrongNo = 'STRONG_NO',
  StrongYes = 'STRONG_YES',
  Yes = 'YES'
}

export enum InterviewSkillsEvaluationStatusV2 {
  Done = 'DONE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS'
}

export type InterviewStage = {
  __typename?: 'InterviewStage';
  activeBlueprints?: Maybe<Array<InterviewGuideBlueprintModel>>;
  createdAt: Scalars['Date']['output'];
  duration: Scalars['Int']['output'];
  focus: InterviewStageFocus;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
  publishedBlueprints?: Maybe<Array<InterviewGuideBlueprintModel>>;
  softSkills: Array<SoftSkill>;
  subId: Scalars['ID']['output'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date']['output'];
};

export type InterviewStageCandidate = {
  __typename?: 'InterviewStageCandidate';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  projectCandidateId: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type InterviewStageCandidateIdFilter = {
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum InterviewStageFocus {
  CoreSkills = 'CORE_SKILLS',
  SpecialistSkills = 'SPECIALIST_SKILLS',
  ValuesAlignment = 'VALUES_ALIGNMENT'
}

export type InterviewStageUpdateData = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  focus?: InputMaybe<InterviewStageFocus>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InterviewV2Model = {
  __typename?: 'InterviewV2Model';
  createdAt: Scalars['Date']['output'];
  createdBy: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  evaluators: Array<InterviewEvaluatorModel>;
  id: Scalars['String']['output'];
  linkedInterviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  linkedProjectJobRoleId?: Maybe<Scalars['Int']['output']>;
  meetingId: Scalars['String']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  projectCandidateSubId?: Maybe<Scalars['String']['output']>;
  status: InterviewV2Status;
  updatedAt: Scalars['Date']['output'];
};

export enum InterviewV2Status {
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  Processing = 'PROCESSING'
}

/** One interviewer's availability over the window */
export type InterviewerAvailabilityModel = {
  __typename?: 'InterviewerAvailabilityModel';
  access: CalendarAccessState;
  /** Empty unless their calendar is accessible */
  busy: Array<BusyBlockModel>;
  confidence: AvailabilityConfidence;
  /** Present only while confidence is low */
  fallbackWindow?: Maybe<FallbackWorkingWindowModel>;
  /** Present exactly when confidence is low */
  lowConfidenceReason?: Maybe<AvailabilityLowConfidenceReason>;
  /** True when a refresh of their calendar is on its way (queued by this preview, or the first sync of a newly connected calendar); read again shortly to see it */
  syncRequested: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export enum InvitationLastActionType {
  Accepted = 'ACCEPTED',
  Bounced = 'BOUNCED',
  Clicked = 'CLICKED',
  Deferred = 'DEFERRED',
  Delivered = 'DELIVERED',
  DispatchedToSendgrid = 'DISPATCHED_TO_SENDGRID',
  Dropped = 'DROPPED',
  NotSent = 'NOT_SENT',
  Opened = 'OPENED',
  Processed = 'PROCESSED'
}

export type InvitationModel = {
  __typename?: 'InvitationModel';
  companyId: Scalars['Float']['output'];
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  invitationToken: Scalars['String']['output'];
  issuedAt: Scalars['Date']['output'];
  lastActionType?: Maybe<InvitationLastActionType>;
  lastName?: Maybe<Scalars['String']['output']>;
  status: InvitationStatusCode;
  targetId: Scalars['Float']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

/** Entity that holds the invitation session */
export type InvitationSession = {
  __typename?: 'InvitationSession';
  areInternalCandidates: Scalars['Boolean']['output'];
  candidates?: Maybe<Array<InvitationSessionCandidate>>;
  companyId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['Date']['output']>;
  completedCandidates?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  defaultProjectId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  failedCandidates?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  inviteToAssessment: Scalars['Boolean']['output'];
  locale: SupportedLocale;
  name: Scalars['String']['output'];
  sendEmail: Scalars['Boolean']['output'];
  skippedCandidates?: Maybe<Scalars['Int']['output']>;
  source: InvitationSessionSource;
  stageSubId?: Maybe<Scalars['String']['output']>;
  stageType?: Maybe<Scalars['String']['output']>;
  status: InvitationSessionStatus;
  totalCandidates?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
  userEmail?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Child entity of the invitation session that holds the candidate that has to be invited */
export type InvitationSessionCandidate = {
  __typename?: 'InvitationSessionCandidate';
  applicationDate?: Maybe<Scalars['Date']['output']>;
  applicationId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invitationSession: InvitationSession;
  lastName: Scalars['String']['output'];
  locale?: Maybe<SupportedLocale>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  managerEmail?: Maybe<Scalars['String']['output']>;
  managerUserId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  requisitionId?: Maybe<Scalars['String']['output']>;
  requisitionName?: Maybe<Scalars['String']['output']>;
  stageCandidateId?: Maybe<Scalars['String']['output']>;
  status: InvitationSessionCandidateStatus;
  updatedAt: Scalars['Date']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

/** Status of the invitation session single candidate. */
export enum InvitationSessionCandidateStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Skipped = 'SKIPPED'
}

export type InvitationSessionPaginated = {
  __typename?: 'InvitationSessionPaginated';
  data?: Maybe<Array<InvitationSession>>;
  pageInfo?: Maybe<Pageinfo>;
};

export enum InvitationSessionSort {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UploadedBy = 'UPLOADED_BY'
}

/** Source of the invitation session. */
export enum InvitationSessionSource {
  Csv = 'CSV',
  Icims = 'ICIMS',
  Kombo = 'KOMBO',
  Stackone = 'STACKONE'
}

/** Status of the invitation session. */
export enum InvitationSessionStatus {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Partial = 'PARTIAL',
  Processing = 'PROCESSING'
}

export enum InvitationStatusCode {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING'
}

export type InvitationStatusResult = {
  __typename?: 'InvitationStatusResult';
  isCompleted: Scalars['Boolean']['output'];
  isExpired: Scalars['Boolean']['output'];
};

export enum InvitationType {
  Candidate = 'CANDIDATE',
  Company = 'COMPANY',
  TalentReview = 'TALENT_REVIEW'
}

export type InvivitationTokenProcessingResult = {
  __typename?: 'InvivitationTokenProcessingResult';
  invitationProcessingResult: Scalars['String']['output'];
};

export enum IqFooterType {
  Hints = 'HINTS',
  IqFeedback = 'IQ_FEEDBACK',
  None = 'NONE'
}

export enum JobRoleFamily {
  AgricultureHorticultureOutdoors = 'AGRICULTURE_HORTICULTURE_OUTDOORS',
  BusinessManagementOperations = 'BUSINESS_MANAGEMENT_OPERATIONS',
  ClericalAdministrative = 'CLERICAL_ADMINISTRATIVE',
  CommunitySocialServices = 'COMMUNITY_SOCIAL_SERVICES',
  ConstructionExtractionArchitecture = 'CONSTRUCTION_EXTRACTION_ARCHITECTURE',
  CustomerClientSupport = 'CUSTOMER_CLIENT_SUPPORT',
  DesignMediaWriting = 'DESIGN_MEDIA_WRITING',
  EducationTraining = 'EDUCATION_TRAINING',
  Engineering = 'ENGINEERING',
  Finance = 'FINANCE',
  Healthcare = 'HEALTHCARE',
  HospitalityFoodTourism = 'HOSPITALITY_FOOD_TOURISM',
  HumanResources = 'HUMAN_RESOURCES',
  InformationTechnologyComputerScience = 'INFORMATION_TECHNOLOGY_COMPUTER_SCIENCE',
  LawCompliancePublicSafety = 'LAW_COMPLIANCE_PUBLIC_SAFETY',
  MaintenanceRepairInstallation = 'MAINTENANCE_REPAIR_INSTALLATION',
  ManufacturingProduction = 'MANUFACTURING_PRODUCTION',
  MarketingPublicRelations = 'MARKETING_PUBLIC_RELATIONS',
  Military = 'MILITARY',
  NotEmployed = 'NOT_EMPLOYED',
  PerformingArts = 'PERFORMING_ARTS',
  PersonalServices = 'PERSONAL_SERVICES',
  Sales = 'SALES',
  ScienceResearch = 'SCIENCE_RESEARCH',
  SocialAnalysisPlanning = 'SOCIAL_ANALYSIS_PLANNING',
  Students = 'STUDENTS',
  Transportation = 'TRANSPORTATION',
  UnclassifiedJobFamily = 'UNCLASSIFIED_JOB_FAMILY'
}

export type JobRoleFindManyPaginatedFiltersArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  search?: InputMaybe<Scalars['String']['input']>;
  skillsProfileSourceInputs?: InputMaybe<JobRoleSkillsProfileSourceInputsFilter>;
  source?: InputMaybe<JobRoleSource>;
};

export type JobRoleFindManyPaginatedOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<JobRoleFindManyPaginatedOrderField>;
};

export enum JobRoleFindManyPaginatedOrderField {
  CompanyName = 'COMPANY_NAME',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

export type JobRoleModel = {
  __typename?: 'JobRoleModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  family?: Maybe<JobRoleFamily>;
  id: Scalars['Int']['output'];
  isAttachedToStage: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  qualifier?: Maybe<Scalars['String']['output']>;
  roleLevel: ContentRoleLevel;
  skillsProfiles: Array<SuccessProfile>;
  source: JobRoleSource;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type JobRolePaginated = {
  __typename?: 'JobRolePaginated';
  data: Array<JobRolePaginatedData>;
  page: Pageinfo;
};

export type JobRolePaginatedData = {
  __typename?: 'JobRolePaginatedData';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  family?: Maybe<JobRoleFamily>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  projectsCount: Scalars['Int']['output'];
  qualifier?: Maybe<Scalars['String']['output']>;
  roleLevel: ContentRoleLevel;
  skillsProfiles: Array<SuccessProfile>;
  source: JobRoleSource;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum JobRoleSkillsProfileSourceInputsFilter {
  HasIntakeMeetingOnly = 'HAS_INTAKE_MEETING_ONLY',
  HasJobDescriptionAndIntakeMeeting = 'HAS_JOB_DESCRIPTION_AND_INTAKE_MEETING',
  HasJobDescriptionOnly = 'HAS_JOB_DESCRIPTION_ONLY',
  NoInputs = 'NO_INPUTS'
}

export enum JobRoleSource {
  RoleRequirements = 'ROLE_REQUIREMENTS',
  SzAdmin = 'SZ_ADMIN'
}

export type JoinConferenceInput = {
  /** Controls whether agent interruptions are allowed. Default behaviour is true. */
  allowAgentInterruptions?: InputMaybe<Scalars['Boolean']['input']>;
  avatar: Avatar;
  /** Grammatical form the interviewer uses to address the candidate. Only applies to gendered locales. */
  grammaticalGender?: InputMaybe<GrammaticalGender>;
  /** Locale the candidate is taking the conference in (CR-224). */
  locale?: InputMaybe<SupportedLocale>;
};

export type KomboClearJobsResponse = {
  __typename?: 'KomboClearJobsResponse';
  deletedCount: Scalars['Int']['output'];
  dryRun: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type KomboIntegrationModel = {
  __typename?: 'KomboIntegrationModel';
  assessmentConnectedAt?: Maybe<Scalars['Date']['output']>;
  assessmentIntegrationId?: Maybe<Scalars['String']['output']>;
  atsConnectedAt?: Maybe<Scalars['Date']['output']>;
  atsIntegrationId?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  endUserEmail?: Maybe<Scalars['String']['output']>;
  endUserOrgName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  latestSyncRun?: Maybe<KomboSyncRunModel>;
  syncEnabled: Scalars['Boolean']['output'];
  tool: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type KomboIntegrationPaginated = {
  __typename?: 'KomboIntegrationPaginated';
  data?: Maybe<Array<KomboIntegrationModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type KomboJobHiringTeamMemberModel = {
  __typename?: 'KomboJobHiringTeamMemberModel';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  komboId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
  sourceAtsId?: Maybe<Scalars['String']['output']>;
};

export type KomboJobModel = {
  __typename?: 'KomboJobModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  department?: Maybe<Scalars['String']['output']>;
  hiringTeamMembers?: Maybe<Array<KomboJobHiringTeamMemberModel>>;
  id: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  jobCode?: Maybe<Scalars['String']['output']>;
  komboId?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationRaw?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  remoteCreatedAt?: Maybe<Scalars['Date']['output']>;
  remoteUpdatedAt?: Maybe<Scalars['Date']['output']>;
  sourceAtsId?: Maybe<Scalars['String']['output']>;
  stages?: Maybe<Array<KomboJobStageModel>>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type KomboJobProjectModel = {
  __typename?: 'KomboJobProjectModel';
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum KomboJobSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  RemoteCreatedAt = 'REMOTE_CREATED_AT'
}

export type KomboJobStageModel = {
  __typename?: 'KomboJobStageModel';
  id: Scalars['String']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  komboId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sourceAtsId?: Maybe<Scalars['String']['output']>;
};

export enum KomboJobStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export type KomboJobWithProject = {
  __typename?: 'KomboJobWithProject';
  job: KomboJobModel;
  jobProject?: Maybe<KomboJobProjectModel>;
};

export type KomboJobWithProjectPaginated = {
  __typename?: 'KomboJobWithProjectPaginated';
  data?: Maybe<Array<KomboJobWithProject>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type KomboSyncRunModel = {
  __typename?: 'KomboSyncRunModel';
  companyId: Scalars['Int']['output'];
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  /** Record count of the last completed full sync of the same type — the best available guess at this run's final size (Kombo exposes no total count). Null on delta or job-scoped runs. */
  estimatedTotalCount?: Maybe<Scalars['Int']['output']>;
  fullSync: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  recordCount?: Maybe<Scalars['Int']['output']>;
  /** Kombo remote job id this run is scoped to (link / publish / backfill application pulls); null for company-wide runs. */
  scopeKomboJobId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: KomboSyncRunStatus;
  trigger: KomboSyncRunTrigger;
};

export enum KomboSyncRunStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export enum KomboSyncRunTrigger {
  IntegrationCreated = 'INTEGRATION_CREATED',
  Manual = 'MANUAL',
  ManualBackfill = 'MANUAL_BACKFILL',
  ProjectLinked = 'PROJECT_LINKED',
  ProjectPublished = 'PROJECT_PUBLISHED',
  Webhook = 'WEBHOOK'
}

export type KomboSyncStatusModel = {
  __typename?: 'KomboSyncStatusModel';
  cachedJobCount: Scalars['Int']['output'];
  integrationId?: Maybe<Scalars['String']['output']>;
  lastSyncAt?: Maybe<Scalars['Date']['output']>;
  lastSyncError?: Maybe<Scalars['String']['output']>;
  lastSyncRecordCount?: Maybe<Scalars['Int']['output']>;
  syncEnabled: Scalars['Boolean']['output'];
};

export enum Language {
  Afar = 'AFAR',
  Afrikaans = 'AFRIKAANS',
  Akan = 'AKAN',
  Albanian = 'ALBANIAN',
  Amharic = 'AMHARIC',
  Arabic = 'ARABIC',
  Aragonese = 'ARAGONESE',
  Armenian = 'ARMENIAN',
  Assamese = 'ASSAMESE',
  Avaric = 'AVARIC',
  Avestan = 'AVESTAN',
  Aymara = 'AYMARA',
  Azerbaijani = 'AZERBAIJANI',
  Bambara = 'BAMBARA',
  Bashkir = 'BASHKIR',
  Basque = 'BASQUE',
  Belarusian = 'BELARUSIAN',
  Bengali = 'BENGALI',
  Bislama = 'BISLAMA',
  Bosnian = 'BOSNIAN',
  Breton = 'BRETON',
  Bulgarian = 'BULGARIAN',
  Burmese = 'BURMESE',
  CatalanValencian = 'CATALAN_VALENCIAN',
  CentralKhmer = 'CENTRAL_KHMER',
  Chamorro = 'CHAMORRO',
  Chechen = 'CHECHEN',
  ChichewaChewaNyanja = 'CHICHEWA_CHEWA_NYANJA',
  Chinese = 'CHINESE',
  Chuvash = 'CHUVASH',
  Cornish = 'CORNISH',
  Corsican = 'CORSICAN',
  Cree = 'CREE',
  Croatian = 'CROATIAN',
  Czech = 'CZECH',
  Danish = 'DANISH',
  DivehiDhivehiMaldivian = 'DIVEHI_DHIVEHI_MALDIVIAN',
  DutchFlemish = 'DUTCH_FLEMISH',
  Dzongkha = 'DZONGKHA',
  English = 'ENGLISH',
  Esperanto = 'ESPERANTO',
  Estonian = 'ESTONIAN',
  Ewe = 'EWE',
  Faroese = 'FAROESE',
  Fijian = 'FIJIAN',
  Finnish = 'FINNISH',
  French = 'FRENCH',
  Fulah = 'FULAH',
  Gaelic = 'GAELIC',
  Galician = 'GALICIAN',
  Ganda = 'GANDA',
  Georgian = 'GEORGIAN',
  German = 'GERMAN',
  GreekModern = 'GREEK_MODERN',
  Guarani = 'GUARANI',
  Gujarati = 'GUJARATI',
  Haitian = 'HAITIAN',
  Hausa = 'HAUSA',
  Hebrew = 'HEBREW',
  Herero = 'HERERO',
  Hindi = 'HINDI',
  HiriMotu = 'HIRI_MOTU',
  Hungarian = 'HUNGARIAN',
  Icelandic = 'ICELANDIC',
  Ido = 'IDO',
  Igbo = 'IGBO',
  Indonesian = 'INDONESIAN',
  Interlingua = 'INTERLINGUA',
  Interlingue = 'INTERLINGUE',
  Inuktitut = 'INUKTITUT',
  Inupiaq = 'INUPIAQ',
  Irish = 'IRISH',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Javanese = 'JAVANESE',
  KalaallisutGreenlandic = 'KALAALLISUT_GREENLANDIC',
  Kannada = 'KANNADA',
  Kanuri = 'KANURI',
  Kashmiri = 'KASHMIRI',
  Kazakh = 'KAZAKH',
  KikuyuGikuyu = 'KIKUYU_GIKUYU',
  Kinyarwanda = 'KINYARWANDA',
  KirghizKyrgyz = 'KIRGHIZ_KYRGYZ',
  Komi = 'KOMI',
  Kongo = 'KONGO',
  Korean = 'KOREAN',
  KuanyamaKwanyama = 'KUANYAMA_KWANYAMA',
  Kurdish = 'KURDISH',
  Lao = 'LAO',
  Latin = 'LATIN',
  Latvian = 'LATVIAN',
  LimburganLimburgerLimburgish = 'LIMBURGAN_LIMBURGER_LIMBURGISH',
  Lingala = 'LINGALA',
  Lithuanian = 'LITHUANIAN',
  LubaKatanga = 'LUBA_KATANGA',
  LuxembourgishLetzeburgesch = 'LUXEMBOURGISH_LETZEBURGESCH',
  Macedonian = 'MACEDONIAN',
  Malagasy = 'MALAGASY',
  Malay = 'MALAY',
  Malayalam = 'MALAYALAM',
  Maltese = 'MALTESE',
  Manx = 'MANX',
  Maori = 'MAORI',
  Marathi = 'MARATHI',
  Marshallese = 'MARSHALLESE',
  Mongolian = 'MONGOLIAN',
  Nauru = 'NAURU',
  NavajoNavaho = 'NAVAJO_NAVAHO',
  Ndonga = 'NDONGA',
  Nepali = 'NEPALI',
  NorthernSami = 'NORTHERN_SAMI',
  NorthNdebele = 'NORTH_NDEBELE',
  Norwegian = 'NORWEGIAN',
  NorwegianBokmal = 'NORWEGIAN_BOKMAL',
  NorwegianNynorsk = 'NORWEGIAN_NYNORSK',
  Occitan = 'OCCITAN',
  Ojibwa = 'OJIBWA',
  OldSlavonic = 'OLD_SLAVONIC',
  Oriya = 'ORIYA',
  Oromo = 'OROMO',
  OssetianOssetic = 'OSSETIAN_OSSETIC',
  Pali = 'PALI',
  PashtoPushto = 'PASHTO_PUSHTO',
  Persian = 'PERSIAN',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  PunjabiPanjabi = 'PUNJABI_PANJABI',
  Quechua = 'QUECHUA',
  RomanianMoldavian = 'ROMANIAN_MOLDAVIAN',
  Romansh = 'ROMANSH',
  Rundi = 'RUNDI',
  Russian = 'RUSSIAN',
  Samoan = 'SAMOAN',
  Sango = 'SANGO',
  Sanskrit = 'SANSKRIT',
  Sardinian = 'SARDINIAN',
  Serbian = 'SERBIAN',
  Shona = 'SHONA',
  SichuanYiNuosu = 'SICHUAN_YI_NUOSU',
  Sindhi = 'SINDHI',
  SinhalaSinhalese = 'SINHALA_SINHALESE',
  Slovak = 'SLOVAK',
  Slovenian = 'SLOVENIAN',
  Somali = 'SOMALI',
  SouthernSotho = 'SOUTHERN_SOTHO',
  SouthNdebele = 'SOUTH_NDEBELE',
  SpanishCastilian = 'SPANISH_CASTILIAN',
  Sundanese = 'SUNDANESE',
  Swahili = 'SWAHILI',
  Swati = 'SWATI',
  Swedish = 'SWEDISH',
  Tagalog = 'TAGALOG',
  Tahitian = 'TAHITIAN',
  Tajik = 'TAJIK',
  Tamil = 'TAMIL',
  Tatar = 'TATAR',
  Telugu = 'TELUGU',
  Thai = 'THAI',
  Tibetan = 'TIBETAN',
  Tigrinya = 'TIGRINYA',
  Tonga = 'TONGA',
  Tsonga = 'TSONGA',
  Tswana = 'TSWANA',
  Turkish = 'TURKISH',
  Turkmen = 'TURKMEN',
  Twi = 'TWI',
  Uighur = 'UIGHUR',
  Ukrainian = 'UKRAINIAN',
  Urdu = 'URDU',
  Uzbek = 'UZBEK',
  Venda = 'VENDA',
  Vietnamese = 'VIETNAMESE',
  Volapuk = 'VOLAPUK',
  Walloon = 'WALLOON',
  Welsh = 'WELSH',
  WesternFrisian = 'WESTERN_FRISIAN',
  Wolof = 'WOLOF',
  Xhosa = 'XHOSA',
  Yiddish = 'YIDDISH',
  Yoruba = 'YORUBA',
  ZhuangChuang = 'ZHUANG_CHUANG',
  Zulu = 'ZULU'
}

export enum LivekitAgentName {
  AiInterviewer = 'AI_INTERVIEWER',
  AiInterviewerCascade = 'AI_INTERVIEWER_CASCADE',
  AiInterviewerGemini = 'AI_INTERVIEWER_GEMINI'
}

export type LivekitConfig = {
  __typename?: 'LivekitConfig';
  agentAvatarId?: Maybe<Scalars['String']['output']>;
  agentVoiceId?: Maybe<Scalars['String']['output']>;
  allowAgentInterruptions: Scalars['Boolean']['output'];
  isTimingAgentEnabled: Scalars['Boolean']['output'];
};

export type LocationLinkCreateArgs = {
  companyId: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  userGroupId: Scalars['Int']['input'];
};

export type LocationLinkCreateOneResult = {
  __typename?: 'LocationLinkCreateOneResult';
  error?: Maybe<Scalars['String']['output']>;
  link?: Maybe<LocationLinkModel>;
  status: Scalars['String']['output'];
};

export type LocationLinkDeleteManyArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  userGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationLinkFindManyArgs = {
  locationId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  userGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationLinkModel = {
  __typename?: 'LocationLinkModel';
  id: Scalars['Int']['output'];
  locationId: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
  userGroupId: Scalars['Int']['output'];
};

export type LongTextField = Field & {
  __typename?: 'LongTextField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  textBoxHeight?: Maybe<Scalars['Int']['output']>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export enum MeasurementConstructType {
  Behavior = 'BEHAVIOR',
  CalculatedOnSsSummary = 'CALCULATED_ON_SS_SUMMARY',
  Cognitive = 'COGNITIVE',
  Values = 'VALUES'
}

/** An artifact attached to a meeting (recording, transcript, or summary) */
export type MeetingArtifactModel = {
  __typename?: 'MeetingArtifactModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  /** Content tag/hash for idempotency */
  eTag?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /** Last time this artifact was viewed/accessed */
  lastViewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Locales associated with this artifact */
  locales?: Maybe<Array<Scalars['String']['output']>>;
  /** Parent meeting ID */
  meetingId: Scalars['String']['output'];
  /** Artifact-specific metadata */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Associated participant ID for per-participant artifacts */
  participantId?: Maybe<Scalars['String']['output']>;
  /** Source URI or storage key */
  src?: Maybe<Scalars['String']['output']>;
  /** Processing status of the artifact */
  status: MeetingArtifactStatus;
  /** Template ID used for summary generation */
  templateId?: Maybe<Scalars['String']['output']>;
  /** Type of artifact */
  type: MeetingArtifactType;
  updatedAt: Scalars['Date']['output'];
};

export enum MeetingArtifactStatus {
  Failed = 'failed',
  Processing = 'processing',
  Ready = 'ready'
}

export enum MeetingArtifactType {
  Recording = 'recording',
  Summary = 'summary',
  Transcript = 'transcript'
}

export type MeetingAttendeeModel = {
  __typename?: 'MeetingAttendeeModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOrganiser: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Company user data — null for external/candidate attendees */
  user?: Maybe<UserModel>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum MeetingCalendarPlatform {
  Meet = 'meet',
  Teams = 'teams',
  Unknown = 'unknown',
  Zoom = 'zoom'
}

export type MeetingFeatures = {
  recording?: Scalars['Boolean']['input'];
  summary?: Scalars['Boolean']['input'];
  transcript?: Scalars['Boolean']['input'];
};

/** Links a meeting to an external calendar entry for deduplication */
export type MeetingIdentityModel = {
  __typename?: 'MeetingIdentityModel';
  /** Cross-copy logical identifier (e.g., iCalUID) */
  correlationId: Scalars['String']['output'];
  /** Per-occurrence identifier for recurring events */
  correlationInstance: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  /** External calendar ID from the provider (e.g., Google calendar email) */
  externalCalendarId: Scalars['String']['output'];
  /** Provider's event identifier for this calendar entry */
  externalEventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

/** Links a meeting to hiring domain identifiers */
export type MeetingLinkModel = {
  __typename?: 'MeetingLinkModel';
  /** Company ID from the workspace context */
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  /** Interview stage candidate ID for interview pipelines */
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  /** Candidate ID from the projects domain */
  projectCandidateId?: Maybe<Scalars['Int']['output']>;
  /** Candidate subscription ID */
  projectCandidateSubId?: Maybe<Scalars['String']['output']>;
  /** Project ID from the projects domain */
  projectId?: Maybe<Scalars['Int']['output']>;
  /** Job role ID from the projects domain */
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type MeetingMetadataArgs = {
  templates: Scalars['JSON']['input'];
};

export type MeetingMetadataModel = {
  __typename?: 'MeetingMetadataModel';
  templates: Scalars['JSON']['output'];
};

export type MeetingModel = {
  __typename?: 'MeetingModel';
  attendees?: Maybe<Array<MeetingAttendeeModel>>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hasSubmittedEvaluation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  projectCandidateId?: Maybe<Scalars['Int']['output']>;
  projectCandidateSubId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  recordingConfig?: Maybe<RecordingConfigModel>;
  status: MeetingStatus;
  summaries: Array<MeetingSummaryModel>;
  transcriptConfig?: Maybe<TranscriptConfigModel>;
  type: MeetingScope;
  updatedAt: Scalars['Date']['output'];
};

/** A meeting with all related entities */
export type MeetingModelV2 = {
  __typename?: 'MeetingModelV2';
  /** Meeting artifacts (recordings, transcripts, summaries) */
  artifacts: Array<MeetingArtifactModel>;
  /** Associated bot ID if a bot session exists */
  botId?: Maybe<Scalars['String']['output']>;
  /** When the meeting pipeline completed */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  /** Scheduled end time in UTC */
  endAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** External calendar identities for deduplication */
  identities: Array<MeetingIdentityModel>;
  /** Link to hiring domain identifiers */
  link?: Maybe<MeetingLinkModel>;
  /** Meeting participants */
  participants: Array<MeetingParticipantModel>;
  /** Conferencing or calendar provider */
  provider?: Maybe<MeetingProvider>;
  /** Scheduled start time in UTC */
  startAt?: Maybe<Scalars['DateTime']['output']>;
  /** Pipeline status of the meeting lifecycle */
  status: MeetingStatusV2;
  /** Human-friendly title of the meeting */
  title: Scalars['String']['output'];
  /** Business classification (interview/intake/general) */
  type: MeetingScope;
  updatedAt: Scalars['Date']['output'];
  /** Primary join URL for the conferencing system */
  url?: Maybe<Scalars['String']['output']>;
};

export type MeetingParticipantArgs = {
  email: Scalars['String']['input'];
  isOrganiser?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A participant in a meeting */
export type MeetingParticipantModel = {
  __typename?: 'MeetingParticipantModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  /** Email address of the participant */
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Whether this participant is the meeting organiser */
  isOrganiser: Scalars['Boolean']['output'];
  /** Display name of the participant */
  name?: Maybe<Scalars['String']['output']>;
  /** RSVP status of the participant */
  rsvp?: Maybe<MeetingParticipantRsvp>;
  updatedAt: Scalars['Date']['output'];
  /** Company user data — null for external/candidate participants */
  user?: Maybe<UserModel>;
  /** Internal user ID if the participant is a known user */
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum MeetingParticipantRsvp {
  Accepted = 'accepted',
  Declined = 'declined',
  NotResponded = 'notResponded',
  Tentative = 'tentative'
}

export enum MeetingProvider {
  Google = 'google',
  Microsoft = 'microsoft',
  Unknown = 'unknown',
  Zoom = 'zoom'
}

export enum MeetingRecodingStatus {
  Error = 'error',
  Generated = 'generated'
}

export enum MeetingScope {
  General = 'general',
  Intake = 'intake',
  Interview = 'interview'
}

export enum MeetingStatus {
  Done = 'done',
  Error = 'error',
  Recording = 'recording',
  Summarising = 'summarising',
  Transcribing = 'transcribing'
}

export enum MeetingStatusV2 {
  Done = 'done',
  Error = 'error',
  Recording = 'recording',
  Summarising = 'summarising',
  Transcribing = 'transcribing',
  Upcoming = 'upcoming'
}

export type MeetingSummaryModel = {
  __typename?: 'MeetingSummaryModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  lastViewedAt?: Maybe<Scalars['Date']['output']>;
  meetingId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId: Scalars['Int']['output'];
  src?: Maybe<Scalars['String']['output']>;
  status: MeetingSummaryStatus;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum MeetingSummaryStatus {
  Error = 'error',
  Generated = 'generated',
  Processing = 'processing'
}

export enum MeetingTranscriptStatus {
  Error = 'error',
  Generated = 'generated',
  Transcribing = 'transcribing'
}

export type MeetingTypeModel = {
  __typename?: 'MeetingTypeModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  scope: MeetingScope;
  templateId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type MeetingUserCalendarModel = {
  __typename?: 'MeetingUserCalendarModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  externalCalendarId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ownerId?: Maybe<Scalars['Int']['output']>;
  platformName: UserCalendarPlatform;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export enum Method {
  CalendarIntegration = 'calendarIntegration',
  Email = 'email'
}

export type MfaResult = {
  __typename?: 'MfaResult';
  mfaAccessToken: Scalars['String']['output'];
};

export type MonolithBlobModel = {
  __typename?: 'MonolithBlobModel';
  acl: Acl;
  bucket: Scalars['String']['output'];
  contentEncoding?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  extension: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  ownerService: Scalars['String']['output'];
  publishedName: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type MotivationResultScoreModel = {
  __typename?: 'MotivationResultScoreModel';
  isFlagged: Scalars['Boolean']['output'];
  motivationScore: Scalars['Float']['output'];
};

export type MultiSelectField = Field & {
  __typename?: 'MultiSelectField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isFreetextField?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  selectOptions?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export type MultipartCompletedPart = {
  ETag: Scalars['String']['input'];
  PartNumber: Scalars['Float']['input'];
};

export type MultipartUpload = {
  __typename?: 'MultipartUpload';
  key: Scalars['String']['output'];
  signedUrls: Array<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
};

export type MultipartUploadResponseModel = {
  __typename?: 'MultipartUploadResponseModel';
  key: Scalars['String']['output'];
  signedUrls: Array<Scalars['String']['output']>;
  uploadId: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  AdminBackfillParticipantUserIds: BackfillUserIdsResult;
  AdminResultsCsvFileExport: FileExportScheduledTask;
  AdminSendMeetingSummaryEmails: SendSummaryEmailsResult;
  /** Records that the candidate declines AI interview consent and notifies the company support address. */
  AiInterviewConsentDecline: AiInterviewConsent;
  /** Records that the candidate consents to AI transcription and scoring for this AI interview, for the text currently shown. */
  AiInterviewConsentGive: AiInterviewConsent;
  AnswerCreate?: Maybe<Answer>;
  AnswerDelete?: Maybe<DeleteResult>;
  AnswerUpdate?: Maybe<Answer>;
  ApiKeyCompanyDisable: Scalars['Boolean']['output'];
  ApiKeyCompanyGenerate: AmApiKeyModel;
  ApiKeyDisable: Scalars['Boolean']['output'];
  ApiKeyDisableUser: Scalars['Boolean']['output'];
  ApiKeyUserGenerate: AmApiKeyModel;
  ApiUserCreateOne: ApiUserModel;
  ApiUserResetClientSecret: ApiUserModel;
  ApiUserUpdateOne: ApiUserModel;
  ArchiveHiringProcessTemplate: Scalars['Boolean']['output'];
  ArchiveSkillsProfileTemplate: Scalars['Boolean']['output'];
  BehaviourContentCreateOne: BehaviourContentModel;
  BehaviourContentDeleteOne: DeleteResult;
  BehaviourContentUpdateOne: BehaviourContentModel;
  BehaviourCreateOne: BehaviourModel;
  BehaviourDeleteOne: DeleteResult;
  BehaviourFromCsvRowsCreateMany: Scalars['String']['output'];
  BehaviourUpdateOne: BehaviourModel;
  BulkUpdateCandidateShortlist: Array<ShortlistStageCandidate>;
  CalibrationFileUpload: CalibrationFileUploadModel;
  CandidateAcceptIndirectInvitation: CandidateAcceptIndirectInvitationResult;
  CandidateFeedbackGenerateOneV2: CandidateFeedbackModelV2;
  CandidateFeedbackUpdateOneV2: CandidateFeedbackModelV2;
  CandidateInterviewGuideConfirm: Scalars['Boolean']['output'];
  CandidateInterviewGuideCreate: CandidateInterviewGuideModel;
  /** Populate an assessment question for a candidate guide. */
  CandidateInterviewGuidePopulateAssessmentQuestion: CandidateInterviewGuideQuestionModel;
  CandidateInterviewGuideQuestionCreateOne: CandidateInterviewGuideQuestionModel;
  CandidateInterviewGuideQuestionDeleteOne: CandidateInterviewGuideQuestionModel;
  /** Generate and save a new AI-powered interview question for a candidate guide. */
  CandidateInterviewGuideQuestionGenerate: CandidateInterviewGuideQuestionModel;
  /** Regenerate an existing AI-powered interview question in a candidate guide while preserving the skills it was originally intended to assess. This allows users to get a new formulation or framing of the question while maintaining the same skill coverage. */
  CandidateInterviewGuideQuestionRegenerate: CandidateInterviewGuideQuestionModel;
  /** Reorder a question to a new position. Updates only affected questions for optimal performance. Returns true on success; frontend should handle reordering optimistically. */
  CandidateInterviewGuideQuestionReorder: Scalars['Boolean']['output'];
  CandidateInterviewGuideQuestionUpdateOne: CandidateInterviewGuideQuestionModel;
  CandidateInterviewGuideRegenerate: CandidateInterviewGuideModel;
  /** Requests an Interview Guide PDF generation and returns a unique requestId to subscribe to lifecycle events. */
  CandidateInterviewGuideRequestPdf: Scalars['String']['output'];
  CandidateInviteMany: Array<ProjectCandidate>;
  ClientAuthenticate: AuthCodeResult;
  ClientMFAAuthenticate: AuthCodeResultCookie;
  ClientRegisterAccount: AuthCodeResult;
  CompanyAllowedEmailDomainsUpdate: Array<Scalars['String']['output']>;
  CompanyBrandingUpsert: CompanyBranding;
  CompanyConsentCaptureUpdate: Company;
  CompanyCreateUser: User;
  CompanyEmployeeCreate: CompanyEmployeeModel;
  CompanyEmployeeDeleteOne: DeleteResult;
  CompanyEmployeeFileUpload: CompanyEmployeeFileUploadModel;
  CompanyEmployeeSyncWithUserCompanyInfo?: Maybe<Array<CompanyEmployeeModel>>;
  CompanyEmployeeUpdate: CompanyEmployeeModel;
  CompanyMeetingConfigurationCreateOne: CompanyMeetingConfigurationModel;
  CompanyMeetingConfigurationUpdateOne: CompanyMeetingConfigurationModel;
  /** Remove a user from a workspace. Removes all company roles but keeps the user account intact (they may belong to other workspaces). Requires FULL_ACCESS permission. */
  CompanyRemoveUser: Scalars['Boolean']['output'];
  CompanyResendInvite: Scalars['Boolean']['output'];
  CompanyRoleUpsert: CompanyRole;
  CompanySignatureCreateOne: CompanySignatureModel;
  CompanySignatureDeleteOne: DeleteResult;
  CompanySignatureSoftDeleteOne: DeleteResult;
  CompanySignatureUpdateOne: CompanySignatureModel;
  CompanyStageCandidateDeleteOne: DeleteResult;
  /** Update a user's access level for a workspace. Replaces all existing company roles with the new role. Requires FULL_ACCESS permission and caller can only assign roles they themselves have. */
  CompanyUpdateUserRole: User;
  ContentStageCandidateMarkComplete: MyRoleContentStage;
  CreateAssessmentBrowserSwitchCandidateTrackingEvent: Scalars['Boolean']['output'];
  CreateCompanyUser: User;
  CreateHiringProcessTemplate: HiringProcessTemplate;
  CreateHiringProcessTemplateVersion: HiringProcessTemplate;
  CreateInterviewGuideBlueprintsForInterviewStage: InterviewGuideBlueprintModel;
  CreateInterviewGuideBlueprintsForProjectJobRole: InterviewGuideBlueprintModel;
  CreateSkillsProfileTemplate: SkillsProfileTemplate;
  CreateSkillsProfileTemplateVersion: SkillsProfileTemplate;
  /** @deprecated Use archiveAssessmentStageDeiAction instead */
  DeiStageActionArchive: DeiStageActionModel;
  DeiStageActionCandidateClearAllForCandidate: Scalars['Int']['output'];
  DeiStageActionCandidateDeclineConsent: DeiStageActionCandidateModel;
  DeiStageActionCandidateGiveConsent: DeiStageActionCandidateModel;
  DeiStageActionCandidateReopen: DeiStageActionCandidateModel;
  DeiStageActionCandidateRevokeConsent: DeiStageActionCandidateModel;
  DeiStageActionCandidateSubmitResponses: DeiStageActionCandidateModel;
  DeiStageActionTemplateUpsert: DeiStageActionTemplateModel;
  /** @deprecated Use unarchiveAssessmentStageDeiAction instead */
  DeiStageActionUnarchive: DeiStageActionModel;
  /** @deprecated Use upsertAssessmentStageDeiAction instead */
  DeiStageActionUpsert: DeiStageActionModel;
  DeleteMonolithBlob: Scalars['Boolean']['output'];
  DeleteShortlistStageResume: Scalars['Boolean']['output'];
  E2eCookie: AuthenticationResultE2eCookie;
  ExchangeAuthCode: AuthenticationResult;
  FieldCreate?: Maybe<Field>;
  FieldDelete?: Maybe<DeleteResult>;
  FieldUpdate?: Maybe<Field>;
  FormAddField?: Maybe<Form>;
  FormBuilderCreate?: Maybe<FormBuilder>;
  FormBuilderUpdate?: Maybe<FormBuilder>;
  FormCreate?: Maybe<Form>;
  FormDelete?: Maybe<DeleteResult>;
  FormFieldRemove?: Maybe<Form>;
  FormFieldUpdate?: Maybe<Form>;
  FormUpdate?: Maybe<Form>;
  GenerateRSP: SkillsProfileSource;
  IdentityProviderCreateOne: IdentityProviderModel;
  IdentityProviderDeleteOne: DeleteResult;
  IdentityProviderRestoreOne?: Maybe<IdentityProviderModel>;
  IdentityProviderSoftDeleteOne: DeleteResult;
  IdentityProviderUpdateOne: IdentityProviderModel;
  InitializeShortlistCalibrationBorderlineQuestions: ShortlistCalibrationBorderlineQuestions;
  InterviewAutosuggestionUpdateOneV2: InterviewAutosuggestionModelV2;
  InterviewDecisionCreateOneV2: InterviewDecisionModelV2;
  InterviewDecisionDeleteOneV2: DeleteResult;
  InterviewDecisionUpdateOneV2: InterviewDecisionModelV2;
  InterviewDeleteOneV2: DeleteResult;
  /** Submit an interview evaluation as COMPLETED or SKIPPED. This action is final and irreversible. COMPLETED requires the skills evaluation to be submitted first. */
  InterviewEvaluationSubmit: InterviewEvaluationModel;
  InterviewGuideBlueprintPublish: InterviewGuideBlueprintModel;
  InterviewGuideBlueprintQuestionAddSoftSkill: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionCreate: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionDelete: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionGenerate: InterviewGuideBlueprintQuestionModel;
  /** Regenerate an existing AI-powered interview question in a blueprint while preserving the skills it was originally intended to assess. This allows users to get a new formulation or framing of the question while maintaining the same skill coverage. */
  InterviewGuideBlueprintQuestionRegenerate: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionRemoveSoftSkill: InterviewGuideBlueprintQuestionModel;
  /** Reorder a question to a new position. Updates only affected questions for optimal performance. Returns true on success; frontend should handle reordering optimistically. */
  InterviewGuideBlueprintQuestionReorder: Scalars['Boolean']['output'];
  /** Retry AI generation for a question that failed. Only works for questions with generationStatus FAILED and retryCount < MAX_RETRIES (2). Publishes GENERATION_STARTED, GENERATION_COMPLETED, or GENERATION_FAILED events. */
  InterviewGuideBlueprintQuestionRetry: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionUpdate: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintQuestionUpdateSoftSkill: InterviewGuideBlueprintQuestionModel;
  InterviewGuideBlueprintRegenerateQuestions: Scalars['Boolean']['output'];
  InterviewGuideContentTemplateUpsert: InterviewGuideContentTemplateModel;
  InterviewQuestionRoleLevelContentUpdate?: Maybe<InterviewQuestionRoleLevel>;
  InterviewQuestionRoleLevelContentUpload: InterviewQuestionRoleLevelContentUploadModel;
  InterviewStageDelete: Scalars['Boolean']['output'];
  InterviewStageUpdate: InterviewStage;
  InterviewStageUpdateDuration: InterviewStage;
  InterviewUpdateOneV2: InterviewV2Model;
  InvitationCreate: InvitationModel;
  InvitationDeleteMany: DeleteResult;
  InvitationDeleteOne: DeleteResult;
  InvitationUpdate: InvitationModel;
  JobRoleCreateOne: JobRoleModel;
  JobRoleDeleteOne: DeleteResult;
  JobRoleDuplicate: JobRoleModel;
  JobRoleSoftDeleteOne: DeleteResult;
  JobRoleUpdateOne: JobRoleModel;
  LocationLinkCreateMany: Array<LocationLinkCreateOneResult>;
  LocationLinkCreateOne: LocationLinkCreateOneResult;
  LocationLinkDeleteMany: Array<LocationLinkModel>;
  MarkCandidateAsHired: ProjectCandidate;
  MarkCandidatesAsHired: Array<ProjectCandidate>;
  MeetingCreateOne: MeetingModel;
  MeetingDeleteOne: Scalars['Boolean']['output'];
  MeetingGenerateTranslatedTranscript?: Maybe<Scalars['String']['output']>;
  MeetingParticipantCreateMany: MeetingModel;
  MeetingRecordingCompleteUpload: MeetingModel;
  MeetingRecordingCreateUpload: RecordingUploadModel;
  MeetingRecordingDeleteUpload: DeleteResultModel;
  MeetingSummaryGenerateOne: MeetingSummaryModel;
  MeetingSummaryUpdateOne: MeetingSummaryModel;
  MeetingTypeCreateOne: MeetingTypeModel;
  MeetingTypeUpdateOne: MeetingTypeModel;
  MeetingUpdateOne: MeetingModel;
  MeetingUserCalendarDeleteOne: DeleteResultModel;
  OverwriteInterviewStageSkills: InterviewStage;
  ProgressCandidate: ProjectCandidate;
  ProgressCandidates: ProgressCandidatesPayload;
  ProjectAddInterviewStage: Project;
  ProjectAddShortlistStage: ProjectAddShortlistStage;
  ProjectArtifactCompleteJobDescriptionUpload: Project;
  ProjectArtifactDeleteJobDescription: Project;
  ProjectArtifactInitiateJobDescriptionUpload: SinglepartUpload;
  ProjectArtifactLinkMeeting: Project;
  ProjectArtifactUnlinkMeeting: Project;
  ProjectCandidateDelete: Scalars['Boolean']['output'];
  ProjectCandidateInviteMany: Array<ProjectCandidate>;
  ProjectCandidateInviteToAssessment: ProjectCandidate;
  ProjectCandidateUpdateDeadline: ProjectCandidate;
  ProjectCandidateUpsertAssignees: ProjectCandidate;
  ProjectCollaboratorsCreateMany: Array<ProjectCollaboratorRole>;
  ProjectCollaboratorsDeleteMany: Array<ProjectCollaboratorDeleteManyResult>;
  ProjectCollaboratorsUpdateRole: ProjectCollaboratorRole;
  ProjectDelete: DeleteResult;
  ProjectJobRoleCreateOne: ProjectJobRoleModel;
  ProjectJobRoleDeleteOne: DeleteResult;
  ProjectJobRoleSetMain: ProjectJobRoleModel;
  ProjectJobRoleSoftDeleteOne: DeleteResult;
  ProjectRequestCreateOne: ProjectRequestModel;
  ProjectRequestDeleteOne: DeleteResult;
  ProjectRequestFileUpload: Scalars['String']['output'];
  ProjectRequestFileUploadDeleteOne: DeleteResult;
  ProjectRequestFileUploadSoftDeleteOne: DeleteResult;
  ProjectRequestLinkProject: ProjectRequestModel;
  ProjectRequestRequestJobSpecification: Scalars['Boolean']['output'];
  ProjectRequestRequestManagerSurvey: Scalars['Boolean']['output'];
  ProjectRequestRestoreOne?: Maybe<ProjectRequestModel>;
  ProjectRequestSoftDeleteOne: DeleteResult;
  ProjectRequestUpdateManagerSurvey: ProjectRequestModel;
  ProjectRequestUpdateOne: ProjectRequestModel;
  ProjectRequestUserApprovalCreateMany: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalCreateOne: ProjectRequestUserApprovalModel;
  ProjectRequestUserApprovalDeleteOne: DeleteResult;
  ProjectRequestUserApprovalSoftDeleteOne: DeleteResult;
  ProjectRequestUserApprovalUpdateMany: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalUpdateOne: ProjectRequestUserApprovalModel;
  ProjectRequestUserCreateMany: Array<ProjectRequestUserModel>;
  ProjectRequestUserCreateOne: ProjectRequestUserModel;
  ProjectRequestUserDeleteOne: DeleteResult;
  ProjectRequestUserSoftDeleteOne: DeleteResult;
  ProjectRequestUserUpdateOne: ProjectRequestUserModel;
  ProjectSetCompanySignature: Project;
  ProjectStagesReorder: Array<ProjectStageOrderModel>;
  ProjectUpdateStatus: Project;
  ProjectUserDeleteOne: ProjectUser;
  ProjectUserUpdateOne: ProjectUser;
  ProjectWizardCreateAiInterviewAssessmentStage: Project;
  ProjectWizardCreateAssessmentStage: Project;
  ProjectWizardCreateInterviewStage: Project;
  ProjectWizardCreateProject: Project;
  ProjectWizardCreateShortlistStage: ProjectAddShortlistStage;
  ProjectWizardInterviewStageDelete: Scalars['Boolean']['output'];
  ProjectWizardInterviewStageUpdate: InterviewStage;
  ProjectWizardInterviewStageUpdateDuration: InterviewStage;
  ProjectWizardProjectCollaboratorsCreateMany: Array<ProjectCollaboratorRole>;
  ProjectWizardProjectCollaboratorsDeleteMany: Array<ProjectCollaboratorDeleteManyResult>;
  ProjectWizardShortlistStageDelete: Scalars['Boolean']['output'];
  ProjectWizardStageDeleteOne: DeleteResult;
  ProjectWizardUpdateAiInterviewAssessmentStage: SmStageModel;
  ProjectWizardUpdateStageReportEmailSettings: SmStageModel;
  ProjectWizardUpdateStatus: Project;
  QCalcGetNextQuestion: QCalcResponse;
  QuestionnaireSubmitResponses: MyRoleQuestionnaireStage;
  RejectCandidates: RejectCandidatesPayload;
  ReportAssignmentCreate?: Maybe<ReportAssignment>;
  ReportAssignmentDelete?: Maybe<DeleteResult>;
  ReportAssignmentUpdate?: Maybe<ReportAssignment>;
  ReportConfigCreate?: Maybe<ReportConfig>;
  ReportConfigDelete?: Maybe<DeleteResult>;
  ReportCopy?: Maybe<Report>;
  ReportCreate?: Maybe<Report>;
  ReportDelete?: Maybe<DeleteResult>;
  /** @deprecated Please use either StageResultsReportRenderCreate, or SuccessProfileReportRenderCreate */
  ReportRenderCreate?: Maybe<ReportRender>;
  ReportRenderDelete?: Maybe<DeleteResult>;
  ReportUpdate?: Maybe<Report>;
  ReportUpdateIsArchived?: Maybe<Report>;
  RequeueRejectedEvent?: Maybe<DlxRejectedEvent>;
  ResetShortlistStageCandidateQuestionnaire: ShortlistStageCandidate;
  RespondantFormDeleteByRespondantAndAssociatedId?: Maybe<DeleteResult>;
  RespondantFormDeleteByRespondantId?: Maybe<DeleteResult>;
  RespondantFormUpdate?: Maybe<RespondantForm>;
  ResultCreateManySoftSkillsProfileFromSc: Array<ResultModel>;
  ResultCreateManyTechnicalSkillsProfileFromSc: Array<ResultModel>;
  ResultCreateOneBehaviour: ResultModel;
  ResultCreateOnePspSoftSkill: ResultModel;
  ResultCreateOnePspTechnicalSkill: ResultModel;
  ResultDeleteMany: DeleteResult;
  ResultUpdateOneBehaviour: ResultModel;
  RetryResumeProcessing: Scalars['Boolean']['output'];
  /** Archives up to 100 roles for the caller's organisation, regardless of status, unlinking each role's ATS requisition. Reports per role: unknown ids, other companies' roles and already-archived roles come back as NOT_FOUND rather than failing the request. Cannot be undone from the company app. */
  RoleBatchArchive: RoleBatchResultModel;
  /** Pins roles for the active workspace, appended in request order. Accepts up to 100 ids, but a user may hold only 5 pins, so this succeeds only while the newly pinned roles fit: all or nothing, rejected with code ROLE_PIN_LIMIT_EXCEEDED. Idempotent — already-pinned roles keep their position and do not count against the limit. Rejected with ROLE_NOT_PINNABLE when any role is not available to the caller. */
  RoleBatchPin: Array<RoleModel>;
  /** Unpins up to 100 roles in the active workspace. Idempotent — ids that are not pinned are not an error. Re-pinning afterwards places those roles at the bottom of the group. */
  RoleBatchUnpin: Array<RoleModel>;
  /** Closes up to 100 Published roles, or reopens up to 100 Closed ones. Reports per role: a role whose status does not qualify comes back as NOT_PUBLISHED or NOT_CLOSED rather than failing the request. Only CLOSED and PUBLISHED are accepted as targets. */
  RoleBatchUpdateStatus: RoleBatchResultModel;
  RoleLinkRequisition: RoleModel;
  /** Pins a role to the bottom of the pinned group for the active workspace. Idempotent — pinning an already-pinned role does not move it. Rejects a sixth pin with code ROLE_PIN_LIMIT_EXCEEDED. */
  RolePin: Array<RoleModel>;
  /** Reorders stages in the hiring pipeline by updating their order indices. */
  RoleStagesReorder: Array<RoleStageOrderModel>;
  RoleUnlinkRequisition: RoleModel;
  /** Unpins a role in the active workspace. Idempotent — unpinning a role that is not pinned is not an error. Re-pinning afterwards places the role at the bottom of the group. */
  RoleUnpin: Array<RoleModel>;
  RoleWizardAddSoftSkills: RoleModel;
  /** Adds team members to the role. All users must belong to the same company. Existing members are skipped. */
  RoleWizardAddTeamMembers: RoleModel;
  RoleWizardAddTechnicalSkills: RoleModel;
  /** Applies a hiring process template's latest version to a draft role, creating its stages in template order. */
  RoleWizardApplyHiringProcessTemplate: RoleModel;
  /** Archives a role. Archived roles are read-only and cannot be published or edited. */
  RoleWizardArchive: RoleModel;
  /** Clears every non-Offer stage from a draft role, returning it to the hiring process build-method chooser. */
  RoleWizardClearHiringProcess: RoleModel;
  /** Completes a job description upload and attaches the file to the role. */
  RoleWizardCompleteJobDescriptionUpload: RoleModel;
  /** Confirms the RSP and creates assessment/interview stages. Role stays in DRAFT. */
  RoleWizardConfirmRSP: RoleModel;
  /** Creates the role in DRAFT status with the caller as the initial team member. */
  RoleWizardCreate: RoleModel;
  /** Adds an AI interview assessment stage to the role. Validates CREATE_ASSESSMENT_STAGE policy. */
  RoleWizardCreateAiInterviewAssessmentStage: RoleModel;
  /** Adds an assessment stage to the role. Validates CREATE_ASSESSMENT_STAGE policy. */
  RoleWizardCreateAssessmentStage: RoleModel;
  /** Adds a content stage to the role. Validates CREATE_CONTENT_STAGE policy. */
  RoleWizardCreateContentStage: RoleModel;
  /** Adds an interview stage to the role. Validates CREATE_INTERVIEW_STAGE policy. */
  RoleWizardCreateInterviewStage: RoleModel;
  /** Adds a shortlist stage to the role. Validates CREATE_SHORTLIST_STAGE policy. */
  RoleWizardCreateShortlistStage: RoleModel;
  /** Deletes a content stage by id. Validates REMOVE_CONTENT_STAGE policy. */
  RoleWizardDeleteContentStage: RoleModel;
  /** Deletes an interview stage by UUID. Validates REMOVE_INTERVIEW_STAGE policy. */
  RoleWizardDeleteInterviewStage: RoleModel;
  /** Deletes the attached job description. No-ops if no file is attached. */
  RoleWizardDeleteJobDescription: RoleModel;
  /** Deletes a shortlist stage by UUID. Validates REMOVE_SHORTLIST_STAGE policy. */
  RoleWizardDeleteShortlistStage: RoleModel;
  /** Deletes a stage by id. Validates REMOVE_ASSESSMENT_STAGE policy on the role. */
  RoleWizardDeleteStage: DeleteResult;
  /** Triggers RSP skill generation for the role. skillsProfileId is resolved automatically. */
  RoleWizardGenerateSkills: RoleModel;
  /** Initiates a job description upload. Call CompleteJobDescriptionUpload after uploading to attach. */
  RoleWizardInitiateJobDescriptionUpload: SinglepartUpload;
  /** Links an intake meeting to the role. Only allowed for DRAFT roles. */
  RoleWizardLinkIntakeMeeting: RoleModel;
  /** Removes the applied hiring process template from a draft role, clearing every non-Offer stage. */
  RoleWizardRemoveHiringProcessTemplate: RoleModel;
  /** Removes all skills from the role's success profile and resets skill generation state. */
  RoleWizardRemoveRSPSkills: RoleModel;
  RoleWizardRemoveSoftSkill: RoleModel;
  /** Removes a team member from the role. The last remaining member cannot be removed. */
  RoleWizardRemoveTeamMember: RoleModel;
  RoleWizardRemoveTechnicalSkill: RoleModel;
  /** Archives a role for the caller's organisation, regardless of its current status. Cannot be undone from the company app. */
  RoleWizardRoleArchive: RoleModel;
  /** Transitions a role to a new status. Invalid status transitions throw. */
  RoleWizardRoleUpdateStatus: RoleModel;
  /** Removes the intake meeting link from the role. Only allowed for DRAFT roles. */
  RoleWizardUnlinkIntakeMeeting: RoleModel;
  RoleWizardUnlinkRequisition: RoleModel;
  /** Updates role fields. Validates UPDATE_PROJECT_NAME policy when name is supplied. */
  RoleWizardUpdate: RoleModel;
  /** Updates an AI interview assessment stage. No policy validation, mirrors project-level behaviour. */
  RoleWizardUpdateAiInterviewAssessmentStage: RoleModel;
  /** Updates the report and email settings of an assessment stage. Validates UPDATE_ASSESSMENT_STAGE_REPORT_AND_EMAIL policy. */
  RoleWizardUpdateAssessmentStageEmailSettings: RoleModel;
  /** Updates a content stage. Validates UPDATE_CONTENT_STAGE policy. */
  RoleWizardUpdateContentStage: RoleModel;
  /** Updates the name, duration, or focus of an interview stage. Validates UPDATE_INTERVIEW_STAGE_NAME and UPDATE_INTERVIEW_STAGE_DURATION policies. */
  RoleWizardUpdateInterviewStage: RoleModel;
  /** Sets or clears the skills profile template applied to the role, resets and regenerates RSP skills accordingly. */
  RoleWizardUpdateSkillsProfileTemplate: RoleModel;
  RssAssessmentCandidateReopenAllSubmittedForStageCandidate: Array<RssAssessmentCandidateModel>;
  RssAssessmentCandidateSubmitOne: RssAssessmentCandidateModel;
  /** @deprecated Use createAssessmentStageRssAction instead */
  RssAssessmentCreateMany: Array<RssAssessmentModel>;
  /** @deprecated Use deleteAssessmentStageRssAction instead */
  RssAssessmentDeleteMany: DeleteResult;
  SamlAuthInfoCreateOne: SamlAuthInfoModel;
  SamlAuthInfoDeleteOne: DeleteResult;
  SamlAuthInfoRestoreOne?: Maybe<SamlAuthInfoModel>;
  SamlAuthInfoSoftDeleteOne: DeleteResult;
  SamlAuthInfoUpdateOne: SamlAuthInfoModel;
  ScheduleCandidatesDebriefExport: FileExportScheduledTask;
  ScheduleROICsvFileExport: FileExportScheduledTask;
  ScheduleStageCandidateResultsCsvFileExport: FileExportScheduledTask;
  ScheduledCandidateUsageCsvFileExport: FileExportScheduledTask;
  SchedulingDeadLetterReplay: DeadLetterReplayReport;
  ShortlistCandidate: ShortlistStageCandidate;
  ShortlistStageConfigure: ShortlistStage;
  ShortlistStageDelete: Scalars['Boolean']['output'];
  /** Full-replace of the stage's eligibility questionnaire. An empty items list deletes it. Returns null when the questionnaire was removed. */
  ShortlistStageQuestionnaireConfigure?: Maybe<Questionnaire>;
  /** Toggles auto progression/rejection on the stage's eligibility questionnaire — for post-publish settings. Enabling requires a questionnaire. */
  ShortlistStageUpdateAutoProgression: ShortlistStage;
  ShortlistStageUpdateCriteria: ShortlistStage;
  /** Renames the stage without touching criteria or calibration — for post-publish settings. */
  ShortlistStageUpdateName: ShortlistStage;
  SkillsEvaluationUpdateOneV2: SkillsEvaluationModelV2;
  SkillsProfileSourceAddSoftSkills: SkillsProfileSource;
  SkillsProfileSourceAddTechnicalSkills: SkillsProfileSource;
  SkillsProfileSourceArchiveSoftSkill: SkillsProfileSource;
  SkillsProfileSourceArchiveTechnicalSkill: SkillsProfileSource;
  SkillsProfileSourceCompleteIntakeMeetingUpload: SkillsProfileSource;
  SkillsProfileSourceCompleteJobDescriptionUpload: SkillsProfileSource;
  SkillsProfileSourceCreate: SkillsProfileSource;
  SkillsProfileSourceDelete: Scalars['Boolean']['output'];
  SkillsProfileSourceDeleteIntakeMeeting: SkillsProfileSource;
  SkillsProfileSourceDeleteJobDescription: SkillsProfileSource;
  SkillsProfileSourceGenerateSkills: SkillsProfileSource;
  SkillsProfileSourceInitiateIntakeMeetingUpload: MultipartUpload;
  SkillsProfileSourceInitiateJobDescriptionUpload: SinglepartUpload;
  SkillsProfileSourceLinkMeeting: SkillsProfileSource;
  SkillsProfileSourceLinkUpcomingMeeting: SkillsProfileSource;
  SkillsProfileSourceRemoveSoftSkill: SkillsProfileSource;
  SkillsProfileSourceRemoveTechnicalSkill: SkillsProfileSource;
  SkillsProfileSourceSignOff: SkillsProfileSource;
  SkillsProfileSourceUnlinkMeeting: SkillsProfileSource;
  SkillsProfileSourceUnlinkUpcomingMeeting: SkillsProfileSource;
  SkillsProfileSourceUpdate: SkillsProfileSource;
  SkillsProfileSourceUpsertCollaborators: SkillsProfileSource;
  SoftSkillAddTrait?: Maybe<SoftSkill>;
  SoftSkillBulkUpdateTraits?: Maybe<SoftSkill>;
  SoftSkillCreate?: Maybe<SoftSkill>;
  SoftSkillDeleteTrait?: Maybe<SoftSkill>;
  SoftSkillRestore: SoftSkill;
  SoftSkillRoleLevelContentCsvFileExport: FileExportScheduledTask;
  SoftSkillRoleLevelContentUpdate?: Maybe<SoftSkillRoleLevelContent>;
  SoftSkillRoleLevelContentUpload: Scalars['Boolean']['output'];
  SoftSkillSoftDelete: SoftSkill;
  SoftSkillSuccessProfileContentCreate?: Maybe<SoftSkillSuccessProfileContent>;
  SoftSkillSuccessProfileContentDelete?: Maybe<DeleteResult>;
  SoftSkillSuccessProfileContentUpdate?: Maybe<SoftSkillSuccessProfileContent>;
  SoftSkillTypeSuccessProfileContentCreate?: Maybe<SoftSkillTypeSuccessProfileContent>;
  SoftSkillTypeSuccessProfileContentDelete?: Maybe<DeleteResult>;
  SoftSkillTypeSuccessProfileContentUpdate?: Maybe<SoftSkillTypeSuccessProfileContent>;
  SoftSkillUpdate: SoftSkill;
  StageBrandingUpsert: StageBranding;
  StageCandidateAcceptIndirectInvitation: SmStageCandidateModel;
  StageCandidateDeleteOne: DeleteResult;
  StageCandidatePledgeAnticheating: Scalars['Boolean']['output'];
  StageCandidateReprocessOne: Scalars['Boolean']['output'];
  StageCandidateResetOne: Scalars['Boolean']['output'];
  StageCandidateSubmitAdjustmentQuestionnaire: SmStageCandidateModel;
  StageCandidateUpdateDeadline: SmStageCandidateModel;
  StageCreate: SmStageModel;
  /** @deprecated Use deleteAssessmentStage mutation instead! */
  StageDeleteOne: DeleteResult;
  StageResultsReportRenderCreate?: Maybe<ReportRender>;
  /** @deprecated Use updateAssessmentStage instead! */
  StageUpdate: SmStageModel;
  SuccessProfileAddSoftSkills: SuccessProfile;
  SuccessProfileAddTechnicalSkills: SuccessProfile;
  SuccessProfileConfirm: SuccessProfile;
  /** @deprecated use SuccessProfileCreateOne instead */
  SuccessProfileCreate: SuccessProfile;
  SuccessProfileCreateOne: SuccessProfile;
  SuccessProfileDelete: DeleteResult;
  SuccessProfileDeleteMany?: Maybe<DeleteResult>;
  SuccessProfileGenerateSkills: SuccessProfile;
  SuccessProfileRemoveSoftSkill: SuccessProfile;
  SuccessProfileRemoveTechnicalSkill: SuccessProfile;
  SuccessProfileReportRenderCreate?: Maybe<ReportRender>;
  SuccessProfileSoftSkillsOverwrite: SuccessProfile;
  SuccessProfileTechnicalSkillCreateMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillCreateOne: SuccessProfileTechnicalSkill;
  SuccessProfileTechnicalSkillDeleteMany: DeleteResult;
  SuccessProfileTechnicalSkillDeleteOne: DeleteResult;
  SuccessProfileTechnicalSkillOverwriteMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillSoftDeleteMany: DeleteResult;
  SuccessProfileTechnicalSkillSoftDeleteOne: DeleteResult;
  SuccessProfileTechnicalSkillUpdateMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillUpdateOne: SuccessProfileTechnicalSkill;
  SuccessProfileTechnicalSkillsOverwrite: SuccessProfile;
  /** @deprecated use SuccessProfileUpdateOne instead */
  SuccessProfileUpdate: SuccessProfile;
  SuccessProfileUpdateOne: SuccessProfile;
  SummaryTemplateCreateOne: SummaryTemplateResponseModel;
  SummaryTemplateDeleteOne: DeleteResultModel;
  SummaryTemplateUpdateOne: SummaryTemplateResponseModel;
  SzAdminReportRenderRetry: Array<ReportRender>;
  SzSkillsMergeCreateMany: Array<SzSkillsMerge>;
  SzSkillsMergeCreateOne: SzSkillsMerge;
  SzSkillsMergeDeleteMany: DeleteResult;
  SzSkillsMergeDeleteOne: DeleteResult;
  SzSkillsMergeSoftDeleteMany: DeleteResult;
  SzSkillsMergeSoftDeleteOne: DeleteResult;
  SzSkillsMergeUpdateMany: Array<SzSkillsMerge>;
  SzSkillsMergeUpdateOne: SzSkillsMerge;
  TechnicalSkillCreateOne: TechnicalSkill;
  TechnicalSkillIconUpload: Scalars['String']['output'];
  TechnicalSkillRestore: TechnicalSkill;
  TechnicalSkillSoftDelete: TechnicalSkill;
  TechnicalSkillUpdate: TechnicalSkill;
  TraitCreate?: Maybe<Trait>;
  TraitDelete?: Maybe<DeleteResult>;
  TraitRoleLevelContentUpdate?: Maybe<TraitRoleLevelContent>;
  TraitRoleLevelContentUpload: Scalars['Boolean']['output'];
  TraitSoftSkillContextCreateOne: TraitSoftSkillContextModel;
  TraitSoftSkillContextDeleteMany: DeleteResult;
  TraitSoftSkillContextDeleteOne: DeleteResult;
  TraitSoftSkillContextFileUpload: TraitSoftSkillContextFileUploadModel;
  TraitTestTypeReplaceMany?: Maybe<Array<TraitTestTypeModel>>;
  TraitUpdate?: Maybe<Trait>;
  TraitUpdateIsArchived?: Maybe<Trait>;
  UnarchiveHiringProcessTemplate: HiringProcessTemplate;
  UnarchiveSkillsProfileTemplate: SkillsProfileTemplate;
  UnmarkCandidateAsHired: ProjectCandidate;
  UnmarkCandidatesAsHired: Array<ProjectCandidate>;
  UnrejectCandidate: ProjectCandidate;
  UnrejectCandidates: Array<ProjectCandidate>;
  UnshortlistCandidate: ShortlistStageCandidate;
  UpcomingMeetingAddBot: UpcomingMeetingModel;
  UpcomingMeetingDeleteMany: DeleteResultModel;
  UpcomingMeetingRemoveBot: UpcomingMeetingModel;
  UpcomingMeetingUpdateOne: UpcomingMeetingModel;
  UpdateHiringProcessTemplate: HiringProcessTemplate;
  /** Requires (or stops requiring) candidate consent before this role's AI interview. Enabling needs the company's consent capture switch on. */
  UpdateProjectAiInterviewConsentEnabled: Project;
  /** Updates the role's candidate portal landing page (cover photo, title, intro) — for post-publish settings. */
  UpdateProjectCandidatePortalBranding: Project;
  /** Turns the role's candidate portal on or off — for post-publish settings. Enabling requires the company's whitelabeling entitlement; disabling also clears the hiring process deadline and reminder cadence. */
  UpdateProjectCandidatePortalEnabled: Project;
  /** Updates the role's candidate-portal hiring process deadline (relative or absolute) and reminder email cadence — for post-publish settings. With `applyAbsoluteDeadlineToInvitedCandidates`, an absolute date is also stamped on already-invited candidates whose own deadline is earlier or missing (CR-453). */
  UpdateProjectHiringProcessDeadlineSettings: HiringProcessDeadlineSettingsUpdatePayload;
  UpdateProjectIntegrityMonitoring: Project;
  UpdateProjectLocales: Project;
  UpdateProjectName: Project;
  UpdateSkillsProfileTemplate: SkillsProfileTemplate;
  /** @deprecated Use updateAssessmentStageEmailSettings instead */
  UpdateStageReportEmailSettings: SmStageModel;
  UserAnonymise: User;
  UserCompanyInfoCreate: UserCompanyInfo;
  UserCompanyInfoDeleteOne: DeleteResult;
  UserCompanyInfoUpdate: UserCompanyInfo;
  UserCreate: User;
  UserDelete: DeleteResult;
  UserDeleteByEmail: DeleteResult;
  UserGroupCreateOne: UserGroupModel;
  UserGroupDeleteOne: Scalars['Boolean']['output'];
  UserGroupMembersCreateMany: Scalars['Boolean']['output'];
  UserGroupMembersDeleteMany: Scalars['Boolean']['output'];
  UserGroupUpdateOne: UserGroupModel;
  UserMeetingConfigurationCreateOne: UserMeetingConfigurationModel;
  UserMeetingConfigurationUpdateOne: UserMeetingConfigurationModel;
  UserRoleCreate?: Maybe<UserRole>;
  UserRoleDelete: DeleteResult;
  UserRoleUpdate: UserRole;
  UserSettingsCreate: UserSettings;
  UserSettingsDeleteOne: DeleteResult;
  UserSettingsUpdate: UserSettings;
  UserUpdate: User;
  WidgetConfigCreate?: Maybe<WidgetConfig>;
  WidgetConfigDelete?: Maybe<DeleteResult>;
  WidgetConfigUpdate?: Maybe<WidgetConfig>;
  WidgetConfigUpdateMany?: Maybe<Array<WidgetConfig>>;
  WidgetCreate?: Maybe<Widget>;
  WidgetDelete?: Maybe<DeleteResult>;
  WidgetDeleteScreenShot: Widget;
  WidgetOptionCreate?: Maybe<WidgetOption>;
  WidgetOptionDelete?: Maybe<DeleteResult>;
  WidgetOptionUpdate?: Maybe<WidgetOption>;
  WidgetOptionUpdateIsArchived?: Maybe<WidgetOption>;
  WidgetOptionUploadBrandedSoftSkillImage: MonolithBlobModel;
  WidgetOptionUploadCoverPageImage: MonolithBlobModel;
  WidgetUpdate?: Maybe<Widget>;
  WidgetUpdateIsArchived?: Maybe<Widget>;
  WidgetUploadScreenShot: Widget;
  addCoderbyteToAssessmentStage: CoderbyteAssessmentStageAction;
  addCognitiveTestToAssessmentStage: CognitiveTestAssessmentStageAction;
  addEnglishProficiencyToAssessmentStage: EnglishProficiencyAssessmentStageAction;
  addPersonalityTestToAssessmentStage: PersonalityTestAssessmentStageAction;
  archiveAssessmentStageDeiAction: DeiStageActionModel;
  authenticate: AuthenticationResult;
  authenticateAiAgent: AuthenticationResult;
  authenticateApi: AuthenticationResult;
  /** Fans out the ats_application_id backfill across every company that has a Kombo integration. Sequential, not parallel. Returns aggregate counters plus a per-company breakdown. Same eligibility filter and matching strategy as the per-company variant. */
  backfillAtsApplicationIdsForAllIntegratedCompanies: BackfillAtsApplicationIdsForAllIntegratedCompaniesResultModel;
  /** Backfills `project_candidate.ats_application_id` for the given company's project candidates that originated from an ATS sync but lack the column. Walks every linked Kombo job, matches PCs to ATS applications by lowercased email, persists the canonical SDK id. Idempotent. */
  backfillAtsApplicationIdsForCompany: BackfillAtsApplicationIdsForCompanyResultModel;
  /** Backfills `sm_stage_candidate` rows for project candidates created via the ATS integration whose current stage is an assessment stage. Mirrors what `ProjectCandidateInviterService.processAssessmentInvite` does on the manual invite path. Idempotent. */
  backfillAtsAssessmentStageCandidates: BackfillAtsAssessmentStageCandidatesResultModel;
  /** Fans the rejection-reason backfill across every company that has a Kombo integration. Sequential both within and across companies, so on a large tenant it can outlive the HTTP timeout in front of this mutation. Nothing is lost when that happens — the writes are not transactional and the whole thing is idempotent — but the operator sees an error on a run that partly succeeded and must re-run to read real counters. Prefer `backfillAtsRejectionReasonsForCompany` per company in production and use this only when those runs come back small. Returns aggregate counters plus a per-company breakdown. */
  backfillAtsRejectionReasonsForAllIntegratedCompanies: BackfillAtsRejectionReasonsForAllIntegratedCompaniesResultModel;
  /** Backfills `project_candidate.ats_rejection_reason` for the given company's already-rejected ATS project candidates (EM-151). They don't re-emit application events unless the application changes upstream, so the mirror stays null for them without this. Resolves each application from the gateway's own synced cache — no Kombo API calls. Idempotent, so safe to re-run as a repair. `noApplicationId` in the result is a diagnostic, not a precondition — it counts every rejected PC with no ats_application_id, mostly manually-invited candidates that never had an ATS application, so it will not reach zero. Prefer this per-company mutation over the all-integrated one for large tenants. */
  backfillAtsRejectionReasonsForCompany: BackfillAtsRejectionReasonsForCompanyResultModel;
  /** Ensures CandidateInterviewGuide records are correctly linked to InterviewStageCandidate records (backfill). */
  backfillCandidateInterviewGuides: BackfillCandidateInterviewGuideModel;
  /** Retro-materialise stuck Kombo applications for a single project by re-triggering the same `SYNC_JOB_APPLICATIONS` chain `linkProject` uses, with `fullSync: true` (so the company-wide `updated_after` watermark is NOT applied — that's the BL-1378 regression that left older applications behind). The project must be PUBLISHED and linked to a Kombo job. Idempotent: gateway dedupes by remote id and the materialiser dedupes via `findOneByProjectAndUser`. Use as the operational alternative to unlink/relink for Roles stuck behind the regression. */
  backfillKomboApplicationsForProject: BackfillKomboApplicationsForProjectResultModel;
  /** Cancels a candidate's scheduling request and, when it is booked, its interview */
  cancelSchedulingRequest: SchedulingRequestModel;
  /** Cleans up duplicate DRAFT blueprints for the same stage/job role combination. Keeps the blueprint with the best generation status (COMPLETED preferred over GENERATION_FAILED). Returns detailed information about duplicate groups including affected projects and job roles. */
  cleanupDuplicateBlueprints: CleanupDuplicateBlueprintsResult;
  /** Removes relationships between questions and skills that start with forbidden prefixes (e.g., "right for", "cognitive"). */
  cleanupForbiddenSkillRelations: CleanupForbiddenSkillRelationsResult;
  cleanupStaleEditingSessions: CleanupResultModel;
  createAssessmentStageRssAction: RssAssessmentModel;
  /** Mints a single-use SSO link into the company Coderbyte workspace, creating the caller's Coderbyte account on their first crossing. The returned URL expires within seconds — navigate to it immediately rather than storing it or rendering it into a link. */
  createCoderbyteSsoLink: CoderbyteSsoLink;
  createCompany: Company;
  createProject: Project;
  createProjectFile: ProjectFile;
  /** Opens a short-lived upload for one scheduling material */
  createRequestMaterialUpload: RequestMaterialUploadModel;
  /** Raises one draft scheduling request per selected candidate */
  createSchedulingRequests: SchedulingBatchModel;
  deauthenticate: Scalars['Boolean']['output'];
  deleteAiInterviewAssessmentStageAction: Scalars['Boolean']['output'];
  deleteAssessmentStage: Scalars['Boolean']['output'];
  deleteAssessmentStageRssAction: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  /** Removes an unsent draft batch: its requests, their offered slots and its seats. Succeeds when nothing is left to remove */
  discardSchedulingDraft: Scalars['Boolean']['output'];
  disconnectOrgCalendar: OrgCalendarDisconnectModel;
  /** TEMPORARY backfill: sends the eligibility-questions invite email to one shortlist stage candidate. Skips (without sending) when the role has no candidate portal, the stage has no questionnaire, the candidate is no longer on the stage, or an invite was already recorded (`invite_method` set) - so repeat calls send at most one email. A send failure releases the claim and surfaces as an error; re-run the mutation to retry. */
  dispatchEligibilityInviteForShortlistStageCandidate: DispatchEligibilityInviteForShortlistStageCandidateResultModel;
  editProject: Project;
  editProjectArchiving: Project;
  editProjectCandidateReportState: Project;
  editProjectState: Project;
  endIntegrityMonitoringSession: IntegrityMonitoringSession;
  /** Ensures InterviewStageCandidate records exist for active stages/projects. */
  ensureInterviewStageCandidates: EnsureIscResultModel;
  finishAiInterview: AiInterviewAssessmentStageActionCandidate;
  forceStopEditingQuestion: Scalars['Boolean']['output'];
  /** Generate a shareable workspace link with automatic workspace switching */
  generateShareLink: Scalars['String']['output'];
  initiateAiInterview: AiInterviewAssessmentStageActionCandidate;
  initiateVerification: VerificationSession;
  joinConference: ConferenceToken;
  joinDemoConference: DemoConferenceToken;
  /** Cancel a running sync for a company. The sync stops after the current page — a new sync starts fresh. */
  komboCancelSync: KomboSyncRunModel;
  /** Clear all cached Kombo jobs for a company. Use dryRun: true to preview how many jobs would be deleted without actually deleting them. */
  komboClearJobs: KomboClearJobsResponse;
  /** Create or update a Kombo integration for a company (upsert). Accepts atsIntegrationId and/or assessmentIntegrationId — at least one must be provided. Each provided ID is validated against the Kombo API before persisting. Sets the corresponding connectedAt timestamp for each ID. Publishes INTEGRATION_CREATED events that trigger job sync (ATS) and/or assessment package registration (ASSESSMENT). */
  komboCreateIntegration: KomboIntegrationModel;
  /** Force-delete the Kombo integration for a company. Clears all cached jobs and publishes INTEGRATION_DELETED events for each connected ID. */
  komboDeleteIntegration: Scalars['Boolean']['output'];
  /** Disconnect one or both Kombo integration types from a company. Pass ats: true and/or assessment: true to disconnect the corresponding integration. At least one must be true. Nulls the integration ID and its connectedAt timestamp. Publishes an INTEGRATION_DELETED event for each disconnected ID. Returns the updated record, or null if both IDs are now null (record auto-deleted and cached jobs cleared). */
  komboDisconnectIntegration?: Maybe<KomboIntegrationModel>;
  /** Link a project to a cached Kombo job (1:1 mapping). The jobId must be the internal UUID from the kombo_job cache table. Triggers hiring team sync from the job to the project. */
  komboLinkProject: KomboJobProjectModel;
  /** Re-push the company's assessment packages to its ATS via Kombo. Fire-and-forget: returns true once the refresh has been dispatched; no-ops when the company has no enabled assessment integration. */
  komboSetAssessmentPackages: Scalars['Boolean']['output'];
  /** Enable or disable the entire Kombo integration for a company. When disabled, all processing stops: no webhooks processed, no syncs, no assessment orders. */
  komboToggleEnabled: KomboIntegrationModel;
  /** Enable or disable job sync for a company. When sync is disabled, webhook events are still processed (assessment orders work) but data-changed sync is skipped. Use as a kill switch for bad data. */
  komboToggleSyncEnabled: KomboIntegrationModel;
  /** Unlink a project from its Kombo job. Soft-deletes the link record. Does not remove team members (additive-only model). */
  komboUnlinkProject: Scalars['Boolean']['output'];
  mfaAccessToken: MfaResult;
  mfaAuthenticate: AuthenticationResultCookie;
  /** Replaces the interview times a draft batch offers its candidates */
  offerSlots: Array<OfferedSlotModel>;
  overwriteAssessmentStageSkills: AssessmentStage;
  processInvitation: InvivitationTokenProcessingResult;
  projectWizardDeleteAssessmentStage: Scalars['Boolean']['output'];
  projectWizardUpdateAssessmentStage: AssessmentStage;
  projectWizardUpdateAssessmentStageEmailSettings: AssessmentStage;
  /** Creates the company its own Coderbyte organization and records it as awaiting its API key. Billable, in every environment. Refuses if CODERBYTE_ALLOWED_COMPANY_IDS is set and does not name the company. */
  provisionCoderbyteWorkspace: CoderbyteWorkspace;
  refreshCoderbyteAssessmentDetails: CoderbyteAssessmentStageAction;
  registerAccount: AuthenticationResult;
  removeCoderbyteFromAssessmentStage: Scalars['Boolean']['output'];
  removeCognitiveTestFromAssessmentStage: Scalars['Boolean']['output'];
  removeEnglishProficiencyFromAssessmentStage: Scalars['Boolean']['output'];
  removePersonalityTestFromAssessmentStage: Scalars['Boolean']['output'];
  /** Removes AI-generated questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) that have no skills attached/tagged. */
  removeUntaggedAiQuestions: RemoveUntaggedAiQuestionsResult;
  renameCoderbyteAssessment: CoderbyteAssessmentStageAction;
  /** Offers a sent scheduling request a fresh round of slots, with a new link */
  reofferSchedulingRequest: SchedulingRequestModel;
  replaceCompanySchedulingSettings: CompanySchedulingSettingsModel;
  reportIntegrityEvents: Scalars['Boolean']['output'];
  requestMfaCode: Scalars['Boolean']['output'];
  requestPasswordRecovery: Scalars['Boolean']['output'];
  requestTokenRefresh: AuthenticationResult;
  /** Moves a booked interview, by offering the candidate fresh slots or to a time the recruiter names */
  rescheduleSchedulingRequest: SchedulingRescheduleResultModel;
  resetAiInterview: AiInterviewAssessmentStageActionCandidate;
  resetCoderbyteAssessment: CoderbyteAssessmentStageActionCandidate;
  resetCognitiveTest: CognitiveTestAssessmentStageActionCandidate;
  resetEnglishProficiencyAssessment: EnglishProficiencyAssessmentStageActionCandidate;
  resetPersonalityTest: PersonalityTestAssessmentStageActionCandidate;
  retryCoderbyteAssessmentResults: Array<CoderbyteResultRetry>;
  /** Saves a reviewer's annotation on one AI interview score (skill–indicator line). Every save keeps the previous version. The AI score never changes. */
  saveAiInterviewScoreAnnotation: AiInterviewScore;
  saveEnglishProficiencyResponse: EnglishProficiencySavedResponse;
  /** Saves an existing draft batch again */
  saveSchedulingDraft: SchedulingBatchModel;
  /** Exchange global JWT for company-scoped JWT by selecting a workspace */
  selectWorkspace: AuthenticationResult;
  /** Sends a draft batch: emails each candidate a booking link, or, with fixedTimes, books every request at its time */
  sendSchedulingRequests: SchedulingSendReportModel;
  /** Toggle whether AI Interview results are pushed back to the ATS as an application result link when scoring completes ("Result link + order" when enabled, "Assessment order only" when disabled). Opt-in (defaults to disabled). Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsAiInterviewResultsEnabled: AtsSettingsGqlModel;
  /** Replace the allowlist of rejection reasons recruiters can pick in the reject modal. Omit/null `ids` (or pass an empty list) to clear the filter and show every reason. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsAllowedRejectionReasonIds: AtsSettingsGqlModel;
  /** Toggle whether ATS applications are surfaced in SZ for a company. Maps to the Miro "Application tracking on/off" setting. Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsApplicationTrackingEnabled: AtsSettingsGqlModel;
  /** Toggle whether Online Assessment results are pushed back to the ATS as an application result link when a result completes ("Result link + order" when enabled, "Assessment order only" when disabled). Order-closing is unchanged in both options. Opt-in (defaults to disabled). Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsAssessmentResultsEnabled: AtsSettingsGqlModel;
  /** Set when SZ materialises candidates from ATS applications: ALL pulls every applicant on a linked job (the legacy default), MAPPED_STAGES creates candidates only when their application enters a mapped ATS stage. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsCandidatePullMode: AtsSettingsGqlModel;
  /** Toggle whether the ATS hiring-team sync may grant SZ access for a company (create accounts for unmatched members and add users of other companies to this one). When disabled, only members who are already users of this company are added to the role team; everyone else is skipped and logged, and gets added by a later sync once an admin makes them a company user. Defaults to enabled. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsHiringTeamUserProvisioningEnabled: AtsSettingsGqlModel;
  /** Toggle whether Interview Evaluation results are pushed back to the ATS as an application result link on submit. Opt-in (defaults to disabled). Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsInterviewEvaluationResultsEnabled: AtsSettingsGqlModel;
  /** Toggle rejection write-back for a company: SZ rejections are mirrored to the ATS. Persists on the gateway-side integration row; survives restarts. Returns the post-update canonical Settings. */
  setAtsProgressionEnabled: AtsSettingsGqlModel;
  /** Set the ATS user remote ID outbound rejections are performed on behalf of (Workable integrations only at send time — sent as remote_fields.workable.on_behalf_of_user_remote_id so Workable-side rejection automations key off a real user). Omit/null (or blank, normalised gateway-side) to clear. Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsRejectOnBehalfOfUserRemoteId: AtsSettingsGqlModel;
  /** Update per-result-type result delivery config in one call: the order-result switch, the result-link switch, and each tool's passthrough switch plus its field mapping (iCIMS custom fields via sendToAtsFields/fieldIds, Workday custom objects via sendToWorkdayObjects/objectAlias/fieldAliases). Entries are partial per result type; a provided fieldIds or fieldAliases object replaces that type's mapping wholesale (blank values clear), while toggling a switch off leaves the mapping stored. iCIMS keys are rejected for non-iCIMS integrations and Workday keys for non-Workday ones; sendAssessmentOrder is rejected for AI_SHORTLIST and INTERVIEW_EVALUATION (no orders). completionStageRef names the ATS stage a completed application is moved to; send null or blank to clear it, and note it is rejected for AI_SHORTLIST and INTERVIEW_EVALUATION and when it names a stage already used in the stage map. Returns the post-update canonical Settings. */
  setAtsResultPushConfig: AtsSettingsGqlModel;
  /** Replace the per-tenant ATS stage map wholesale. Each entry pairs an SZ stage type with a provider-native ATS stage ref (plus Workday step ids, one per process variant, on Workday integrations). Omit/null `entries` (or pass an empty list) to clear the map. The gateway validates the whole list before any write — unknown stage types, duplicate types, a step id under two stage types, two step-less entries on one ref and non-Workday step ids are rejected with no partial write. Returns the post-update canonical Settings. */
  setAtsStageMap: AtsSettingsGqlModel;
  /** Toggle progression write-back for a company: SZ stage moves into mapped stage types are mirrored to the ATS (outbound move-to-stage), mapped Offer included. Off keeps that direction one-way — the ATS drives, SZ reacts. Opt-in (defaults to disabled). Persists on the gateway-side integration row. Returns the post-update canonical Settings. */
  setAtsStagePushEnabled: AtsSettingsGqlModel;
  /** Replace the per-stage rejection reasons wholesale: for each ATS stage, the rejection reasons valid there. Keyed by any stage in atsAllStages, not only mapped ones; stages can be left out. Omit/null `entries` (or pass an empty list) to clear it. Workday integrations only, since only Workday rejects a reason that is invalid for the stage. The gateway validates the whole list before any write — duplicate stages and blank or repeated reason ids are rejected with no partial write. Reasons outside the global allow-list are accepted (they are simply never offered). Returns the post-update canonical Settings. */
  setAtsStageRejectionReasons: AtsSettingsGqlModel;
  /** Stores the password for the workspace's Coderbyte admin account. Coderbyte emails a temporary one on creation which must be reset there first; record the working password here. A workspace only becomes active once it has both this and an API key. */
  setCoderbyteWorkspaceAdminPassword: CoderbyteWorkspace;
  /** Stores the workspace API key and brings the workspace into service. The key is proved against Coderbyte before being written, so a mistyped paste is rejected here rather than weeks later. Write-only — the key is never readable back through the API. */
  setCoderbyteWorkspaceApiKey: CoderbyteWorkspace;
  setIndirectInviteSSO: Scalars['Boolean']['output'];
  setIntegrityMonitoringSessionVerdict: IntegrityMonitoringSession;
  setProjectCobranding: Scalars['Boolean']['output'];
  startAiInterviewIntegrityMonitoringSession: IntegrityMonitoringSession;
  startCoderbyteAssessment: CoderbyteAssessmentStageActionCandidateStart;
  startCognitiveTestAssessment: CognitiveTestAssessmentStageActionCandidate;
  startCognitiveTestIntegrityMonitoringSession: IntegrityMonitoringSession;
  startCognitiveTestPracticeAssessment: CognitiveTestPracticeAssessment;
  startEditingQuestion: EditingResultModel;
  startEnglishProficiencyAssessment: EnglishProficiencyAssessmentStageActionCandidate;
  startEnglishProficiencyIntegrityMonitoringSession: IntegrityMonitoringSession;
  startOrgCalendarConsent: OrgCalendarConsentStartModel;
  startPersonalityTestAssessment: PersonalityTestAssessmentStageActionCandidate;
  startPersonalityTestIntegrityMonitoringSession: IntegrityMonitoringSession;
  stopEditingQuestion: Scalars['Boolean']['output'];
  submitAiInterviewFeedback: AiInterviewAssessmentStageActionCandidate;
  submitEnglishProficiencyAssessment: Scalars['Boolean']['output'];
  /** Translates the conference transcript into the given locale, populating each utterance with the translated text. No-op for utterances that already have it. */
  translateConferenceTranscript: Conference;
  /** Re-runs the canonical ATS pipeline (materialise project candidate + download CV + upload to the project's first shortlist stage) for a single application, identified by its canonical SDK id. Force-uploads the CV even when the project candidate already has a resume; use this to repair candidates that hit the link race or the swallowed-error CV upload failure. Idempotent on materialise; potentially destructive only via shortlist stage resume (which keeps version history). */
  triggerAtsCvUploadForApplication: TriggerAtsCvUploadForApplicationResultModel;
  unarchiveAssessmentStageDeiAction: DeiStageActionModel;
  updateAiInterviewActionStageAction: AiInterviewAssessmentStageAction;
  updateAiInterviewAssessmentStageActionIsAvatarEnabled: AiInterviewAssessmentStageAction;
  updateAiInterviewAssessmentStageActionIsTimingAgentEnabled: AiInterviewAssessmentStageAction;
  updateAiInterviewAssessmentStageActionLivekitAgentName: AiInterviewAssessmentStageAction;
  /** Saves the hiring team's note on an AI interview. An empty note clears it. */
  updateAiInterviewCandidateNote: AiInterviewAssessmentStageActionCandidate;
  updateAssessmentStage: AssessmentStage;
  updateAssessmentStageEmailSettings: AssessmentStage;
  updateCoderbyteAssessmentTechnicalSkills: CoderbyteAssessmentStageAction;
  updateCoderbyteAssessmentTimeAllowance: CoderbyteAssessmentStageActionCandidate;
  updateCognitiveTestSectionCount: CognitiveTestAssessmentStageAction;
  updateCognitiveTestTimeAllowance: CognitiveTestAssessmentStageActionCandidate;
  updateCompany: Company;
  updateEnglishProficiencyRequiredCefrLevel: EnglishProficiencyAssessmentStageAction;
  updateIdentityPassword: Scalars['Boolean']['output'];
  /** Adds or removes interviewers on a booked interview without moving it; the candidate is not told */
  updateInterviewPanel: UpdateInterviewPanelResultModel;
  updateMyLocalePreference: User;
  updatePersonalityTestQuestionsPerTraitCount: PersonalityTestAssessmentStageAction;
  updatePersonalityTestSelectedLocales: PersonalityTestAssessmentStageAction;
  uploadCompanyLogo: Scalars['String']['output'];
  uploadFile: UploadResult;
  upsertAssessmentStageDeiAction: DeiStageActionModel;
  /** Re-checks the stored key against Coderbyte and stamps keyVerifiedAt on success. Never suspends the workspace on failure — a revoked key and a network blip are indistinguishable, so that stays a human decision. */
  verifyCoderbyteWorkspaceApiKey: CoderbyteWorkspace;
};


export type MutationAdminBackfillParticipantUserIdsArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAdminResultsCsvFileExportArgs = {
  exportLevel?: InputMaybe<AdminResultsExportLevel>;
  includeDeiData?: InputMaybe<Scalars['Boolean']['input']>;
  includeFormsData?: InputMaybe<Scalars['Boolean']['input']>;
  lastDateOfCandidateActionFrom?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionTo?: InputMaybe<Scalars['Date']['input']>;
  scoreType?: InputMaybe<AdminResultsExportScoreType>;
  stageIds: Array<Scalars['Int']['input']>;
};


export type MutationAdminSendMeetingSummaryEmailsArgs = {
  meetingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  participantEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationAiInterviewConsentDeclineArgs = {
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID']['input'];
};


export type MutationAiInterviewConsentGiveArgs = {
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID']['input'];
};


export type MutationAnswerCreateArgs = {
  associatedId: Scalars['Int']['input'];
  fieldId: Scalars['Int']['input'];
  formId: Scalars['Int']['input'];
  respondantId: Scalars['Int']['input'];
  response: Scalars['String']['input'];
};


export type MutationAnswerDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAnswerUpdateArgs = {
  associatedId?: InputMaybe<Scalars['Int']['input']>;
  fieldId?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  respondantId?: InputMaybe<Scalars['Int']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApiKeyCompanyDisableArgs = {
  companyId: Scalars['Int']['input'];
  permission?: InputMaybe<IdentityPermissionRole>;
};


export type MutationApiKeyCompanyGenerateArgs = {
  companyId: Scalars['Int']['input'];
  permission: IdentityPermissionRole;
};


export type MutationApiKeyDisableArgs = {
  key: Scalars['String']['input'];
};


export type MutationApiKeyDisableUserArgs = {
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userSubId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApiKeyUserGenerateArgs = {
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userSubId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationApiUserCreateOneArgs = {
  companyId: Scalars['Int']['input'];
  hasClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: ApiUserOwnerType;
};


export type MutationApiUserResetClientSecretArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationApiUserUpdateOneArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationArchiveHiringProcessTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationArchiveSkillsProfileTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBehaviourContentCreateOneArgs = {
  behaviourId: Scalars['Int']['input'];
  negativeSummary: Scalars['String']['input'];
  positiveSummary: Scalars['String']['input'];
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationBehaviourContentDeleteOneArgs = {
  behaviourId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  negativeSummary?: InputMaybe<Scalars['String']['input']>;
  positiveSummary?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationBehaviourContentUpdateOneArgs = {
  behaviourId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  negativeSummary?: InputMaybe<Scalars['String']['input']>;
  positiveSummary?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationBehaviourCreateOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  internalName: Scalars['String']['input'];
};


export type MutationBehaviourDeleteOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBehaviourFromCsvRowsCreateManyArgs = {
  dto: Array<BehaviourFromCsvRowsCreateManyArgs>;
};


export type MutationBehaviourUpdateOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  internalName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkUpdateCandidateShortlistArgs = {
  ids: Array<Scalars['ID']['input']>;
  isShortlisted: Scalars['Boolean']['input'];
};


export type MutationCalibrationFileUploadArgs = {
  apply: Scalars['Boolean']['input'];
  args: CalibrationFileUploadArgs;
  file: Scalars['Upload']['input'];
};


export type MutationCandidateAcceptIndirectInvitationArgs = {
  hiringManagers?: InputMaybe<Array<HiringManager>>;
  stageId: Scalars['Int']['input'];
};


export type MutationCandidateFeedbackGenerateOneV2Args = {
  interviewEvaluationId: Scalars['String']['input'];
};


export type MutationCandidateFeedbackUpdateOneV2Args = {
  id: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};


export type MutationCandidateInterviewGuideConfirmArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationCandidateInterviewGuideCreateArgs = {
  interviewGuideBlueprintId: Scalars['Int']['input'];
  interviewStageCandidateId: Scalars['Int']['input'];
};


export type MutationCandidateInterviewGuidePopulateAssessmentQuestionArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationCandidateInterviewGuideQuestionCreateOneArgs = {
  candidateInterviewGuideId: Scalars['Int']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  extraContent?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CandidateInterviewGuideQuestionCreateQuestionType>;
};


export type MutationCandidateInterviewGuideQuestionDeleteOneArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationCandidateInterviewGuideQuestionGenerateArgs = {
  guideSubId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  skills: Array<Scalars['String']['input']>;
  subtype: InterviewGuideBlueprintQuestionSubtype;
};


export type MutationCandidateInterviewGuideQuestionRegenerateArgs = {
  subId: Scalars['String']['input'];
};


export type MutationCandidateInterviewGuideQuestionReorderArgs = {
  fromPosition: Scalars['Int']['input'];
  subId: Scalars['String']['input'];
  toPosition: Scalars['Int']['input'];
};


export type MutationCandidateInterviewGuideQuestionUpdateOneArgs = {
  data: CandidateInterviewGuideQuestionUpdateData;
  subId: Scalars['String']['input'];
};


export type MutationCandidateInterviewGuideRegenerateArgs = {
  subId: Scalars['String']['input'];
};


export type MutationCandidateInterviewGuideRequestPdfArgs = {
  candidateInterviewGuideSubId: Scalars['String']['input'];
};


export type MutationCandidateInviteManyArgs = {
  settings: ProjectCandidateInvitationSettings;
  stageInviteSettings: CandidateStageInviteSettings;
  userDetails: Array<ProjectCandidateUserDetails>;
};


export type MutationClientAuthenticateArgs = {
  clientType?: InputMaybe<ClientType>;
  email: Scalars['String']['input'];
  mfaCookie?: InputMaybe<Array<Scalars['String']['input']>>;
  password: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClientMfaAuthenticateArgs = {
  mfaAccessToken: Scalars['String']['input'];
  mfaCode: Scalars['String']['input'];
};


export type MutationClientRegisterAccountArgs = {
  companyId?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<SupportedLocale>;
  password: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCompanyAllowedEmailDomainsUpdateArgs = {
  allowedEmailDomains: Array<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationCompanyBrandingUpsertArgs = {
  accentColor1?: InputMaybe<Scalars['String']['input']>;
  accentColor2?: InputMaybe<Scalars['String']['input']>;
  careersLinkUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  signInBackgroundUrl?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<Scalars['String']['input']>;
  websiteLinkUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompanyConsentCaptureUpdateArgs = {
  consentText?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  supportEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompanyCreateUserArgs = {
  companyId: Scalars['Float']['input'];
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  role?: InputMaybe<IdentityPermissionRole>;
  roles?: InputMaybe<Array<IdentityPermissionRole>>;
  sendInvite: Scalars['Boolean']['input'];
};


export type MutationCompanyEmployeeCreateArgs = {
  companyId: Scalars['Int']['input'];
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeeId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCompanyEmployeeDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCompanyEmployeeFileUploadArgs = {
  apply: Scalars['Boolean']['input'];
  args: CompanyEmployeeFileUploadArgs;
  file: Scalars['Upload']['input'];
};


export type MutationCompanyEmployeeSyncWithUserCompanyInfoArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCompanyEmployeeUpdateArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCompanyMeetingConfigurationCreateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationCompanyMeetingConfigurationUpdateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationCompanyRemoveUserArgs = {
  companyId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationCompanyResendInviteArgs = {
  companyId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};


export type MutationCompanyRoleUpsertArgs = {
  companyId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  roleId: Scalars['Int']['input'];
  samlAuthInfoIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCompanySignatureCreateOneArgs = {
  companyId: Scalars['Int']['input'];
  isDefault: Scalars['Boolean']['input'];
  signature: Scalars['String']['input'];
  signatureEmail: Scalars['String']['input'];
};


export type MutationCompanySignatureDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCompanySignatureSoftDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCompanySignatureUpdateOneArgs = {
  id: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signatureEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCompanyStageCandidateDeleteOneArgs = {
  subId: Scalars['String']['input'];
};


export type MutationCompanyUpdateUserRoleArgs = {
  companyId: Scalars['Int']['input'];
  newRole: IdentityPermissionRole;
  userId: Scalars['Int']['input'];
};


export type MutationContentStageCandidateMarkCompleteArgs = {
  contentStageCandidateId: Scalars['Int']['input'];
};


export type MutationCreateAssessmentBrowserSwitchCandidateTrackingEventArgs = {
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  assessmentSubId?: InputMaybe<Scalars['String']['input']>;
  assessmentTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  type: AssessmentBrowserSwitchCandidateTrackingEvent;
};


export type MutationCreateCompanyUserArgs = {
  companyId: Scalars['Float']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roles: Array<IdentityPermissionRole>;
};


export type MutationCreateHiringProcessTemplateArgs = {
  description: Scalars['String']['input'];
  fixed?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  stages: Array<HiringProcessTemplateStageInput>;
};


export type MutationCreateHiringProcessTemplateVersionArgs = {
  fixed?: Scalars['Boolean']['input'];
  stages: Array<HiringProcessTemplateStageInput>;
  templateId: Scalars['Int']['input'];
};


export type MutationCreateInterviewGuideBlueprintsForInterviewStageArgs = {
  interviewStageId: Scalars['Float']['input'];
};


export type MutationCreateInterviewGuideBlueprintsForProjectJobRoleArgs = {
  projectJobRoleId: Scalars['Float']['input'];
};


export type MutationCreateSkillsProfileTemplateArgs = {
  description: Scalars['String']['input'];
  fixed?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  softSkills: Array<SkillsProfileTemplateSkillInput>;
  technicalSkills: Array<SkillsProfileTemplateSkillInput>;
};


export type MutationCreateSkillsProfileTemplateVersionArgs = {
  fixed?: Scalars['Boolean']['input'];
  softSkills: Array<SkillsProfileTemplateSkillInput>;
  technicalSkills: Array<SkillsProfileTemplateSkillInput>;
  templateId: Scalars['Int']['input'];
};


export type MutationDeiStageActionArchiveArgs = {
  stageId: Scalars['Int']['input'];
};


export type MutationDeiStageActionCandidateClearAllForCandidateArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationDeiStageActionCandidateDeclineConsentArgs = {
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationDeiStageActionCandidateGiveConsentArgs = {
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationDeiStageActionCandidateReopenArgs = {
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationDeiStageActionCandidateRevokeConsentArgs = {
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationDeiStageActionCandidateSubmitResponsesArgs = {
  responses: DeiStageActionCandidateResponsesInput;
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationDeiStageActionTemplateUpsertArgs = {
  companyId: Scalars['Int']['input'];
  fields: DeiStageActionTemplateFieldsInput;
};


export type MutationDeiStageActionUnarchiveArgs = {
  fields?: InputMaybe<DeiStageActionFieldsInput>;
  stageId: Scalars['Int']['input'];
};


export type MutationDeiStageActionUpsertArgs = {
  fields: DeiStageActionFieldsInput;
  stageId: Scalars['Int']['input'];
};


export type MutationDeleteMonolithBlobArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteShortlistStageResumeArgs = {
  resumeSubId: Scalars['ID']['input'];
};


export type MutationE2eCookieArgs = {
  email: Scalars['String']['input'];
};


export type MutationExchangeAuthCodeArgs = {
  authCode: Scalars['String']['input'];
  clientType?: InputMaybe<ClientType>;
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFieldCreateArgs = {
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: InputMaybe<Scalars['Int']['input']>;
  fieldOwnerType: FieldOwnerType;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: InputMaybe<Scalars['String']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  selectOptions?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<FieldSettingsArgs>;
};


export type MutationFieldDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFieldUpdateArgs = {
  hint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  selectOptions?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<FieldSettingsArgs>;
};


export type MutationFormAddFieldArgs = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  fieldId: Scalars['Int']['input'];
  formId: Scalars['Int']['input'];
  isOptional: Scalars['Boolean']['input'];
};


export type MutationFormBuilderCreateArgs = {
  addFields?: InputMaybe<Array<CreateFormFieldByFieldIdArgs>>;
  formManagerType: FormManagerType;
  formOwnerId: Scalars['Int']['input'];
  formType: FormType;
  name: Scalars['String']['input'];
};


export type MutationFormBuilderUpdateArgs = {
  addFields?: InputMaybe<Array<CreateFormFieldByFieldIdArgs>>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  removeFields?: InputMaybe<Array<DeleteFormFieldByFieldIdArgs>>;
  updateFields?: InputMaybe<Array<UpdateFormFieldByFieldIdArgs>>;
};


export type MutationFormCreateArgs = {
  formManagerType: FormManagerType;
  formOwnerId: Scalars['Int']['input'];
  formType: FormType;
  name: Scalars['String']['input'];
};


export type MutationFormDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFormFieldRemoveArgs = {
  fieldId: Scalars['Int']['input'];
  formId: Scalars['Int']['input'];
};


export type MutationFormFieldUpdateArgs = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  formFieldId?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFormUpdateArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGenerateRspArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationIdentityProviderCreateOneArgs = {
  name: Scalars['String']['input'];
};


export type MutationIdentityProviderDeleteOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationIdentityProviderRestoreOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationIdentityProviderSoftDeleteOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationIdentityProviderUpdateOneArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInitializeShortlistCalibrationBorderlineQuestionsArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationInterviewAutosuggestionUpdateOneV2Args = {
  id: Scalars['String']['input'];
  isAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInterviewDecisionCreateOneV2Args = {
  interviewEvaluationId: Scalars['String']['input'];
  recommendedDecision: InterviewRecommendedDecision;
};


export type MutationInterviewDecisionDeleteOneV2Args = {
  id: Scalars['String']['input'];
};


export type MutationInterviewDecisionUpdateOneV2Args = {
  id: Scalars['String']['input'];
  recommendedDecision: InterviewRecommendedDecision;
};


export type MutationInterviewDeleteOneV2Args = {
  id: Scalars['String']['input'];
};


export type MutationInterviewEvaluationSubmitArgs = {
  id: Scalars['String']['input'];
  status: InterviewEvaluationStatus;
};


export type MutationInterviewGuideBlueprintPublishArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationInterviewGuideBlueprintQuestionAddSoftSkillArgs = {
  indicators?: InputMaybe<Array<SoftSkillIndicatorInput>>;
  questionSubId: Scalars['String']['input'];
  softSkillId: Scalars['Int']['input'];
};


export type MutationInterviewGuideBlueprintQuestionCreateArgs = {
  blueprintId: Scalars['Int']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  extraContent?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  subtype?: InputMaybe<InterviewGuideBlueprintQuestionSubtype>;
  type?: InputMaybe<InterviewGuideBlueprintQuestionCreateQuestionType>;
};


export type MutationInterviewGuideBlueprintQuestionDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationInterviewGuideBlueprintQuestionGenerateArgs = {
  blueprintId: Scalars['Int']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  skills: Array<Scalars['String']['input']>;
  subtype: InterviewGuideBlueprintQuestionSubtype;
};


export type MutationInterviewGuideBlueprintQuestionRegenerateArgs = {
  subId: Scalars['String']['input'];
};


export type MutationInterviewGuideBlueprintQuestionRemoveSoftSkillArgs = {
  questionSubId: Scalars['String']['input'];
  softSkillId: Scalars['Int']['input'];
};


export type MutationInterviewGuideBlueprintQuestionReorderArgs = {
  fromPosition: Scalars['Int']['input'];
  subId: Scalars['String']['input'];
  toPosition: Scalars['Int']['input'];
};


export type MutationInterviewGuideBlueprintQuestionRetryArgs = {
  subId: Scalars['String']['input'];
};


export type MutationInterviewGuideBlueprintQuestionUpdateArgs = {
  data: InterviewGuideBlueprintQuestionUpdateData;
  subId: Scalars['String']['input'];
};


export type MutationInterviewGuideBlueprintQuestionUpdateSoftSkillArgs = {
  indicators: Array<SoftSkillIndicatorInput>;
  questionSubId: Scalars['String']['input'];
  softSkillId: Scalars['Int']['input'];
};


export type MutationInterviewGuideBlueprintRegenerateQuestionsArgs = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  subId: Scalars['String']['input'];
};


export type MutationInterviewGuideContentTemplateUpsertArgs = {
  introContent?: InputMaybe<Scalars['String']['input']>;
  updateExistingIntroFieldsInGuides?: InputMaybe<Scalars['Boolean']['input']>;
  updateExistingWrapUpFieldsInGuides?: InputMaybe<Scalars['Boolean']['input']>;
  wrapUpContent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInterviewQuestionRoleLevelContentUpdateArgs = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  mainQuestion?: InputMaybe<Scalars['String']['input']>;
  reasonForQuestion?: InputMaybe<Scalars['String']['input']>;
  subQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
};


export type MutationInterviewQuestionRoleLevelContentUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationInterviewStageDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationInterviewStageUpdateArgs = {
  data: InterviewStageUpdateData;
  subId: Scalars['ID']['input'];
};


export type MutationInterviewStageUpdateDurationArgs = {
  duration: Scalars['Int']['input'];
  subId: Scalars['ID']['input'];
};


export type MutationInterviewUpdateOneV2Args = {
  id: Scalars['String']['input'];
  linkedInterviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  linkedProjectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']['input']>;
  stageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InterviewV2Status>;
};


export type MutationInvitationCreateArgs = {
  companyId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invitationType: InvitationType;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']['input']>;
  shouldCreateAccount?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId: Scalars['Int']['input'];
};


export type MutationInvitationDeleteManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationInvitationDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationInvitationUpdateArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  invitationType?: InputMaybe<InvitationType>;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']['input']>;
  shouldCreateAccount?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationJobRoleCreateOneArgs = {
  companyId: Scalars['Int']['input'];
  family?: InputMaybe<JobRoleFamily>;
  name: Scalars['String']['input'];
  qualifier?: InputMaybe<Scalars['String']['input']>;
  roleLevel: ContentRoleLevel;
  source?: InputMaybe<JobRoleSource>;
};


export type MutationJobRoleDeleteOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationJobRoleDuplicateArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationJobRoleSoftDeleteOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationJobRoleUpdateOneArgs = {
  family?: InputMaybe<JobRoleFamily>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationLocationLinkCreateManyArgs = {
  links: Array<LocationLinkCreateArgs>;
};


export type MutationLocationLinkCreateOneArgs = {
  companyId: Scalars['Int']['input'];
  locationName: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  userGroupId: Scalars['Int']['input'];
};


export type MutationLocationLinkDeleteManyArgs = {
  args: LocationLinkDeleteManyArgs;
};


export type MutationMarkCandidateAsHiredArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationMarkCandidatesAsHiredArgs = {
  subIds: Array<Scalars['ID']['input']>;
};


export type MutationMeetingCreateOneArgs = {
  attendees?: Array<CreateMeetingAttendeeArgs>;
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  interviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectCandidateId?: InputMaybe<Scalars['Int']['input']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  recordingConfig?: InputMaybe<Array<RecordingConfigArgs>>;
  status?: MeetingStatus;
  transcriptConfig?: InputMaybe<Array<TranscriptConfigArgs>>;
  type?: MeetingScope;
};


export type MutationMeetingDeleteOneArgs = {
  meetingId: Scalars['String']['input'];
};


export type MutationMeetingGenerateTranslatedTranscriptArgs = {
  id: Scalars['String']['input'];
};


export type MutationMeetingParticipantCreateManyArgs = {
  meetingId: Scalars['ID']['input'];
  participants: Array<MeetingParticipantArgs>;
};


export type MutationMeetingRecordingCompleteUploadArgs = {
  attendees?: Array<CreateMeetingAttendeeArgs>;
  date: Scalars['DateTime']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  interviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  mediaFormat?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parts: Array<MultipartCompletedPart>;
  projectCandidateId?: InputMaybe<Scalars['Int']['input']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  status?: MeetingStatus;
  type?: MeetingScope;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  uploadId: Scalars['String']['input'];
};


export type MutationMeetingRecordingCreateUploadArgs = {
  mediaFormat: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parts: Scalars['Int']['input'];
};


export type MutationMeetingRecordingDeleteUploadArgs = {
  key: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationMeetingSummaryGenerateOneArgs = {
  meetingId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationMeetingSummaryUpdateOneArgs = {
  id: Scalars['String']['input'];
  payload: Scalars['String']['input'];
};


export type MutationMeetingTypeCreateOneArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  scope: MeetingScope;
  templateId: Scalars['String']['input'];
};


export type MutationMeetingTypeUpdateOneArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<MeetingScope>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMeetingUpdateOneArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCandidateId?: InputMaybe<Scalars['Int']['input']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  recordingConfig?: InputMaybe<Array<RecordingConfigArgs>>;
  transcriptConfig?: InputMaybe<Array<TranscriptConfigArgs>>;
  type?: InputMaybe<MeetingScope>;
};


export type MutationMeetingUserCalendarDeleteOneArgs = {
  externalCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOverwriteInterviewStageSkillsArgs = {
  id: Scalars['ID']['input'];
  skillsProfileId: Scalars['Int']['input'];
  softSkillIds: Array<Scalars['Int']['input']>;
  technicalSkillIds: Array<Scalars['Int']['input']>;
};


export type MutationProgressCandidateArgs = {
  inviteMethod?: InputMaybe<StageCandidateInviteMethod>;
  stageId: Scalars['Int']['input'];
  stageType: StageType;
  subId: Scalars['ID']['input'];
};


export type MutationProgressCandidatesArgs = {
  deadlineInEmail?: InputMaybe<Scalars['Date']['input']>;
  inviteMethod?: InputMaybe<StageCandidateInviteMethod>;
  stageId: Scalars['Int']['input'];
  stageType: StageType;
  subIds: Array<Scalars['ID']['input']>;
};


export type MutationProjectAddInterviewStageArgs = {
  duration?: Scalars['Int']['input'];
  focus?: InputMaybe<InterviewStageFocus>;
  name: Scalars['String']['input'];
  subId: Scalars['ID']['input'];
};


export type MutationProjectAddShortlistStageArgs = {
  name: Scalars['String']['input'];
  subId: Scalars['ID']['input'];
};


export type MutationProjectArtifactCompleteJobDescriptionUploadArgs = {
  args: ProjectCompleteJobDescriptionUploadArgs;
  projectSubId: Scalars['ID']['input'];
};


export type MutationProjectArtifactDeleteJobDescriptionArgs = {
  projectSubId: Scalars['ID']['input'];
};


export type MutationProjectArtifactInitiateJobDescriptionUploadArgs = {
  args: ProjectInitiateJobDescriptionUploadArgs;
  projectSubId: Scalars['ID']['input'];
};


export type MutationProjectArtifactLinkMeetingArgs = {
  meetingId: Scalars['ID']['input'];
  projectSubId: Scalars['ID']['input'];
};


export type MutationProjectArtifactUnlinkMeetingArgs = {
  projectSubId: Scalars['ID']['input'];
};


export type MutationProjectCandidateDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationProjectCandidateInviteManyArgs = {
  assessmentInviteSettings?: InputMaybe<ProjectCandidateAssessmentInviteSettings>;
  projectSubId: Scalars['ID']['input'];
  settings: ProjectCandidateInvitationSettings;
  userDetails: Array<ProjectCandidateUserDetails>;
};


export type MutationProjectCandidateInviteToAssessmentArgs = {
  assessmentInviteSettings: ProjectCandidateAssessmentInviteSettings;
  settings: ProjectCandidateInvitationSettingsWithoutAssignees;
  subId: Scalars['ID']['input'];
};


export type MutationProjectCandidateUpdateDeadlineArgs = {
  deadlineAt?: InputMaybe<Scalars['Date']['input']>;
  subId: Scalars['ID']['input'];
};


export type MutationProjectCandidateUpsertAssigneesArgs = {
  args: ProjectCandidateUpsertAssigneesArgs;
  subId: Scalars['ID']['input'];
};


export type MutationProjectCollaboratorsCreateManyArgs = {
  collaborators: Array<ProjectCollaboratorCreateOneArgs>;
};


export type MutationProjectCollaboratorsDeleteManyArgs = {
  collaborators: Array<Scalars['Int']['input']>;
};


export type MutationProjectCollaboratorsUpdateRoleArgs = {
  newActorRole?: InputMaybe<ActorRole>;
  projectTeamMemberId: Scalars['Int']['input'];
};


export type MutationProjectDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectJobRoleCreateOneArgs = {
  isMainRole?: InputMaybe<Scalars['Boolean']['input']>;
  jobRoleId: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
  skillsProfileId: Scalars['Int']['input'];
};


export type MutationProjectJobRoleDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectJobRoleSetMainArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectJobRoleSoftDeleteOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  skillsProfileId?: InputMaybe<Scalars['Int']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationProjectRequestCreateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyId: Scalars['Int']['input'];
  creatorId: Scalars['Int']['input'];
  projectName: Scalars['String']['input'];
  status?: InputMaybe<ProjectRequestStatus>;
};


export type MutationProjectRequestDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectRequestFileUploadArgs = {
  args: ProjectRequestFileUploadArgs;
  file: Scalars['Upload']['input'];
};


export type MutationProjectRequestFileUploadDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectRequestFileUploadSoftDeleteOneArgs = {
  blobId?: InputMaybe<Scalars['Int']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectRequestLinkProjectArgs = {
  id: Scalars['Int']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationProjectRequestRequestJobSpecificationArgs = {
  id: Scalars['Int']['input'];
  projectRequestUserIds: Array<Scalars['Int']['input']>;
};


export type MutationProjectRequestRequestManagerSurveyArgs = {
  id: Scalars['Int']['input'];
  projectRequestUserIds: Array<Scalars['Int']['input']>;
  surveyLink: Scalars['String']['input'];
};


export type MutationProjectRequestRestoreOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  managerSurveyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<ProjectRequestStatus>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type MutationProjectRequestSoftDeleteOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  managerSurveyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectRequestStatus>;
};


export type MutationProjectRequestUpdateManagerSurveyArgs = {
  id: Scalars['Int']['input'];
  managerSurveyId: Scalars['String']['input'];
};


export type MutationProjectRequestUpdateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  managerSurveyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectRequestStatus>;
};


export type MutationProjectRequestUserApprovalCreateManyArgs = {
  dto: Array<IProjectRequestUserApprovalCreateOneArgs>;
};


export type MutationProjectRequestUserApprovalCreateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  projectRequestUserId: Scalars['Int']['input'];
};


export type MutationProjectRequestUserApprovalDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectRequestUserApprovalSoftDeleteOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectRequestUserApprovalUpdateManyArgs = {
  dto: Array<IProjectRequestUserApprovalUpdateOneArgs>;
};


export type MutationProjectRequestUserApprovalUpdateOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  id: Scalars['Int']['input'];
};


export type MutationProjectRequestUserCreateManyArgs = {
  dto: Array<IProjectRequestUserCreateOneWithEmployeeCheckArgs>;
};


export type MutationProjectRequestUserCreateOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  projectRequestId: Scalars['Int']['input'];
  type: ProjectRequestUserType;
};


export type MutationProjectRequestUserDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectRequestUserSoftDeleteOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectRequestUserType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectRequestUserUpdateOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ProjectRequestUserType>;
};


export type MutationProjectSetCompanySignatureArgs = {
  companySignatureId?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
};


export type MutationProjectStagesReorderArgs = {
  stageOrderArgs: Array<ProjectStageOrderArgs>;
};


export type MutationProjectUpdateStatusArgs = {
  projectId: Scalars['Int']['input'];
  status: ProjectStatus;
};


export type MutationProjectUserDeleteOneArgs = {
  projectId: Scalars['Float']['input'];
  userId: Scalars['Float']['input'];
};


export type MutationProjectUserUpdateOneArgs = {
  actorRole: ActorRole;
  projectId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationProjectWizardCreateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration: Scalars['Int']['input'];
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName: Scalars['String']['input'];
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationProjectWizardCreateAssessmentStageArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport: Scalars['Boolean']['input'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
  skillsProfileId: Scalars['Int']['input'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationProjectWizardCreateInterviewStageArgs = {
  companyId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  focus?: InputMaybe<InterviewStageFocus>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationProjectWizardCreateProjectArgs = {
  companyId: Scalars['Int']['input'];
  jobRoleId: Scalars['Int']['input'];
  locales: Array<SupportedLocale>;
  managers: Array<CreateProjectManagerInput>;
  name: Scalars['String']['input'];
  skillProfileId: Scalars['Int']['input'];
};


export type MutationProjectWizardCreateShortlistStageArgs = {
  name: Scalars['String']['input'];
  subId: Scalars['ID']['input'];
};


export type MutationProjectWizardInterviewStageDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationProjectWizardInterviewStageUpdateArgs = {
  data: InterviewStageUpdateData;
  subId: Scalars['ID']['input'];
};


export type MutationProjectWizardInterviewStageUpdateDurationArgs = {
  duration: Scalars['Int']['input'];
  subId: Scalars['ID']['input'];
};


export type MutationProjectWizardProjectCollaboratorsCreateManyArgs = {
  collaborators: Array<ProjectCollaboratorCreateOneArgs>;
};


export type MutationProjectWizardProjectCollaboratorsDeleteManyArgs = {
  collaborators: Array<Scalars['Int']['input']>;
};


export type MutationProjectWizardShortlistStageDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationProjectWizardStageDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationProjectWizardUpdateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']['input']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
  stageId: Scalars['Int']['input'];
};


export type MutationProjectWizardUpdateStageReportEmailSettingsArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
};


export type MutationProjectWizardUpdateStatusArgs = {
  projectId: Scalars['Int']['input'];
  status: ProjectStatus;
};


export type MutationQCalcGetNextQuestionArgs = {
  answers?: InputMaybe<Array<AssessmentDataAnswerGqlModel>>;
  assessmentSubId: Scalars['String']['input'];
  nQuestions?: Scalars['Int']['input'];
};


export type MutationQuestionnaireSubmitResponsesArgs = {
  responses: Array<QuestionnaireItemResponseGqlInput>;
  shortlistStageCandidateId: Scalars['Int']['input'];
};


export type MutationRejectCandidatesArgs = {
  rejectionReasonId?: InputMaybe<Scalars['String']['input']>;
  subIds: Array<Scalars['ID']['input']>;
};


export type MutationReportAssignmentCreateArgs = {
  assignedId: Scalars['Int']['input'];
  assignedType: RAssignedType;
  reportId: Scalars['Int']['input'];
};


export type MutationReportAssignmentDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReportAssignmentUpdateArgs = {
  assignedId: Scalars['Int']['input'];
  assignedType: RAssignedType;
  id: Scalars['Int']['input'];
  reportId: Scalars['Int']['input'];
};


export type MutationReportConfigCreateArgs = {
  newPageBefore?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  reportId: Scalars['Int']['input'];
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
  widgetId: Scalars['Int']['input'];
};


export type MutationReportConfigDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReportCopyArgs = {
  copyReportId: Scalars['Int']['input'];
  footerType?: InputMaybe<ReportFooterType>;
  name: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  ownerType: ReportOwnerType;
  subType?: InputMaybe<ReportSubType>;
  type: ReportType;
};


export type MutationReportCreateArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  name: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  ownerType: ReportOwnerType;
  subType?: InputMaybe<ReportSubType>;
  type: ReportType;
};


export type MutationReportDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReportRenderCreateArgs = {
  dataSourceId: Scalars['Int']['input'];
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  reportId: Scalars['Int']['input'];
  reportRenderType: ReportRenderType;
};


export type MutationReportRenderDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReportUpdateArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reportConfigsToCreate?: InputMaybe<Array<ReportConfigCreateOneBatchedWithReportArgs>>;
  reportConfigsToDelete?: InputMaybe<Array<DeleteByIdArgs>>;
  reportConfigsToUpdate?: InputMaybe<Array<ReportConfigUpdateOneArgs>>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type MutationReportUpdateIsArchivedArgs = {
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
};


export type MutationRequeueRejectedEventArgs = {
  id: Scalars['Int']['input'];
};


export type MutationResetShortlistStageCandidateQuestionnaireArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRespondantFormDeleteByRespondantAndAssociatedIdArgs = {
  associatedId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
};


export type MutationRespondantFormDeleteByRespondantIdArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRespondantFormUpdateArgs = {
  answers?: InputMaybe<Array<UpdateRespondantFormAnswerArgs>>;
  associatedId: Scalars['Int']['input'];
  formOwnerId: Scalars['Int']['input'];
  formType: FormType;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  respondantId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationResultCreateManySoftSkillsProfileFromScArgs = {
  args: Array<ResultSoftSkillProfileCreateOneFromSc>;
};


export type MutationResultCreateManyTechnicalSkillsProfileFromScArgs = {
  args: Array<ResultTechnicalSkillProfileCreateOneFromSc>;
};


export type MutationResultCreateOneBehaviourArgs = {
  copiedFrom?: InputMaybe<Scalars['Int']['input']>;
  doneBy: Scalars['Int']['input'];
  doneFor: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  manuallyAdjustedBy?: InputMaybe<Scalars['Int']['input']>;
  measurementId: Scalars['Int']['input'];
  measurementType: ResultMeasurementType;
  normGroupStatisticsId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  score: IIgBehaviourResultScoreModel;
};


export type MutationResultCreateOnePspSoftSkillArgs = {
  score: ISoftSkillSelfAssessmentScoreModel;
  softSkillId: Scalars['Int']['input'];
};


export type MutationResultCreateOnePspTechnicalSkillArgs = {
  score: ITechnicalSkillSelfAssessmentScoreModel;
  technicalSkillId: Scalars['Int']['input'];
};


export type MutationResultDeleteManyArgs = {
  copiedFrom?: InputMaybe<Scalars['Int']['input']>;
  copiedFroms?: InputMaybe<Array<Scalars['Int']['input']>>;
  doneBy?: InputMaybe<Scalars['Int']['input']>;
  doneBys?: InputMaybe<Array<Scalars['Int']['input']>>;
  doneFor?: InputMaybe<Scalars['Int']['input']>;
  doneFors?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  manuallyAdjustedBy?: InputMaybe<Scalars['Int']['input']>;
  manuallyAdjustedBys?: InputMaybe<Array<Scalars['Int']['input']>>;
  measurementId?: InputMaybe<Scalars['Int']['input']>;
  measurementIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  measurementType?: InputMaybe<ResultMeasurementType>;
  measurementTypes?: InputMaybe<Array<ResultMeasurementType>>;
  normGroupStatisticsId?: InputMaybe<Scalars['Int']['input']>;
  onlyLatest?: InputMaybe<Scalars['Boolean']['input']>;
  onlyLatestVersionPerLabel?: InputMaybe<Scalars['Boolean']['input']>;
  previousVersionId?: InputMaybe<Scalars['Int']['input']>;
  previousVersionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  scoreType?: InputMaybe<ResultScoreType>;
  scoreTypes?: InputMaybe<Array<ResultScoreType>>;
  version?: InputMaybe<Scalars['Int']['input']>;
  versions?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationResultUpdateOneBehaviourArgs = {
  copiedFrom?: InputMaybe<Scalars['Int']['input']>;
  doneBy: Scalars['Int']['input'];
  doneFor: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  manuallyAdjustedBy?: InputMaybe<Scalars['Int']['input']>;
  measurementId: Scalars['Int']['input'];
  measurementType: ResultMeasurementType;
  normGroupStatisticsId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  score: IIgBehaviourResultScoreModel;
};


export type MutationRetryResumeProcessingArgs = {
  resumeSubId: Scalars['ID']['input'];
};


export type MutationRoleBatchArchiveArgs = {
  roleIds: Array<Scalars['Int']['input']>;
};


export type MutationRoleBatchPinArgs = {
  roleIds: Array<Scalars['Int']['input']>;
};


export type MutationRoleBatchUnpinArgs = {
  roleIds: Array<Scalars['Int']['input']>;
};


export type MutationRoleBatchUpdateStatusArgs = {
  roleIds: Array<Scalars['Int']['input']>;
  status: RoleStatus;
};


export type MutationRoleLinkRequisitionArgs = {
  removeCandidates?: Scalars['Boolean']['input'];
  requisitionId: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};


export type MutationRolePinArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleStagesReorderArgs = {
  stageOrderArgs: Array<RoleStageOrderArgs>;
};


export type MutationRoleUnlinkRequisitionArgs = {
  id: Scalars['Int']['input'];
  removeCandidates?: Scalars['Boolean']['input'];
};


export type MutationRoleUnpinArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardAddSoftSkillsArgs = {
  roleId: Scalars['Int']['input'];
  softSkillSubIds: Array<Scalars['String']['input']>;
};


export type MutationRoleWizardAddTeamMembersArgs = {
  roleId: Scalars['Int']['input'];
  teamMembers: Array<RoleTeamMemberInput>;
};


export type MutationRoleWizardAddTechnicalSkillsArgs = {
  roleId: Scalars['Int']['input'];
  skills: Array<TechnicalSkillInput>;
};


export type MutationRoleWizardApplyHiringProcessTemplateArgs = {
  roleId: Scalars['Int']['input'];
  templateId: Scalars['Int']['input'];
};


export type MutationRoleWizardArchiveArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardClearHiringProcessArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardCompleteJobDescriptionUploadArgs = {
  etag: Scalars['String']['input'];
  key: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
  uploadId: Scalars['String']['input'];
};


export type MutationRoleWizardConfirmRspArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardCreateArgs = {
  companyId: Scalars['Int']['input'];
  family: JobRoleFamily;
  name: Scalars['String']['input'];
  requisitionId?: InputMaybe<Scalars['String']['input']>;
  roleLevel: ContentRoleLevel;
};


export type MutationRoleWizardCreateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration: Scalars['Int']['input'];
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationRoleWizardCreateAssessmentStageArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
  skillsProfileId: Scalars['Int']['input'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
};


export type MutationRoleWizardCreateContentStageArgs = {
  blocks: Array<ContentStageBlockInput>;
  description: Scalars['String']['input'];
  estimatedDurationMinutes: Scalars['Int']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardCreateInterviewStageArgs = {
  companyId: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  focus?: InputMaybe<InterviewStageFocus>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationRoleWizardCreateShortlistStageArgs = {
  name: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardDeleteContentStageArgs = {
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardDeleteInterviewStageArgs = {
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardDeleteJobDescriptionArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardDeleteShortlistStageArgs = {
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardDeleteStageArgs = {
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardGenerateSkillsArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardInitiateJobDescriptionUploadArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardLinkIntakeMeetingArgs = {
  meetingId: Scalars['String']['input'];
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardRemoveHiringProcessTemplateArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardRemoveRspSkillsArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardRemoveSoftSkillArgs = {
  roleId: Scalars['Int']['input'];
  softSkillSubId: Scalars['String']['input'];
};


export type MutationRoleWizardRemoveTeamMemberArgs = {
  roleId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRoleWizardRemoveTechnicalSkillArgs = {
  roleId: Scalars['Int']['input'];
  technicalSkillId: Scalars['Int']['input'];
};


export type MutationRoleWizardRoleArchiveArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardRoleUpdateStatusArgs = {
  id: Scalars['Int']['input'];
  status: RoleStatus;
};


export type MutationRoleWizardUnlinkIntakeMeetingArgs = {
  roleId: Scalars['Int']['input'];
};


export type MutationRoleWizardUnlinkRequisitionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRoleWizardUpdateArgs = {
  candidatePortalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  candidatePortalIntro?: InputMaybe<Scalars['String']['input']>;
  candidatePortalTitle?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  family?: InputMaybe<JobRoleFamily>;
  hiringProcessAbsoluteDeadlineAt?: InputMaybe<Scalars['Date']['input']>;
  hiringProcessDeadlineType?: InputMaybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: InputMaybe<Scalars['Int']['input']>;
  hiringProcessRelativeDeadlineUnit?: InputMaybe<HiringProcessDeadlineUnit>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reminderEmailCadenceDays?: InputMaybe<Scalars['Int']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
};


export type MutationRoleWizardUpdateAiInterviewAssessmentStageArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']['input']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['Int']['input'];
  stageActionLocales?: InputMaybe<Array<AssessmentStageActionLocales>>;
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardUpdateAssessmentStageEmailSettingsArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport: Scalars['Boolean']['input'];
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardUpdateContentStageArgs = {
  blocks?: InputMaybe<Array<ContentStageBlockInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardUpdateInterviewStageArgs = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  focus?: InputMaybe<InterviewStageFocus>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationRoleWizardUpdateSkillsProfileTemplateArgs = {
  roleId: Scalars['Int']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRssAssessmentCandidateReopenAllSubmittedForStageCandidateArgs = {
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationRssAssessmentCandidateSubmitOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRssAssessmentCreateManyArgs = {
  dto: Array<RssAssessmentCreateOneArgs>;
};


export type MutationRssAssessmentDeleteManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationSamlAuthInfoCreateOneArgs = {
  cert: Scalars['String']['input'];
  entryPoint: Scalars['String']['input'];
  identityProviderId: Scalars['Int']['input'];
  issuer: Scalars['String']['input'];
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSamlAuthInfoDeleteOneArgs = {
  cert?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityProviderId?: InputMaybe<Scalars['Int']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSamlAuthInfoRestoreOneArgs = {
  cert?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityProviderId?: InputMaybe<Scalars['Int']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSamlAuthInfoSoftDeleteOneArgs = {
  cert?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityProviderId?: InputMaybe<Scalars['Int']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSamlAuthInfoUpdateOneArgs = {
  cert?: InputMaybe<Scalars['String']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  identityProviderId?: InputMaybe<Scalars['Int']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScheduleCandidatesDebriefExportArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  includeRejected?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
};


export type MutationScheduleRoiCsvFileExportArgs = {
  projectIds: Array<Scalars['Int']['input']>;
};


export type MutationScheduleStageCandidateResultsCsvFileExportArgs = {
  exportLevel: CandidateResultsExportLevel;
  includeFormsData?: InputMaybe<Scalars['Boolean']['input']>;
  lastDateOfCandidateActionFrom?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionTo?: InputMaybe<Scalars['Date']['input']>;
  projectId: Scalars['Int']['input'];
  stageId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationScheduledCandidateUsageCsvFileExportArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  stageCandidateCreatedAtFrom?: InputMaybe<Scalars['Date']['input']>;
  stageCandidateCreatedAtTo?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationSchedulingDeadLetterReplayArgs = {
  limit: Scalars['Int']['input'];
};


export type MutationShortlistCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationShortlistStageConfigureArgs = {
  applicationQuestionDrafts?: InputMaybe<Array<ShortlistStageApplicationQuestionDraft>>;
  borderlineQuestionsId?: InputMaybe<Scalars['String']['input']>;
  calibrationAnswers?: InputMaybe<CalibrationAnswersInput>;
  criterionDrafts: Array<ShortlistStageCriterionDraft>;
  id: Scalars['ID']['input'];
  weightingStrategy?: InputMaybe<ShortlistStageWeightingStrategy>;
};


export type MutationShortlistStageDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationShortlistStageQuestionnaireConfigureArgs = {
  id: Scalars['ID']['input'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<QuestionnaireItemDraftInput>;
};


export type MutationShortlistStageUpdateAutoProgressionArgs = {
  id: Scalars['ID']['input'];
  isAutoProgressionEnabled: Scalars['Boolean']['input'];
};


export type MutationShortlistStageUpdateCriteriaArgs = {
  criterionDrafts: Array<ShortlistStageCriterionDraft>;
  id: Scalars['ID']['input'];
};


export type MutationShortlistStageUpdateNameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationSkillsEvaluationUpdateOneV2Args = {
  id: Scalars['String']['input'];
  isUserUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  skills?: InputMaybe<Array<SkillArgs>>;
};


export type MutationSkillsProfileSourceAddSoftSkillsArgs = {
  args: Array<SkillsProfileSourceAddSoftSkillsArgs>;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceAddTechnicalSkillsArgs = {
  args: Array<SkillsProfileSourceAddTechnicalSkillsArgs>;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceArchiveSoftSkillArgs = {
  args: SkillsProfileSourceRemoveSoftSkillArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceArchiveTechnicalSkillArgs = {
  args: SkillsProfileSourceRemoveTechnicalSkillArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceCompleteIntakeMeetingUploadArgs = {
  args: SkillsProfileSourceCompleteIntakeMeetingUploadArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceCompleteJobDescriptionUploadArgs = {
  args: SkillsProfileSourceCompleteJobDescriptionUploadArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceCreateArgs = {
  collaborators: Array<SkillsProfileSourceCollaboratorArgs>;
  companyId: Scalars['Int']['input'];
  jobRoleMetadata: SkillsProfileSourceJobRoleMetadataArgs;
};


export type MutationSkillsProfileSourceDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceDeleteIntakeMeetingArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceDeleteJobDescriptionArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceGenerateSkillsArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceInitiateIntakeMeetingUploadArgs = {
  args: SkillsProfileSourceInitiateIntakeMeetingUploadArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceInitiateJobDescriptionUploadArgs = {
  args: SkillsProfileSourceInitiateJobDescriptionUploadArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceLinkMeetingArgs = {
  meetingId: Scalars['ID']['input'];
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceLinkUpcomingMeetingArgs = {
  subId: Scalars['ID']['input'];
  upcomingMeetingSharedId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceRemoveSoftSkillArgs = {
  args: SkillsProfileSourceRemoveSoftSkillArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceRemoveTechnicalSkillArgs = {
  args: SkillsProfileSourceRemoveTechnicalSkillArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceSignOffArgs = {
  args: SkillsProfileSourceSignOffArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceUnlinkMeetingArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceUnlinkUpcomingMeetingArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceUpdateArgs = {
  args: SkillsProfileSourceUpdateArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSkillsProfileSourceUpsertCollaboratorsArgs = {
  args: SkillsProfileSourceUpsertCollaboratorsArgs;
  subId: Scalars['ID']['input'];
};


export type MutationSoftSkillAddTraitArgs = {
  addEmptyContent?: InputMaybe<Scalars['Boolean']['input']>;
  orientation: Orientation;
  softSkillId: Scalars['Int']['input'];
  traitId: Scalars['Int']['input'];
  weight: Scalars['Float']['input'];
};


export type MutationSoftSkillBulkUpdateTraitsArgs = {
  softSkillTraits: Array<BulkUpdateSoftSkillTraitArgsSingle>;
};


export type MutationSoftSkillCreateArgs = {
  category: SoftSkillCategory;
  childSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Array<Scalars['String']['input']>>;
  granularity?: InputMaybe<SoftSkillGranularity>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name: Scalars['String']['input'];
  parentSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  taxonomyVersion?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSoftSkillDeleteTraitArgs = {
  softSkillId: Scalars['Int']['input'];
  traitId: Scalars['Int']['input'];
};


export type MutationSoftSkillRestoreArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSoftSkillRoleLevelContentUpdateArgs = {
  candidateContent?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hiringManagerContent?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  internalCandidateContent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSoftSkillRoleLevelContentUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationSoftSkillSoftDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationSoftSkillSuccessProfileContentCreateArgs = {
  description: Scalars['String']['input'];
  roleLevel: ContentRoleLevel;
  shortDescription: Scalars['String']['input'];
  softSkillId: Scalars['Int']['input'];
};


export type MutationSoftSkillSuccessProfileContentDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSoftSkillSuccessProfileContentUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  roleLevel?: InputMaybe<ContentRoleLevel>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSoftSkillTypeSuccessProfileContentCreateArgs = {
  description: Scalars['String']['input'];
  softSkillType: SoftSkillType;
};


export type MutationSoftSkillTypeSuccessProfileContentDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSoftSkillTypeSuccessProfileContentUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  softSkillType?: InputMaybe<SoftSkillType>;
};


export type MutationSoftSkillUpdateArgs = {
  args: SoftSkillUpdateArgs;
  subId: Scalars['ID']['input'];
};


export type MutationStageBrandingUpsertArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  estimatedTimeMinutes?: InputMaybe<Scalars['Int']['input']>;
  stageSubId: Scalars['ID']['input'];
  stageType: StageType;
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStageCandidateAcceptIndirectInvitationArgs = {
  hiringManagers?: InputMaybe<Array<HiringManager>>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  stageId: Scalars['Int']['input'];
};


export type MutationStageCandidateDeleteOneArgs = {
  subId: Scalars['String']['input'];
};


export type MutationStageCandidatePledgeAnticheatingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationStageCandidateReprocessOneArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['Int']['input']>;
  doneBy?: InputMaybe<Scalars['Int']['input']>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StageCandidateStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStageCandidateResetOneArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['Int']['input']>;
  doneBy?: InputMaybe<Scalars['Int']['input']>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StageCandidateStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStageCandidateSubmitAdjustmentQuestionnaireArgs = {
  responses: Array<AdjustmentQuestionnaireResponse>;
  stageCandidateId: Scalars['Int']['input'];
};


export type MutationStageCandidateUpdateDeadlineArgs = {
  deadlineAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationStageCreateArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']['input']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']['input']>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  cognitiveMode: CognitiveMode;
  emailCandidateReport: Scalars['Boolean']['input'];
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<AssessmentStageKind>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<StageStatus>;
};


export type MutationStageDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationStageResultsReportRenderCreateArgs = {
  dataSourceId: Scalars['Int']['input'];
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  projectJobRoleId: Scalars['Int']['input'];
  reportId: Scalars['Int']['input'];
  reportRenderType: ReportRenderType;
};


export type MutationStageUpdateArgs = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']['input']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']['input']>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']['input']>;
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationSuccessProfileAddSoftSkillsArgs = {
  softSkillSubId: Scalars['ID']['input'];
  successProfileId: Scalars['Int']['input'];
};


export type MutationSuccessProfileAddTechnicalSkillsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  successProfileId: Scalars['Int']['input'];
};


export type MutationSuccessProfileConfirmArgs = {
  selectedAssessments: SuccessProfileSelectedAssessments;
  successProfileId: Scalars['Int']['input'];
};


export type MutationSuccessProfileCreateArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  jobRoleId: Scalars['Int']['input'];
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs>;
};


export type MutationSuccessProfileCreateOneArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  jobRoleId: Scalars['Int']['input'];
};


export type MutationSuccessProfileDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSuccessProfileDeleteManyArgs = {
  calculationMethod?: InputMaybe<CalculationMethod>;
  gradingMethod?: InputMaybe<GradingMethod>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
  jobRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationSuccessProfileGenerateSkillsArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSuccessProfileRemoveSoftSkillArgs = {
  softSkillSubId: Scalars['ID']['input'];
  successProfileId: Scalars['Int']['input'];
};


export type MutationSuccessProfileRemoveTechnicalSkillArgs = {
  successProfileId: Scalars['Int']['input'];
  technicalSkillId: Scalars['Int']['input'];
};


export type MutationSuccessProfileReportRenderCreateArgs = {
  dataSourceId: Scalars['Int']['input'];
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  reportId: Scalars['Int']['input'];
  reportRenderType: ReportRenderType;
};


export type MutationSuccessProfileSoftSkillsOverwriteArgs = {
  id: Scalars['Int']['input'];
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillCreateManyArgs = {
  dto: Array<SuccessProfileTechnicalSkillCreateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillCreateOneArgs = {
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId: Scalars['Int']['input'];
};


export type MutationSuccessProfileTechnicalSkillDeleteManyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  successProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationSuccessProfileTechnicalSkillDeleteOneArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuccessProfileTechnicalSkillOverwriteManyArgs = {
  dto: Array<SuccessProfileTechnicalSkillCreateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillSoftDeleteManyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  successProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationSuccessProfileTechnicalSkillSoftDeleteOneArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuccessProfileTechnicalSkillUpdateManyArgs = {
  dto: Array<SuccessProfileTechnicalSkillUpdateOneArgs>;
};


export type MutationSuccessProfileTechnicalSkillUpdateOneArgs = {
  id: Scalars['Int']['input'];
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuccessProfileTechnicalSkillsOverwriteArgs = {
  id: Scalars['Int']['input'];
  technicalSkills: Array<SuccessProfileTechnicalSkillCreateOneArgs>;
};


export type MutationSuccessProfileUpdateArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  id: Scalars['Int']['input'];
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
  softSkills: Array<SuccessProfileSoftSkillCreateOneArgs>;
};


export type MutationSuccessProfileUpdateOneArgs = {
  calculationMethod: CalculationMethod;
  gradingMethod: GradingMethod;
  id: Scalars['Int']['input'];
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSummaryTemplateCreateOneArgs = {
  isReady?: Scalars['Boolean']['input'];
  longDescription?: InputMaybe<Scalars['String']['input']>;
  messages?: Array<TemplateMessageArgs>;
  modelName?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scope: SummaryTemplateScope;
  sections?: InputMaybe<Array<TemplateSectionArgs>>;
  seed?: Scalars['Int']['input'];
  sharedWith?: InputMaybe<Array<Scalars['Int']['input']>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  temperature?: Scalars['Float']['input'];
  topP?: Scalars['Float']['input'];
  type: TemplateType;
};


export type MutationSummaryTemplateDeleteOneArgs = {
  id: Scalars['String']['input'];
};


export type MutationSummaryTemplateUpdateOneArgs = {
  id: Scalars['String']['input'];
  isReady?: InputMaybe<Scalars['Boolean']['input']>;
  longDescription?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<TemplateMessageArgs>>;
  modelName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<SummaryTemplateScope>;
  sections?: InputMaybe<Array<TemplateSectionArgs>>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  sharedWith?: InputMaybe<Array<Scalars['Int']['input']>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
  topP?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<TemplateType>;
};


export type MutationSzAdminReportRenderRetryArgs = {
  reportRenderSubIds: Array<Scalars['String']['input']>;
};


export type MutationSzSkillsMergeCreateManyArgs = {
  dto: Array<SzSkillsMergeCreateOneArgs>;
};


export type MutationSzSkillsMergeCreateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name: Scalars['String']['input'];
  originId: Scalars['Int']['input'];
  skillType: SkillType;
};


export type MutationSzSkillsMergeDeleteManyArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  measurementConstructTypes?: InputMaybe<Array<MeasurementConstructType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  originIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skillType?: InputMaybe<SkillType>;
  skillTypes?: InputMaybe<Array<SkillType>>;
};


export type MutationSzSkillsMergeDeleteOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  skillType?: InputMaybe<SkillType>;
};


export type MutationSzSkillsMergeSoftDeleteManyArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  measurementConstructTypes?: InputMaybe<Array<MeasurementConstructType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  originIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skillType?: InputMaybe<SkillType>;
  skillTypes?: InputMaybe<Array<SkillType>>;
};


export type MutationSzSkillsMergeSoftDeleteOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  skillType?: InputMaybe<SkillType>;
};


export type MutationSzSkillsMergeUpdateManyArgs = {
  dto: Array<SzSkillsMergeUpdateOneArgs>;
};


export type MutationSzSkillsMergeUpdateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  skillType?: InputMaybe<SkillType>;
};


export type MutationTechnicalSkillCreateOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  skillCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTechnicalSkillIconUploadArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationTechnicalSkillRestoreArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationTechnicalSkillSoftDeleteArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationTechnicalSkillUpdateArgs = {
  args: TechnicalSkillUpdateArgs;
  subId: Scalars['ID']['input'];
};


export type MutationTraitCreateArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationTraitDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationTraitRoleLevelContentUpdateArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  developmentContent?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTraitRoleLevelContentUploadArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationTraitSoftSkillContextCreateOneArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  traitId: Scalars['Int']['input'];
};


export type MutationTraitSoftSkillContextDeleteManyArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationTraitSoftSkillContextDeleteOneArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationTraitSoftSkillContextFileUploadArgs = {
  apply: Scalars['Boolean']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationTraitTestTypeReplaceManyArgs = {
  dto: Array<TraitTestTypesUpdateOneArgs>;
};


export type MutationTraitUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTraitUpdateIsArchivedArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUnarchiveHiringProcessTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUnarchiveSkillsProfileTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUnmarkCandidateAsHiredArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationUnmarkCandidatesAsHiredArgs = {
  subIds: Array<Scalars['ID']['input']>;
};


export type MutationUnrejectCandidateArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationUnrejectCandidatesArgs = {
  subIds: Array<Scalars['ID']['input']>;
};


export type MutationUnshortlistCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpcomingMeetingAddBotArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpcomingMeetingDeleteManyArgs = {
  olderThanNumberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpcomingMeetingRemoveBotArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpcomingMeetingUpdateOneArgs = {
  attendees?: InputMaybe<Array<Attendee>>;
  botId?: InputMaybe<Scalars['String']['input']>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  calendarPlatform?: InputMaybe<MeetingCalendarPlatform>;
  conferencingPlatform?: InputMaybe<MeetingCalendarPlatform>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  externalMeetingId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Method>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCandidateId?: InputMaybe<Scalars['Int']['input']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MeetingScope>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateHiringProcessTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectAiInterviewConsentEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUpdateProjectCandidatePortalBrandingArgs = {
  candidatePortalIntro?: InputMaybe<Scalars['String']['input']>;
  candidatePortalTitle?: InputMaybe<Scalars['String']['input']>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
};


export type MutationUpdateProjectCandidatePortalEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUpdateProjectHiringProcessDeadlineSettingsArgs = {
  applyAbsoluteDeadlineToInvitedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  hiringProcessAbsoluteDeadlineAt?: InputMaybe<Scalars['Date']['input']>;
  hiringProcessDeadlineType?: InputMaybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: InputMaybe<Scalars['Int']['input']>;
  hiringProcessRelativeDeadlineUnit?: InputMaybe<HiringProcessDeadlineUnit>;
  id: Scalars['Int']['input'];
  reminderEmailCadenceDays?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateProjectIntegrityMonitoringArgs = {
  id: Scalars['Int']['input'];
  isIntegrityMonitoringEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateProjectLocalesArgs = {
  id: Scalars['Int']['input'];
  locales?: InputMaybe<Array<SupportedLocale>>;
  primaryLocale?: InputMaybe<SupportedLocale>;
};


export type MutationUpdateProjectNameArgs = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSkillsProfileTemplateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStageReportEmailSettingsArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  projectTeamEmailSettings: ProjectTeamEmailSettingsArgs;
};


export type MutationUserAnonymiseArgs = {
  subId: Scalars['ID']['input'];
};


export type MutationUserCompanyInfoCreateArgs = {
  companyId: Scalars['Int']['input'];
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationUserCompanyInfoDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUserCompanyInfoUpdateArgs = {
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUserCreateArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPuppet?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<SupportedLocale>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUserDeleteByEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUserGroupCreateOneArgs = {
  companyId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationUserGroupDeleteOneArgs = {
  subId: Scalars['String']['input'];
};


export type MutationUserGroupMembersCreateManyArgs = {
  groupSubId: Scalars['String']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationUserGroupMembersDeleteManyArgs = {
  groupSubId: Scalars['String']['input'];
  userIds: Array<Scalars['Int']['input']>;
};


export type MutationUserGroupUpdateOneArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subId: Scalars['String']['input'];
};


export type MutationUserMeetingConfigurationCreateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationUserMeetingConfigurationUpdateOneArgs = {
  metadata: MeetingMetadataArgs;
};


export type MutationUserRoleCreateArgs = {
  companyId: Scalars['Float']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  role: IdentityPermissionRole;
  userId: Scalars['Float']['input'];
};


export type MutationUserRoleDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUserRoleUpdateArgs = {
  companyId?: InputMaybe<Scalars['Float']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Float']['input'];
  role?: InputMaybe<IdentityPermissionRole>;
};


export type MutationUserSettingsCreateArgs = {
  settings: UserSettingsOptionsArgs;
  userId: Scalars['Int']['input'];
};


export type MutationUserSettingsDeleteOneArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUserSettingsUpdateArgs = {
  id: Scalars['Int']['input'];
  settings: UserSettingsOptionsArgs;
};


export type MutationUserUpdateArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  twoFactorCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWidgetConfigCreateArgs = {
  reportConfigId: Scalars['Int']['input'];
  settings?: InputMaybe<Scalars['String']['input']>;
  widgetOptionId: Scalars['Int']['input'];
};


export type MutationWidgetConfigDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationWidgetConfigUpdateArgs = {
  id: Scalars['Int']['input'];
  settings?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWidgetConfigUpdateManyArgs = {
  widgetConfigUpdates: Array<WidgetConfigUpdateOneArgs>;
};


export type MutationWidgetCreateArgs = {
  name: Scalars['String']['input'];
  type: WidgetType;
};


export type MutationWidgetDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationWidgetDeleteScreenShotArgs = {
  id: Scalars['Int']['input'];
};


export type MutationWidgetOptionCreateArgs = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldType: WidgetOptionFieldType;
  name: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
  widgetId: Scalars['Int']['input'];
};


export type MutationWidgetOptionDeleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationWidgetOptionUpdateArgs = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldType: WidgetOptionFieldType;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWidgetOptionUpdateIsArchivedArgs = {
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
};


export type MutationWidgetOptionUploadBrandedSoftSkillImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationWidgetOptionUploadCoverPageImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationWidgetUpdateArgs = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WidgetType>;
};


export type MutationWidgetUpdateIsArchivedArgs = {
  id: Scalars['Int']['input'];
  isArchived: Scalars['Boolean']['input'];
};


export type MutationWidgetUploadScreenShotArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationAddCoderbyteToAssessmentStageArgs = {
  coderbyteTestId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  stageId: Scalars['ID']['input'];
  technicalSkillIds: Array<Scalars['Int']['input']>;
};


export type MutationAddCognitiveTestToAssessmentStageArgs = {
  kind: CognitiveKind;
  stageId: Scalars['ID']['input'];
};


export type MutationAddEnglishProficiencyToAssessmentStageArgs = {
  requiredCefrLevel: CefrLevel;
  stageId: Scalars['ID']['input'];
};


export type MutationAddPersonalityTestToAssessmentStageArgs = {
  questionsPerTraitCount?: InputMaybe<Scalars['Int']['input']>;
  selectedLocales?: InputMaybe<Array<SupportedLocale>>;
  stageId: Scalars['ID']['input'];
};


export type MutationArchiveAssessmentStageDeiActionArgs = {
  stageId: Scalars['ID']['input'];
};


export type MutationAuthenticateArgs = {
  clientType?: InputMaybe<ClientType>;
  email: Scalars['String']['input'];
  mfaCookie?: InputMaybe<Array<Scalars['String']['input']>>;
  password: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAuthenticateAiAgentArgs = {
  secret: Scalars['String']['input'];
};


export type MutationAuthenticateApiArgs = {
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBackfillAtsApplicationIdsForAllIntegratedCompaniesArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationBackfillAtsApplicationIdsForCompanyArgs = {
  companyId: Scalars['Int']['input'];
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationBackfillAtsAssessmentStageCandidatesArgs = {
  dryRun?: Scalars['Boolean']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationBackfillAtsRejectionReasonsForAllIntegratedCompaniesArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationBackfillAtsRejectionReasonsForCompanyArgs = {
  companyId: Scalars['Int']['input'];
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationBackfillCandidateInterviewGuidesArgs = {
  cigIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationBackfillKomboApplicationsForProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type MutationCancelSchedulingRequestArgs = {
  requestId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationCleanupDuplicateBlueprintsArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationCleanupForbiddenSkillRelationsArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationCleanupStaleEditingSessionsArgs = {
  timeoutMinutes?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateAssessmentStageRssActionArgs = {
  stageId: Scalars['ID']['input'];
  type: RssAssessmentType;
};


export type MutationCreateCoderbyteSsoLinkArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationCreateCompanyArgs = {
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  companyLifecycle?: InputMaybe<CompanyLifecycle>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  hideReports?: InputMaybe<Scalars['Boolean']['input']>;
  isSkillsEvaluationScoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateProjectArgs = {
  companyId: Scalars['Float']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  locales?: InputMaybe<Array<SupportedLocale>>;
  managers?: InputMaybe<Array<CreateProjectManagerInput>>;
  moduleType?: InputMaybe<ProjectModuleType>;
  name: Scalars['String']['input'];
  productSolution: ProductSolution;
  requireSheetsExport?: Scalars['Boolean']['input'];
};


export type MutationCreateProjectFileArgs = {
  downloadUrl: Scalars['String']['input'];
  id: Scalars['Float']['input'];
};


export type MutationCreateRequestMaterialUploadArgs = {
  contentType: Scalars['String']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationCreateSchedulingRequestsArgs = {
  details: SchedulingRequestDetailsInput;
  stageCandidateIds: Array<Scalars['Int']['input']>;
  stageId: Scalars['Int']['input'];
};


export type MutationDeauthenticateArgs = {
  accessToken: Scalars['String']['input'];
};


export type MutationDeleteAiInterviewAssessmentStageActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAssessmentStageRssActionArgs = {
  stageId: Scalars['ID']['input'];
  type: RssAssessmentType;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDiscardSchedulingDraftArgs = {
  batchId: Scalars['ID']['input'];
  stageId: Scalars['Int']['input'];
};


export type MutationDispatchEligibilityInviteForShortlistStageCandidateArgs = {
  shortlistStageCandidateSubId: Scalars['String']['input'];
};


export type MutationEditProjectArgs = {
  companyId: Scalars['Float']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<SupportedLocale>>;
  managers?: InputMaybe<Array<CreateProjectManagerInput>>;
  name: Scalars['String']['input'];
  primaryLocale?: InputMaybe<SupportedLocale>;
  productSolution?: InputMaybe<ProductSolution>;
  requireSheetsExport?: Scalars['Boolean']['input'];
};


export type MutationEditProjectArchivingArgs = {
  id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationEditProjectCandidateReportStateArgs = {
  id: Scalars['Int']['input'];
  renderCandidateReport: Scalars['Boolean']['input'];
};


export type MutationEditProjectStateArgs = {
  id: Scalars['Int']['input'];
  state: Scalars['Boolean']['input'];
};


export type MutationEndIntegrityMonitoringSessionArgs = {
  sessionId: Scalars['ID']['input'];
};


export type MutationEnsureInterviewStageCandidatesArgs = {
  dryRun?: Scalars['Boolean']['input'];
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationFinishAiInterviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationForceStopEditingQuestionArgs = {
  args: CollaborativeEditingForceStopArgs;
};


export type MutationGenerateShareLinkArgs = {
  url: Scalars['String']['input'];
  workspaceId: Scalars['Int']['input'];
};


export type MutationInitiateAiInterviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJoinConferenceArgs = {
  id: Scalars['ID']['input'];
  input: JoinConferenceInput;
};


export type MutationJoinDemoConferenceArgs = {
  id: Scalars['ID']['input'];
  input: JoinConferenceInput;
};


export type MutationKomboCancelSyncArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationKomboClearJobsArgs = {
  companyId: Scalars['Int']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationKomboCreateIntegrationArgs = {
  assessmentIntegrationId?: InputMaybe<Scalars['String']['input']>;
  atsIntegrationId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['Int']['input'];
};


export type MutationKomboDeleteIntegrationArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationKomboDisconnectIntegrationArgs = {
  assessment?: InputMaybe<Scalars['Boolean']['input']>;
  ats?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['Int']['input'];
};


export type MutationKomboLinkProjectArgs = {
  companyId: Scalars['Int']['input'];
  jobId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
};


export type MutationKomboSetAssessmentPackagesArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationKomboToggleEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationKomboToggleSyncEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationKomboUnlinkProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type MutationMfaAccessTokenArgs = {
  clientDomainType: ClientDomainType;
  clientType?: InputMaybe<ClientType>;
  email: Scalars['String']['input'];
  mfaCookie?: InputMaybe<Array<Scalars['String']['input']>>;
  password: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMfaAuthenticateArgs = {
  mfaAccessToken: Scalars['String']['input'];
  mfaCode: Scalars['String']['input'];
};


export type MutationOfferSlotsArgs = {
  batchId: Scalars['ID']['input'];
  slots: Array<SlotWindowInput>;
  stageId: Scalars['Int']['input'];
};


export type MutationOverwriteAssessmentStageSkillsArgs = {
  id: Scalars['ID']['input'];
  skillsProfileId: Scalars['Int']['input'];
  softSkillIds: Array<Scalars['Int']['input']>;
  technicalSkillIds: Array<Scalars['Int']['input']>;
};


export type MutationProcessInvitationArgs = {
  invitationToken: Scalars['String']['input'];
  subId: Scalars['String']['input'];
};


export type MutationProjectWizardDeleteAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationProjectWizardUpdateAssessmentStageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentStageInput;
};


export type MutationProjectWizardUpdateAssessmentStageEmailSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentStageEmailSettingsInput;
};


export type MutationProvisionCoderbyteWorkspaceArgs = {
  companyId: Scalars['Int']['input'];
};


export type MutationRefreshCoderbyteAssessmentDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRegisterAccountArgs = {
  companyId?: InputMaybe<Scalars['Float']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Language>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<SupportedLocale>;
  password: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationRemoveCoderbyteFromAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCognitiveTestFromAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveEnglishProficiencyFromAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePersonalityTestFromAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUntaggedAiQuestionsArgs = {
  dryRun?: Scalars['Boolean']['input'];
};


export type MutationRenameCoderbyteAssessmentArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationReofferSchedulingRequestArgs = {
  requestId: Scalars['ID']['input'];
  slots: Array<SlotWindowInput>;
  version: Scalars['Int']['input'];
};


export type MutationReplaceCompanySchedulingSettingsArgs = {
  input: CompanySchedulingSettingsInput;
};


export type MutationReportIntegrityEventsArgs = {
  events: Array<IntegrityEventInput>;
  sessionId: Scalars['ID']['input'];
};


export type MutationRequestMfaCodeArgs = {
  clientDomainType: ClientDomainType;
  mfaAccessToken: Scalars['String']['input'];
};


export type MutationRequestPasswordRecoveryArgs = {
  clientDomainType: ClientDomainType;
  email: Scalars['String']['input'];
  language?: InputMaybe<Language>;
};


export type MutationRequestTokenRefreshArgs = {
  accessToken: Scalars['String']['input'];
  clientType?: InputMaybe<ClientType>;
  refreshToken: Scalars['String']['input'];
};


export type MutationRescheduleSchedulingRequestArgs = {
  confirmBusy?: Scalars['Boolean']['input'];
  fixedStartsAt?: InputMaybe<Scalars['DateTime']['input']>;
  mode: SchedulingRescheduleMode;
  requestId: Scalars['ID']['input'];
  slots?: InputMaybe<Array<SlotWindowInput>>;
  version: Scalars['Int']['input'];
};


export type MutationResetAiInterviewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetCoderbyteAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetCognitiveTestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPersonalityTestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryCoderbyteAssessmentResultsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationSaveAiInterviewScoreAnnotationArgs = {
  input: AiInterviewScoreAnnotationInput;
  scoreId: Scalars['Int']['input'];
};


export type MutationSaveEnglishProficiencyResponseArgs = {
  blankAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  questionIndex: Scalars['Int']['input'];
  selectedAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSaveSchedulingDraftArgs = {
  batchId: Scalars['ID']['input'];
  details: SchedulingRequestDetailsInput;
  stageCandidateIds: Array<Scalars['Int']['input']>;
  stageId: Scalars['Int']['input'];
};


export type MutationSelectWorkspaceArgs = {
  workspaceId: Scalars['Int']['input'];
};


export type MutationSendSchedulingRequestsArgs = {
  batchId: Scalars['ID']['input'];
  confirmBusy?: Scalars['Boolean']['input'];
  fixedTimes?: InputMaybe<Array<FixedInterviewTimeInput>>;
  includeAssessmentReport?: Scalars['Boolean']['input'];
  includeInterviewGuide?: Scalars['Boolean']['input'];
  materials?: InputMaybe<Array<RequestMaterialInput>>;
  stageId: Scalars['Int']['input'];
};


export type MutationSetAtsAiInterviewResultsEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsAllowedRejectionReasonIdsArgs = {
  companyId: Scalars['Int']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSetAtsApplicationTrackingEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsAssessmentResultsEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsCandidatePullModeArgs = {
  companyId: Scalars['Int']['input'];
  mode: AtsCandidatePullMode;
};


export type MutationSetAtsHiringTeamUserProvisioningEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsInterviewEvaluationResultsEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsProgressionEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsRejectOnBehalfOfUserRemoteIdArgs = {
  companyId: Scalars['Int']['input'];
  userRemoteId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetAtsResultPushConfigArgs = {
  companyId: Scalars['Int']['input'];
  configs: Array<AtsResultPushConfigInput>;
};


export type MutationSetAtsStageMapArgs = {
  companyId: Scalars['Int']['input'];
  entries?: InputMaybe<Array<AtsStageMapEntryInput>>;
};


export type MutationSetAtsStagePushEnabledArgs = {
  companyId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetAtsStageRejectionReasonsArgs = {
  companyId: Scalars['Int']['input'];
  entries?: InputMaybe<Array<AtsStageRejectionReasonsEntryInput>>;
};


export type MutationSetCoderbyteWorkspaceAdminPasswordArgs = {
  adminPassword: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
};


export type MutationSetCoderbyteWorkspaceApiKeyArgs = {
  apiKey: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
};


export type MutationSetIndirectInviteSsoArgs = {
  id: Scalars['Int']['input'];
  indirectInviteSSO: Scalars['Boolean']['input'];
};


export type MutationSetIntegrityMonitoringSessionVerdictArgs = {
  sessionId: Scalars['ID']['input'];
  verdict: IntegrityMonitoringSessionVerdict;
};


export type MutationSetProjectCobrandingArgs = {
  cobrandingEnabled: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};


export type MutationStartAiInterviewIntegrityMonitoringSessionArgs = {
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
};


export type MutationStartCoderbyteAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartCognitiveTestAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartCognitiveTestIntegrityMonitoringSessionArgs = {
  cognitiveTestAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
};


export type MutationStartCognitiveTestPracticeAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartEditingQuestionArgs = {
  args: CollaborativeEditingStartArgs;
};


export type MutationStartEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartEnglishProficiencyIntegrityMonitoringSessionArgs = {
  englishProficiencyAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
};


export type MutationStartPersonalityTestAssessmentArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<SupportedLocale>;
};


export type MutationStartPersonalityTestIntegrityMonitoringSessionArgs = {
  input: StartIntegrityMonitoringSessionInput;
  personalityTestAssessmentStageActionCandidateId: Scalars['ID']['input'];
};


export type MutationStopEditingQuestionArgs = {
  args: CollaborativeEditingStopArgs;
};


export type MutationSubmitAiInterviewFeedbackArgs = {
  feedback: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSubmitEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTranslateConferenceTranscriptArgs = {
  id: Scalars['ID']['input'];
  locale: SupportedLocale;
};


export type MutationTriggerAtsCvUploadForApplicationArgs = {
  applicationId: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
};


export type MutationUnarchiveAssessmentStageDeiActionArgs = {
  fields?: InputMaybe<DeiStageActionFieldsInput>;
  stageId: Scalars['ID']['input'];
};


export type MutationUpdateAiInterviewActionStageActionArgs = {
  id: Scalars['ID']['input'];
  input: AiInterviewAssessmentStageActionUpdateInput;
};


export type MutationUpdateAiInterviewAssessmentStageActionIsAvatarEnabledArgs = {
  id: Scalars['ID']['input'];
  isAvatarEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateAiInterviewAssessmentStageActionIsTimingAgentEnabledArgs = {
  id: Scalars['ID']['input'];
  isTimingAgentEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateAiInterviewAssessmentStageActionLivekitAgentNameArgs = {
  id: Scalars['ID']['input'];
  livekitAgentName: LivekitAgentName;
};


export type MutationUpdateAiInterviewCandidateNoteArgs = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateAssessmentStageArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentStageInput;
};


export type MutationUpdateAssessmentStageEmailSettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAssessmentStageEmailSettingsInput;
};


export type MutationUpdateCoderbyteAssessmentTechnicalSkillsArgs = {
  id: Scalars['ID']['input'];
  technicalSkillIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateCoderbyteAssessmentTimeAllowanceArgs = {
  id: Scalars['ID']['input'];
  timeModifierPercentage: Scalars['Float']['input'];
};


export type MutationUpdateCognitiveTestSectionCountArgs = {
  id: Scalars['ID']['input'];
  sectionCount: Scalars['Int']['input'];
};


export type MutationUpdateCognitiveTestTimeAllowanceArgs = {
  id: Scalars['ID']['input'];
  timeModifierPercentage: Scalars['Float']['input'];
};


export type MutationUpdateCompanyArgs = {
  aiInterviewConsentText?: InputMaybe<Scalars['String']['input']>;
  aiPrivateNetworking?: InputMaybe<Scalars['Boolean']['input']>;
  alternativeSupportEmail?: InputMaybe<Scalars['String']['input']>;
  areCognitiveTestsBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  areMultiAssessmentStagesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  areRffSoftSkillsDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  atsPullJobsFromDate?: InputMaybe<Scalars['Date']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  companyLifecycle?: InputMaybe<CompanyLifecycle>;
  csmUserId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']['input']>;
  enableCompanyCodingAssessments?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  generateCandidateReport?: InputMaybe<Scalars['Boolean']['input']>;
  generateManagerReport?: InputMaybe<Scalars['Boolean']['input']>;
  hideReports?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isAiInterviewEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAlternativeSupportEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicationAnswerEvidenceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAssigneeManagedViaIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  isAtsRoleCreationWithRequisitionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAtsRoleCreationWithoutRequisitionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isConsentCaptureEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHiringTeamMemberAddedEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringAiInterviewDefaultEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringAssessmentDefaultEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  isInterviewGuideConfirmationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInterviewGuideScoresEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLegalAcknowledgementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLiveChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonalityTestMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRoleLiveEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isRoleRequirementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSchedulingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isShortlistingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSkillsEvaluationScoreEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isViewGuidanceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWhitelabelingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  reasonableAdjustmentsOption?: InputMaybe<ReasonableAdjustmentsOptionArgs>;
  rfuModelType?: InputMaybe<CompanyRfuModelType>;
};


export type MutationUpdateEnglishProficiencyRequiredCefrLevelArgs = {
  id: Scalars['ID']['input'];
  requiredCefrLevel: CefrLevel;
};


export type MutationUpdateIdentityPasswordArgs = {
  newPassword: Scalars['String']['input'];
  recoveryToken: Scalars['String']['input'];
};


export type MutationUpdateInterviewPanelArgs = {
  addUserIds: Array<Scalars['Int']['input']>;
  confirmBusy?: Scalars['Boolean']['input'];
  removeUserIds: Array<Scalars['Int']['input']>;
  requestId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationUpdateMyLocalePreferenceArgs = {
  locale: SupportedLocale;
};


export type MutationUpdatePersonalityTestQuestionsPerTraitCountArgs = {
  id: Scalars['ID']['input'];
  questionsPerTraitCount: Scalars['Int']['input'];
};


export type MutationUpdatePersonalityTestSelectedLocalesArgs = {
  id: Scalars['ID']['input'];
  selectedLocales: Array<SupportedLocale>;
};


export type MutationUploadCompanyLogoArgs = {
  file: Scalars['Upload']['input'];
  id: Scalars['Int']['input'];
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUpsertAssessmentStageDeiActionArgs = {
  fields: DeiStageActionFieldsInput;
  stageId: Scalars['ID']['input'];
};


export type MutationVerifyCoderbyteWorkspaceApiKeyArgs = {
  companyId: Scalars['Int']['input'];
};

export type MyRole = {
  __typename?: 'MyRole';
  candidateJourney: Array<MyRoleCandidateJourneyStage>;
  candidatePortalEnabled: Scalars['Boolean']['output'];
  candidatePortalIntro?: Maybe<Scalars['String']['output']>;
  candidatePortalTitle?: Maybe<Scalars['String']['output']>;
  company: MyRoleCompany;
  contentStages: Array<MyRoleContentStage>;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  deadlineAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  questionnaireStages: Array<MyRoleQuestionnaireStage>;
  stages: Array<MyRoleStage>;
};


export type MyRoleContentStagesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MyRoleQuestionnaireStagesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MyRoleStagesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MyRoleCandidateJourneyStage = {
  __typename?: 'MyRoleCandidateJourneyStage';
  description?: Maybe<Scalars['String']['output']>;
  estimatedTimeMinutes?: Maybe<Scalars['Int']['output']>;
  stageId?: Maybe<Scalars['ID']['output']>;
  stageType: StageType;
  status: CandidateJourneyStageStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MyRoleCompany = {
  __typename?: 'MyRoleCompany';
  branding?: Maybe<CompanyBranding>;
  id: Scalars['Int']['output'];
  isLiveChatEnabled: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reasonableAdjustmentsOption?: Maybe<ReasonableAdjustmentsOption>;
  supportEmail: Scalars['String']['output'];
  usesBehaviouralLabel: Scalars['Boolean']['output'];
};

export type MyRoleContentStage = {
  __typename?: 'MyRoleContentStage';
  blocks: Array<ContentStageBlockModel>;
  contentStageCandidateId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  estimatedDurationMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: ContentStageCandidateStatus;
};

export type MyRoleQuestionnaireItem = {
  __typename?: 'MyRoleQuestionnaireItem';
  answer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type MyRoleQuestionnaireStage = {
  __typename?: 'MyRoleQuestionnaireStage';
  id: Scalars['ID']['output'];
  items: Array<MyRoleQuestionnaireItem>;
  name: Scalars['String']['output'];
  shortlistStageCandidateId: Scalars['Int']['output'];
  status: QuestionnaireCandidateStatus;
};

export type MyRoleStage = {
  __typename?: 'MyRoleStage';
  actions: MyRoleStageActions;
  candidateStatus: StageCandidateStatus;
  deadlineAt?: Maybe<Scalars['Date']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  hasAdjustmentQuestionnaire: Scalars['Boolean']['output'];
  hasCompletedAdjustmentQuestionnaire: Scalars['Boolean']['output'];
  hasPledgedAnticheating: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isIntegrityMonitoringEnabled: Scalars['Boolean']['output'];
  kind: AssessmentStageKind;
  name: Scalars['String']['output'];
  stageCandidateId: Scalars['Int']['output'];
  stageStatus: StageStatus;
};

export type MyRoleStageActions = {
  __typename?: 'MyRoleStageActions';
  aiInterviewActions: Array<MyRoleStageAiInterviewAction>;
  coderbyteAction?: Maybe<MyRoleStageCoderbyteAction>;
  cognitiveTestActions: Array<MyRoleStageCognitiveTestAction>;
  deiAction?: Maybe<MyRoleStageDeiAction>;
  englishProficiencyAction?: Maybe<MyRoleStageEnglishProficiencyAction>;
  formActions: Array<MyRoleStageFormAction>;
  personalityTestAction?: Maybe<MyRoleStagePersonalityTestAction>;
  softRssAssessmentAction?: Maybe<MyRoleStageRssAssessmentAction>;
  technicalRssAssessmentAction?: Maybe<MyRoleStageRssAssessmentAction>;
};

export type MyRoleStageAiInterviewAction = {
  __typename?: 'MyRoleStageAiInterviewAction';
  conferenceId?: Maybe<Scalars['ID']['output']>;
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: AiInterviewAssessmentStageActionCandidateStatus;
};

export type MyRoleStageCoderbyteAction = {
  __typename?: 'MyRoleStageCoderbyteAction';
  allowedTimeSeconds?: Maybe<Scalars['Int']['output']>;
  estimatedTimeSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: CoderbyteAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float']['output'];
};

export type MyRoleStageCognitiveTestAction = {
  __typename?: 'MyRoleStageCognitiveTestAction';
  allowedSectionTimeSeconds: Scalars['Int']['output'];
  allowedTimeSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  kind: CognitiveKind;
  status: CognitiveTestAssessmentStageActionCandidateStatus;
  timeModifierPercentage: Scalars['Float']['output'];
};

export type MyRoleStageDeiAction = {
  __typename?: 'MyRoleStageDeiAction';
  id: Scalars['Int']['output'];
  status: DeiStageActionCandidateStatus;
};

export type MyRoleStageEnglishProficiencyAction = {
  __typename?: 'MyRoleStageEnglishProficiencyAction';
  allowedTimeSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  status: EnglishProficiencyAssessmentStageActionCandidateStatus;
};

export type MyRoleStageFormAction = {
  __typename?: 'MyRoleStageFormAction';
  formType: FormType;
  id: Scalars['Int']['output'];
  status: FormCandidateStatus;
};

export type MyRoleStagePersonalityTestAction = {
  __typename?: 'MyRoleStagePersonalityTestAction';
  estimatedTimeSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  selectedLocales: Array<SupportedLocale>;
  status: PersonalityTestAssessmentStageActionCandidateStatus;
};

export type MyRoleStageRssAssessmentAction = {
  __typename?: 'MyRoleStageRssAssessmentAction';
  id: Scalars['Int']['output'];
  status: RssAssessmentCandidateStatus;
};

export type NewStructuredScoreModel = {
  __typename?: 'NewStructuredScoreModel';
  children?: Maybe<Array<NewStructuredScoreModel>>;
  copiedFrom?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  doneBy: Scalars['Int']['output'];
  doneFor: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  manuallyAdjustedBy?: Maybe<Scalars['Int']['output']>;
  measurementId: Scalars['Int']['output'];
  measurementType: ResultMeasurementType;
  order?: Maybe<Scalars['Int']['output']>;
  previousVersionId?: Maybe<Scalars['Int']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  score: ResultScoreUnion;
  scoreType: ResultScoreType;
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export type NormGroupModel = {
  __typename?: 'NormGroupModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  jobRoleFamily?: Maybe<JobRoleFamily>;
  roleLevel?: Maybe<ContentRoleLevel>;
  trait: Trait;
  traitId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum NormGroupType {
  AdministrativeStaff = 'ADMINISTRATIVE_STAFF',
  CogAdministrativeOperationalNonGraduate = 'COG_ADMINISTRATIVE_OPERATIONAL_NON_GRADUATE',
  CogApprenticesSchoolLeaversEntryLevelStaff = 'COG_APPRENTICES_SCHOOL_LEAVERS_ENTRY_LEVEL_STAFF',
  CogGradsManagersProfessionalsExecutives = 'COG_GRADS_MANAGERS_PROFESSIONALS_EXECUTIVES',
  Executives = 'EXECUTIVES',
  Finance = 'FINANCE',
  FirstLineManagers = 'FIRST_LINE_MANAGERS',
  GeneralPopulation = 'GENERAL_POPULATION',
  Graduates = 'GRADUATES',
  HealthProfessionals = 'HEALTH_PROFESSIONALS',
  Hr = 'HR',
  LegalProfessionals = 'LEGAL_PROFESSIONALS',
  ManagementConsultants = 'MANAGEMENT_CONSULTANTS',
  MarketingProfessionals = 'MARKETING_PROFESSIONALS',
  MiddleManagers = 'MIDDLE_MANAGERS',
  SalesProfessionals = 'SALES_PROFESSIONALS',
  Stem = 'STEM',
  Teaching = 'TEACHING'
}

export type NumericRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type NumericalOptionModel = {
  __typename?: 'NumericalOptionModel';
  key: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NumericalQuestionModel = {
  __typename?: 'NumericalQuestionModel';
  difficulty: Scalars['Float']['output'];
  options: Array<NumericalOptionModel>;
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NumericalTestletModel = {
  __typename?: 'NumericalTestletModel';
  imageUrl: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  questions: Array<NumericalQuestionModel>;
  remainingQuestions: Scalars['Int']['output'];
  remainingTime: Scalars['Int']['output'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  timeLimit: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type OfferStageCandidateModel = {
  __typename?: 'OfferStageCandidateModel';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  kind: GenericStageKind;
  projectCandidate: ProjectCandidate;
  projectCandidateId: Scalars['Int']['output'];
  stage: OfferStageModel;
  stageId: Scalars['Int']['output'];
  subId: Scalars['ID']['output'];
};

export type OfferStageModel = {
  __typename?: 'OfferStageModel';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  kind: GenericStageKind;
  name: Scalars['String']['output'];
  project: Project;
  projectId: Scalars['Int']['output'];
  subId: Scalars['ID']['output'];
};

/** An interview window offered to a batch */
export type OfferedSlotModel = {
  __typename?: 'OfferedSlotModel';
  endsAt: Scalars['DateTime']['output'];
  /** Whether an interviewer's calendar is already busy for this window */
  overBusy: Scalars['Boolean']['output'];
  /** The seat standing for this window */
  seatId: Scalars['ID']['output'];
  startsAt: Scalars['DateTime']['output'];
};

export type OffsetBasedPaginationArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};

export type OmnisearchAll = {
  __typename?: 'OmnisearchAll';
  candidates: CandidateSearchPage;
  myRolesApplies: Scalars['Boolean']['output'];
  myRolesDefault: Scalars['Boolean']['output'];
  roles: RoleSearchPage;
};

export type OmnisearchPageArgs = {
  page?: Scalars['Int']['input'];
  size?: Scalars['Int']['input'];
};

export type OmnisearchRecents = {
  __typename?: 'OmnisearchRecents';
  candidates: Array<RecentCandidate>;
  roles: Array<RecentRole>;
};

export type OptionModel = {
  __typename?: 'OptionModel';
  key: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
};

export type OrderByArgs = {
  direction?: InputMaybe<OrderByDirection>;
  nullLow?: InputMaybe<Scalars['Boolean']['input']>;
  priority: Scalars['Int']['input'];
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrgCalendarConnectionHistoryModel = {
  __typename?: 'OrgCalendarConnectionHistoryModel';
  previouslyConnected: Scalars['Boolean']['output'];
};

export type OrgCalendarConsentRefusalModel = {
  __typename?: 'OrgCalendarConsentRefusalModel';
  createdAt: Scalars['DateTime']['output'];
  missingPermissions: Array<Scalars['String']['output']>;
  reasonCode: OrgCalendarRemediationCode;
};

export type OrgCalendarConsentStartModel = {
  __typename?: 'OrgCalendarConsentStartModel';
  consentUrl: Scalars['String']['output'];
  expiresAt: Scalars['Float']['output'];
};

export type OrgCalendarDisconnectModel = {
  __typename?: 'OrgCalendarDisconnectModel';
  connectionsFrozen: Scalars['Int']['output'];
  grantId?: Maybe<Scalars['String']['output']>;
};

export type OrgCalendarGrantModel = {
  __typename?: 'OrgCalendarGrantModel';
  consentInFlight: Scalars['Boolean']['output'];
  grantedScopes: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastProbeAt?: Maybe<Scalars['DateTime']['output']>;
  provider: CalendarProviderV2;
  remediationCode?: Maybe<OrgCalendarRemediationCode>;
  status: OrgCalendarGrantStatus;
  tenantId: Scalars['String']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrgCalendarGrantStatus {
  Active = 'active',
  Failed = 'failed',
  NeedsAdminConsent = 'needsAdminConsent',
  Revoked = 'revoked'
}

export enum OrgCalendarRemediationCode {
  CalendarReadBlocked = 'calendarReadBlocked',
  ConsentDeclined = 'consentDeclined',
  ExpiredState = 'expiredState',
  InvalidState = 'invalidState',
  MissingPermission = 'missingPermission',
  SchedulingDisabled = 'schedulingDisabled',
  TenantMismatch = 'tenantMismatch',
  TryAgain = 'tryAgain'
}

export enum Orientation {
  Inverted = 'INVERTED',
  Standard = 'STANDARD'
}

export type Pageinfo = {
  __typename?: 'Pageinfo';
  currentPage: Scalars['Int']['output'];
  itemsOnPage: Scalars['Int']['output'];
  itemsTotal: Scalars['Int']['output'];
  pageTotal: Scalars['Int']['output'];
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
};

export type PaginatedCompanySettingChangesModel = {
  __typename?: 'PaginatedCompanySettingChangesModel';
  data?: Maybe<Array<CompanySettingChangeModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedMeetingModel = {
  __typename?: 'PaginatedMeetingModel';
  data: Array<MeetingModel>;
  total: Scalars['Int']['output'];
};

export type PaginatedProjectsModel = {
  __typename?: 'PaginatedProjectsModel';
  data?: Maybe<Array<Project>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedSoftSkillGqlModel = {
  __typename?: 'PaginatedSoftSkillGQLModel';
  data?: Maybe<Array<SoftSkill>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedSummaryTemplateModel = {
  __typename?: 'PaginatedSummaryTemplateModel';
  data: Array<SummaryTemplateModel>;
  total: Scalars['Int']['output'];
};

export type PaginatedSzSkillsMerge = {
  __typename?: 'PaginatedSzSkillsMerge';
  skills: Array<SzSkillsMergeWithAvailability>;
  total: Scalars['Int']['output'];
};

export type PaginatedTechnicalSkill = {
  __typename?: 'PaginatedTechnicalSkill';
  technicalSkills: Array<TechnicalSkill>;
  total: Scalars['Int']['output'];
};

export type PaginatedTechnicalSkillModel = {
  __typename?: 'PaginatedTechnicalSkillModel';
  data?: Maybe<Array<TechnicalSkill>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type PaginatedUnifiedMeeting = {
  __typename?: 'PaginatedUnifiedMeeting';
  data: Array<UnifiedMeeting>;
  total: Scalars['Int']['output'];
};

export type PaginatedUpcomingMeetingModel = {
  __typename?: 'PaginatedUpcomingMeetingModel';
  data: Array<UpcomingMeetingModel>;
  total: Scalars['Int']['output'];
};

/** Status of the Candidate Interview Guide PDF generation lifecycle */
export enum PdfGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type PersonalInfoSpecifics = {
  __typename?: 'PersonalInfoSpecifics';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type PersonalityItemModel = {
  __typename?: 'PersonalityItemModel';
  isCompleted: Scalars['Boolean']['output'];
  questions: Array<PersonalityQuestionModel>;
  remainingQuestions: Scalars['Int']['output'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  totalQuestions: Scalars['Int']['output'];
};

export type PersonalityOptionModel = {
  __typename?: 'PersonalityOptionModel';
  key: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type PersonalityQuestionModel = {
  __typename?: 'PersonalityQuestionModel';
  difficulty: Scalars['Float']['output'];
  options: Array<PersonalityOptionModel>;
  orientation: QuestionOrientation;
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PersonalityTestAssessmentStageAction = {
  __typename?: 'PersonalityTestAssessmentStageAction';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  questionsPerTraitCount: Scalars['Int']['output'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type PersonalityTestAssessmentStageActionCandidate = {
  __typename?: 'PersonalityTestAssessmentStageActionCandidate';
  action: PersonalityTestAssessmentStageActionNested;
  assessmentId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  integrityMonitoringSession?: Maybe<IntegrityMonitoringSession>;
  locale?: Maybe<SupportedLocale>;
  resultStatus: PersonalityTestAssessmentStageActionCandidateResultStatus;
  stageCandidate: SmStageCandidateModel;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: PersonalityTestAssessmentStageActionCandidateStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum PersonalityTestAssessmentStageActionCandidateResultStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum PersonalityTestAssessmentStageActionCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type PersonalityTestAssessmentStageActionNested = {
  __typename?: 'PersonalityTestAssessmentStageActionNested';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  questionsPerTraitCount: Scalars['Int']['output'];
  selectedLocales: Array<SupportedLocale>;
  stageId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum PollingStatus {
  Error = 'ERROR',
  Generating = 'GENERATING',
  Idling = 'IDLING',
  Ready = 'READY'
}

export enum ProductSolution {
  EarlyCareerHiring = 'EARLY_CAREER_HIRING',
  Learning = 'LEARNING',
  ProfessionalHiring = 'PROFESSIONAL_HIRING',
  Reskilling = 'RESKILLING',
  SuccessionPlanning = 'SUCCESSION_PLANNING',
  VolumeHiring = 'VOLUME_HIRING'
}

export type ProgressCandidatesPayload = {
  __typename?: 'ProgressCandidatesPayload';
  atsWritebackFailures: Array<AtsProgressionWritebackFailure>;
  atsWritebackSuccess?: Maybe<AtsProgressionWritebackSuccess>;
  projectCandidates: Array<ProjectCandidate>;
};

export enum ProgressionEventPerformedByType {
  Ats = 'ATS',
  System = 'SYSTEM',
  User = 'USER'
}

export enum ProgressionStatus {
  Active = 'ACTIVE',
  Hired = 'HIRED',
  Rejected = 'REJECTED'
}

export type Project = {
  __typename?: 'Project';
  /** @deprecated Use "assessmentStagesV2" and find the stage with kind === AI_INTERVIEW client-side. Singular stage accessors on Project are being phased out in favour of the array-based "assessmentStagesV2". */
  aiInterviewStage?: Maybe<AssessmentStage>;
  applicationQuestions: Array<RoleApplicationQuestion>;
  /** @deprecated Use "assessmentStagesV2" and find the stage with kind === ASSESSMENT client-side. Singular stage accessors on Project are being phased out in favour of the array-based "assessmentStagesV2". */
  assessmentStage?: Maybe<AssessmentStage>;
  assessmentStages: Array<SmStageModel>;
  assessmentStagesV2: Array<AssessmentStage>;
  candidatePortalEnabled: Scalars['Boolean']['output'];
  candidatePortalIntro?: Maybe<Scalars['String']['output']>;
  candidatePortalTitle?: Maybe<Scalars['String']['output']>;
  company?: Maybe<ProjectCompany>;
  companyId?: Maybe<Scalars['Float']['output']>;
  companySignatureId?: Maybe<Scalars['Int']['output']>;
  completedAssessmentsCount: Scalars['Int']['output'];
  contentStages: Array<ContentStageModel>;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hiringProcessAbsoluteDeadlineAt?: Maybe<Scalars['Date']['output']>;
  hiringProcessDeadlineType?: Maybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: Maybe<Scalars['Int']['output']>;
  hiringProcessRelativeDeadlineUnit?: Maybe<HiringProcessDeadlineUnit>;
  hiringProcessTemplateVersion?: Maybe<HiringProcessTemplateVersion>;
  id: Scalars['Int']['output'];
  idVerificationEnabled: Scalars['Boolean']['output'];
  indirectInviteSSOEnabled?: Maybe<Scalars['Boolean']['output']>;
  interviewStages: Array<InterviewStage>;
  isAiInterviewExplicitConsentEnabled: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntegrityMonitoringEnabled: Scalars['Boolean']['output'];
  isStopped: Scalars['Boolean']['output'];
  jobDescriptionLocales?: Maybe<Array<Scalars['String']['output']>>;
  jobDescriptionUrl?: Maybe<Scalars['String']['output']>;
  lastCandidateActivity?: Maybe<Scalars['Date']['output']>;
  locales: Array<SupportedLocale>;
  /** @deprecated Please use "teamMembers" instead! */
  managers?: Maybe<Array<ProjectManager>>;
  moduleType: ProjectModuleType;
  name: Scalars['String']['output'];
  offerStage?: Maybe<OfferStageModel>;
  primaryLocale: SupportedLocale;
  productSolution?: Maybe<ProductSolution>;
  projectCandidatesCount: Scalars['Int']['output'];
  projectRequest?: Maybe<ProjectRequestModel>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedBy?: Maybe<User>;
  reminderEmailCadenceDays?: Maybe<Scalars['Int']['output']>;
  renderCandidateReport: Scalars['Boolean']['output'];
  requireSheetsExport: Scalars['Boolean']['output'];
  shortlistCalibrationBorderlineQuestions?: Maybe<ShortlistCalibrationBorderlineQuestions>;
  shortlistCriteriaSuggestionStatus?: Maybe<ProjectShortlistCriteriaSuggestionStatus>;
  shortlistCriteriaSuggestions?: Maybe<Array<ProjectShortlistCriteriaSuggestion>>;
  shortlistStages: Array<ShortlistStage>;
  source: ProjectSource;
  status: ProjectStatus;
  subId: Scalars['String']['output'];
  teamMembers?: Maybe<Array<ProjectManager>>;
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<User>;
  version: Scalars['Float']['output'];
};

export enum ProjectAction {
  AddAssessmentStageAction = 'ADD_ASSESSMENT_STAGE_ACTION',
  AddProjectCandidate = 'ADD_PROJECT_CANDIDATE',
  CompanyAppCandidateResultExport = 'COMPANY_APP_CANDIDATE_RESULT_EXPORT',
  CreateAssessmentStage = 'CREATE_ASSESSMENT_STAGE',
  CreateContentStage = 'CREATE_CONTENT_STAGE',
  CreateInterviewStage = 'CREATE_INTERVIEW_STAGE',
  CreateProjectJobRole = 'CREATE_PROJECT_JOB_ROLE',
  CreateShortlistStage = 'CREATE_SHORTLIST_STAGE',
  DecisionKitActions = 'DECISION_KIT_ACTIONS',
  InviteAssessmentStageCandidate = 'INVITE_ASSESSMENT_STAGE_CANDIDATE',
  LinkRspSoftSkill = 'LINK_RSP_SOFT_SKILL',
  LinkRspTechnicalSkill = 'LINK_RSP_TECHNICAL_SKILL',
  RemoveAssessmentStage = 'REMOVE_ASSESSMENT_STAGE',
  RemoveAssessmentStageAction = 'REMOVE_ASSESSMENT_STAGE_ACTION',
  RemoveAssessmentStageCandidate = 'REMOVE_ASSESSMENT_STAGE_CANDIDATE',
  RemoveContentStage = 'REMOVE_CONTENT_STAGE',
  RemoveInterviewStage = 'REMOVE_INTERVIEW_STAGE',
  RemoveProjectCandidate = 'REMOVE_PROJECT_CANDIDATE',
  RemoveProjectJobRole = 'REMOVE_PROJECT_JOB_ROLE',
  RemoveShortlistStage = 'REMOVE_SHORTLIST_STAGE',
  SetMainProjectJobRole = 'SET_MAIN_PROJECT_JOB_ROLE',
  UnlinkRspSoftSkill = 'UNLINK_RSP_SOFT_SKILL',
  UnlinkRspTechnicalSkill = 'UNLINK_RSP_TECHNICAL_SKILL',
  UpdateAssessmentStageName = 'UPDATE_ASSESSMENT_STAGE_NAME',
  UpdateAssessmentStageReportAndEmail = 'UPDATE_ASSESSMENT_STAGE_REPORT_AND_EMAIL',
  UpdateAssessmentStageStartEndDate = 'UPDATE_ASSESSMENT_STAGE_START_END_DATE',
  UpdateCandidateAssignees = 'UPDATE_CANDIDATE_ASSIGNEES',
  UpdateCandidateDeadline = 'UPDATE_CANDIDATE_DEADLINE',
  UpdateCognitiveMode = 'UPDATE_COGNITIVE_MODE',
  UpdateContentStage = 'UPDATE_CONTENT_STAGE',
  UpdateInterviewStageDuration = 'UPDATE_INTERVIEW_STAGE_DURATION',
  UpdateInterviewStageName = 'UPDATE_INTERVIEW_STAGE_NAME',
  UpdateJobRoleFamily = 'UPDATE_JOB_ROLE_FAMILY',
  UpdateJobRoleLevel = 'UPDATE_JOB_ROLE_LEVEL',
  UpdateJobRoleName = 'UPDATE_JOB_ROLE_NAME',
  UpdateProjectAiInterviewConsent = 'UPDATE_PROJECT_AI_INTERVIEW_CONSENT',
  UpdateProjectCandidatePortalBranding = 'UPDATE_PROJECT_CANDIDATE_PORTAL_BRANDING',
  UpdateProjectCobranding = 'UPDATE_PROJECT_COBRANDING',
  UpdateProjectHiringProcessDeadline = 'UPDATE_PROJECT_HIRING_PROCESS_DEADLINE',
  UpdateProjectIndirectInviteSsoSignUp = 'UPDATE_PROJECT_INDIRECT_INVITE_SSO_SIGN_UP',
  UpdateProjectLanguages = 'UPDATE_PROJECT_LANGUAGES',
  UpdateProjectName = 'UPDATE_PROJECT_NAME',
  UpdateProjectSolution = 'UPDATE_PROJECT_SOLUTION',
  UpdateProjectTeamMembers = 'UPDATE_PROJECT_TEAM_MEMBERS',
  UpdateRspSkillWeight = 'UPDATE_RSP_SKILL_WEIGHT',
  UpdateRspTraitWeight = 'UPDATE_RSP_TRAIT_WEIGHT',
  UpdateShortlistStageName = 'UPDATE_SHORTLIST_STAGE_NAME'
}

export type ProjectAddShortlistStage = {
  __typename?: 'ProjectAddShortlistStage';
  project: Project;
  shortlistStage: ShortlistStage;
};

export type ProjectCandidate = {
  __typename?: 'ProjectCandidate';
  assessmentStageCandidates: Array<SmStageCandidateModel>;
  assignees: Array<ProjectManager>;
  atsApplicationUrl?: Maybe<Scalars['String']['output']>;
  atsRejectionReasonName?: Maybe<Scalars['String']['output']>;
  atsStage?: Maybe<Scalars['String']['output']>;
  candidateProfile?: Maybe<ProjectCandidateProfile>;
  contentStageCandidates: Array<ContentStageCandidateModel>;
  createdAt: Scalars['Date']['output'];
  currentStageId?: Maybe<Scalars['Int']['output']>;
  currentStageType?: Maybe<StageType>;
  deadlineAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  interviewStageCandidates: Array<InterviewStageCandidate>;
  isExpired: Scalars['Boolean']['output'];
  offerStageCandidate?: Maybe<OfferStageCandidateModel>;
  otherAttempts: Array<BasicProjectCandidate>;
  progressionData: CandidateProgressionData;
  progressionStatus: ProgressionStatus;
  project: Project;
  shortlistStageCandidates: Array<ShortlistStageCandidate>;
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type ProjectCandidateAssessmentInviteSettings = {
  assessmentStageSubId: Scalars['ID']['input'];
  deadlineInEmail?: InputMaybe<Scalars['Date']['input']>;
};

export enum ProjectCandidateAssessmentStatusFilter {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Invited = 'INVITED',
  InProgress = 'IN_PROGRESS',
  NotInvited = 'NOT_INVITED',
  Processing = 'PROCESSING'
}

export type ProjectCandidateInvitationSettings = {
  areInternalCandidates: Scalars['Boolean']['input'];
  assignees: Array<Scalars['Int']['input']>;
  supportedLocale: SupportedLocale;
};

export type ProjectCandidateInvitationSettingsWithoutAssignees = {
  areInternalCandidates: Scalars['Boolean']['input'];
  supportedLocale: SupportedLocale;
};

export enum ProjectCandidateOrderField {
  AssessmentStatus = 'ASSESSMENT_STATUS',
  DateAdded = 'DATE_ADDED',
  DateInvited = 'DATE_INVITED',
  DateUpdated = 'DATE_UPDATED',
  Name = 'NAME',
  Stage = 'STAGE',
  State = 'STATE'
}

export enum ProjectCandidatePreferredAnswersFilter {
  GaveAllPreferredAnswers = 'GAVE_ALL_PREFERRED_ANSWERS',
  MissedOneOrMore = 'MISSED_ONE_OR_MORE'
}

export type ProjectCandidateProfile = {
  __typename?: 'ProjectCandidateProfile';
  additionalExperience?: Maybe<Array<Scalars['String']['output']>>;
  candidateLocation?: Maybe<Scalars['String']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Date']['output'];
  currentSeniorityLevel?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Array<Scalars['String']['output']>>;
  employmentGaps?: Maybe<Array<EmploymentGap>>;
  experience?: Maybe<Array<Scalars['String']['output']>>;
  experienceSummary?: Maybe<Array<ExperienceSummaryEntry>>;
  highestEducationLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industries?: Maybe<Array<ResumeExtractedDataIndustry>>;
  interests?: Maybe<Array<Scalars['String']['output']>>;
  isEnglishLanguage: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  other?: Maybe<Array<Scalars['String']['output']>>;
  personalInfo?: Maybe<Array<Scalars['String']['output']>>;
  personalSpecifics?: Maybe<PersonalInfoSpecifics>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  source: ProjectCandidateProfileSource;
  summary?: Maybe<Scalars['String']['output']>;
  totalYearsExperience?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export enum ProjectCandidateProfileSource {
  ExternalService = 'EXTERNAL_SERVICE',
  ProjectCandidateProfile = 'PROJECT_CANDIDATE_PROFILE',
  Resume = 'RESUME'
}

export enum ProjectCandidateShortlistedFilter {
  NotShortlisted = 'NOT_SHORTLISTED',
  Shortlisted = 'SHORTLISTED'
}

export type ProjectCandidateStageBreakdown = {
  __typename?: 'ProjectCandidateStageBreakdown';
  candidatesCount: Scalars['Int']['output'];
  category: ProjectCandidateStageCategory;
  completedCount?: Maybe<Scalars['Int']['output']>;
};

export enum ProjectCandidateStageCategory {
  AiInterview = 'AI_INTERVIEW',
  ContentStage = 'CONTENT_STAGE',
  InterviewStage = 'INTERVIEW_STAGE',
  NotInAStage = 'NOT_IN_A_STAGE',
  OfferStage = 'OFFER_STAGE',
  OnlineAssessment = 'ONLINE_ASSESSMENT',
  ShortlistStage = 'SHORTLIST_STAGE'
}

export type ProjectCandidateUpsertAssigneesArgs = {
  projectTeamMemberIds: Array<Scalars['Int']['input']>;
};

export type ProjectCandidateUserDetails = {
  email: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
};

export type ProjectCandidatesArgs = {
  projectSubId?: InputMaybe<Scalars['ID']['input']>;
  userSubId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProjectCandidatesFilterArgs = {
  allAttempts?: Scalars['Boolean']['input'];
  assessmentStatus?: InputMaybe<Array<ProjectCandidateAssessmentStatusFilter>>;
  dateAdded?: InputMaybe<DateFilter>;
  dateInvited?: InputMaybe<DateFilter>;
  dateUpdated?: InputMaybe<DateFilter>;
  nameOrEmailContains?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCandidatesOrderArgs = {
  direction?: SortOption;
  field?: ProjectCandidateOrderField;
};

export type ProjectCandidatesPaginated = {
  __typename?: 'ProjectCandidatesPaginated';
  data?: Maybe<Array<ProjectCandidate>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type ProjectCobrandingModel = {
  __typename?: 'ProjectCobrandingModel';
  accentColor1?: Maybe<Scalars['String']['output']>;
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProjectCollaborator = {
  __typename?: 'ProjectCollaborator';
  /** The decorative role that user got assigned for this particular project. Optional. */
  actorRole?: Maybe<ActorRole>;
  group?: Maybe<ProjectCollaboratorGroup>;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  user?: Maybe<ProjectCollaboratorUser>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ProjectCollaboratorArgs = {
  collaboratorType?: InputMaybe<ProjectCollaboratorType>;
  membersPreviewCount?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectCollaboratorCreateOneArgs = {
  actorRole?: InputMaybe<ActorRole>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  isAutogenerated?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ProjectCollaboratorDeleteManyResult = {
  __typename?: 'ProjectCollaboratorDeleteManyResult';
  collaboratorId: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type ProjectCollaboratorGroup = {
  __typename?: 'ProjectCollaboratorGroup';
  companyId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  membersCount: Scalars['Int']['output'];
  membersPreview: Array<ProjectCollaboratorGroupMembersPreview>;
  name: Scalars['String']['output'];
  subId: Scalars['String']['output'];
};

export type ProjectCollaboratorGroupMembersPreview = {
  __typename?: 'ProjectCollaboratorGroupMembersPreview';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ProjectCollaboratorIndividual = {
  __typename?: 'ProjectCollaboratorIndividual';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  calculatedActorRole?: Maybe<ActorRole>;
  /** Array of actual access roles that user holds for company that owns project */
  companyRoles?: Maybe<Array<Maybe<IdentityPermissionRole>>>;
  directAccess: DirectAccessInfo;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<GroupInfo>>>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ProjectCollaboratorIndividualPaginated = {
  __typename?: 'ProjectCollaboratorIndividualPaginated';
  data?: Maybe<Array<ProjectCollaboratorIndividual>>;
  pageInfo?: Maybe<Pageinfo>;
};

export enum ProjectCollaboratorOrderField {
  FirstName = 'FIRST_NAME'
}

export type ProjectCollaboratorOrderOptions = {
  direction: SortOption;
  field: ProjectCollaboratorOrderField;
};

export type ProjectCollaboratorPaginated = {
  __typename?: 'ProjectCollaboratorPaginated';
  data?: Maybe<Array<ProjectCollaborator>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type ProjectCollaboratorRole = {
  __typename?: 'ProjectCollaboratorRole';
  /** The decorative role that user got assigned for this particular project. Optional. */
  actorRole?: Maybe<ActorRole>;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum ProjectCollaboratorType {
  Group = 'GROUP',
  User = 'USER'
}

export type ProjectCollaboratorUser = {
  __typename?: 'ProjectCollaboratorUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Array of actual access roles that user holds for company that owns project */
  companyRoles?: Maybe<Array<Maybe<IdentityPermissionRole>>>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type ProjectCompany = {
  __typename?: 'ProjectCompany';
  candidateReport?: Maybe<Report>;
  emailCandidateReport: Scalars['Boolean']['output'];
  enableCompanyCodingAssessments: Scalars['Boolean']['output'];
  generateCandidateReport: Scalars['Boolean']['output'];
  generateManagerReport: Scalars['Boolean']['output'];
  hideReports: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  managerReport?: Maybe<Report>;
  name: Scalars['String']['output'];
  projectTeamEmailSettings: ProjectTeamEmailSettings;
};

export type ProjectCompanyId = {
  __typename?: 'ProjectCompanyId';
  companyId: Scalars['Int']['output'];
};

export type ProjectCompleteJobDescriptionUploadArgs = {
  etag: Scalars['String']['input'];
  key: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  downloadUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type ProjectFilterArgs = {
  /** True for roles currently linked to an ATS requisition, false for roles without one. Omit for no filtering. Link status comes from the ATS service, so the query fails rather than returning unfiltered results when it cannot be reached. */
  atsLinked?: InputMaybe<Scalars['Boolean']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateCreated?: InputMaybe<DateFilter>;
  dateLastEdited?: InputMaybe<DateFilter>;
  datePublished?: InputMaybe<DateFilter>;
  fromCompletedAssessmentCount?: InputMaybe<Scalars['Int']['input']>;
  fromProjectCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  /** Restricts results to projects where any of these users is on the hiring team, directly or via a user group they belong to. */
  hiringTeamUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  /** When true, restricts results to projects where the caller is a hiring team member, either directly or via a user group they belong to. */
  onlyMyHiringTeamRoles?: InputMaybe<Scalars['Boolean']['input']>;
  /** Per-stage-type rules the role must all satisfy. A stage type with no rule is not filtered on. */
  stageTypeFilters?: InputMaybe<Array<ProjectStageTypeFilterArgs>>;
  statuses?: InputMaybe<Array<ProjectStatus>>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  toCompletedAssessmentCount?: InputMaybe<Scalars['Int']['input']>;
  toProjectCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  withAdminAppDrafts?: Scalars['Boolean']['input'];
  withDIG?: ProjectTriboolFilter;
  withDeleted?: ProjectTriboolFilter;
  withStages?: ProjectWithStagesFilter;
  withStopped?: ProjectTriboolFilter;
};

export type ProjectIndividualArgs = {
  projectId: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectInitiateJobDescriptionUploadArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export enum ProjectJobDescriptionProcessingStatus {
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type ProjectJobRoleModel = {
  __typename?: 'ProjectJobRoleModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isLocalizedBenchmarkGroup?: Maybe<Scalars['Boolean']['output']>;
  isMainRole: Scalars['Boolean']['output'];
  jobRole: JobRoleModel;
  jobRoleId: Scalars['Int']['output'];
  project: Project;
  projectId: Scalars['Int']['output'];
  skillsProfile: SuccessProfile;
  skillsProfileId: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ProjectJobRoleWithConfidenceModel = {
  __typename?: 'ProjectJobRoleWithConfidenceModel';
  confidenceRating: Scalars['Float']['output'];
  projectJobRole: ProjectJobRoleModel;
};

export type ProjectManager = {
  __typename?: 'ProjectManager';
  /** The decorative role that user got assigned for this particular project. Optional. */
  actorRole?: Maybe<ActorRole>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  group?: Maybe<UserGroupModel>;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['Int']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type ProjectMeetingLinkedStatus = {
  __typename?: 'ProjectMeetingLinkedStatus';
  isLinked: Scalars['Boolean']['output'];
  meetingId: Scalars['ID']['output'];
};

export enum ProjectModuleType {
  Hiring = 'HIRING',
  TalentReview = 'TALENT_REVIEW'
}

export type ProjectNested = {
  __typename?: 'ProjectNested';
  id: Scalars['ID']['output'];
};

export type ProjectOrderArgs = {
  direction?: SortOption;
  field?: ProjectOrderField;
};

export enum ProjectOrderField {
  CompanyName = 'COMPANY_NAME',
  ProjectActivity = 'PROJECT_ACTIVITY',
  ProjectCandidatesCount = 'PROJECT_CANDIDATES_COUNT',
  ProjectCompletedAssessmentCount = 'PROJECT_COMPLETED_ASSESSMENT_COUNT',
  ProjectCreatedAt = 'PROJECT_CREATED_AT',
  ProjectName = 'PROJECT_NAME',
  ProjectPublishedAt = 'PROJECT_PUBLISHED_AT',
  ProjectStages = 'PROJECT_STAGES',
  ProjectStatus = 'PROJECT_STATUS',
  ProjectUpdatedAt = 'PROJECT_UPDATED_AT',
  Status = 'STATUS'
}

export type ProjectRequestFileUploadArgs = {
  fileName: Scalars['String']['input'];
  projectRequestId: Scalars['Int']['input'];
};

export type ProjectRequestFileUploadModel = {
  __typename?: 'ProjectRequestFileUploadModel';
  blob?: Maybe<MonolithBlobModel>;
  blobId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  projectRequest?: Maybe<ProjectRequestModel>;
  projectRequestId?: Maybe<Scalars['Int']['output']>;
};

export type ProjectRequestModel = {
  __typename?: 'ProjectRequestModel';
  approvalRequestDate?: Maybe<Scalars['Date']['output']>;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  creator?: Maybe<User>;
  creatorId: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  managerSurveyId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectName: Scalars['String']['output'];
  status: ProjectRequestStatus;
  updatedAt: Scalars['Date']['output'];
};

export enum ProjectRequestStatus {
  ConfirmMatch = 'CONFIRM_MATCH',
  JobSpecsRecieved = 'JOB_SPECS_RECIEVED',
  ProjectCreated = 'PROJECT_CREATED',
  RequiresProject = 'REQUIRES_PROJECT'
}

export type ProjectRequestUserApprovalModel = {
  __typename?: 'ProjectRequestUserApprovalModel';
  approvalRequestDate: Scalars['Date']['output'];
  approvalStatus: ProjectRequestUserApprovalStatus;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum ProjectRequestUserApprovalStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Sent = 'SENT'
}

export type ProjectRequestUserModel = {
  __typename?: 'ProjectRequestUserModel';
  approval?: Maybe<ProjectRequestUserApprovalModel>;
  approvalId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  projectRequest?: Maybe<ProjectRequestModel>;
  projectRequestId?: Maybe<Scalars['Int']['output']>;
  type: ProjectRequestUserType;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export enum ProjectRequestUserType {
  AdditionalContact = 'ADDITIONAL_CONTACT',
  Manager = 'MANAGER',
  Recruiter = 'RECRUITER'
}

export type ProjectShortlistCriteriaSuggestion = {
  __typename?: 'ProjectShortlistCriteriaSuggestion';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export enum ProjectShortlistCriteriaSuggestionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Processing = 'PROCESSING'
}

export enum ProjectSource {
  AdminApp = 'ADMIN_APP',
  RoleKickoff = 'ROLE_KICKOFF'
}

export enum ProjectStageAssessmentStatusFilter {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type ProjectStageOrderArgs = {
  order: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
  stageType: StageType;
};

export type ProjectStageOrderModel = {
  __typename?: 'ProjectStageOrderModel';
  activeCandidatesCount: Scalars['Int']['output'];
  hiringProcessTemplateVersionStageId?: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
  stageActionName?: Maybe<Scalars['String']['output']>;
  stageId: Scalars['Int']['output'];
  stageName?: Maybe<Scalars['String']['output']>;
  stageSubId?: Maybe<Scalars['ID']['output']>;
  stageSubType?: Maybe<AssessmentStageKind>;
  stageType: StageType;
};

export type ProjectStageTypeFilterArgs = {
  assessmentStatus?: InputMaybe<ProjectStageAssessmentStatusFilter>;
  category: ProjectCandidateStageCategory;
  hasStageType: Scalars['Boolean']['input'];
  interviewLinked?: InputMaybe<Scalars['Boolean']['input']>;
  minCandidates?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProjectStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Review = 'REVIEW'
}

export enum ProjectTeamEmailMode {
  AccessBased = 'ACCESS_BASED',
  AssigneeBased = 'ASSIGNEE_BASED',
  Disabled = 'DISABLED',
  ProjectRoleAndAssigneeBased = 'PROJECT_ROLE_AND_ASSIGNEE_BASED',
  ProjectRoleBased = 'PROJECT_ROLE_BASED'
}

export type ProjectTeamEmailSettings = {
  __typename?: 'ProjectTeamEmailSettings';
  actorRoles: Array<ActorRole>;
  mode: ProjectTeamEmailMode;
};

export type ProjectTeamEmailSettingsArgs = {
  actorRoles: Array<ActorRole>;
  mode: ProjectTeamEmailMode;
};

export enum ProjectTriboolFilter {
  All = 'ALL',
  Only = 'ONLY',
  OnlyNot = 'ONLY_NOT'
}

export type ProjectUser = {
  __typename?: 'ProjectUser';
  actorRole?: Maybe<ActorRole>;
  project: Project;
  user: User;
};

export type ProjectWithStageCandidates = {
  __typename?: 'ProjectWithStageCandidates';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberOfCompletedInTimeFrameStageCandidates: Scalars['Int']['output'];
  numberOfStageCandidates: Scalars['Int']['output'];
  percentageOfCompletedStageCandidates: Scalars['Float']['output'];
};

export enum ProjectWithStagesFilter {
  All = 'ALL',
  DoesNotHaveStage = 'DOES_NOT_HAVE_STAGE',
  HasAssessmentStage = 'HAS_ASSESSMENT_STAGE',
  HasAssessmentStageAndInterviewStage = 'HAS_ASSESSMENT_STAGE_AND_INTERVIEW_STAGE',
  HasAssessmentStageOrInterviewStage = 'HAS_ASSESSMENT_STAGE_OR_INTERVIEW_STAGE',
  HasInterviewStage = 'HAS_INTERVIEW_STAGE',
  OnlyHasAssessmentStage = 'ONLY_HAS_ASSESSMENT_STAGE',
  OnlyHasInterviewStage = 'ONLY_HAS_INTERVIEW_STAGE'
}

export type QCalcPersonalityDisplayedAnswerModel = {
  __typename?: 'QCalcPersonalityDisplayedAnswerModel';
  ability?: Maybe<Scalars['Float']['output']>;
  answerText?: Maybe<Scalars['String']['output']>;
  answerValue?: Maybe<Scalars['Float']['output']>;
  grade?: Maybe<Grade>;
  percentile?: Maybe<Scalars['Float']['output']>;
  questionDifficulty?: Maybe<Scalars['Float']['output']>;
  questionOrientation: QuestionOrientation;
  questionText: Scalars['String']['output'];
  stenScore?: Maybe<Scalars['Float']['output']>;
  zScore?: Maybe<Scalars['Float']['output']>;
};

export type QCalcResponse = InductiveItemModel | NumericalTestletModel | PersonalityItemModel | TrItemModel | VerbalTestletModel;

export type QCalcTestletDisplayedAnswerModel = {
  __typename?: 'QCalcTestletDisplayedAnswerModel';
  answerText?: Maybe<Scalars['String']['output']>;
  correctOptionText: Scalars['String']['output'];
  inTime: Scalars['Boolean']['output'];
  isCorrect: Scalars['Boolean']['output'];
  questionDifficulty: Scalars['Float']['output'];
  questionText: Scalars['String']['output'];
};

export type QCalcTrDisplayedAnswerModel = {
  __typename?: 'QCalcTrDisplayedAnswerModel';
  answerText?: Maybe<Scalars['String']['output']>;
  answerValue?: Maybe<Scalars['Float']['output']>;
  questionOrientation: QuestionOrientation;
  questionText: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type Query = {
  __typename?: 'Query';
  Answer?: Maybe<Answer>;
  Answers?: Maybe<Array<Answer>>;
  ApiKeyCompanyFindMany: Array<AmApiKeyModel>;
  ApiKeyFindAll: Array<AmApiKeyModel>;
  ApiKeyUserFindOne?: Maybe<AmApiKeyModel>;
  ApiUserFindMany?: Maybe<Array<Maybe<ApiUserModel>>>;
  ApiUserFindOne?: Maybe<ApiUserModel>;
  AssessmentStageActionSupportedLocales: Array<SupportedLocale>;
  AssessmentStageResults: AssessmentStageResultsOutput;
  BehaviourContentFindOne: BehaviourContentModel;
  BehaviourFindOne?: Maybe<BehaviourModel>;
  CalibrationConfigExtendedGenerateOne: CalibrationConfigExtendedModel;
  CalibrationConfigFindOne?: Maybe<CalibrationConfigModel>;
  CalibrationConfigGenerateMany: Array<CalibrationConfigModel>;
  CalibrationConfigGenerateOne?: Maybe<CalibrationConfigModel>;
  CandidateFeedbackFindOneV2?: Maybe<CandidateFeedbackModelV2>;
  CandidateInterviewGuide: CandidateInterviewGuideModel;
  CandidateInterviewGuideForProjectCandidate: Array<CandidateInterviewGuideModel>;
  /** Every stage of one candidate's pipeline, in pipeline order, each carrying the headline result for its stage type. Stages the candidate has not reached are returned with no result rather than omitted. All scores are scoped to the candidate's main role. */
  CandidateOverviewStageResults: Array<CandidateOverviewStageResult>;
  CompaniesPaginated: CompaniesPaginatedGqlModel;
  CompanyAllowedEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  CompanyEmployee?: Maybe<CompanyEmployeeModel>;
  CompanyEmployeeCompanyWriteAccess?: Maybe<Array<Scalars['Int']['output']>>;
  CompanyEmployeeFindMany?: Maybe<Array<CompanyEmployeeModel>>;
  CompanyEmployeeFindOne?: Maybe<CompanyEmployeeModel>;
  CompanyEmployeeFreeTextSearchPaginate?: Maybe<CompanyEmployeeModelPaginated>;
  CompanyEmployees?: Maybe<Array<CompanyEmployeeModel>>;
  CompanyFindManyUsersWithRoles: CompanyUserInfoPaginated;
  CompanyFindUsers: Array<Maybe<User>>;
  CompanyFindUsersPaginated: UserModelPaginated;
  CompanyGetDefaultReports: CompanyDefaultReports;
  CompanyMaybeUserEmployeeFindMany?: Maybe<Array<CompanyMaybeUserEmployeeModel>>;
  CompanyMeetingConfigurationFindOne?: Maybe<CompanyMeetingConfigurationModel>;
  CompanyRole?: Maybe<CompanyRole>;
  CompanyRoles: Array<CompanyRole>;
  CompanySignature?: Maybe<CompanySignatureModel>;
  CompanySignatureFindMany?: Maybe<Array<CompanySignatureModel>>;
  CompanySignatureFindOne?: Maybe<CompanySignatureModel>;
  CompanySignatures?: Maybe<Array<CompanySignatureModel>>;
  /** Fetch paginated list of users and groups in a company with optional filtering by search, user type, and access levels. */
  CompanyUsersFindManyPaginated: CompanyUserModelPaginated;
  ContentViewerViewStageCandidateManagerReport: ContentViewerViewStageCandidateManagerReportModel;
  ContentViewerViewStageCandidateReport: ContentViewerViewStageCandidateReportModel;
  DeiStageAction?: Maybe<DeiStageActionModel>;
  DeiStageActionTemplate?: Maybe<DeiStageActionTemplateModel>;
  DynamicEnum?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use Project.locales */
  EntityLanguageFindMany?: Maybe<Array<EntityLanguageModel>>;
  Field?: Maybe<Field>;
  Fields?: Maybe<Array<Field>>;
  FindManyAssessmentBrowserSwitchCandidateTrackingEvent?: Maybe<Array<AssessmentCandidateBrowserSwitchTrackingEventModel>>;
  FindOneAssessmentBrowserSwitchCandidateTrackingEvent?: Maybe<AssessmentCandidateBrowserSwitchTrackingEventModel>;
  FindOneCandidatesDebriefCsvFileExportScheduledTask: FileExportScheduledTask;
  FindOneROICsvFileExportScheduledTask: FileExportScheduledTask;
  FindOneStageCandidateResultsCsvFileExportScheduledTask: FileExportScheduledTask;
  FindProjectCandidatesPaginated: ProjectCandidatesPaginated;
  FindProjectStageOrderByStage?: Maybe<ProjectStageOrderModel>;
  FindProjectStageOrdersByProject: Array<ProjectStageOrderModel>;
  /** Returns the order record for a specific stage, or null if the stage has no order entry. */
  FindRoleStageOrderByStage?: Maybe<RoleStageOrderModel>;
  /** Returns all stage order records for a role, in pipeline order. */
  FindRoleStageOrdersByRole: Array<RoleStageOrderModel>;
  FindScheduledTask: FileExportScheduledTask;
  FixContentPiece?: Maybe<ContentValidatiorPieceModel>;
  Form?: Maybe<Form>;
  FormBuilder?: Maybe<FormBuilder>;
  FormBuilderFindByOwnerAndType?: Maybe<FormBuilder>;
  FormReportFindAssociatedIds?: Maybe<FormReportIndividualQueries>;
  FormReportFindFormManagerTypes?: Maybe<FormReportIndividualQueries>;
  FormReportFindFormOwners?: Maybe<Array<FormReportFormOwners>>;
  FormReportFindFormTypes?: Maybe<FormReportIndividualQueries>;
  Forms?: Maybe<Array<Form>>;
  GetAdditionalAssessmentsTimeEstimates: Array<SkillsProfileSourceAdditionalAvailableAssessment>;
  GetAuthenticationMethods: Array<AuthenticationMethodModel>;
  GetCurrentProjectCollaborator?: Maybe<ProjectCollaborator>;
  GetDlxQueueMessageCount?: Maybe<Scalars['Float']['output']>;
  GetHiringProcessTemplate?: Maybe<HiringProcessTemplate>;
  GetHiringProcessTemplateOptions: Array<HiringProcessTemplateOption>;
  GetHiringProcessTemplateVersion?: Maybe<HiringProcessTemplateVersion>;
  GetHiringProcessTemplateVersions: Array<HiringProcessTemplateVersion>;
  GetHiringProcessTemplates: HiringProcessTemplatePaginated;
  GetSkillsProfileTemplate?: Maybe<SkillsProfileTemplate>;
  GetSkillsProfileTemplateVersion?: Maybe<SkillsProfileTemplateVersion>;
  GetSkillsProfileTemplateVersions: Array<SkillsProfileTemplateVersion>;
  GetSkillsProfileTemplates: SkillsProfileTemplatePaginated;
  GetStageActionSummaries: Array<StageActionSummary>;
  /** Users of the given companies, for the roles list's hiring team filter. One row per user per company. */
  HiringTeamUsersFindMany: Array<HiringTeamUser>;
  IdentityProviderFindMany?: Maybe<Array<IdentityProviderModel>>;
  IdentityProviderFindOne?: Maybe<IdentityProviderModel>;
  InterviewAutosuggestionFindManyV2: Array<InterviewAutosuggestionModelV2>;
  InterviewDecisionFindOneV2?: Maybe<InterviewDecisionModelV2>;
  /** Get evaluation decision summaries for all interviews linked to an interview stage candidate */
  InterviewEvaluationDecisionsByStageCandidateFindMany: Array<InterviewEvaluationDecisionsModel>;
  InterviewEvaluationFindOne: InterviewEvaluationModel;
  /** Get aggregated evaluation results for an interview scoped to a project job role */
  InterviewEvaluationResultsFindOne: InterviewEvaluationResultsModel;
  InterviewEvaluatorFindOne: InterviewEvaluatorModel;
  InterviewFindManyByProjectCandidateV2: Array<InterviewV2Model>;
  InterviewFindManyV2: Array<InterviewV2Model>;
  InterviewFindOneV2?: Maybe<InterviewV2Model>;
  InterviewGuideBlueprint: InterviewGuideBlueprintModel;
  InterviewGuideContentTemplate?: Maybe<InterviewGuideContentTemplateModel>;
  InterviewGuideContentTemplateAffectedCount: InterviewGuideContentTemplateAffectedCountModel;
  InterviewQuestionRoleLevelContent: InterviewQuestionRoleLevel;
  InterviewQuestionRoleLevelContentFindManyAndCount: InterviewQuestionRoleLevelPaginatedModel;
  InterviewQuestionRoleLevelContents: Array<InterviewQuestionRoleLevel>;
  InterviewStage: InterviewStage;
  InterviewStages: Array<InterviewStage>;
  Invitation?: Maybe<InvitationModel>;
  InvitationFindMany?: Maybe<Array<InvitationModel>>;
  InvitationFindOne?: Maybe<InvitationModel>;
  InvitationSessionFindManyPaginated: InvitationSessionPaginated;
  InvitationSessionFindOne: InvitationSession;
  Invitations?: Maybe<Array<InvitationModel>>;
  JobRoleFindMany: Array<JobRoleModel>;
  JobRoleFindManyPaginated: JobRolePaginated;
  JobRoleFindOne?: Maybe<JobRoleModel>;
  LocationLinkFindMany: Array<LocationLinkModel>;
  MeetingCreateShareLink: Scalars['String']['output'];
  MeetingFindMany: PaginatedMeetingModel;
  MeetingFindOne?: Maybe<MeetingModel>;
  MeetingTypeFindMany: Array<MeetingTypeModel>;
  MeetingTypeFindOne: MeetingTypeModel;
  MeetingUserCalendarFindMany: Array<MeetingUserCalendarModel>;
  MeetingUserCalendarFindOne?: Maybe<MeetingUserCalendarModel>;
  /** Returns the caller's pinned roles for their active workspace, oldest pin first. Archived roles and roles the caller can no longer see are omitted. */
  PinnedRoles: Array<RoleModel>;
  ProjectArtifactGetJobDescriptionUrl?: Maybe<Scalars['String']['output']>;
  ProjectCandidate: ProjectCandidate;
  ProjectCandidateFindOneByInterviewStageCandidateId: ProjectCandidate;
  ProjectCandidates: ProjectCandidatesPaginated;
  /** How many of a role's active candidates would have their hiring process deadline extended to `deadlineAt` (their own deadline is earlier, or missing). Previews the "also apply to already-invited candidates" option of the deadline settings (CR-453). Requires STANDARD_ACCESS on the project's company. */
  ProjectCandidatesDeadlineExtensionCount: Scalars['Int']['output'];
  ProjectCollaboratorsFindManyPaginated?: Maybe<ProjectCollaboratorPaginated>;
  /** Fetches a paginated list of individual project collaborators based on specified filters, including project ID and search criteria. It returns consolidated list of users that are on the project, either directly or through group, where each user appears only once */
  ProjectCollaboratorsIndividualFindManyPaginated?: Maybe<ProjectCollaboratorIndividualPaginated>;
  ProjectFindMany?: Maybe<Array<Project>>;
  ProjectFindManyByCompany: Array<Project>;
  ProjectFindManysByCompanyWithStageCandidateRange: Array<CompanyProjects>;
  ProjectGetAllowedTransitions: Array<ProjectStatus>;
  ProjectGetCandidateStageBreakdown: Array<ProjectCandidateStageBreakdown>;
  ProjectGetInterviewLinkCount: Scalars['Int']['output'];
  ProjectJobRoleFindMany: Array<ProjectJobRoleModel>;
  ProjectJobRoleFindOne?: Maybe<ProjectJobRoleModel>;
  ProjectJobRoleRecent: Array<ProjectJobRoleModel>;
  ProjectJobRoleSearch: Array<ProjectJobRoleWithConfidenceModel>;
  ProjectRequest?: Maybe<ProjectRequestModel>;
  ProjectRequestFileUpload?: Maybe<ProjectRequestFileUploadModel>;
  ProjectRequestFileUploadFindMany: Array<ProjectRequestFileUploadModel>;
  ProjectRequestFileUploadFindOne?: Maybe<ProjectRequestFileUploadModel>;
  ProjectRequestFileUploads: Array<ProjectRequestFileUploadModel>;
  ProjectRequestFindMany?: Maybe<Array<ProjectRequestModel>>;
  ProjectRequestFindOne?: Maybe<ProjectRequestModel>;
  ProjectRequestUser?: Maybe<ProjectRequestUserModel>;
  ProjectRequestUserApproval?: Maybe<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalFindMany: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovalFindOne?: Maybe<ProjectRequestUserApprovalModel>;
  ProjectRequestUserApprovals: Array<ProjectRequestUserApprovalModel>;
  ProjectRequestUserFindMany: Array<ProjectRequestUserModel>;
  ProjectRequestUserFindOne?: Maybe<ProjectRequestUserModel>;
  ProjectRequestUsers: Array<ProjectRequestUserModel>;
  ProjectRequests: Array<ProjectRequestModel>;
  ProjectUserFindMany: Array<ProjectUser>;
  ProjectValidatePolicyActions: Array<Scalars['Boolean']['output']>;
  ProjectWizardSkillsProfileSourcesByProjectId: Array<SkillsProfileSource>;
  Projects: PaginatedProjectsModel;
  QCalcTestDataCacheGetSupportedLocales: Array<Maybe<Scalars['String']['output']>>;
  Report?: Maybe<Report>;
  ReportAssignment?: Maybe<ReportAssignment>;
  ReportAssignmentFindMany?: Maybe<Array<ReportAssignment>>;
  ReportAssignmentFindStageReport?: Maybe<ReportAssignment>;
  ReportAssignments?: Maybe<Array<ReportAssignment>>;
  ReportConfig?: Maybe<ReportConfig>;
  ReportConfigFindMany?: Maybe<Array<ReportConfig>>;
  ReportConfigs?: Maybe<Array<ReportConfig>>;
  ReportFindMany?: Maybe<Array<Report>>;
  ReportRender?: Maybe<ReportRender>;
  ReportRenderDeleteMany?: Maybe<DeleteResult>;
  ReportRenderFindMany?: Maybe<Array<ReportRender>>;
  ReportRenderFindOne?: Maybe<ReportRender>;
  ReportRenderWithDataApi?: Maybe<ReportRender>;
  ReportRenders: Array<ReportRender>;
  Reports?: Maybe<Array<Report>>;
  ReportsFindByCompany?: Maybe<Array<Report>>;
  RespondantForm?: Maybe<RespondantForm>;
  ResultValidatedSkills: ResultValidatedSkillsPaginatedModel;
  RoleFindMany: Array<Role>;
  RoleRequisitionHistory: RoleRequisitionHistoryModel;
  /** Returns available assessments for the role RSP. Used before RoleWizardConfirmRSP. */
  RoleWizardAvailableAssessments: SuccessProfileAvailableAssessments;
  /** Checks whether any of the supplied meeting ids are already linked to a role. */
  RoleWizardCheckMeetingLinks: Array<ProjectMeetingLinkedStatus>;
  RoleWizardFindRequisitionsPaginated: RequisitionPaginatedModel;
  /** Returns a pre-signed download URL for the job description, or null if none is attached. */
  RoleWizardGetJobDescriptionUrl?: Maybe<Scalars['String']['output']>;
  /** Returns company-scoped roles matching the supplied filters. */
  RoleWizardRoleFindMany: RolePaginatedModel;
  /** Returns null when the role does not exist or belongs to a different company. */
  RoleWizardRoleFindOne?: Maybe<RoleModel>;
  Roles: Array<Role>;
  /** Counts company-scoped roles where the caller is a hiring team member, directly or via a user group. Applies only the structural subset of the supplied filters. */
  RolesHiringTeamMembershipCount: Scalars['Int']['output'];
  RssAssessmentCandidateOpenOne: RssCandidateOpenOneModel;
  /** @deprecated Please use "query RssAsssessmentFindAllForStage" instead! */
  RssAssessmentFindMany: Array<RssAssessmentModel>;
  RssAsssessmentFindAllForStage: Array<RssAssessmentModel>;
  SamlAuthInfoFindMany?: Maybe<Array<SamlAuthInfoModel>>;
  SamlAuthInfoFindOne?: Maybe<SamlAuthInfoModel>;
  SharedMeetingFindOne: SharedMeetingModel;
  ShortlistStageResumes: Array<ShortlistStageResume>;
  ShortlistedCandidatesCount: Scalars['Int']['output'];
  SkillCategoryFindMany: Array<SkillCategory>;
  SkillsEvaluationFindOneV2?: Maybe<SkillsEvaluationModelV2>;
  SkillsProfileOpenOne: SkillsProfileOpenOneModel;
  SkillsProfileSource: SkillsProfileSource;
  SkillsProfileSourceAvailableAssessments: SkillsProfileSourceAvailableAssessments;
  SkillsProfileSourceByJobRoleId?: Maybe<SkillsProfileSource>;
  SkillsProfileSourceByMeetingId?: Maybe<SkillsProfileSource>;
  SkillsProfileSourceCheckMeetingLinks: SkillsProfileSourceMeetingLinks;
  SkillsProfileSourceGetJobDescriptionUrl?: Maybe<Scalars['String']['output']>;
  SkillsProfileSources: SkillsProfileSourcesPaginated;
  SoftSkill?: Maybe<SoftSkill>;
  SoftSkillFindMany?: Maybe<Array<SoftSkill>>;
  SoftSkillFindManyPaginated: PaginatedSoftSkillGqlModel;
  SoftSkillGetAllValidForProject: Array<SoftSkill>;
  SoftSkillRoleLevelContent: SoftSkillRoleLevelContent;
  SoftSkillRoleLevelContentFindManyAndCount: SoftSkillRoleLevelContentPaginated;
  SoftSkillRoleLevelContents: Array<SoftSkillRoleLevelContent>;
  SoftSkillSuccessProfileContent: SoftSkillSuccessProfileContent;
  SoftSkillSuccessProfileContentFindManyAndCount: SoftSkillSuccessProfileContentPaginated;
  SoftSkillSuccessProfileContents: Array<SoftSkillSuccessProfileContent>;
  SoftSkillTraitFindManyBySoftSkill?: Maybe<Array<SoftSkillTrait>>;
  SoftSkillTraitFindManyBySoftSkills?: Maybe<Array<SoftSkillTrait>>;
  SoftSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  SoftSkillTypeSuccessProfileContent: SoftSkillTypeSuccessProfileContent;
  SoftSkillTypeSuccessProfileContentFindMany: Array<SoftSkillTypeSuccessProfileContent>;
  SoftSkillTypeSuccessProfileContentFindOne: SoftSkillTypeSuccessProfileContent;
  SoftSkillTypeSuccessProfileContents: Array<SoftSkillTypeSuccessProfileContent>;
  SoftSkills?: Maybe<Array<SoftSkill>>;
  /** @deprecated Use assessmentStage query instead! */
  Stage?: Maybe<SmStageModel>;
  StageCandidateFindById?: Maybe<SmStageCandidateModel>;
  StageCandidateFindBySubId?: Maybe<SmStageCandidateModel>;
  StageCandidateFindMany?: Maybe<Array<SmStageCandidateModel>>;
  StageCandidateFindOne?: Maybe<SmStageCandidateModel>;
  StageCandidateSkillsProfileResultsFindOne: StageCandidateSkillsProfileResultsModel;
  /** @deprecated Please use query AssessmentStageResults instead! */
  StageCandidateStatisticsByProjectJobRoleFindMany: StageCandidateStatisticsByProjectJobRoleFindManyOutput;
  /** @deprecated Please use query AssessmentStageResults instead! */
  StageCandidateStatisticsFindMany: StageCandidateStatisticsFindManyOutput;
  StageCandidateStatisticsFindOne: StageCandidateStatisticsModel;
  /** @deprecated Use `ProjectFindMany` and load the `assessmentStage` property the return type to fetch assessmentStages by project! */
  StageFindMany?: Maybe<Array<SmStageModel>>;
  /** @deprecated Either use `assessmentStage` query or load a project with the `assessmentStage` property loaded. */
  StageFindOne?: Maybe<SmStageModel>;
  /** @deprecated Use the "inviteUrl" property on AssessmentStage instead! */
  StageGenerateIndirectInvitationUrl: GenerateStageIndirectInvitationUrlModel;
  StageProgressSummary?: Maybe<StageCandidateStatisticsFindManyOutput>;
  /** @deprecated Please use query AssessmentStageResults instead! */
  StageResultsSummary: StageCandidateStatisticsByProjectJobRoleFindManyOutput;
  /** @deprecated Success Profile no longer has a link with Project. If you're looking for the Success Profiles connected to a Project, fetch the linked ProjectJobRoles. */
  SuccessProfile?: Maybe<SuccessProfile>;
  SuccessProfileAvailableAssessments: SuccessProfileAvailableAssessments;
  SuccessProfileFindMany?: Maybe<Array<SuccessProfile>>;
  SuccessProfileTechnicalSkill?: Maybe<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillFindMany: Array<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkillFindOne?: Maybe<SuccessProfileTechnicalSkill>;
  SuccessProfileTechnicalSkills: Array<SuccessProfileTechnicalSkill>;
  SuccessProfiles?: Maybe<Array<SuccessProfile>>;
  SummaryTemplateFindMany: PaginatedSummaryTemplateModel;
  SummaryTemplateFindOne?: Maybe<SummaryTemplateModel>;
  SzSkillsMerge?: Maybe<SzSkillsMerge>;
  SzSkillsMergeFindMany: Array<SzSkillsMerge>;
  SzSkillsMergeFindOne?: Maybe<SzSkillsMerge>;
  SzSkillsMergeFreeTextSearchPaginated: PaginatedSzSkillsMerge;
  TechnicalSkill: TechnicalSkill;
  /** @deprecated Please use TechnicalSkillFindManyPaginated instead */
  TechnicalSkillFindMany: Array<TechnicalSkill>;
  TechnicalSkillFindManyPaginated: PaginatedTechnicalSkillModel;
  TechnicalSkillFreeTextSearchPaginated: PaginatedTechnicalSkill;
  Trait?: Maybe<Trait>;
  TraitFindManyBySoftSkillId?: Maybe<Array<Trait>>;
  TraitRoleLevelContent: TraitRoleLevelContent;
  TraitRoleLevelContentFindManyAndCount: TraitRoleLevelContentPaginatedModel;
  TraitRoleLevelContents: Array<TraitRoleLevelContent>;
  TraitSoftSkillContextCsvGenerateAndUpload?: Maybe<MonolithBlobModel>;
  TraitSoftSkillContextFindMany?: Maybe<Array<TraitSoftSkillContextModel>>;
  TraitSoftSkillContextFindOne?: Maybe<TraitSoftSkillContextModel>;
  Traits?: Maybe<Array<Trait>>;
  TranslatedProjectCandidateProfile: ProjectCandidateProfile;
  TranslatedShortlistStageCandidateCitations: Array<ShortlistStageCandidateCriterionResult>;
  UnifiedMeetings: PaginatedUnifiedMeeting;
  UpcomingMeetingFindBySharedId?: Maybe<UpcomingMeetingModel>;
  UpcomingMeetingFindMany: PaginatedUpcomingMeetingModel;
  UpcomingMeetingFindOne?: Maybe<UpcomingMeetingModel>;
  User?: Maybe<User>;
  UserCompanyInfo?: Maybe<UserCompanyInfo>;
  UserCompanyInfoFindMany?: Maybe<Array<UserCompanyInfo>>;
  UserCompanyInfoFindOne?: Maybe<UserCompanyInfo>;
  UserCompanyInfos?: Maybe<Array<UserCompanyInfo>>;
  UserFreeTextSearchPaginate?: Maybe<UserModelPaginated>;
  UserGroupFindManyPaginated: UserGroupPaginatedModel;
  UserGroupFindOne: UserGroupModel;
  UserGroupMemberFindManyPaginated: UserModelPaginated;
  UserMeetingConfigurationFindOne?: Maybe<UserMeetingConfigurationModel>;
  UserSettings?: Maybe<UserSettings>;
  UserSettingsFindMany?: Maybe<Array<UserSettings>>;
  UserSettingsFindOne?: Maybe<UserSettings>;
  UserSettingss?: Maybe<Array<UserSettings>>;
  Users?: Maybe<Array<User>>;
  ValidateContent?: Maybe<ContentValidator>;
  ValidateContentPiece?: Maybe<ContentValidatiorPieceModel>;
  Widget?: Maybe<Widget>;
  WidgetConfig?: Maybe<WidgetConfig>;
  WidgetConfigFindMany?: Maybe<Array<WidgetConfig>>;
  WidgetConfigs?: Maybe<Array<WidgetConfig>>;
  WidgetFindMany?: Maybe<Array<Widget>>;
  WidgetOption?: Maybe<WidgetOption>;
  WidgetOptionFindMany?: Maybe<Array<WidgetOption>>;
  WidgetOptions?: Maybe<Array<WidgetOption>>;
  Widgets?: Maybe<Array<Widget>>;
  aiInterviewAssessmentStageAction?: Maybe<AiInterviewAssessmentStageAction>;
  aiInterviewAssessmentStageActionCandidate: AiInterviewAssessmentStageActionCandidate;
  aiInterviewAssessmentStageActionCandidateByConferenceId: AiInterviewAssessmentStageActionCandidate;
  aiInterviewAssessmentStageActionCandidateRoleStage: AiInterviewAssessmentStageActionCandidateRoleStage;
  assessmentStage: AssessmentStage;
  /** The company's FULL ATS rejection-reason catalogue, ignoring the allowlist. Used by the admin client's Integrations settings to configure the allowlist. Admin-only. */
  atsAllRejectionReasons: Array<RejectionReasonGqlModel>;
  /** The company's tenant-wide distinct ATS stage catalogue — the option set for stage-map configuration. Stages whose provider-native ref is not yet back-filled are excluded; missingRefCount says how many were, so an empty list can be told apart from an unsynced integration. Admin-only. */
  atsAllStages: AtsStageCatalogueGqlModel;
  /** Read the per-customer ATS settings (progression / application-tracking flags). Returns null when the company has no active Kombo integration. Admin-only. */
  atsSettings?: Maybe<AtsSettingsGqlModel>;
  /** Interviewer calendar access and busy time over a window, for choosing interview times */
  availabilityPreview: AvailabilityPreviewModel;
  /** Whether each candidate has an assessment report and an interview guide to link on the hiring team's invite */
  candidateMaterialsAvailability: Array<CandidateMaterialsAvailabilityModel>;
  coderbyteAssessmentDetails?: Maybe<CoderbyteAssessmentStageActionDetails>;
  coderbyteAvailableAssessments: Array<CoderbyteAvailableAssessment>;
  /** A company's Coderbyte workspace, or null if it has none. */
  coderbyteWorkspace?: Maybe<CoderbyteWorkspace>;
  /** Reveals the stored Coderbyte admin password. Its own operation rather than a field, so a secret only leaves the server when something asked for it outright. Every call is logged. */
  coderbyteWorkspaceAdminPassword?: Maybe<Scalars['String']['output']>;
  /** Reveals the stored workspace API key. Its own operation rather than a field, so a secret only leaves the server when something asked for it outright. Every call is logged. */
  coderbyteWorkspaceApiKey?: Maybe<Scalars['String']['output']>;
  /** Every company with a Coderbyte workspace, newest first. Backs the integrations dashboard. */
  coderbyteWorkspaces: Array<CoderbyteWorkspace>;
  cognitiveTestAssessmentStageActionCandidate: CognitiveTestAssessmentStageActionCandidate;
  companies?: Maybe<Array<Company>>;
  company?: Maybe<Company>;
  companyFindManyByIds?: Maybe<Array<Company>>;
  companySchedulingSettings: CompanySchedulingSettingsModel;
  companySettingChanges: PaginatedCompanySettingChangesModel;
  conference: Conference;
  englishProficiencyAssessment: EnglishProficiencyAssessment;
  englishProficiencyAssessmentStageActionCandidate: EnglishProficiencyAssessmentStageActionCandidate;
  generateCoderbyteTechnicalSkills: Array<TechnicalSkill>;
  getAllProjectFiles: Array<ProjectFile>;
  getAllProjects: Array<Project>;
  getCompanyId: ProjectCompanyId;
  getEditingInfo?: Maybe<EditingInfoModel>;
  getFormReportCSV?: Maybe<Scalars['String']['output']>;
  getInvitationStatus: InvitationStatusResult;
  getProjectById?: Maybe<Project>;
  getProjectCobranding: ProjectCobrandingModel;
  getProjectSamlAuthInfo: Scalars['String']['output'];
  hello: Scalars['String']['output'];
  /** Whether this company has a Coderbyte workspace in service, and so whether `createCoderbyteSsoLink` has anywhere to send the caller. False for a caller who holds no role at the company. */
  isCoderbyteWorkspaceAvailable: Scalars['Boolean']['output'];
  /** List all Kombo integrations (paginated). Each integration represents a company's connection to an ATS via Kombo, with separate IDs for ATS sync and assessment operations. */
  komboIntegrationsFindManyPaginated: KomboIntegrationPaginated;
  /** Get the Kombo integration for a specific company. Returns null if the company has no Kombo integration. */
  komboIntegrationsFindOne?: Maybe<KomboIntegrationModel>;
  /** Get a single cached Kombo job by its internal ID, along with its linked project (if any). */
  komboJobFindOne?: Maybe<KomboJobWithProject>;
  /** List cached Kombo jobs for a company (paginated). Supports filtering by status, search term, and whether a project is linked. Each result includes the job and its linked project (if any). */
  komboJobsFindManyPaginated: KomboJobWithProjectPaginated;
  /** Get sync history for a company (most recent first). */
  komboSyncHistory: Array<KomboSyncRunModel>;
  /** Get a specific sync run by ID. */
  komboSyncRun?: Maybe<KomboSyncRunModel>;
  /** Get the sync health status for a company's Kombo integration. Returns sync state, last sync timestamp, error info, and cached job count. */
  komboSyncStatus?: Maybe<KomboSyncStatusModel>;
  /** A candidate's most recent cancelled scheduling request at a stage, for the drawer to show while nothing newer stands; null when none was cancelled */
  latestCancelledSchedulingRequest?: Maybe<SchedulingCancellationModel>;
  me: User;
  myRole: MyRole;
  myRoles: Array<MyRole>;
  omnisearch: OmnisearchAll;
  omnisearchCandidates: CandidateSearchPage;
  omnisearchResolveRecents: OmnisearchRecents;
  omnisearchRoles: RoleSearchPage;
  orgCalendarConnectionHistory: OrgCalendarConnectionHistoryModel;
  orgCalendarConsentRefusals: Array<OrgCalendarConsentRefusalModel>;
  orgCalendarGrant?: Maybe<OrgCalendarGrantModel>;
  personalityTestAssessmentStageActionCandidate: PersonalityTestAssessmentStageActionCandidate;
  /** Rejection reasons recently used on a role, for the "Recent reasons" section of the reject modal. Pass `projectId` alone to aggregate across the whole role, or add `stageId` to narrow to rejections made from that stage. Distinct, most-recent first. Requires STANDARD_ACCESS on the project's company. */
  recentRejectionReasons: Array<RecentRejectionReasonGqlModel>;
  /** Get recently accessed workspaces for the current user */
  recentWorkspaces: Array<WorkspaceModel>;
  /** The company's ATS rejection-reason catalogue, fetched live from the connected ATS for the reject modal. Returns an empty list when the company has no ATS integration, the integration has no named reasons, or the gateway is unavailable — never an error. The `id` round-trips verbatim to the ATS on reject. When an allowlist is configured for the company, only allowlisted reasons are returned. */
  rejectionReasons: Array<RejectionReasonGqlModel>;
  /** The rejection reasons offered for rejecting these candidates: `rejectionReasons`, further narrowed to the reasons valid at every candidate's current ATS stage when the company has per-stage rejection reasons configured (Workday only today, since only Workday rejects an invalid reason). `isStageScoped` is true when that narrowing applied, so an empty list can be told apart from an unavailable catalogue. Refuses more than 2,000 `subIds`. */
  rejectionReasonsForCandidates: RejectionReasonsForCandidatesGqlModel;
  /** Resolve a share link token to get workspace and URL information */
  resolveShareLink: ShareLinkDataModel;
  /** A saved batch read back to reopen the wizard: its requests, with their interview details, and the interviewers they name */
  schedulingBatch: SchedulingSavedBatchModel;
  /** The interview times a batch already offers, to reopen it */
  schedulingBatchSlots: Array<OfferedSlotModel>;
  /** A sent scheduling request's candidate booking link, for the recruiter to copy. Refused when the link would open nothing the candidate can act on: a draft, a cancelled, declined or expired request, or an offer whose link has run out */
  schedulingBookingLink: Scalars['String']['output'];
  /** How the request's current interviewers have replied to the calendar invitation, for the drawer */
  schedulingInterviewerReplies: SchedulingInterviewerRepliesModel;
  /** One candidate's scheduling request, for the drawer */
  schedulingRequest: SchedulingRequestModel;
  /** The interview times a sent request offers its candidate right now: what their booking link shows, for the drawer. A batch's chosen slots can still include an earlier round's times, so the drawer reads this instead */
  schedulingRequestOfferedSlots: Array<OfferedSlotModel>;
  /** What has happened to one candidate's scheduling request, oldest first, for the drawer */
  schedulingRequestTimeline: Array<SchedulingTimelineEntryModel>;
  /** Interview scheduling state for every candidate at a stage */
  stageSchedulingProjection: Array<StageSchedulingRowModel>;
  /** Get all workspaces available to the current user (paginated) */
  workspaces: WorkspacesResponse;
};


export type QueryAnswerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAnswersArgs = {
  associatedId?: InputMaybe<Scalars['Int']['input']>;
  associatedIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fieldId?: InputMaybe<Scalars['Int']['input']>;
  fields?: InputMaybe<Array<Scalars['Int']['input']>>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  respondantId?: InputMaybe<Scalars['Int']['input']>;
  respondantIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  response?: InputMaybe<Scalars['String']['input']>;
};


export type QueryApiKeyCompanyFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  permission?: InputMaybe<IdentityPermissionRole>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryApiKeyUserFindOneArgs = {
  getOption?: InputMaybe<GetOption>;
  relationDepth?: InputMaybe<RelationDepth>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userSubId?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryApiUserFindManyArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  getOption?: InputMaybe<GetOption>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']['input']>;
  puppetUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryApiUserFindOneArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  getOption?: InputMaybe<GetOption>;
  hasClientSecret?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ApiUserOwnerType>;
  puppetUserId?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryAssessmentStageActionSupportedLocalesArgs = {
  kind: AssessmentStageActionKind;
};


export type QueryAssessmentStageResultsArgs = {
  filter?: InputMaybe<AssessmentStageResultsFilterArgs>;
  order?: InputMaybe<AssessmentStageResultsOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  stageId: Scalars['Int']['input'];
};


export type QueryBehaviourContentFindOneArgs = {
  behaviourId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  negativeSummary?: InputMaybe<Scalars['String']['input']>;
  positiveSummary?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryBehaviourFindOneArgs = {
  contextIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCalibrationConfigExtendedGenerateOneArgs = {
  doneBy: Scalars['Int']['input'];
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  scoreType: ResultScoreType;
  stageCandidateId: Scalars['Int']['input'];
};


export type QueryCalibrationConfigFindOneArgs = {
  ig?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
};


export type QueryCalibrationConfigGenerateManyArgs = {
  ig?: InputMaybe<Scalars['Boolean']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryCalibrationConfigGenerateOneArgs = {
  ig?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['Int']['input'];
};


export type QueryCandidateFeedbackFindOneV2Args = {
  id?: InputMaybe<Scalars['String']['input']>;
  interviewEvaluationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCandidateInterviewGuideArgs = {
  locale?: InputMaybe<SupportedLocale>;
  subId: Scalars['ID']['input'];
};


export type QueryCandidateInterviewGuideForProjectCandidateArgs = {
  projectCandidateSubId: Scalars['ID']['input'];
};


export type QueryCandidateOverviewStageResultsArgs = {
  projectCandidateSubId: Scalars['ID']['input'];
};


export type QueryCompaniesPaginatedArgs = {
  filters?: InputMaybe<CompaniesPaginatedFilters>;
  includeCompanyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
};


export type QueryCompanyAllowedEmailDomainsArgs = {
  id: Scalars['Float']['input'];
};


export type QueryCompanyEmployeeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyEmployeeFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanyEmployeeFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  customFields?: InputMaybe<UserCompanyInfoCustomFieldsArgs>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanyEmployeeFreeTextSearchPaginateArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  freetext?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<CompanyEmployeeOrderByArgs>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyFindManyUsersWithRolesArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  userRoles: Array<IdentityPermissionRole>;
};


export type QueryCompanyFindUsersArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyFindUsersPaginatedArgs = {
  id: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryCompanyMaybeUserEmployeeFindManyArgs = {
  companyId: Scalars['Float']['input'];
};


export type QueryCompanyRoleArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryCompanyRolesArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  roleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  twoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type QueryCompanySignatureArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanySignatureFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signatureEmail?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanySignatureFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  signature?: InputMaybe<Scalars['String']['input']>;
  signatureEmail?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryCompanyUsersFindManyPaginatedArgs = {
  args: CompanyUsersArgs;
  order?: CompanyUsersOrderOptions;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryContentViewerViewStageCandidateManagerReportArgs = {
  stageCandidateSub: Scalars['String']['input'];
};


export type QueryContentViewerViewStageCandidateReportArgs = {
  stageCandidateSub: Scalars['String']['input'];
};


export type QueryDeiStageActionArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryDeiStageActionTemplateArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryEntityLanguageFindManyArgs = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entityType?: InputMaybe<EntityType>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  language?: InputMaybe<Language>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryFieldArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFieldsArgs = {
  fieldType?: InputMaybe<FieldType>;
  formManagerType?: InputMaybe<FormManagerType>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindManyAssessmentBrowserSwitchCandidateTrackingEventArgs = {
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  assessmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<AssessmentBrowserSwitchCandidateTrackingEvent>;
  types?: InputMaybe<Array<AssessmentBrowserSwitchCandidateTrackingEvent>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type QueryFindOneAssessmentBrowserSwitchCandidateTrackingEventArgs = {
  assessmentId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AssessmentBrowserSwitchCandidateTrackingEvent>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryFindOneCandidatesDebriefCsvFileExportScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  triggeredBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindOneRoiCsvFileExportScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  triggeredBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindOneStageCandidateResultsCsvFileExportScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  triggeredBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindProjectCandidatesPaginatedArgs = {
  aiInterviewStageFilters?: InputMaybe<FindProjectCandidatesPaginatedAiInterviewStageFilterArgs>;
  args: ProjectCandidatesArgs;
  generalFilters?: FindProjectCandidatesPaginatedFilterArgs;
  order?: FindProjectCandidatesPaginatedOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
  progressionFilters: FindProjectCandidatesPaginatedProgressionFilterArgs;
  shortlistStageFilters?: InputMaybe<FindProjectCandidatesPaginatedShortlistStageFilterArgs>;
};


export type QueryFindProjectStageOrderByStageArgs = {
  stageId: Scalars['Int']['input'];
  stageType: StageType;
};


export type QueryFindProjectStageOrdersByProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryFindRoleStageOrderByStageArgs = {
  stageId: Scalars['Int']['input'];
  stageType: StageType;
};


export type QueryFindRoleStageOrdersByRoleArgs = {
  roleId: Scalars['Int']['input'];
};


export type QueryFindScheduledTaskArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ScheduledTaskStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  triggeredBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFixContentPieceArgs = {
  softSkillId: Scalars['Int']['input'];
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFormArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFormBuilderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFormBuilderFindByOwnerAndTypeArgs = {
  formManagerType?: InputMaybe<FormManagerType>;
  formOwnerId?: InputMaybe<Scalars['Int']['input']>;
  formType?: InputMaybe<FormType>;
};


export type QueryFormReportFindAssociatedIdsArgs = {
  formManagerType?: InputMaybe<FormManagerType>;
  formOwnerId?: InputMaybe<Scalars['Int']['input']>;
  formType?: InputMaybe<FormType>;
};


export type QueryFormReportFindFormOwnersArgs = {
  formManagerType: FormManagerType;
  formType: FormType;
};


export type QueryFormReportFindFormTypesArgs = {
  formManagerType: FormManagerType;
};


export type QueryFormsArgs = {
  formManagerType?: InputMaybe<FormManagerType>;
  formOwnerId?: InputMaybe<Scalars['Int']['input']>;
  formType?: InputMaybe<FormType>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAuthenticationMethodsArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetCurrentProjectCollaboratorArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryGetHiringProcessTemplateArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryGetHiringProcessTemplateOptionsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryGetHiringProcessTemplateVersionArgs = {
  versionId: Scalars['Int']['input'];
};


export type QueryGetHiringProcessTemplateVersionsArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryGetHiringProcessTemplatesArgs = {
  filterArgs?: GetHiringProcessTemplatesFilterArgs;
  orderArgs?: GetHiringProcessTemplatesOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryGetSkillsProfileTemplateArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryGetSkillsProfileTemplateVersionArgs = {
  versionId: Scalars['Int']['input'];
};


export type QueryGetSkillsProfileTemplateVersionsArgs = {
  templateId: Scalars['Int']['input'];
};


export type QueryGetSkillsProfileTemplatesArgs = {
  filterArgs?: GetSkillsProfileTemplatesFilterArgs;
  orderArgs?: GetSkillsProfileTemplatesOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryGetStageActionSummariesArgs = {
  stageId?: InputMaybe<Scalars['Int']['input']>;
  stageSubId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHiringTeamUsersFindManyArgs = {
  companyIds: Array<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdentityProviderFindManyArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type QueryIdentityProviderFindOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryInterviewAutosuggestionFindManyV2Args = {
  interviewId: Scalars['String']['input'];
};


export type QueryInterviewDecisionFindOneV2Args = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInterviewEvaluationDecisionsByStageCandidateFindManyArgs = {
  interviewStageCandidateId: Scalars['Int']['input'];
};


export type QueryInterviewEvaluationFindOneArgs = {
  interviewEvaluatorId: Scalars['String']['input'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInterviewEvaluationResultsFindOneArgs = {
  interviewId: Scalars['String']['input'];
  interviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleId: Scalars['Int']['input'];
};


export type QueryInterviewEvaluatorFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  interviewId: Scalars['String']['input'];
};


export type QueryInterviewFindManyByProjectCandidateV2Args = {
  projectCandidateSubId: Scalars['String']['input'];
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInterviewFindManyV2Args = {
  linkedInterviewStageCandidateId: Scalars['Int']['input'];
  linkedProjectJobRoleId: Scalars['Int']['input'];
};


export type QueryInterviewFindOneV2Args = {
  id?: InputMaybe<Scalars['String']['input']>;
  linkedInterviewStageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  linkedProjectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  meetingId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCandidateSubId?: InputMaybe<Scalars['String']['input']>;
  stageCandidateId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<InterviewV2Status>;
};


export type QueryInterviewGuideBlueprintArgs = {
  locale?: InputMaybe<SupportedLocale>;
  subId: Scalars['ID']['input'];
};


export type QueryInterviewQuestionRoleLevelContentArgs = {
  classification?: InputMaybe<ContentClassification>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mainQuestion?: InputMaybe<Scalars['String']['input']>;
  reasonForQuestion?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  subQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInterviewQuestionRoleLevelContentFindManyAndCountArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainQuestion?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reasonForQuestion?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInterviewQuestionRoleLevelContentsArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  feedback?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  mainQuestion?: InputMaybe<Scalars['String']['input']>;
  reasonForQuestion?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subQuestions?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInterviewStageArgs = {
  subId: Scalars['ID']['input'];
};


export type QueryInterviewStagesArgs = {
  projectSubId: Scalars['ID']['input'];
};


export type QueryInvitationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvitationFindManyArgs = {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationType?: InputMaybe<InvitationType>;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryInvitationFindOneArgs = {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  invitationType?: InputMaybe<InvitationType>;
  language?: InputMaybe<Language>;
  lastActionType?: InputMaybe<InvitationLastActionType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  projectSubId?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<InvitationStatusCode>;
  targetId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryInvitationSessionFindManyPaginatedArgs = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<FilterMomentRange>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  skip: Scalars['Int']['input'];
  sortField?: InputMaybe<InvitationSessionSort>;
  sortOrder?: InputMaybe<SortOption>;
  sources?: InputMaybe<Array<InvitationSessionSource>>;
  statuses?: InputMaybe<Array<InvitationSessionStatus>>;
  take: Scalars['Int']['input'];
};


export type QueryInvitationSessionFindOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryJobRoleFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  families?: InputMaybe<Array<JobRoleFamily>>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  qualifiers?: InputMaybe<Array<Scalars['String']['input']>>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type QueryJobRoleFindManyPaginatedArgs = {
  filters?: InputMaybe<JobRoleFindManyPaginatedFiltersArgs>;
  order?: InputMaybe<JobRoleFindManyPaginatedOrderArgs>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
};


export type QueryJobRoleFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  family?: InputMaybe<JobRoleFamily>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameOrQualifierContains?: InputMaybe<Scalars['String']['input']>;
  qualifier?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryLocationLinkFindManyArgs = {
  args?: InputMaybe<LocationLinkFindManyArgs>;
};


export type QueryMeetingCreateShareLinkArgs = {
  meetingId: Scalars['String']['input'];
  sharedFeatures?: MeetingFeatures;
  summaryId: Scalars['String']['input'];
};


export type QueryMeetingFindManyArgs = {
  attendeeEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  direction?: InputMaybe<SortOrder>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyMyMeetings?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<MeetingStatus>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<MeetingScope>>;
};


export type QueryMeetingFindOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryMeetingTypeFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<MeetingScope>;
};


export type QueryMeetingUserCalendarFindManyArgs = {
  externalCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  platformName?: InputMaybe<UserCalendarPlatform>;
};


export type QueryMeetingUserCalendarFindOneArgs = {
  externalCalendarId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  platformName?: InputMaybe<UserCalendarPlatform>;
};


export type QueryProjectArtifactGetJobDescriptionUrlArgs = {
  projectSubId: Scalars['ID']['input'];
};


export type QueryProjectCandidateArgs = {
  subId: Scalars['ID']['input'];
};


export type QueryProjectCandidateFindOneByInterviewStageCandidateIdArgs = {
  interviewStageCandidateId: Scalars['ID']['input'];
};


export type QueryProjectCandidatesArgs = {
  args: ProjectCandidatesArgs;
  filters?: ProjectCandidatesFilterArgs;
  order?: ProjectCandidatesOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryProjectCandidatesDeadlineExtensionCountArgs = {
  deadlineAt: Scalars['Date']['input'];
  projectId: Scalars['Int']['input'];
};


export type QueryProjectCollaboratorsFindManyPaginatedArgs = {
  args: ProjectCollaboratorArgs;
  order?: ProjectCollaboratorOrderOptions;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryProjectCollaboratorsIndividualFindManyPaginatedArgs = {
  args: ProjectIndividualArgs;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryProjectFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companySignatureId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isStopped?: InputMaybe<Scalars['Boolean']['input']>;
  managerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  moduleType?: InputMaybe<ProjectModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectFindManyByCompanyArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryProjectFindManysByCompanyWithStageCandidateRangeArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companySignatureId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isStopped?: InputMaybe<Scalars['Boolean']['input']>;
  managerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  moduleType?: InputMaybe<ProjectModuleType>;
  name?: InputMaybe<Scalars['String']['input']>;
  stageCandidateCreatedAtFrom?: InputMaybe<Scalars['Date']['input']>;
  stageCandidateCreatedAtTo?: InputMaybe<Scalars['Date']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectGetAllowedTransitionsArgs = {
  app: SzApp;
  projectId: Scalars['Int']['input'];
};


export type QueryProjectGetCandidateStageBreakdownArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectGetInterviewLinkCountArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectJobRoleFindManyArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isMainRole?: InputMaybe<Scalars['Boolean']['input']>;
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
  jobRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skillsProfileId?: InputMaybe<Scalars['Int']['input']>;
  skillsProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type QueryProjectJobRoleFindOneArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  skillsProfileId?: InputMaybe<Scalars['Int']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};


export type QueryProjectJobRoleRecentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryProjectJobRoleSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProjectRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectRequestFileUploadArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectRequestFileUploadFindManyArgs = {
  blobId?: InputMaybe<Scalars['Int']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
  projectRequestIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestFileUploadFindOneArgs = {
  blobId?: InputMaybe<Scalars['Int']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestFindManyArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  managerSurveyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<ProjectRequestStatus>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestFindOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  managerSurveyId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectName?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  status?: InputMaybe<ProjectRequestStatus>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectRequestUserApprovalArgs = {
  id: Scalars['Int']['input'];
};


export type QueryProjectRequestUserApprovalFindManyArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectRequestUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserApprovalFindOneArgs = {
  approvalRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  approvalStatus?: InputMaybe<ProjectRequestUserApprovalStatus>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserFindManyArgs = {
  approvalId?: InputMaybe<Scalars['Int']['input']>;
  approvalIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
  projectRequestIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  type?: InputMaybe<ProjectRequestUserType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectRequestUserFindOneArgs = {
  approvalId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  projectRequestId?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  type?: InputMaybe<ProjectRequestUserType>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryProjectUserFindManyArgs = {
  includeArchivedProjects?: InputMaybe<Scalars['Boolean']['input']>;
  includeClosedProjects?: InputMaybe<Scalars['Boolean']['input']>;
  userIds: Array<Scalars['Int']['input']>;
};


export type QueryProjectValidatePolicyActionsArgs = {
  actions: Array<ProjectAction>;
  app: SzApp;
  projectId: Scalars['Int']['input'];
};


export type QueryProjectWizardSkillsProfileSourcesByProjectIdArgs = {
  projectId: Scalars['Int']['input'];
};


export type QueryProjectsArgs = {
  filters?: ProjectFilterArgs;
  order?: ProjectOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryQCalcTestDataCacheGetSupportedLocalesArgs = {
  testSubType?: InputMaybe<TestSubType>;
  testType: TestType;
};


export type QueryReportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReportAssignmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReportAssignmentFindManyArgs = {
  assignedId?: InputMaybe<Scalars['Int']['input']>;
  assignedType?: InputMaybe<RAssignedType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryReportAssignmentFindStageReportArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  subType: ReportSubType;
  type: ReportType;
};


export type QueryReportConfigArgs = {
  id: Scalars['Int']['input'];
};


export type QueryReportConfigFindManyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  newPageBefore?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
  widgetId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportFindManyArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryReportRenderArgs = {
  subId: Scalars['String']['input'];
};


export type QueryReportRenderDeleteManyArgs = {
  dataSourceId?: InputMaybe<Scalars['Int']['input']>;
  dataSourceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  footerType?: InputMaybe<ReportFooterType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  reportRenderStatus?: InputMaybe<Scalars['String']['input']>;
  reportRenderStatuses?: InputMaybe<Array<ReportRenderStatus>>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryReportRenderFindManyArgs = {
  dataSourceId?: InputMaybe<Scalars['Int']['input']>;
  dataSourceIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  footerType?: InputMaybe<ReportFooterType>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  projectJobRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  reportRenderStatus?: InputMaybe<Scalars['String']['input']>;
  reportRenderStatuses?: InputMaybe<Array<ReportRenderStatus>>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryReportRenderFindOneArgs = {
  dataSourceId?: InputMaybe<Scalars['Int']['input']>;
  dontSendEmailToCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  footerType?: InputMaybe<ReportFooterType>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  reportId?: InputMaybe<Scalars['Int']['input']>;
  reportRenderStatus?: InputMaybe<Scalars['String']['input']>;
  reportRenderType?: InputMaybe<ReportRenderType>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryReportRenderWithDataApiArgs = {
  identitySubId: Scalars['String']['input'];
  subId: Scalars['String']['input'];
};


export type QueryReportsFindByCompanyArgs = {
  footerType?: InputMaybe<ReportFooterType>;
  includeSharedReports: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<ReportOwnerType>;
  subType?: InputMaybe<ReportSubType>;
  type?: InputMaybe<ReportType>;
};


export type QueryRespondantFormArgs = {
  associatedId: Scalars['Int']['input'];
  formOwnerId: Scalars['Int']['input'];
  formType: FormType;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  respondantId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResultValidatedSkillsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryRoleFindManyArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  filterForIdentity?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<RoleType>;
  types?: InputMaybe<Array<RoleType>>;
};


export type QueryRoleRequisitionHistoryArgs = {
  roleId: Scalars['Int']['input'];
};


export type QueryRoleWizardAvailableAssessmentsArgs = {
  roleId: Scalars['Int']['input'];
};


export type QueryRoleWizardCheckMeetingLinksArgs = {
  meetingIds: Array<Scalars['ID']['input']>;
};


export type QueryRoleWizardFindRequisitionsPaginatedArgs = {
  companyId: Scalars['Int']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  pagination?: OffsetBasedPaginationArgs;
};


export type QueryRoleWizardGetJobDescriptionUrlArgs = {
  roleId: Scalars['Int']['input'];
};


export type QueryRoleWizardRoleFindManyArgs = {
  filters?: ProjectFilterArgs;
  order?: ProjectOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
  withPinnedRoles?: Scalars['Boolean']['input'];
};


export type QueryRoleWizardRoleFindOneArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRolesHiringTeamMembershipCountArgs = {
  filters?: ProjectFilterArgs;
};


export type QueryRssAssessmentCandidateOpenOneArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRssAssessmentFindManyArgs = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  stageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<RssAssessmentType>;
  types?: InputMaybe<Array<RssAssessmentType>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
};


export type QueryRssAsssessmentFindAllForStageArgs = {
  stageId: Scalars['Int']['input'];
};


export type QuerySamlAuthInfoFindManyArgs = {
  cert?: InputMaybe<Scalars['String']['input']>;
  certs?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  entryPoints?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityProviderId?: InputMaybe<Scalars['Int']['input']>;
  identityProviderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  issuers?: InputMaybe<Array<Scalars['String']['input']>>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithms?: InputMaybe<Array<Scalars['String']['input']>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  updatedAts?: InputMaybe<Array<Scalars['Date']['input']>>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySamlAuthInfoFindOneArgs = {
  cert?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  entryPoint?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identityProviderId?: InputMaybe<Scalars['Int']['input']>;
  issuer?: InputMaybe<Scalars['String']['input']>;
  signatureAlgorithm?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  wantAssertionsSigned?: InputMaybe<Scalars['Boolean']['input']>;
  wantAuthResponseSigned?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySharedMeetingFindOneArgs = {
  shareLinkId: Scalars['String']['input'];
};


export type QueryShortlistStageResumesArgs = {
  shortlistStageSubId: Scalars['ID']['input'];
  source?: InputMaybe<ShortlistStageResumeSource>;
  statuses: Array<ShortlistStageResumeProcessingStatus>;
};


export type QueryShortlistedCandidatesCountArgs = {
  stageId: Scalars['ID']['input'];
};


export type QuerySkillCategoryFindManyArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySkillsEvaluationFindOneV2Args = {
  id: Scalars['String']['input'];
};


export type QuerySkillsProfileSourceArgs = {
  subId: Scalars['ID']['input'];
};


export type QuerySkillsProfileSourceAvailableAssessmentsArgs = {
  subId: Scalars['ID']['input'];
};


export type QuerySkillsProfileSourceByJobRoleIdArgs = {
  jobRoleId: Scalars['Int']['input'];
};


export type QuerySkillsProfileSourceByMeetingIdArgs = {
  meetingId: Scalars['ID']['input'];
};


export type QuerySkillsProfileSourceCheckMeetingLinksArgs = {
  meetingIds: Array<Scalars['ID']['input']>;
  upcomingMeetingSharedIds: Array<Scalars['ID']['input']>;
};


export type QuerySkillsProfileSourceGetJobDescriptionUrlArgs = {
  subId: Scalars['ID']['input'];
};


export type QuerySkillsProfileSourcesArgs = {
  filters?: InputMaybe<SkillsProfileSourcesFiltersArgs>;
  order?: InputMaybe<SkillsProfileSourcesOrderArgs>;
  pagination: OffsetBasedPaginationArgs;
};


export type QuerySoftSkillArgs = {
  subId: Scalars['ID']['input'];
};


export type QuerySoftSkillFindManyArgs = {
  category?: InputMaybe<SoftSkillCategory>;
  childSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Array<Scalars['String']['input']>>;
  granularity?: InputMaybe<SoftSkillGranularity>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  parentSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  taxonomyVersion?: InputMaybe<Scalars['Int']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySoftSkillFindManyPaginatedArgs = {
  filters?: InputMaybe<SoftSkillFindManyPaginatedFilters>;
  order?: InputMaybe<SoftSkillFindManyPaginatedOrder>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
  semanticSearch?: InputMaybe<SoftSkillSemanticSearchArgs>;
};


export type QuerySoftSkillGetAllValidForProjectArgs = {
  projectId: Scalars['Int']['input'];
};


export type QuerySoftSkillRoleLevelContentArgs = {
  candidateContent?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade>;
  hiringManagerContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  internalCandidateContent?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySoftSkillRoleLevelContentFindManyAndCountArgs = {
  candidateContent?: InputMaybe<Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade>;
  grades?: InputMaybe<Array<Grade>>;
  hiringManagerContent?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  internalCandidateContent?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySoftSkillRoleLevelContentsArgs = {
  candidateContent?: InputMaybe<Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Grade>;
  grades?: InputMaybe<Array<Grade>>;
  hiringManagerContent?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  internalCandidateContent?: InputMaybe<Scalars['String']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QuerySoftSkillSuccessProfileContentArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySoftSkillSuccessProfileContentFindManyAndCountArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySoftSkillSuccessProfileContentsArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QuerySoftSkillTraitFindManyBySoftSkillArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySoftSkillTraitFindManyBySoftSkillsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySoftSkillTraitsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  orientation?: InputMaybe<Orientation>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};


export type QuerySoftSkillTypeSuccessProfileContentArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySoftSkillTypeSuccessProfileContentFindManyArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillType?: InputMaybe<SoftSkillType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySoftSkillTypeSuccessProfileContentFindOneArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillType?: InputMaybe<SoftSkillType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStageCandidateFindByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStageCandidateFindBySubIdArgs = {
  subId: Scalars['String']['input'];
};


export type QueryStageCandidateFindManyArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['Int']['input']>;
  createdAtFrom?: InputMaybe<Scalars['Date']['input']>;
  createdAtTo?: InputMaybe<Scalars['Date']['input']>;
  doneBy?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastDateOfCandidateActionFrom?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionTo?: InputMaybe<Scalars['Date']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  stageIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<StageCandidateStatus>;
  statuses?: InputMaybe<Array<StageCandidateStatus>>;
  subId?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageCandidateFindOneArgs = {
  applicationId?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['Int']['input']>;
  doneBy?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  hasPledgedAnticheating?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<StageCandidateStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageCandidateSkillsProfileResultsFindOneArgs = {
  projectJobRoleId: Scalars['Int']['input'];
  stageCandidateId: Scalars['Int']['input'];
};


export type QueryStageCandidateStatisticsByProjectJobRoleFindManyArgs = {
  filter?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectJobRoleId: Scalars['Int']['input'];
};


export type QueryStageCandidateStatisticsFindManyArgs = {
  filter?: InputMaybe<StageCandidateStatisticsFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectId: Scalars['Int']['input'];
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStageCandidateStatisticsFindOneArgs = {
  stageCandidateId: Scalars['Int']['input'];
};


export type QueryStageFindManyArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']['input']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']['input']>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']['input']>;
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<AssessmentStageKind>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  relationDepth?: InputMaybe<RelationDepth>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<StageStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageFindOneArgs = {
  aiInterviewStageActionDuration?: InputMaybe<Scalars['Int']['input']>;
  aiInterviewStageActionKnowledgeBase?: InputMaybe<Scalars['String']['input']>;
  aiInterviewStageActionName?: InputMaybe<Scalars['String']['input']>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  cognitiveMode?: InputMaybe<CognitiveMode>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']['input']>;
  enableF2fInterviews?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  formId?: InputMaybe<Scalars['Int']['input']>;
  getOption?: InputMaybe<GetOption>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  hasCalibration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<AssessmentStageKind>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['Int']['input']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
  relationDepth?: InputMaybe<RelationDepth>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<StageStatus>;
  subId?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryStageGenerateIndirectInvitationUrlArgs = {
  id: Scalars['Int']['input'];
  language?: InputMaybe<Language>;
  locale?: InputMaybe<SupportedLocale>;
};


export type QueryStageProgressSummaryArgs = {
  filter?: InputMaybe<StageCandidateStatisticsFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectId: Scalars['Int']['input'];
  projectJobRoleId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStageResultsSummaryArgs = {
  filter?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyFilterArgs>;
  order?: InputMaybe<StageCandidateStatisticsByProjectJobRoleFindManyOrderArgs>;
  paginate?: InputMaybe<OffsetBasedPaginationArgs>;
  projectJobRoleId: Scalars['Int']['input'];
};


export type QuerySuccessProfileArgs = {
  projectId: Scalars['Int']['input'];
};


export type QuerySuccessProfileAvailableAssessmentsArgs = {
  successProfileId: Scalars['Float']['input'];
};


export type QuerySuccessProfileFindManyArgs = {
  calculationMethod?: InputMaybe<CalculationMethod>;
  gradingMethod?: InputMaybe<GradingMethod>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobRoleId?: InputMaybe<Scalars['Int']['input']>;
  jobRoleIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QuerySuccessProfileTechnicalSkillArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySuccessProfileTechnicalSkillFindManyArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  successProfileIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySuccessProfileTechnicalSkillFindOneArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySummaryTemplateFindManyArgs = {
  direction?: InputMaybe<SortOrder>;
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isReady?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  scope?: InputMaybe<SummaryTemplateScope>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<TemplateType>;
  types?: InputMaybe<Array<TemplateType>>;
};


export type QuerySummaryTemplateFindOneArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  isReady?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<SummaryTemplateScope>;
  type?: InputMaybe<TemplateType>;
};


export type QuerySzSkillsMergeArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySzSkillsMergeFindManyArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  measurementConstructTypes?: InputMaybe<Array<MeasurementConstructType>>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  originIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillType?: InputMaybe<SkillType>;
  skillTypes?: InputMaybe<Array<SkillType>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySzSkillsMergeFindOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillType?: InputMaybe<SkillType>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QuerySzSkillsMergeFreeTextSearchPaginatedArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  freetext?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillType?: InputMaybe<SkillType>;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTechnicalSkillArgs = {
  subId: Scalars['ID']['input'];
};


export type QueryTechnicalSkillFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  iconBlobIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillCategoryId?: InputMaybe<Scalars['Int']['input']>;
  skillCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTechnicalSkillFindManyPaginatedArgs = {
  filters?: InputMaybe<TechnicalSkillFindManyPaginatedFilters>;
  order?: InputMaybe<TechnicalSkillFindManyPaginatedOrder>;
  pagination?: InputMaybe<OffsetBasedPaginationArgs>;
  semanticSearch?: InputMaybe<TechnicalSkillSemanticSearchArgs>;
};


export type QueryTechnicalSkillFreeTextSearchPaginatedArgs = {
  freetext?: InputMaybe<Scalars['String']['input']>;
  getOption?: InputMaybe<GetOption>;
  relationDepth?: InputMaybe<RelationDepth>;
  skillCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skillCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  skip: Scalars['Int']['input'];
  sortField?: InputMaybe<TechnicalSkillSortField>;
  sortOrder?: InputMaybe<SortOption>;
  take: Scalars['Int']['input'];
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTraitFindManyBySoftSkillIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTraitRoleLevelContentArgs = {
  classification?: InputMaybe<ContentClassification>;
  content?: InputMaybe<Scalars['String']['input']>;
  developmentContent?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTraitRoleLevelContentFindManyAndCountArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  developmentContent?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  order?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTraitRoleLevelContentsArgs = {
  classification?: InputMaybe<ContentClassification>;
  classifications?: InputMaybe<Array<ContentClassification>>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  developmentContent?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  roleLevel?: InputMaybe<ContentRoleLevel>;
  roleLevels?: InputMaybe<Array<ContentRoleLevel>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTraitSoftSkillContextCsvGenerateAndUploadArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitSoftSkillContextFindManyArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitSoftSkillContextFindOneArgs = {
  behaviourIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  traitId?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryTraitsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryTranslatedProjectCandidateProfileArgs = {
  projectCandidateProfileId: Scalars['ID']['input'];
};


export type QueryTranslatedShortlistStageCandidateCitationsArgs = {
  shortlistStageCandidateId: Scalars['ID']['input'];
};


export type QueryUnifiedMeetingsArgs = {
  filters?: InputMaybe<UnifiedMeetingsFilters>;
  pagination: OffsetBasedPaginationArgs;
};


export type QueryUpcomingMeetingFindBySharedIdArgs = {
  sharedId: Scalars['String']['input'];
};


export type QueryUpcomingMeetingFindManyArgs = {
  botId?: InputMaybe<Scalars['Boolean']['input']>;
  direction?: InputMaybe<SortOrder>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  types?: InputMaybe<Array<MeetingScope>>;
};


export type QueryUpcomingMeetingFindOneArgs = {
  botId?: InputMaybe<Scalars['String']['input']>;
  calendarId?: InputMaybe<Scalars['String']['input']>;
  externalMeetingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  sharedId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filterFakeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPuppet?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  recoveryToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  subId?: InputMaybe<Scalars['String']['input']>;
  twoFactorCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserCompanyInfoArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserCompanyInfoFindManyArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  employeeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUserCompanyInfoFindOneArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  employeeId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  getOption?: InputMaybe<GetOption>;
  hrManagerEmployeeId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUserFreeTextSearchPaginateArgs = {
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filterFakeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  freetext: Scalars['String']['input'];
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserGroupFindManyPaginatedArgs = {
  args: UserGroupFindManyArgs;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryUserGroupFindOneArgs = {
  subId: Scalars['String']['input'];
};


export type QueryUserGroupMemberFindManyPaginatedArgs = {
  args: UserGroupMemberFindManyArgs;
  paginate?: OffsetBasedPaginationArgs;
};


export type QueryUserSettingsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserSettingsFindManyArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  relationDepth?: InputMaybe<RelationDepth>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUserSettingsFindOneArgs = {
  getOption?: InputMaybe<GetOption>;
  id?: InputMaybe<Scalars['Int']['input']>;
  relationDepth?: InputMaybe<RelationDepth>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<WithDeletedChoice>;
};


export type QueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  filterFakeUsers?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPasswordDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPuppet?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<SupportedLocale>;
  recoveryToken?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subIds?: InputMaybe<Array<Scalars['String']['input']>>;
  twoFactorCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateContentArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  softSkillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryValidateContentPieceArgs = {
  softSkillId: Scalars['Int']['input'];
  traitIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryWidgetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWidgetConfigArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWidgetConfigFindManyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  reportConfigId?: InputMaybe<Scalars['Int']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  widgetOptionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWidgetFindManyArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WidgetType>;
};


export type QueryWidgetOptionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWidgetOptionFindManyArgs = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<WidgetOptionFieldType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  widgetId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAiInterviewAssessmentStageActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiInterviewAssessmentStageActionCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAiInterviewAssessmentStageActionCandidateByConferenceIdArgs = {
  conferenceId: Scalars['ID']['input'];
};


export type QueryAiInterviewAssessmentStageActionCandidateRoleStageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAssessmentStageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAtsAllRejectionReasonsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryAtsAllStagesArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryAtsSettingsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryAvailabilityPreviewArgs = {
  from: Scalars['DateTime']['input'];
  interviewerUserIds: Array<Scalars['Int']['input']>;
  projectId: Scalars['Int']['input'];
  to: Scalars['DateTime']['input'];
};


export type QueryCandidateMaterialsAvailabilityArgs = {
  stageCandidateIds: Array<Scalars['Int']['input']>;
  stageId: Scalars['Int']['input'];
};


export type QueryCoderbyteAssessmentDetailsArgs = {
  coderbyteTestId: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
};


export type QueryCoderbyteAvailableAssessmentsArgs = {
  companyId: Scalars['Int']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCoderbyteWorkspaceArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCoderbyteWorkspaceAdminPasswordArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCoderbyteWorkspaceApiKeyArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryCognitiveTestAssessmentStageActionCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyFindManyByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanySettingChangesArgs = {
  companyId: Scalars['Int']['input'];
  order?: CompanySettingChangeOrderArgs;
  pagination?: OffsetBasedPaginationArgs;
  settingKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  settingSearch?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<CompanySettingChangeSource>;
};


export type QueryConferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnglishProficiencyAssessmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEnglishProficiencyAssessmentStageActionCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGenerateCoderbyteTechnicalSkillsArgs = {
  coderbyteTestId: Scalars['String']['input'];
  projectId: Scalars['Int']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAllProjectFilesArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetCompanyIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetEditingInfoArgs = {
  args: CollaborativeEditingGetInfoArgs;
};


export type QueryGetFormReportCsvArgs = {
  associatedId: Scalars['Int']['input'];
  formManagerType: FormManagerType;
  formOwnerId: Scalars['Int']['input'];
  formType: FormType;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetInvitationStatusArgs = {
  invitationToken: Scalars['String']['input'];
};


export type QueryGetProjectByIdArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetProjectCobrandingArgs = {
  subId: Scalars['String']['input'];
};


export type QueryGetProjectSamlAuthInfoArgs = {
  id: Scalars['Float']['input'];
};


export type QueryIsCoderbyteWorkspaceAvailableArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryKomboIntegrationsFindManyPaginatedArgs = {
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
};


export type QueryKomboIntegrationsFindOneArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryKomboJobFindOneArgs = {
  id: Scalars['String']['input'];
};


export type QueryKomboJobsFindManyPaginatedArgs = {
  companyId: Scalars['Int']['input'];
  hasProjectLinked?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip: Scalars['Int']['input'];
  sortField?: InputMaybe<KomboJobSortField>;
  sortOrder?: InputMaybe<SortOption>;
  statuses?: InputMaybe<Array<KomboJobStatus>>;
  take: Scalars['Int']['input'];
};


export type QueryKomboSyncHistoryArgs = {
  companyId: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryKomboSyncRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryKomboSyncStatusArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryLatestCancelledSchedulingRequestArgs = {
  stageCandidateId: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
};


export type QueryMyRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOmnisearchArgs = {
  myRoles?: Scalars['Boolean']['input'];
  query: Scalars['String']['input'];
};


export type QueryOmnisearchCandidatesArgs = {
  direction?: InputMaybe<SortOption>;
  myRoles?: Scalars['Boolean']['input'];
  pagination?: OmnisearchPageArgs;
  query: Scalars['String']['input'];
  sort?: CandidateSearchSort;
};


export type QueryOmnisearchResolveRecentsArgs = {
  projectCandidateSubIds: Array<Scalars['ID']['input']>;
  projectSubIds: Array<Scalars['ID']['input']>;
};


export type QueryOmnisearchRolesArgs = {
  direction?: InputMaybe<SortOption>;
  myRoles?: Scalars['Boolean']['input'];
  pagination?: OmnisearchPageArgs;
  query: Scalars['String']['input'];
  sort?: RoleSearchSort;
  statuses?: InputMaybe<Array<ProjectStatus>>;
};


export type QueryPersonalityTestAssessmentStageActionCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecentRejectionReasonsArgs = {
  projectId: Scalars['Int']['input'];
  stageId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecentWorkspacesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRejectionReasonsArgs = {
  companyId: Scalars['Int']['input'];
};


export type QueryRejectionReasonsForCandidatesArgs = {
  companyId: Scalars['Int']['input'];
  subIds: Array<Scalars['ID']['input']>;
};


export type QueryResolveShareLinkArgs = {
  token: Scalars['String']['input'];
};


export type QuerySchedulingBatchArgs = {
  batchId: Scalars['ID']['input'];
  stageId: Scalars['Int']['input'];
};


export type QuerySchedulingBatchSlotsArgs = {
  batchId: Scalars['ID']['input'];
  stageId: Scalars['Int']['input'];
};


export type QuerySchedulingBookingLinkArgs = {
  requestId: Scalars['ID']['input'];
};


export type QuerySchedulingInterviewerRepliesArgs = {
  requestId: Scalars['ID']['input'];
};


export type QuerySchedulingRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type QuerySchedulingRequestOfferedSlotsArgs = {
  requestId: Scalars['ID']['input'];
  stageId: Scalars['Int']['input'];
};


export type QuerySchedulingRequestTimelineArgs = {
  requestId: Scalars['ID']['input'];
};


export type QueryStageSchedulingProjectionArgs = {
  stageId: Scalars['Int']['input'];
};


export type QueryWorkspacesArgs = {
  accessType?: InputMaybe<WorkspaceAccessType>;
  includeProjectCount?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionModel = {
  __typename?: 'QuestionModel';
  options: Array<OptionModel>;
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export enum QuestionOrientation {
  Inverted = 'INVERTED',
  Standard = 'STANDARD'
}

/** The type of question being edited */
export enum QuestionType {
  Blueprint = 'BLUEPRINT',
  Candidate = 'CANDIDATE'
}

export type Questionnaire = {
  __typename?: 'Questionnaire';
  id: Scalars['ID']['output'];
  items: Array<QuestionnaireItem>;
};

export enum QuestionnaireCandidateStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED'
}

export type QuestionnaireItem = {
  __typename?: 'QuestionnaireItem';
  correctAnswer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type QuestionnaireItemDraftInput = {
  correctAnswer: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export type QuestionnaireItemResponse = {
  __typename?: 'QuestionnaireItemResponse';
  answer: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemId: Scalars['ID']['output'];
};

export type QuestionnaireItemResponseGqlInput = {
  answer: Scalars['Boolean']['input'];
  itemId: Scalars['ID']['input'];
};

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  id: Scalars['ID']['output'];
  responses: Array<QuestionnaireItemResponse>;
  status: QuestionnaireResultStatus;
};

export enum QuestionnaireResultStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Passed = 'PASSED'
}

export enum RAssignedType {
  Company = 'COMPANY',
  Project = 'PROJECT',
  Stage = 'STAGE'
}

export type ReasonableAdjustmentsOption = {
  __typename?: 'ReasonableAdjustmentsOption';
  kind: ReasonableAdjustmentsOptionKind;
  value?: Maybe<Scalars['String']['output']>;
};

export type ReasonableAdjustmentsOptionArgs = {
  kind: ReasonableAdjustmentsOptionKind;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum ReasonableAdjustmentsOptionKind {
  ContactCompanyEmail = 'CONTACT_COMPANY_EMAIL',
  ContactCompanyGeneric = 'CONTACT_COMPANY_GENERIC',
  ContactCompanyUrl = 'CONTACT_COMPANY_URL',
  EmailSz = 'EMAIL_SZ',
  SelfServe = 'SELF_SERVE'
}

export type RecentCandidate = {
  __typename?: 'RecentCandidate';
  application: CandidateApplication;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  requestedId: Scalars['ID']['output'];
  userSubId: Scalars['ID']['output'];
};

export type RecentRejectionReasonGqlModel = {
  __typename?: 'RecentRejectionReasonGQLModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RecentRole = {
  __typename?: 'RecentRole';
  createdAt: Scalars['DateTime']['output'];
  isMine: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectSubId: Scalars['ID']['output'];
  requestedId: Scalars['ID']['output'];
  requisitionCode?: Maybe<Scalars['String']['output']>;
  requisitionLocation?: Maybe<RequisitionLocationModel>;
  status: ProjectStatus;
};

export type RecordingAvailable = {
  __typename?: 'RecordingAvailable';
  /** Recording duration in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Recording file size in bytes */
  sizeBytes?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type RecordingConfigArgs = {
  duration?: InputMaybe<DurationArgs>;
  format?: InputMaybe<Scalars['String']['input']>;
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  status: MeetingRecodingStatus;
};

export type RecordingConfigModel = {
  __typename?: 'RecordingConfigModel';
  duration?: Maybe<DurationModel>;
  format?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  status: MeetingRecodingStatus;
};

export type RecordingInfo = RecordingAvailable | RecordingUnavailable;

export type RecordingUnavailable = {
  __typename?: 'RecordingUnavailable';
  status: RecordingUnavailableStatus;
};

/** Status of an unavailable recording */
export enum RecordingUnavailableStatus {
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type RecordingUploadModel = {
  __typename?: 'RecordingUploadModel';
  id: Scalars['String']['output'];
  multipartUploadData: MultipartUploadResponseModel;
};

export type RejectCandidatesPayload = {
  __typename?: 'RejectCandidatesPayload';
  atsWritebackFailures: Array<AtsWritebackFailure>;
  projectCandidates: Array<ProjectCandidate>;
};

export type RejectionReasonGqlModel = {
  __typename?: 'RejectionReasonGQLModel';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  remoteId: Scalars['String']['output'];
};

export type RejectionReasonsForCandidatesGqlModel = {
  __typename?: 'RejectionReasonsForCandidatesGQLModel';
  /** True when the list was narrowed to the candidates' Workday stages. An empty list is then a real answer (no valid reason), not an unavailable catalogue. */
  isStageScoped: Scalars['Boolean']['output'];
  reasons: Array<RejectionReasonGqlModel>;
};

export enum RelationDepth {
  Basic = 'BASIC',
  Full = 'FULL',
  FullWithExternal = 'FULL_WITH_EXTERNAL',
  NoRelations = 'NO_RELATIONS'
}

export type RemoveUntaggedAiQuestionsResult = {
  __typename?: 'RemoveUntaggedAiQuestionsResult';
  /** Number of blueprint AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) checked for removal. */
  blueprintQuestionsChecked: Scalars['Int']['output'];
  /** Number of blueprint AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) removed. */
  blueprintQuestionsRemoved: Scalars['Int']['output'];
  /** Number of candidate AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) checked for removal. */
  candidateQuestionsChecked: Scalars['Int']['output'];
  /** Number of candidate AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) removed. */
  candidateQuestionsRemoved: Scalars['Int']['output'];
  /** Total duration of the operation execution in milliseconds. */
  durationMs: Scalars['Int']['output'];
  /** Indicates if the operation was executed in dry-run mode (no changes persisted). */
  isDryRun: Scalars['Boolean']['output'];
  /** Total number of AI questions (AI_QUESTION and CUSTOMIZED_AI_QUESTION types) removed across all tables. */
  totalQuestionsRemoved: Scalars['Int']['output'];
};

export type Report = {
  __typename?: 'Report';
  company?: Maybe<Company>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  footerType: ReportFooterType;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: ReportOwnerType;
  reportConfigs?: Maybe<Array<ReportConfig>>;
  reportRenders?: Maybe<Array<ReportRender>>;
  subType?: Maybe<ReportSubType>;
  type: ReportType;
  updatedAt: Scalars['Date']['output'];
};

export type ReportAssignment = {
  __typename?: 'ReportAssignment';
  assignedId: Scalars['Int']['output'];
  assignedType: RAssignedType;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  inheritsSetting?: Maybe<Scalars['Boolean']['output']>;
  report: Report;
  reportId: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ReportConfig = {
  __typename?: 'ReportConfig';
  id: Scalars['Int']['output'];
  newPageBefore: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  report: Report;
  reportId: Scalars['Int']['output'];
  widget: Widget;
  widgetConfigs?: Maybe<Array<WidgetConfig>>;
  widgetId: Scalars['Int']['output'];
};

export type ReportConfigCreateOneBatchedWithReportArgs = {
  newPageBefore?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
  widgetId: Scalars['Int']['input'];
};

export type ReportConfigUpdateOneArgs = {
  id: Scalars['Int']['input'];
  newPageBefore?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  widgetConfigsToUpsert?: InputMaybe<Array<WidgetConfigUpsertOneBatchedWithReportConfigArgs>>;
};

export enum ReportFooterType {
  Default = 'DEFAULT',
  Simple = 'SIMPLE'
}

export enum ReportOwnerType {
  /** Company owner */
  Company = 'COMPANY',
  /** User owner */
  User = 'USER'
}

export type ReportRender = {
  __typename?: 'ReportRender';
  blob?: Maybe<MonolithBlobModel>;
  blobId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  dataSourceId: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  report: Report;
  reportId: Scalars['Int']['output'];
  reportRenderStatus?: Maybe<ReportRenderStatus>;
  reportRenderType?: Maybe<ReportRenderType>;
  statusMessage?: Maybe<Scalars['String']['output']>;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  widgetRenders?: Maybe<Array<WidgetRender>>;
};

export enum ReportRenderStatus {
  CollectingData = 'COLLECTING_DATA',
  Complete = 'COMPLETE',
  CompleteEmailed = 'COMPLETE_EMAILED',
  CompleteEmailing = 'COMPLETE_EMAILING',
  Failed = 'FAILED',
  Initialisation = 'INITIALISATION',
  Rendering = 'RENDERING'
}

export enum ReportRenderType {
  Csv = 'CSV',
  Data = 'DATA',
  Pdf = 'PDF'
}

export enum ReportSubType {
  /** Stage results candidate */
  StageResultsCandidate = 'STAGE_RESULTS_CANDIDATE',
  /** Stage results manager */
  StageResultsManager = 'STAGE_RESULTS_MANAGER',
  /** Sp report full */
  SuccessProfileFull = 'SUCCESS_PROFILE_FULL',
  /** Sp report partial */
  SuccessProfilePartial = 'SUCCESS_PROFILE_PARTIAL'
}

export enum ReportType {
  /** Stage results */
  StageResults = 'STAGE_RESULTS',
  /** Success profile results */
  SuccessProfile = 'SUCCESS_PROFILE'
}

export type RequestMaterialInput = {
  /** Who the material is for */
  audience: SchedulingMaterialAudience;
  /** The type of the uploaded file; required with uploadKey */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** The name shown for the material */
  label: Scalars['String']['input'];
  /** The uploadKey createRequestMaterialUpload returned */
  uploadKey?: InputMaybe<Scalars['String']['input']>;
  /** An https link; set this or uploadKey, never both */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A short-lived upload destination for one scheduling material */
export type RequestMaterialUploadModel = {
  __typename?: 'RequestMaterialUploadModel';
  /** When the upload URL stops accepting the file */
  expiresAt: Scalars['DateTime']['output'];
  /** The key to reference the uploaded file by when sending */
  uploadKey: Scalars['String']['output'];
  /** The URL to PUT the file to */
  uploadUrl: Scalars['String']['output'];
};

export type RequisitionLinkEventModel = {
  __typename?: 'RequisitionLinkEventModel';
  candidatesRemoved: Scalars['Boolean']['output'];
  eventType: RequisitionLinkEventType;
  id: Scalars['Int']['output'];
  occurredAt: Scalars['DateTime']['output'];
  performedByType: RequisitionLinkPerformedByType;
  performedByUser?: Maybe<User>;
  performedByUserId?: Maybe<Scalars['Int']['output']>;
  requisitionCode?: Maybe<Scalars['String']['output']>;
  requisitionId: Scalars['String']['output'];
  requisitionTitle?: Maybe<Scalars['String']['output']>;
};

export enum RequisitionLinkEventType {
  Linked = 'LINKED',
  Unlinked = 'UNLINKED'
}

export enum RequisitionLinkPerformedByType {
  System = 'SYSTEM',
  User = 'USER'
}

export type RequisitionLocationModel = {
  __typename?: 'RequisitionLocationModel';
  city?: Maybe<Scalars['String']['output']>;
  /** Country as the ATS sends it: usually an ISO 3166-1 alpha-2 code, otherwise free text. */
  country?: Maybe<Scalars['String']['output']>;
};

export type RequisitionModel = {
  __typename?: 'RequisitionModel';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isLinked: Scalars['Boolean']['output'];
  location?: Maybe<RequisitionLocationModel>;
  remoteUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type RequisitionPaginatedModel = {
  __typename?: 'RequisitionPaginatedModel';
  page: Pageinfo;
  requisitions: Array<RequisitionModel>;
};

export type RespondantFieldWithAnswers = {
  __typename?: 'RespondantFieldWithAnswers';
  answer?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  field?: Maybe<Field>;
  isOptional: Scalars['Boolean']['output'];
  selectOptionAnswerIsFreeText?: Maybe<Scalars['Boolean']['output']>;
};

export type RespondantForm = {
  __typename?: 'RespondantForm';
  associatedId: Scalars['Int']['output'];
  formId: Scalars['Int']['output'];
  formOwnerId: Scalars['Int']['output'];
  formType: FormType;
  isComplete: Scalars['Boolean']['output'];
  respondantFieldWithAnswers: Array<RespondantFieldWithAnswers>;
  submittedFormLogId?: Maybe<Scalars['Int']['output']>;
};

export enum ResponseType {
  CompanyEmployeeSelectResponse = 'COMPANY_EMPLOYEE_SELECT_RESPONSE',
  DateResponse = 'DATE_RESPONSE',
  LongTextResponse = 'LONG_TEXT_RESPONSE',
  MultipleSelectResponse = 'MULTIPLE_SELECT_RESPONSE',
  ShortTextResponse = 'SHORT_TEXT_RESPONSE',
  SingleSelectResponse = 'SINGLE_SELECT_RESPONSE'
}

export enum ResultMeasurementType {
  Behaviour = 'BEHAVIOUR',
  InterviewGuide = 'INTERVIEW_GUIDE',
  SoftSkill = 'SOFT_SKILL',
  SuccessProfile = 'SUCCESS_PROFILE',
  TechnicalSkill = 'TECHNICAL_SKILL',
  Trait = 'TRAIT'
}

export type ResultModel = {
  __typename?: 'ResultModel';
  copiedFrom?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  doneBy: Scalars['Int']['output'];
  doneFor: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  manuallyAdjustedBy?: Maybe<Scalars['Int']['output']>;
  measurementId: Scalars['Int']['output'];
  measurementType: ResultMeasurementType;
  previousVersionId?: Maybe<Scalars['Int']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  score: ResultScoreUnion;
  scoreType: ResultScoreType;
  updatedAt: Scalars['Date']['output'];
  version: Scalars['Int']['output'];
};

export enum ResultScoreType {
  ExternalAssessmentCode = 'EXTERNAL_ASSESSMENT_CODE',
  ExternalAssessmentFinal = 'EXTERNAL_ASSESSMENT_FINAL',
  ExternalAssessmentMcq = 'EXTERNAL_ASSESSMENT_MCQ',
  IgBehaviour = 'IG_BEHAVIOUR',
  IgCustom = 'IG_CUSTOM',
  IgFinalDecision = 'IG_FINAL_DECISION',
  Motivation = 'MOTIVATION',
  RoleSoftSkillsProfile = 'ROLE_SOFT_SKILLS_PROFILE',
  RoleTechnicalSkillsProfile = 'ROLE_TECHNICAL_SKILLS_PROFILE',
  Statistical = 'STATISTICAL',
  TrCustom = 'TR_CUSTOM'
}

export type ResultScoreUnion = ExternalAssessmentCodeScoreModel | ExternalAssessmentFinalScoreModel | ExternalAssessmentMcqScoreModel | IgBehaviourResultScoreModel | IgCustomResultScoreModel | IgFinalDecisionResultScoreModel | MotivationResultScoreModel | SoftSkillSelfAssessmentScoreModel | StatisticalResultScoreModel | TechnicalSkillSelfAssessmentScoreModel | TrCustomResultScoreModel;

export type ResultSoftSkillProfileCreateOneFromSc = {
  score: ISoftSkillSelfAssessmentScoreModel;
  softSkillId: Scalars['Int']['input'];
  stageCandidateId: Scalars['Int']['input'];
};

export type ResultTechnicalSkillProfileCreateOneFromSc = {
  score: ITechnicalSkillSelfAssessmentScoreModel;
  stageCandidateId: Scalars['Int']['input'];
  technicalSkillId: Scalars['Int']['input'];
};

export type ResultValidatedSkillsModel = {
  __typename?: 'ResultValidatedSkillsModel';
  company: Company;
  totalValidateSkills: Scalars['Int']['output'];
};

export type ResultValidatedSkillsPaginatedModel = {
  __typename?: 'ResultValidatedSkillsPaginatedModel';
  resultValidatedSkills: Array<ResultValidatedSkillsModel>;
  total: Scalars['Int']['output'];
};

export enum ResumeExtractedDataIndustry {
  Accounting = 'ACCOUNTING',
  AerospaceAndDefence = 'AEROSPACE_AND_DEFENCE',
  Agriculture = 'AGRICULTURE',
  Automotive = 'AUTOMOTIVE',
  CharityAndNonProfit = 'CHARITY_AND_NON_PROFIT',
  ConstructionAndEngineering = 'CONSTRUCTION_AND_ENGINEERING',
  ConsultingAndProfessionalServices = 'CONSULTING_AND_PROFESSIONAL_SERVICES',
  Education = 'EDUCATION',
  EnergyAndUtilities = 'ENERGY_AND_UTILITIES',
  EntertainmentAndMedia = 'ENTERTAINMENT_AND_MEDIA',
  FashionAndApparel = 'FASHION_AND_APPAREL',
  FinancialServices = 'FINANCIAL_SERVICES',
  FoodAndBeverage = 'FOOD_AND_BEVERAGE',
  GovernmentAndPublicSector = 'GOVERNMENT_AND_PUBLIC_SECTOR',
  HealthcareAndPharmaceuticals = 'HEALTHCARE_AND_PHARMACEUTICALS',
  HospitalityAndTourism = 'HOSPITALITY_AND_TOURISM',
  Insurance = 'INSURANCE',
  Legal = 'LEGAL',
  LogisticsAndSupplyChain = 'LOGISTICS_AND_SUPPLY_CHAIN',
  Manufacturing = 'MANUFACTURING',
  MiningAndMetals = 'MINING_AND_METALS',
  RealEstateAndProperty = 'REAL_ESTATE_AND_PROPERTY',
  RetailAndECommerce = 'RETAIL_AND_E_COMMERCE',
  Technology = 'TECHNOLOGY',
  Telecommunications = 'TELECOMMUNICATIONS'
}

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: RoleType;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RoleApplicationQuestion = {
  __typename?: 'RoleApplicationQuestion';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  options?: Maybe<Array<RoleApplicationQuestionOption>>;
  preconditionOptions?: Maybe<Array<Scalars['String']['output']>>;
  preconditionQuestionId?: Maybe<Scalars['ID']['output']>;
  required: Scalars['Boolean']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: RoleApplicationQuestionType;
};

export type RoleApplicationQuestionOption = {
  __typename?: 'RoleApplicationQuestionOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum RoleApplicationQuestionType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  MultiSelect = 'MULTI_SELECT',
  Number = 'NUMBER',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT'
}

/** A role a batch action did not change, with the reason why. */
export type RoleBatchFailureModel = {
  __typename?: 'RoleBatchFailureModel';
  reason: RoleBatchFailureReason;
  roleId: Scalars['Int']['output'];
};

/** Why a single role in a batch archive or status change did not change. */
export enum RoleBatchFailureReason {
  Failed = 'FAILED',
  Forbidden = 'FORBIDDEN',
  NotClosed = 'NOT_CLOSED',
  NotFound = 'NOT_FOUND',
  NotPublished = 'NOT_PUBLISHED'
}

/** The outcome of a batch role action, role by role. A mixed selection is expected, so skipped roles are reported rather than failing the request. */
export type RoleBatchResultModel = {
  __typename?: 'RoleBatchResultModel';
  /** The roles that did not change, each with a reason. Empty when every role changed. */
  failed: Array<RoleBatchFailureModel>;
  /** The roles that changed, as they are now. Empty when nothing qualified. */
  succeeded: Array<RoleModel>;
};

export type RoleHit = {
  __typename?: 'RoleHit';
  createdAt: Scalars['DateTime']['output'];
  isMine: Scalars['Boolean']['output'];
  match: SearchMatch;
  name: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectSubId: Scalars['ID']['output'];
  requisitionCode?: Maybe<Scalars['String']['output']>;
  requisitionLocation?: Maybe<RequisitionLocationModel>;
  status: ProjectStatus;
};

export type RoleModel = {
  __typename?: 'RoleModel';
  aiInterviewStage?: Maybe<AssessmentStage>;
  applicationQuestions: Array<RoleApplicationQuestion>;
  assessmentStage?: Maybe<AssessmentStage>;
  assessmentStages: Array<AssessmentStage>;
  candidatePortalEnabled: Scalars['Boolean']['output'];
  candidatePortalIntro?: Maybe<Scalars['String']['output']>;
  candidatePortalTitle?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyId: Scalars['Int']['output'];
  contentStages: Array<ContentStageModel>;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  creatorUser?: Maybe<User>;
  creatorUserId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hiringProcessAbsoluteDeadlineAt?: Maybe<Scalars['Date']['output']>;
  hiringProcessDeadlineType?: Maybe<HiringProcessDeadlineType>;
  hiringProcessRelativeDeadlineAmount?: Maybe<Scalars['Int']['output']>;
  hiringProcessRelativeDeadlineUnit?: Maybe<HiringProcessDeadlineUnit>;
  hiringProcessTemplateVersion?: Maybe<HiringProcessTemplateVersion>;
  id: Scalars['Int']['output'];
  indirectInviteSSOEnabled: Scalars['Boolean']['output'];
  inputsChangedAt?: Maybe<Scalars['Date']['output']>;
  interviewStages: Array<InterviewStage>;
  isAiInterviewExplicitConsentEnabled: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isIntegrityMonitoringEnabled: Scalars['Boolean']['output'];
  /** Whether the calling user has pinned this role in their active workspace. Private to the caller — two users see different values for the same role. */
  isPinned: Scalars['Boolean']['output'];
  isRSPConfirmed: Scalars['Boolean']['output'];
  isStopped: Scalars['Boolean']['output'];
  jobDescriptionFileName?: Maybe<Scalars['String']['output']>;
  jobDescriptionLocales?: Maybe<Array<Scalars['String']['output']>>;
  jobDescriptionProcessingStatus?: Maybe<ProjectJobDescriptionProcessingStatus>;
  jobDescriptionUploadedAt?: Maybe<Scalars['Date']['output']>;
  jobRole?: Maybe<JobRoleModel>;
  lastCandidateActivity?: Maybe<Scalars['Date']['output']>;
  locales: Array<SupportedLocale>;
  meetingId?: Maybe<Scalars['ID']['output']>;
  moduleType: ProjectModuleType;
  name: Scalars['String']['output'];
  primaryLocale: SupportedLocale;
  productSolution?: Maybe<ProductSolution>;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  publishedByUser?: Maybe<User>;
  publishedByUserId?: Maybe<Scalars['Int']['output']>;
  reminderEmailCadenceDays?: Maybe<Scalars['Int']['output']>;
  requisition?: Maybe<RequisitionModel>;
  roleCandidatesCount?: Maybe<Scalars['Int']['output']>;
  shortlistCalibrationBorderlineQuestions?: Maybe<ShortlistCalibrationBorderlineQuestions>;
  shortlistCriteriaSuggestionStatus?: Maybe<ProjectShortlistCriteriaSuggestionStatus>;
  shortlistCriteriaSuggestions?: Maybe<Array<ProjectShortlistCriteriaSuggestion>>;
  shortlistStages: Array<ShortlistStage>;
  skillGenerationStatus?: Maybe<SkillsProfileSkillGenerationStatus>;
  skillsGeneratedAt?: Maybe<Scalars['Date']['output']>;
  skillsProfile?: Maybe<SuccessProfile>;
  source: ProjectSource;
  status: ProjectStatus;
  subId: Scalars['ID']['output'];
  teamMembers: Array<ProjectManager>;
  updatedAt: Scalars['Date']['output'];
  updatedByUser?: Maybe<User>;
  updatedByUserId?: Maybe<Scalars['Int']['output']>;
};

export type RolePaginatedModel = {
  __typename?: 'RolePaginatedModel';
  page: Pageinfo;
  roles: Array<RoleModel>;
};

export type RoleRequisitionHistoryModel = {
  __typename?: 'RoleRequisitionHistoryModel';
  candidateCount: Scalars['Int']['output'];
  candidatesRemovedAtLastUnlink: Scalars['Boolean']['output'];
  events: Array<RequisitionLinkEventModel>;
  lastUnlinkedRequisitionCode?: Maybe<Scalars['String']['output']>;
  lastUnlinkedRequisitionId?: Maybe<Scalars['String']['output']>;
};

export type RoleSearchPage = {
  __typename?: 'RoleSearchPage';
  hasMore: Scalars['Boolean']['output'];
  hits: Array<RoleHit>;
  partial: Scalars['Boolean']['output'];
};

export enum RoleSearchSort {
  Created = 'CREATED',
  Name = 'NAME',
  Published = 'PUBLISHED',
  Relevance = 'RELEVANCE'
}

export type RoleStageOrderArgs = {
  order: Scalars['Int']['input'];
  stageId: Scalars['Int']['input'];
  stageType: StageType;
};

export type RoleStageOrderModel = {
  __typename?: 'RoleStageOrderModel';
  activeCandidatesCount: Scalars['Int']['output'];
  hiringProcessTemplateVersionStageId?: Maybe<Scalars['Int']['output']>;
  order: Scalars['Int']['output'];
  roleId: Scalars['Int']['output'];
  stageActionName?: Maybe<Scalars['String']['output']>;
  stageId: Scalars['Int']['output'];
  stageName?: Maybe<Scalars['String']['output']>;
  stageSubId?: Maybe<Scalars['ID']['output']>;
  stageSubType?: Maybe<AssessmentStageKind>;
  stageType: StageType;
};

export enum RoleStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Review = 'REVIEW'
}

export type RoleTeamMemberInput = {
  actorRole: ActorRole;
  userId: Scalars['Int']['input'];
};

export enum RoleType {
  Company = 'COMPANY',
  External = 'EXTERNAL',
  SzProtected = 'SZ_PROTECTED',
  SzSingleton = 'SZ_SINGLETON'
}

export type RssAssessmentCandidateModel = {
  __typename?: 'RssAssessmentCandidateModel';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  rssAssessment: RssAssessmentModel;
  rssAssessmentId: Scalars['Int']['output'];
  stageCandidate?: Maybe<SmStageCandidateModel>;
  stageCandidateId: Scalars['Int']['output'];
  status: RssAssessmentCandidateStatus;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum RssAssessmentCandidateStatus {
  NotStarted = 'NOT_STARTED',
  OpenForChanges = 'OPEN_FOR_CHANGES',
  Submitted = 'SUBMITTED'
}

export type RssAssessmentCreateOneArgs = {
  stageId: Scalars['Int']['input'];
  type: RssAssessmentType;
};

export type RssAssessmentModel = {
  __typename?: 'RssAssessmentModel';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  stage?: Maybe<SmStageModel>;
  stageId: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
  type: RssAssessmentType;
};

export enum RssAssessmentType {
  SoftSkill = 'SOFT_SKILL',
  TechnicalSkill = 'TECHNICAL_SKILL'
}

export type RssCandidateOpenOneModel = {
  __typename?: 'RssCandidateOpenOneModel';
  gradeBands: Array<GradeBandUnion>;
  rssAssessmentCandidate: RssAssessmentCandidateModel;
  skillsWithResults: Array<SkillWithResultModel>;
};

export type SamlAuthInfoModel = {
  __typename?: 'SamlAuthInfoModel';
  cert: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  entryPoint: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  identityProvider: IdentityProviderModel;
  identityProviderId: Scalars['Int']['output'];
  issuer: Scalars['String']['output'];
  signatureAlgorithm: Scalars['String']['output'];
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  wantAssertionsSigned: Scalars['Boolean']['output'];
  wantAuthResponseSigned: Scalars['Boolean']['output'];
};

export type ScheduleCandidatesDebriefExportArgs = {
  __typename?: 'ScheduleCandidatesDebriefExportArgs';
  dateFrom?: Maybe<Scalars['Date']['output']>;
  dateTo?: Maybe<Scalars['Date']['output']>;
  includeRejected?: Maybe<Scalars['Boolean']['output']>;
  projectId: Scalars['Int']['output'];
};

export type ScheduleRoiCsvFileExportArgs = {
  __typename?: 'ScheduleROICsvFileExportArgs';
  projectIds: Array<Scalars['Int']['output']>;
};

export type ScheduleStageCandidateResultsCsvFileExportArgs = {
  __typename?: 'ScheduleStageCandidateResultsCsvFileExportArgs';
  exportLevel: CandidateResultsExportLevel;
  includeFormsData?: Maybe<Scalars['Boolean']['output']>;
  lastDateOfCandidateActionFrom?: Maybe<Scalars['Date']['output']>;
  lastDateOfCandidateActionTo?: Maybe<Scalars['Date']['output']>;
  projectId: Scalars['Int']['output'];
  stageId?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledTask = {
  args: ScheduledTaskArgs;
  error?: Maybe<Scalars['String']['output']>;
  kind: ScheduledTaskKind;
  status: ScheduledTaskStatus;
  subId: Scalars['String']['output'];
};

export type ScheduledTaskArgs = AdminResultsExportRunnerArgs | ScheduleCandidatesDebriefExportArgs | ScheduleRoiCsvFileExportArgs | ScheduleStageCandidateResultsCsvFileExportArgs;

export enum ScheduledTaskKind {
  AdminResultsExport = 'ADMIN_RESULTS_EXPORT',
  CandidatesDebriefExport = 'CANDIDATES_DEBRIEF_EXPORT',
  CandidateUsageCsvFileExport = 'CANDIDATE_USAGE_CSV_FILE_EXPORT',
  RoiCsvFileExport = 'ROI_CSV_FILE_EXPORT',
  SoftSkillRoleLevelContentExport = 'SOFT_SKILL_ROLE_LEVEL_CONTENT_EXPORT',
  StageCandidateResultsCsvFileExport = 'STAGE_CANDIDATE_RESULTS_CSV_FILE_EXPORT'
}

export enum ScheduledTaskStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}

/** Who caused a scheduling timeline entry: a recruiter, the candidate, an interviewer, or the system on its own */
export enum SchedulingActivityActorKind {
  Candidate = 'candidate',
  Interviewer = 'interviewer',
  Recruiter = 'recruiter',
  System = 'system'
}

/** A set of scheduling requests raised together for one stage */
export type SchedulingBatchModel = {
  __typename?: 'SchedulingBatchModel';
  batchId: Scalars['ID']['output'];
  requests: Array<SchedulingRequestModel>;
  /** Stage candidates skipped because they have been rejected from the project */
  skippedRejectedStageCandidateIds: Array<Scalars['Int']['output']>;
  /** Stage candidates skipped because they already had a live scheduling request */
  skippedStageCandidateIds: Array<Scalars['Int']['output']>;
};

/** The interviewers busy at the time chosen for one request */
export type SchedulingBusyInterviewersModel = {
  __typename?: 'SchedulingBusyInterviewersModel';
  requestId: Scalars['ID']['output'];
  userIds: Array<Scalars['Int']['output']>;
};

/** Provider-reported free/busy classification of an interval */
export enum SchedulingBusyType {
  Busy = 'busy',
  OutOfOffice = 'outOfOffice',
  Tentative = 'tentative'
}

/** A candidate's most recent cancelled scheduling request at a stage, and why it was cancelled */
export type SchedulingCancellationModel = {
  __typename?: 'SchedulingCancellationModel';
  /** True when the candidate cancelled the interview by declining every new time the hiring team offered */
  cancelledByDeclining: Scalars['Boolean']['output'];
  /** What the candidate wrote when declining the new times; null when they wrote nothing, or when the request was not cancelled by their decline. Candidate-supplied free text: render it as text, never as markup */
  candidateNote?: Maybe<Scalars['String']['output']>;
  request: SchedulingRequestModel;
};

/** Conferencing choice for a scheduling request */
export enum SchedulingConferencing {
  None = 'none',
  Teams = 'teams'
}

/** Where a candidate is in interview scheduling for one stage, as shown in the Interview column */
export enum SchedulingInterviewState {
  Booked = 'booked',
  DeclinedAllSlots = 'declinedAllSlots',
  Expired = 'expired',
  NotScheduled = 'notScheduled',
  Rescheduling = 'rescheduling',
  SlotsOffered = 'slotsOffered'
}

/** An interviewer a saved batch names, resolved by user id */
export type SchedulingInterviewerModel = {
  __typename?: 'SchedulingInterviewerModel';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

/** The replies of one scheduling request's current interviewers to the calendar invitation */
export type SchedulingInterviewerRepliesModel = {
  __typename?: 'SchedulingInterviewerRepliesModel';
  /** When the panel event's replies were last read; null until the first read */
  lastCheckedAt?: Maybe<Scalars['DateTime']['output']>;
  /** One reply per current interviewer, in the order of the request's panel; empty when not tracked */
  replies: Array<SchedulingInterviewerReplyModel>;
  /** False when no Outlook panel event exists to read replies from (a calendar-file-only or not yet booked interview): show "Replies not tracked", never "No one has replied" */
  tracked: Scalars['Boolean']['output'];
};

/** One current interviewer's reply to the calendar invitation */
export type SchedulingInterviewerReplyModel = {
  __typename?: 'SchedulingInterviewerReplyModel';
  /** True for the recruiter who sent the request and sits on the panel: they organise the event, so the calendar never reports a reply for them and none is expected */
  isOrganiser: Scalars['Boolean']['output'];
  /** The calendar's time for the reply; null until they reply */
  respondedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The reply; none until they reply, and always none for the organiser */
  response: SchedulingRsvpResponseStatus;
  userId: Scalars['Int']['output'];
};

/** How many days a candidate booking link stays valid for */
export enum SchedulingLinkExpiryDays {
  Five = 'five',
  Fourteen = 'fourteen',
  Seven = 'seven',
  Three = 'three',
  Two = 'two'
}

/** A link the hiring team invite can carry for each candidate */
export enum SchedulingLinkMaterial {
  AssessmentReport = 'assessmentReport',
  InterviewGuide = 'interviewGuide'
}

/** Who a scheduling material is intended for */
export enum SchedulingMaterialAudience {
  Candidate = 'candidate',
  HiringTeam = 'hiringTeam'
}

/** A requested link that is not on one request hiring team invite */
export type SchedulingMissingMaterialModel = {
  __typename?: 'SchedulingMissingMaterialModel';
  material: SchedulingLinkMaterial;
  reason: SchedulingMissingMaterialReason;
  requestId: Scalars['ID']['output'];
};

/** Why a requested link is not on the hiring team invite */
export enum SchedulingMissingMaterialReason {
  LookupFailed = 'lookupFailed',
  NotAvailable = 'notAvailable'
}

export type SchedulingRequestDetailsInput = {
  /** Which conferencing system hosts the interview, if any */
  conferencing: SchedulingConferencing;
  /** How long the interview runs, in minutes */
  durationMinutes: Scalars['Int']['input'];
  /** Whether the Spotted Zebra note taker joins the interview */
  includeSpot: Scalars['Boolean']['input'];
  /** The kind of interview being scheduled */
  interviewType?: InputMaybe<Scalars['String']['input']>;
  /** The users who will interview the candidates */
  interviewerUserIds: Array<Scalars['Int']['input']>;
  /** How many days the candidate booking link stays valid for */
  linkExpiryDays: SchedulingLinkExpiryDays;
  /** Where the interview takes place */
  locationKind: Scalars['String']['input'];
  /** Whether the candidate receives a booking email */
  sendCandidateEmail: Scalars['Boolean']['input'];
  /** Whether the interviewers receive a calendar invitation */
  sendInterviewerInvite: Scalars['Boolean']['input'];
};

/** One candidate's interview scheduling request */
export type SchedulingRequestModel = {
  __typename?: 'SchedulingRequestModel';
  /** The batch the request was raised in */
  batchId: Scalars['ID']['output'];
  candidateUserId: Scalars['Int']['output'];
  conferencing: SchedulingConferencing;
  createdAt: Scalars['DateTime']['output'];
  /** The candidate's own words when they declined every offered slot, if they left any */
  declineReasonText?: Maybe<Scalars['String']['output']>;
  durationMinutes: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  includeSpot: Scalars['Boolean']['output'];
  interviewType?: Maybe<Scalars['String']['output']>;
  interviewerUserIds: Array<Scalars['Int']['output']>;
  /** When the candidate booking link stops working */
  linkExpiresAt: Scalars['DateTime']['output'];
  /** How long the booking link lives once sent, as the recruiter chose it */
  linkExpiryDays: SchedulingLinkExpiryDays;
  locationKind: Scalars['String']['output'];
  /** How many rounds of slots have been offered so far */
  offerRound: Scalars['Int']['output'];
  sendCandidateEmail: Scalars['Boolean']['output'];
  sendInterviewerInvite: Scalars['Boolean']['output'];
  stageCandidateId: Scalars['Int']['output'];
  stageId: Scalars['Int']['output'];
  status: SchedulingRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  /** Changes on every write to the request; sent back with a recruiter action so a request changed in between is refused */
  version: Scalars['Int']['output'];
};

/** Lifecycle state of one scheduling request for one candidate at one stage */
export enum SchedulingRequestStatus {
  Booked = 'booked',
  Cancelled = 'cancelled',
  Declined = 'declined',
  Draft = 'draft',
  Expired = 'expired',
  Offered = 'offered',
  Rescheduling = 'rescheduling'
}

/** How a recruiter moves a booked interview */
export enum SchedulingRescheduleMode {
  FixedTime = 'fixedTime',
  Reoffer = 'reoffer'
}

/** What rescheduling an interview did */
export type SchedulingRescheduleResultModel = {
  __typename?: 'SchedulingRescheduleResultModel';
  /** False only for a fixed time some interviewer is busy at, sent without confirmBusy: nothing was written */
  applied: Scalars['Boolean']['output'];
  /** The interviewers busy at the fixed time, by user id */
  busyInterviewerIds: Array<Scalars['Int']['output']>;
  request: SchedulingRequestModel;
};

/** An interviewer's reply to the calendar invitation; no reply at all reads as none */
export enum SchedulingRsvpResponseStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  None = 'none',
  Tentative = 'tentative'
}

/** A saved batch as the Schedule interviews wizard reopens it: its requests and the interviewers they name */
export type SchedulingSavedBatchModel = {
  __typename?: 'SchedulingSavedBatchModel';
  batchId: Scalars['ID']['output'];
  /** Every interviewer the batch names, in no particular order; an id the directory no longer knows is absent */
  interviewers: Array<SchedulingInterviewerModel>;
  requests: Array<SchedulingRequestModel>;
};

/** What sending a batch did to one of its scheduling requests */
export enum SchedulingSendOutcome {
  AlreadySent = 'alreadySent',
  NotSendable = 'notSendable',
  Sent = 'sent'
}

/** What sending a batch did to one of its scheduling requests */
export type SchedulingSendOutcomeModel = {
  __typename?: 'SchedulingSendOutcomeModel';
  outcome: SchedulingSendOutcome;
  refusal?: Maybe<SchedulingSendRefusal>;
  requestId: Scalars['ID']['output'];
};

/** Why a scheduling request was not sent */
export enum SchedulingSendRefusal {
  BatchHasUnsendableRequest = 'batchHasUnsendableRequest',
  CandidateRejected = 'candidateRejected',
  InterviewerBusy = 'interviewerBusy',
  NoBookableSlot = 'noBookableSlot'
}

/** What sending one scheduling batch did */
export type SchedulingSendReportModel = {
  __typename?: 'SchedulingSendReportModel';
  batchId: Scalars['ID']['output'];
  /** When a batch with fixed times was held back, the interviewers busy at each request’s time. Nothing was sent: send again with confirmBusy to book over it */
  busyInterviewers: Array<SchedulingBusyInterviewersModel>;
  /** Report and guide links the recruiter asked for that a request invite does not carry; empty unless the batch was sent now */
  missingMaterials: Array<SchedulingMissingMaterialModel>;
  /** One outcome per live request in the batch */
  outcomes: Array<SchedulingSendOutcomeModel>;
  /** Whether every request in the batch was sent */
  sent: Scalars['Boolean']['output'];
};

/** What happened to a scheduling request at one point on its timeline */
export enum SchedulingTimelineEntryKind {
  Booked = 'booked',
  Cancelled = 'cancelled',
  CandidateAskedForOtherTimes = 'candidateAskedForOtherTimes',
  Declined = 'declined',
  Expired = 'expired',
  InterviewerDeclined = 'interviewerDeclined',
  Offered = 'offered',
  PanelChanged = 'panelChanged',
  Rescheduling = 'rescheduling'
}

/** One entry on a scheduling request's timeline: what happened, who caused it and when */
export type SchedulingTimelineEntryModel = {
  __typename?: 'SchedulingTimelineEntryModel';
  /** Who caused the entry: never the person themselves, only their part */
  actorKind: SchedulingActivityActorKind;
  /** The recruiter or interviewer who caused the entry, when known; never a candidate */
  actorUserId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  kind: SchedulingTimelineEntryKind;
  occurredAt: Scalars['DateTime']['output'];
};

export type ScoreModel = {
  __typename?: 'ScoreModel';
  customEvaluation?: Maybe<Scalars['String']['output']>;
  customScore?: Maybe<Scalars['Float']['output']>;
  grade?: Maybe<Grade>;
  percentile?: Maybe<Scalars['Float']['output']>;
  stenScore?: Maybe<Scalars['Float']['output']>;
  zScore?: Maybe<Scalars['Float']['output']>;
};

export type SearchMatch = {
  __typename?: 'SearchMatch';
  field: SearchMatchField;
  tier: Scalars['Int']['output'];
};

export enum SearchMatchField {
  Email = 'EMAIL',
  Name = 'NAME',
  RequisitionCode = 'REQUISITION_CODE'
}

/** Result of admin send summary emails operation */
export type SendSummaryEmailsResult = {
  __typename?: 'SendSummaryEmailsResult';
  /** Total meetings for which emails were successfully dispatched */
  meetingsEmailed: Scalars['Int']['output'];
  /** Total meetings for which email dispatch failed */
  meetingsFailed: Scalars['Int']['output'];
  /** Total meetings processed */
  meetingsProcessed: Scalars['Int']['output'];
};

export type ShareLinkDataModel = {
  __typename?: 'ShareLinkDataModel';
  /** The original URL that the share link points to */
  url: Scalars['String']['output'];
  /** The ID of the workspace associated with the share link */
  workspaceId: Scalars['Int']['output'];
};

export type SharedMeetingModel = {
  __typename?: 'SharedMeetingModel';
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hasSubmittedEvaluation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  projectCandidateId?: Maybe<Scalars['Int']['output']>;
  projectCandidateSubId?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['Int']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  recordingConfig?: Maybe<RecordingConfigModel>;
  status: MeetingStatus;
  summary?: Maybe<MeetingSummaryModel>;
  transcriptConfig?: Maybe<TranscriptConfigModel>;
  type: MeetingScope;
  updatedAt: Scalars['Date']['output'];
};

export type ShortTextField = Field & {
  __typename?: 'ShortTextField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export enum ShortlistCalibrationAnswer {
  FullEvidence = 'FULL_EVIDENCE',
  NoEvidence = 'NO_EVIDENCE',
  PotentialEvidence = 'POTENTIAL_EVIDENCE'
}

export enum ShortlistCalibrationBorderlineCases {
  AdjacentDomain = 'ADJACENT_DOMAIN',
  AdjacentExperience = 'ADJACENT_EXPERIENCE',
  NearMatch = 'NEAR_MATCH',
  SecondaryCapacity = 'SECONDARY_CAPACITY',
  StronglyImpliedExperience = 'STRONGLY_IMPLIED_EXPERIENCE'
}

export type ShortlistCalibrationBorderlineQuestions = {
  __typename?: 'ShortlistCalibrationBorderlineQuestions';
  generationErrorMessage?: Maybe<Scalars['String']['output']>;
  generationStatus: ShortlistCalibrationBorderlineQuestionsStatus;
  id: Scalars['ID']['output'];
  questions?: Maybe<Array<ShortlistCalibrationBorderlineQuestionsEntry>>;
};

export type ShortlistCalibrationBorderlineQuestionsEntry = {
  __typename?: 'ShortlistCalibrationBorderlineQuestionsEntry';
  case: ShortlistCalibrationBorderlineCases;
  criterion?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export enum ShortlistCalibrationBorderlineQuestionsStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Success = 'SUCCESS'
}

export type ShortlistCalibrationConfigEntry = {
  __typename?: 'ShortlistCalibrationConfigEntry';
  answer?: Maybe<ShortlistCalibrationAnswer>;
  case: ShortlistCalibrationBorderlineCases;
  criterion?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
};

export type ShortlistStage = {
  __typename?: 'ShortlistStage';
  applicationQuestions: Array<ShortlistStageApplicationQuestion>;
  branding?: Maybe<StageBranding>;
  calibrationConfig?: Maybe<ShortlistStageCalibrationConfig>;
  createdAt: Scalars['Date']['output'];
  criteria: Array<ShortlistStageCriterion>;
  id: Scalars['Int']['output'];
  isAutoProgressionEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  projectId: Scalars['Int']['output'];
  questionnaire?: Maybe<Questionnaire>;
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
  weightingStrategy: ShortlistStageWeightingStrategy;
};

export type ShortlistStageApplicationQuestion = {
  __typename?: 'ShortlistStageApplicationQuestion';
  display: Scalars['Boolean']['output'];
  isKnockOut: Scalars['Boolean']['output'];
  preferredAnswer?: Maybe<ApplicationQuestionPreferredAnswer>;
  questionId: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type ShortlistStageApplicationQuestionDraft = {
  display: Scalars['Boolean']['input'];
  isKnockOut: Scalars['Boolean']['input'];
  /** Omit to clear the preferred answer. */
  preferredAnswer?: InputMaybe<ApplicationQuestionPreferredAnswerInput>;
  /** The screening question this configuration is for. */
  questionId: Scalars['ID']['input'];
};

export type ShortlistStageCalibrationConfig = {
  __typename?: 'ShortlistStageCalibrationConfig';
  config?: Maybe<Array<ShortlistCalibrationConfigEntry>>;
  configuredByUser?: Maybe<User>;
  configuredByUserId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
};

export type ShortlistStageCandidate = {
  __typename?: 'ShortlistStageCandidate';
  applicationQuestionAnswers: Array<ShortlistStageCandidateApplicationQuestionAnswer>;
  createdAt: Scalars['DateTime']['output'];
  criteriaScore?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isKnockedOut: Scalars['Boolean']['output'];
  isShortlisted: Scalars['Boolean']['output'];
  questionnaireResult?: Maybe<QuestionnaireResult>;
  shortlistStageCandidateCriterionResults?: Maybe<Array<ShortlistStageCandidateCriterionResult>>;
  stage?: Maybe<ShortlistStage>;
};

export type ShortlistStageCandidateApplicationQuestionAnswer = {
  __typename?: 'ShortlistStageCandidateApplicationQuestionAnswer';
  /** Null where the candidate did not answer the question. */
  answer?: Maybe<ApplicationQuestionAnswerValue>;
  /** Null while the stage has no preferred answer configured for the question, so there is nothing to judge the answer against. */
  preferred?: Maybe<ApplicationQuestionAnswerPreference>;
  /** The screening question this answer was given for. */
  questionId: Scalars['ID']['output'];
  /** The question as the candidate was asked it, never the shortened display name used for table columns. */
  questionTitle: Scalars['String']['output'];
  questionType: RoleApplicationQuestionType;
};

export type ShortlistStageCandidateCriterionResult = {
  __typename?: 'ShortlistStageCandidateCriterionResult';
  citations: Array<Citation>;
  citationsTranslated?: Maybe<Array<Citation>>;
  evidenceLevel: ShortlistStageCandidateCriterionResultEvidenceLevel;
  id: Scalars['ID']['output'];
  justification: Scalars['String']['output'];
  shortlistStageCriterion?: Maybe<ShortlistStageCriterion>;
};

export enum ShortlistStageCandidateCriterionResultEvidenceLevel {
  FullEvidence = 'FULL_EVIDENCE',
  NoEvidence = 'NO_EVIDENCE',
  PotentialEvidence = 'POTENTIAL_EVIDENCE'
}

export type ShortlistStageCriterion = {
  __typename?: 'ShortlistStageCriterion';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isKnockOut: Scalars['Boolean']['output'];
  prohibitedCriteriaCategory?: Maybe<Scalars['String']['output']>;
  prohibitedCriteriaPromptStatus?: Maybe<ShortlistStageCriterionProhibitedCriteriaPromptStatus>;
  rubricGenerationStatus: ShortlistStageCriterionRubricGenerationStatus;
  shortName?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  source: ShortlistStageCriterionSource;
  text: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ShortlistStageCriterionDraft = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isKnockOut?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<ShortlistStageCriterionSource>;
  text: Scalars['String']['input'];
};

export enum ShortlistStageCriterionProhibitedCriteriaPromptStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export enum ShortlistStageCriterionRubricGenerationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export enum ShortlistStageCriterionSource {
  AiGenerated = 'AI_GENERATED',
  AiModified = 'AI_MODIFIED',
  UserCreated = 'USER_CREATED'
}

export type ShortlistStageResume = {
  __typename?: 'ShortlistStageResume';
  createdAt: Scalars['Date']['output'];
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSizeBytes: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  processingErrorCode?: Maybe<ShortlistStageResumeProcessingErrorCode>;
  processingStatus: ShortlistStageResumeProcessingStatus;
  projectCandidateSubId?: Maybe<Scalars['ID']['output']>;
  shortlistStageId: Scalars['Int']['output'];
  source: ShortlistStageResumeSource;
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum ShortlistStageResumeProcessingErrorCode {
  ExtractDataFailed = 'EXTRACT_DATA_FAILED',
  InvalidFile = 'INVALID_FILE',
  MissingEmail = 'MISSING_EMAIL',
  Other = 'OTHER',
  RedactDataFailed = 'REDACT_DATA_FAILED'
}

export enum ShortlistStageResumeProcessingStatus {
  AwaitingProcessing = 'AWAITING_PROCESSING',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export enum ShortlistStageResumeSource {
  ExternalService = 'EXTERNAL_SERVICE',
  UserUpload = 'USER_UPLOAD'
}

export enum ShortlistStageWeightingStrategy {
  Even = 'EVEN',
  Ranking = 'RANKING'
}

export type SingleSelectField = Field & {
  __typename?: 'SingleSelectField';
  fieldInstanceType: FieldInstanceType;
  fieldOwnerId?: Maybe<Scalars['Int']['output']>;
  fieldOwnerName?: Maybe<Scalars['String']['output']>;
  fieldOwnerType?: Maybe<FieldOwnerType>;
  fieldType: FieldType;
  formManagerType: FormManagerType;
  hint?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  isFreetextField?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  selectOptions?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<FieldSettingsModel>;
  txtData?: Maybe<Scalars['String']['output']>;
};

export type SinglepartUpload = {
  __typename?: 'SinglepartUpload';
  key: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
  uploadId: Scalars['String']['output'];
};

export type SkillArgs = {
  behaviours?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceFound?: Scalars['Boolean']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  /** Omit to leave the scoring untouched; null reverts to the AI score; a number records a human score. */
  humanScore?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Derived by the server from the stored scores; ignored. */
  isAIScored?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  negativeEvidence?: Array<SkillEvidenceArgs>;
  positiveEvidence?: Array<SkillEvidenceArgs>;
  score: Scalars['Int']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SkillCategory = {
  __typename?: 'SkillCategory';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SkillEventPayload = {
  __typename?: 'SkillEventPayload';
  aiScore: Scalars['Int']['output'];
  behaviours: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  evidenceFound: Scalars['Boolean']['output'];
  group?: Maybe<SkillsEvaluationSkillGroup>;
  humanScore?: Maybe<Scalars['Int']['output']>;
  humanScoredAt?: Maybe<Scalars['DateTime']['output']>;
  humanScoredBy?: Maybe<Scalars['Int']['output']>;
  isAIScored: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  negativeEvidence: Array<SkillEvidenceEventPayload>;
  positiveEvidence: Array<SkillEvidenceEventPayload>;
  score: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  type?: Maybe<SkillsEvaluationSkillType>;
};

export type SkillEvidenceArgs = {
  citations: Array<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type SkillEvidenceEventPayload = {
  __typename?: 'SkillEvidenceEventPayload';
  citations: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type SkillEvidenceModel = {
  __typename?: 'SkillEvidenceModel';
  citations: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type SkillModel = {
  __typename?: 'SkillModel';
  aiScore: Scalars['Int']['output'];
  behaviours: Array<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  evidenceFound: Scalars['Boolean']['output'];
  group?: Maybe<SkillsEvaluationSkillGroup>;
  humanScore?: Maybe<Scalars['Int']['output']>;
  humanScoredAt?: Maybe<Scalars['DateTime']['output']>;
  humanScoredBy?: Maybe<Scalars['Int']['output']>;
  isAIScored: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  negativeEvidence: Array<SkillEvidenceModel>;
  positiveEvidence: Array<SkillEvidenceModel>;
  score: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  type?: Maybe<SkillsEvaluationSkillType>;
};

/** Aggregated score for a single skill across all completed evaluations */
export type SkillResultModel = {
  __typename?: 'SkillResultModel';
  /** Average score across all completed evaluations that scored this skill (0-100) */
  aggregateScore: Scalars['Float']['output'];
  /** Individual scores from each evaluator */
  evaluatorScores: Array<EvaluatorSkillScoreModel>;
  /** Skill category (RIGHT_FOR_THE_ROLE / JOB / FUTURE) */
  group?: Maybe<SkillsEvaluationSkillGroup>;
  /** Skill name */
  name: Scalars['String']['output'];
  /** SOFT_SKILL or TECHNICAL_SKILL */
  type?: Maybe<SkillsEvaluationSkillType>;
};

export enum SkillType {
  SoftSkill = 'SOFT_SKILL',
  TechnicalSkill = 'TECHNICAL_SKILL'
}

export type SkillUnion = BroadSoftSkill | FocusedSoftSkill | TechnicalSkill;

export type SkillWithResultModel = {
  __typename?: 'SkillWithResultModel';
  result?: Maybe<ResultModel>;
  skill: SkillUnion;
};

export type SkillsEvaluationEventPayload = {
  __typename?: 'SkillsEvaluationEventPayload';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewEvaluationId: Scalars['String']['output'];
  isUsingRsp: Scalars['Boolean']['output'];
  skills: Array<SkillEventPayload>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date']['output'];
};

export type SkillsEvaluationModelV2 = {
  __typename?: 'SkillsEvaluationModelV2';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  interviewEvaluationId: Scalars['String']['output'];
  isUsingRsp: Scalars['Boolean']['output'];
  skills: Array<SkillModel>;
  status: InterviewSkillsEvaluationStatusV2;
  updatedAt: Scalars['Date']['output'];
};

export enum SkillsEvaluationSkillGroup {
  RightForTheFuture = 'RIGHT_FOR_THE_FUTURE',
  RightForTheJob = 'RIGHT_FOR_THE_JOB',
  RightForTheRole = 'RIGHT_FOR_THE_ROLE'
}

export enum SkillsEvaluationSkillType {
  SoftSkill = 'SOFT_SKILL',
  TechnicalSkill = 'TECHNICAL_SKILL'
}

export type SkillsProfileOpenOneModel = {
  __typename?: 'SkillsProfileOpenOneModel';
  skillsWithResults: Array<SpSkillWithResultModel>;
  softSkillGradeBands: Array<SoftSkillSelfAssessmentGradeBandModel>;
  technicalSkillGradeBands: Array<TechnicalSkillSelfAssessmentGradeBandModel>;
};

export enum SkillsProfileSkillGenerationStatus {
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Processing = 'PROCESSING'
}

export enum SkillsProfileSkillSource {
  Admin = 'ADMIN',
  Ai = 'AI',
  System = 'SYSTEM',
  TemplateLocked = 'TEMPLATE_LOCKED',
  TemplateRecommended = 'TEMPLATE_RECOMMENDED',
  User = 'USER'
}

export type SkillsProfileSource = {
  __typename?: 'SkillsProfileSource';
  collaborators: Array<SkillsProfileSourceCollaboratorGqlModel>;
  company: Company;
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  confirmedBy?: Maybe<User>;
  createdAt: Scalars['Date']['output'];
  creator: User;
  dataSources: SkillsProfileSourceDataSources;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  incompleteInputsGeneration: Scalars['Boolean']['output'];
  inputErrorGeneration: Scalars['Boolean']['output'];
  inputsChangedAt?: Maybe<Scalars['Date']['output']>;
  isConfirmed: Scalars['Boolean']['output'];
  jobRole?: Maybe<JobRoleModel>;
  jobRoleMetadata: SkillsProfileSourceJobRoleMetadata;
  skillGenerationStatus?: Maybe<SkillsProfileSourceSkillGenerationStatus>;
  skillsProfile?: Maybe<SuccessProfile>;
  softSkills: Array<SkillsProfileSourceSoftSkill>;
  status: SkillsProfileSourceStatus;
  subId: Scalars['String']['output'];
  technicalSkills: Array<SkillsProfileSourceTechnicalSkill>;
  updatedAt: Scalars['Date']['output'];
};

export type SkillsProfileSourceAddSoftSkillsArgs = {
  softSkillSubId: Scalars['ID']['input'];
};

export type SkillsProfileSourceAddTechnicalSkillsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SkillsProfileSourceAdditionalAvailableAssessment = {
  __typename?: 'SkillsProfileSourceAdditionalAvailableAssessment';
  timeRequirementMinutes?: Maybe<Scalars['Int']['output']>;
  timeRequirementMinutesMax?: Maybe<Scalars['Int']['output']>;
  timeRequirementMinutesMin?: Maybe<Scalars['Int']['output']>;
  type: AdditionalAssessmentType;
};

export type SkillsProfileSourceAvailableAssessment = {
  __typename?: 'SkillsProfileSourceAvailableAssessment';
  requirement: SkillsProfileSourceAvailableAssessmentRequirement;
  timeRequirementMinutes: Scalars['Int']['output'];
};

export enum SkillsProfileSourceAvailableAssessmentRequirement {
  Available = 'AVAILABLE',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type SkillsProfileSourceAvailableAssessments = {
  __typename?: 'SkillsProfileSourceAvailableAssessments';
  additionalAssessments: Array<SkillsProfileSourceAdditionalAvailableAssessment>;
  inductiveReasoningAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
  numericalReasoningAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
  personalityAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
  verbalReasoningAssessment?: Maybe<SkillsProfileSourceAvailableAssessment>;
};

export type SkillsProfileSourceCollaboratorArgs = {
  role: SkillsProfileSourceCollaboratorRole;
  userId: Scalars['Int']['input'];
};

export type SkillsProfileSourceCollaboratorGqlModel = {
  __typename?: 'SkillsProfileSourceCollaboratorGQLModel';
  role: SkillsProfileSourceCollaboratorRole;
  user: User;
};

export enum SkillsProfileSourceCollaboratorRole {
  HiringManager = 'HIRING_MANAGER',
  Recruiter = 'RECRUITER'
}

export type SkillsProfileSourceCompleteIntakeMeetingUploadArgs = {
  key: Scalars['String']['input'];
  parts: Array<MultipartCompletedPart>;
  uploadId: Scalars['String']['input'];
};

export type SkillsProfileSourceCompleteJobDescriptionUploadArgs = {
  etag: Scalars['String']['input'];
  key: Scalars['String']['input'];
  uploadId: Scalars['String']['input'];
};

export type SkillsProfileSourceDataSources = {
  __typename?: 'SkillsProfileSourceDataSources';
  intakeMeeting: SkillsProfileSourceIntakeMeeting;
  jobDescription: SkillsProfileSourceJobDescription;
  meeting?: Maybe<SkillsProfileSourceMeeting>;
  upcomingMeeting?: Maybe<SkillsProfileSourceUpcomingMeeting>;
};

export type SkillsProfileSourceInitiateIntakeMeetingUploadArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  nParts: Scalars['Int']['input'];
};

export type SkillsProfileSourceInitiateJobDescriptionUploadArgs = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type SkillsProfileSourceIntakeMeeting = {
  __typename?: 'SkillsProfileSourceIntakeMeeting';
  fileName?: Maybe<Scalars['String']['output']>;
  status: SkillsProfileSourceIntakeMeetingProcessingStatus;
};

export enum SkillsProfileSourceIntakeMeetingProcessingStatus {
  Failed = 'FAILED',
  Missing = 'MISSING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type SkillsProfileSourceJobDescription = {
  __typename?: 'SkillsProfileSourceJobDescription';
  fileName?: Maybe<Scalars['String']['output']>;
  status: SkillsProfileSourceJobDescriptionProcessingStatus;
  uploadedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SkillsProfileSourceJobDescriptionProcessingStatus {
  Failed = 'FAILED',
  Missing = 'MISSING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING'
}

export type SkillsProfileSourceJobRoleMetadata = {
  __typename?: 'SkillsProfileSourceJobRoleMetadata';
  family: JobRoleFamily;
  level: ContentRoleLevel;
  name: Scalars['String']['output'];
};

export type SkillsProfileSourceJobRoleMetadataArgs = {
  family: JobRoleFamily;
  level: ContentRoleLevel;
  name: Scalars['String']['input'];
};

export type SkillsProfileSourceJobRoleMetadataUpdateArgs = {
  family?: InputMaybe<JobRoleFamily>;
  level?: InputMaybe<ContentRoleLevel>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SkillsProfileSourceMeeting = {
  __typename?: 'SkillsProfileSourceMeeting';
  id: Scalars['ID']['output'];
};

export type SkillsProfileSourceMeetingLinkedStatus = {
  __typename?: 'SkillsProfileSourceMeetingLinkedStatus';
  isLinked: Scalars['Boolean']['output'];
  meetingId: Scalars['ID']['output'];
};

export type SkillsProfileSourceMeetingLinks = {
  __typename?: 'SkillsProfileSourceMeetingLinks';
  meetings: Array<SkillsProfileSourceMeetingLinkedStatus>;
  upcomingMeetings: Array<SkillsProfileSourceUpcomingMeetingLinkedStatus>;
};

export enum SkillsProfileSourceOrder {
  CreatedAt = 'CREATED_AT',
  RoleName = 'ROLE_NAME',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT'
}

export type SkillsProfileSourceRemoveSoftSkillArgs = {
  removalComments?: InputMaybe<Scalars['String']['input']>;
  removalReasons: Array<SkillsProfileSourceSkillRemovalReason>;
  softSkillSubId: Scalars['ID']['input'];
};

export type SkillsProfileSourceRemoveTechnicalSkillArgs = {
  id: Scalars['Int']['input'];
  removalComments?: InputMaybe<Scalars['String']['input']>;
  removalReasons: Array<SkillsProfileSourceSkillRemovalReason>;
};

export type SkillsProfileSourceSelectedAssessments = {
  inductiveReasoningAssessment: Scalars['Boolean']['input'];
  numericalReasoningAssessment: Scalars['Boolean']['input'];
  personalityAssessment: Scalars['Boolean']['input'];
  verbalReasoningAssessment: Scalars['Boolean']['input'];
};

export type SkillsProfileSourceSignOffArgs = {
  selectedAssessments: SkillsProfileSourceSelectedAssessments;
};

export enum SkillsProfileSourceSkillGenerationStatus {
  Failed = 'FAILED',
  Generated = 'GENERATED',
  Processing = 'PROCESSING'
}

export enum SkillsProfileSourceSkillRemovalReason {
  DuplicateOrRedundant = 'DUPLICATE_OR_REDUNDANT',
  NotRelevant = 'NOT_RELEVANT',
  Other = 'OTHER',
  UnclearOrVague = 'UNCLEAR_OR_VAGUE'
}

export type SkillsProfileSourceSoftSkill = {
  __typename?: 'SkillsProfileSourceSoftSkill';
  addedByUser?: Maybe<User>;
  createdAt: Scalars['Date']['output'];
  softSkill: SoftSkill;
  source: SkillsProfileSourceSoftSkillSource;
  updatedAt: Scalars['Date']['output'];
};

export enum SkillsProfileSourceSoftSkillSource {
  Ai = 'AI',
  System = 'SYSTEM',
  User = 'USER'
}

export enum SkillsProfileSourceStatus {
  ActionRequired = 'ACTION_REQUIRED',
  Confirmed = 'CONFIRMED',
  Processing = 'PROCESSING',
  ReadyForReview = 'READY_FOR_REVIEW'
}

export type SkillsProfileSourceTechnicalSkill = {
  __typename?: 'SkillsProfileSourceTechnicalSkill';
  addedByUser?: Maybe<User>;
  createdAt: Scalars['Date']['output'];
  technicalSkill: TechnicalSkill;
  updatedAt: Scalars['Date']['output'];
};

export type SkillsProfileSourceUpcomingMeeting = {
  __typename?: 'SkillsProfileSourceUpcomingMeeting';
  sharedId: Scalars['ID']['output'];
};

export type SkillsProfileSourceUpcomingMeetingLinkedStatus = {
  __typename?: 'SkillsProfileSourceUpcomingMeetingLinkedStatus';
  isLinked: Scalars['Boolean']['output'];
  upcomingMeetingSharedId: Scalars['ID']['output'];
};

export type SkillsProfileSourceUpdateArgs = {
  jobRoleMetadata: SkillsProfileSourceJobRoleMetadataUpdateArgs;
};

export type SkillsProfileSourceUpsertCollaboratorsArgs = {
  collaborators: Array<SkillsProfileSourceCollaboratorArgs>;
};

export type SkillsProfileSourcesFiltersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SkillsProfileSourcesOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<SkillsProfileSourceOrder>;
};

export type SkillsProfileSourcesPaginated = {
  __typename?: 'SkillsProfileSourcesPaginated';
  page: Pageinfo;
  skillsProfileSources: Array<SkillsProfileSource>;
};

export type SkillsProfileTemplate = {
  __typename?: 'SkillsProfileTemplate';
  company: Company;
  companyId: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latestVersion?: Maybe<SkillsProfileTemplateVersion>;
  name: Scalars['String']['output'];
};

export enum SkillsProfileTemplateOrderField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  PublishedAt = 'PUBLISHED_AT'
}

export type SkillsProfileTemplatePaginated = {
  __typename?: 'SkillsProfileTemplatePaginated';
  archivedCount: Scalars['Int']['output'];
  page: Pageinfo;
  templates: Array<SkillsProfileTemplate>;
};

export type SkillsProfileTemplateSkill = {
  __typename?: 'SkillsProfileTemplateSkill';
  id: Scalars['Int']['output'];
  isLocked: Scalars['Boolean']['output'];
};

export type SkillsProfileTemplateSkillInput = {
  isLocked: Scalars['Boolean']['input'];
  skillId: Scalars['Int']['input'];
};

export type SkillsProfileTemplateVersion = {
  __typename?: 'SkillsProfileTemplateVersion';
  createdAt: Scalars['Date']['output'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['Int']['output']>;
  fixed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  softSkills: Array<SkillsProfileTemplateSkill>;
  technicalSkills: Array<SkillsProfileTemplateSkill>;
  template: SkillsProfileTemplate;
  templateId: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

/** One interview window offered to a candidate */
export type SlotWindowInput = {
  /** When the interview ends */
  endsAt: Scalars['DateTime']['input'];
  /** When the interview starts */
  startsAt: Scalars['DateTime']['input'];
};

export type SmStageCandidateModel = {
  __typename?: 'SmStageCandidateModel';
  actionCandidates: StageCandidateActionCandidates;
  aiInterviewAction?: Maybe<AiInterviewAssessmentStageActionCandidate>;
  applicationId?: Maybe<Scalars['String']['output']>;
  assignees: Array<ProjectManager>;
  /** @deprecated Please use doneFor instead! */
  candidateId: Scalars['Int']['output'];
  candidateProjectManagerIds?: Maybe<Array<Scalars['Int']['output']>>;
  cognitiveTestActionCandidates: Array<CognitiveTestAssessmentStageActionCandidate>;
  companyId?: Maybe<Scalars['Int']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deadlineAt?: Maybe<Scalars['Date']['output']>;
  deiStageActionCandidate?: Maybe<DeiStageActionCandidateModel>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  doneBy: Scalars['Int']['output'];
  doneByUser: User;
  doneFor: Scalars['Int']['output'];
  doneForUser: User;
  formCandidates?: Maybe<Array<Maybe<FormCandidateModel>>>;
  hasCompletedAdjustmentQuestionnaire: Scalars['Boolean']['output'];
  hasPledgedAnticheating: Scalars['Boolean']['output'];
  hiringManagers: Array<User>;
  id: Scalars['Int']['output'];
  interviewGuideBlueprints: Array<CandidateInterviewGuideModel>;
  isNew: Scalars['Boolean']['output'];
  lastDateOfCandidateAction?: Maybe<Scalars['Date']['output']>;
  personalityTestActionCandidate?: Maybe<PersonalityTestAssessmentStageActionCandidate>;
  projectCandidate: BasicProjectCandidate;
  results?: Maybe<Array<ResultModel>>;
  rssAssessmentCandidates?: Maybe<Array<RssAssessmentCandidateModel>>;
  shouldContactUs: Scalars['Boolean']['output'];
  stage: SmStageModel;
  stageId: Scalars['Int']['output'];
  status: StageCandidateStatus;
  subId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type SmStageModel = {
  __typename?: 'SmStageModel';
  additionalAssessmentTypes: Array<AdditionalAssessmentType>;
  aiInterview?: Maybe<AiInterviewAssessmentStageAction>;
  assessmentExpiryOption?: Maybe<AssessmentExpiryOption>;
  availableActions: Array<StageAvailableActionModel>;
  candidateReport?: Maybe<Report>;
  coderbyte?: Maybe<CoderbyteAssessmentStageAction>;
  cognitiveMode: CognitiveMode;
  cognitiveTest?: Maybe<CognitiveTestAssessmentStageAction>;
  cognitiveTests: Array<CognitiveTestAssessmentStageAction>;
  createdAt: Scalars['Date']['output'];
  deiStageAction?: Maybe<DeiStageActionModel>;
  deiStageActionTemplate?: Maybe<DeiStageActionTemplateModel>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  emailCandidateReport: Scalars['Boolean']['output'];
  enableF2fInterviews: Scalars['Boolean']['output'];
  endTime?: Maybe<Scalars['Date']['output']>;
  englishProficiency?: Maybe<EnglishProficiencyAssessmentStageAction>;
  formId?: Maybe<Scalars['Int']['output']>;
  hasAdjustmentQuestionnaire: Scalars['Boolean']['output'];
  hasCalibration: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isIntegrityMonitoringEnabled: Scalars['Boolean']['output'];
  kind: AssessmentStageKind;
  managerReport?: Maybe<Report>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  personalityTest?: Maybe<PersonalityTestAssessmentStageAction>;
  projectId: Scalars['Int']['output'];
  projectTeamEmailSettings: ProjectTeamEmailSettings;
  rssAssessmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  rssAssessments: Array<RssAssessmentModel>;
  softSkills: Array<SoftSkill>;
  startTime?: Maybe<Scalars['Date']['output']>;
  status: StageStatus;
  subId: Scalars['String']['output'];
  technicalSkills: Array<TechnicalSkill>;
  updatedAt: Scalars['Date']['output'];
};


export type SmStageModelCognitiveTestArgs = {
  kind: CognitiveKind;
};

export type SoftSkill = {
  category: SoftSkillCategory;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  examples: Array<Scalars['String']['output']>;
  granularity: SoftSkillGranularity;
  /** @deprecated Please use subId instead */
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  softSkillTraits?: Maybe<Array<SoftSkillTrait>>;
  subId: Scalars['ID']['output'];
  taxonomyVersion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum SoftSkillCategory {
  CognitiveSummary = 'COGNITIVE_SUMMARY',
  RightForTheFuture = 'RIGHT_FOR_THE_FUTURE',
  RightForTheRole = 'RIGHT_FOR_THE_ROLE',
  RightForUs = 'RIGHT_FOR_US'
}

export enum SoftSkillContentHeaderType {
  InterviewInstructions = 'INTERVIEW_INSTRUCTIONS',
  None = 'NONE'
}

export type SoftSkillFindManyPaginatedFilters = {
  category?: InputMaybe<SoftSkillCategory>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companySpecificOnly?: InputMaybe<Scalars['Boolean']['input']>;
  granularity?: InputMaybe<SoftSkillGranularity>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxonomyVersion?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SoftSkillFindManyPaginatedOrder = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<SoftSkillSortField>;
};

export enum SoftSkillGranularity {
  Broad = 'BROAD',
  Focused = 'FOCUSED'
}

export enum SoftSkillImageType {
  CategoryImage = 'CATEGORY_IMAGE',
  SoftSkillImage = 'SOFT_SKILL_IMAGE'
}

export type SoftSkillIndicator = {
  description: Scalars['String']['output'];
  indicator: Scalars['String']['output'];
  probe: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type SoftSkillIndicatorInput = {
  description: Scalars['String']['input'];
  indicator: Scalars['String']['input'];
  negative_evidence: SoftSkillIndicatorV2NegativeEvidenceInput;
  probe: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  scores: Array<SoftSkillIndicatorV2ScoreInput>;
  trigger: Scalars['String']['input'];
};

export type SoftSkillIndicatorV1 = SoftSkillIndicator & {
  __typename?: 'SoftSkillIndicatorV1';
  description: Scalars['String']['output'];
  indicator: Scalars['String']['output'];
  probe: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  rubric_1: Scalars['String']['output'];
  rubric_2: Scalars['String']['output'];
  rubric_3: Scalars['String']['output'];
  rubric_4: Scalars['String']['output'];
  rubric_5: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
};

export type SoftSkillIndicatorV2 = SoftSkillIndicator & {
  __typename?: 'SoftSkillIndicatorV2';
  description: Scalars['String']['output'];
  indicator: Scalars['String']['output'];
  negative_evidence: SoftSkillIndicatorV2NegativeEvidence;
  probe: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  scores: Array<SoftSkillIndicatorV2Score>;
  trigger: Scalars['String']['output'];
};

export type SoftSkillIndicatorV2NegativeEvidence = {
  __typename?: 'SoftSkillIndicatorV2NegativeEvidence';
  red_flags: Array<SoftSkillIndicatorV2Pattern>;
  score_reducing_patterns: Array<SoftSkillIndicatorV2Pattern>;
};

export type SoftSkillIndicatorV2NegativeEvidenceInput = {
  red_flags: Array<SoftSkillIndicatorV2PatternInput>;
  score_reducing_patterns: Array<SoftSkillIndicatorV2PatternInput>;
};

export type SoftSkillIndicatorV2Pattern = {
  __typename?: 'SoftSkillIndicatorV2Pattern';
  example: Scalars['String']['output'];
  pattern: Scalars['String']['output'];
};

export type SoftSkillIndicatorV2PatternInput = {
  example: Scalars['String']['input'];
  pattern: Scalars['String']['input'];
};

export type SoftSkillIndicatorV2Score = {
  __typename?: 'SoftSkillIndicatorV2Score';
  differentiation: Scalars['String']['output'];
  gateway_criteria: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type SoftSkillIndicatorV2ScoreInput = {
  differentiation: Scalars['String']['input'];
  gateway_criteria: Array<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export type SoftSkillRoleLevelContent = {
  __typename?: 'SoftSkillRoleLevelContent';
  candidateContent?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grade: Grade;
  gradeDescription?: Maybe<Scalars['String']['output']>;
  hiringManagerContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  internalCandidateContent?: Maybe<Scalars['String']['output']>;
  roleLevel: ContentRoleLevel;
  scoreRange?: Maybe<Scalars['String']['output']>;
  softSkill: SoftSkill;
  softSkillId?: Maybe<Scalars['Int']['output']>;
};

export type SoftSkillRoleLevelContentPaginated = {
  __typename?: 'SoftSkillRoleLevelContentPaginated';
  count?: Maybe<Scalars['Float']['output']>;
  softSkillContent?: Maybe<Array<SoftSkillRoleLevelContent>>;
};

export type SoftSkillRoleLevelContentUploadLineModel = {
  __typename?: 'SoftSkillRoleLevelContentUploadLineModel';
  candidateContent: Scalars['String']['output'];
  description: Scalars['String']['output'];
  grade: Grade;
  hiringManagerContent: Scalars['String']['output'];
  internalCandidateContent: Scalars['String']['output'];
  roleLevel: ContentRoleLevel;
  softSkillSubId: Scalars['String']['output'];
};

export type SoftSkillSelfAssessmentGradeBandModel = {
  __typename?: 'SoftSkillSelfAssessmentGradeBandModel';
  displayText: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  proficiency: SoftSkillSelfAssessmentProficiencyLevel;
};

export enum SoftSkillSelfAssessmentProficiencyLevel {
  Beginner = 'BEGINNER',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE'
}

export type SoftSkillSelfAssessmentScoreModel = {
  __typename?: 'SoftSkillSelfAssessmentScoreModel';
  proficiency: SoftSkillSelfAssessmentProficiencyLevel;
};

export type SoftSkillSemanticSearchArgs = {
  threshold?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['String']['input'];
};

export enum SoftSkillSortField {
  Category = 'Category',
  Granularity = 'Granularity',
  Name = 'Name',
  Taxonomy = 'Taxonomy'
}

export type SoftSkillSuccessProfileContent = {
  __typename?: 'SoftSkillSuccessProfileContent';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  roleLevel: ContentRoleLevel;
  shortDescription?: Maybe<Scalars['String']['output']>;
  softSkill: SoftSkill;
  softSkillId: Scalars['Int']['output'];
};

export type SoftSkillSuccessProfileContentPaginated = {
  __typename?: 'SoftSkillSuccessProfileContentPaginated';
  count?: Maybe<Scalars['Float']['output']>;
  softSkillContent?: Maybe<Array<SoftSkillSuccessProfileContent>>;
};

export type SoftSkillTrait = {
  __typename?: 'SoftSkillTrait';
  id?: Maybe<Scalars['Int']['output']>;
  orientation: Orientation;
  softSkill?: Maybe<SoftSkill>;
  softSkillId?: Maybe<Scalars['Int']['output']>;
  softSkillName?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<Trait>;
  traitId?: Maybe<Scalars['Int']['output']>;
  traitName?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type SoftSkillTraitUpsertArgs = {
  orientation: Orientation;
  traitId: Scalars['Int']['input'];
  weight: Scalars['Float']['input'];
};

export enum SoftSkillType {
  Core = 'CORE',
  Differentiator = 'DIFFERENTIATOR',
  Diversity = 'DIVERSITY'
}

export type SoftSkillTypeSuccessProfileContent = {
  __typename?: 'SoftSkillTypeSuccessProfileContent';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  softSkillType: SoftSkillType;
};

export type SoftSkillUpdateArgs = {
  category?: InputMaybe<SoftSkillCategory>;
  childSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  examples?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  siblingSubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  softSkillTraits?: InputMaybe<Array<SoftSkillTraitUpsertArgs>>;
  taxonomyVersion?: InputMaybe<Scalars['Int']['input']>;
};

export enum SortOption {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpSkillWithResultModel = {
  __typename?: 'SpSkillWithResultModel';
  result: ResultModel;
  skill: SkillUnion;
};

export enum StageActionAvailability {
  AlreadyExists = 'ALREADY_EXISTS',
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export type StageActionSummary = {
  __typename?: 'StageActionSummary';
  estimatedTime?: Maybe<Scalars['Int']['output']>;
  stageActionKind: AssessmentStageActionKind;
};

export type StageAvailableActionModel = {
  __typename?: 'StageAvailableActionModel';
  availability: StageActionAvailability;
  kind: AssessmentStageActionKind;
  name: Scalars['String']['output'];
};

export type StageBranding = {
  __typename?: 'StageBranding';
  description?: Maybe<Scalars['String']['output']>;
  estimatedTimeMinutes?: Maybe<Scalars['Int']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StageCandidateActionCandidates = {
  __typename?: 'StageCandidateActionCandidates';
  aiInterview?: Maybe<AiInterviewAssessmentStageActionCandidate>;
  coderbyte?: Maybe<CoderbyteAssessmentStageActionCandidate>;
  cognitiveTests: Array<CognitiveTestAssessmentStageActionCandidate>;
  dei?: Maybe<DeiStageActionCandidateModel>;
  englishProficiency?: Maybe<EnglishProficiencyAssessmentStageActionCandidate>;
  forms: Array<FormCandidateModel>;
  personalityTest?: Maybe<PersonalityTestAssessmentStageActionCandidate>;
  roleSkillSelfAssessments: Array<RssAssessmentCandidateModel>;
};

export enum StageCandidateInviteMethod {
  Ats = 'ATS',
  Csv = 'CSV',
  Email = 'EMAIL',
  Url = 'URL'
}

export enum StageCandidateSkillsProfileCategory {
  CognitiveSummary = 'COGNITIVE_SUMMARY',
  GeneralSkills = 'GENERAL_SKILLS',
  RightForTheFuture = 'RIGHT_FOR_THE_FUTURE',
  RightForTheRole = 'RIGHT_FOR_THE_ROLE',
  RightForUs = 'RIGHT_FOR_US'
}

export type StageCandidateSkillsProfileCategoryResultsModel = {
  __typename?: 'StageCandidateSkillsProfileCategoryResultsModel';
  name: StageCandidateSkillsProfileCategory;
  score?: Maybe<StatisticalResultScoreModel>;
  skills: Array<StageCandidateSkillsProfileSkillResultModel>;
};

export type StageCandidateSkillsProfileResultsModel = {
  __typename?: 'StageCandidateSkillsProfileResultsModel';
  categories: Array<StageCandidateSkillsProfileCategoryResultsModel>;
  projectJobRoleId: Scalars['Int']['output'];
  score?: Maybe<StatisticalResultScoreModel>;
  skillsProfileId: Scalars['Int']['output'];
  stageCandidateCreatedAt: Scalars['Date']['output'];
  stageCandidateId: Scalars['Int']['output'];
  stageCandidateLastDateOfCandidateAction?: Maybe<Scalars['Date']['output']>;
  stageCandidateStatus: StageCandidateStatus;
};

export type StageCandidateSkillsProfileSkillResultModel = {
  __typename?: 'StageCandidateSkillsProfileSkillResultModel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  score?: Maybe<ResultScoreUnion>;
  type: SkillType;
};

export type StageCandidateStatisticsByProjectJobRoleFindManyFilterArgs = {
  lastDateOfCandidateActionGte?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionLte?: InputMaybe<Scalars['Date']['input']>;
  nameOrEmailLike?: InputMaybe<Scalars['String']['input']>;
  overallScorePercentileGte?: InputMaybe<Scalars['Float']['input']>;
  overallScorePercentileLte?: InputMaybe<Scalars['Float']['input']>;
};

export type StageCandidateStatisticsByProjectJobRoleFindManyOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<StageCandidateStatisticsByProjectJobRoleOrderField>;
};

export type StageCandidateStatisticsByProjectJobRoleFindManyOutput = {
  __typename?: 'StageCandidateStatisticsByProjectJobRoleFindManyOutput';
  page: Pageinfo;
  projectJobRole: ProjectJobRoleModel;
  stageCandidatesStatisticsByJobRole: Array<StageCandidateStatisticsByProjectJobRoleModel>;
};

export type StageCandidateStatisticsByProjectJobRoleModel = {
  __typename?: 'StageCandidateStatisticsByProjectJobRoleModel';
  cognitiveCombinedScore?: Maybe<StatisticalResultScoreModel>;
  cognitiveSummaryScore?: Maybe<StatisticalResultScoreModel>;
  overallScore?: Maybe<StatisticalResultScoreModel>;
  projectJobRole: ProjectJobRoleModel;
  rightForTheFutureScore?: Maybe<StatisticalResultScoreModel>;
  rightForTheRoleScore?: Maybe<StatisticalResultScoreModel>;
  rightForUsScore?: Maybe<StatisticalResultScoreModel>;
  stageCandidate: SmStageCandidateModel;
};

export enum StageCandidateStatisticsByProjectJobRoleOrderField {
  CognitiveCombinedScore = 'CognitiveCombinedScore',
  CognitiveSummaryScore = 'CognitiveSummaryScore',
  LastDateOfCandidateAction = 'LastDateOfCandidateAction',
  Name = 'Name',
  OverallScore = 'OverallScore',
  RightForTheFutureScore = 'RightForTheFutureScore',
  RightForTheRoleScore = 'RightForTheRoleScore',
  RightForUsScore = 'RightForUsScore'
}

export type StageCandidateStatisticsFindManyFilterArgs = {
  createdAtGte?: InputMaybe<Scalars['Date']['input']>;
  createdAtLte?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionGte?: InputMaybe<Scalars['Date']['input']>;
  lastDateOfCandidateActionLte?: InputMaybe<Scalars['Date']['input']>;
  nameOrEmailContains?: InputMaybe<Scalars['String']['input']>;
  progressionStatusIn?: InputMaybe<Array<ProgressionStatus>>;
  stageProgressionStatusIn?: InputMaybe<Array<StageProgressionStatus>>;
  statusIn?: InputMaybe<Array<StageCandidateStatus>>;
};

export type StageCandidateStatisticsFindManyOrderArgs = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<StageCandidateStatisticsOrderField>;
};

export type StageCandidateStatisticsFindManyOutput = {
  __typename?: 'StageCandidateStatisticsFindManyOutput';
  page: Pageinfo;
  stage: SmStageModel;
  stageCandidatesStatistics: Array<StageCandidateStatisticsModel>;
};

export type StageCandidateStatisticsModel = {
  __typename?: 'StageCandidateStatisticsModel';
  progressionStatus: ProgressionStatus;
  stageCandidate: SmStageCandidateModel;
  stageCandidateStatisticsProjectJobRoles: Array<StageCandidateStatisticsProjectJobRoleModel>;
};

export enum StageCandidateStatisticsOrderField {
  CreatedAt = 'CreatedAt',
  LastDateOfCandidateAction = 'LastDateOfCandidateAction',
  Name = 'Name',
  PsychometricOverall = 'PsychometricOverall',
  Status = 'Status'
}

export type StageCandidateStatisticsProjectJobRoleModel = {
  __typename?: 'StageCandidateStatisticsProjectJobRoleModel';
  cognitiveCombinedScore?: Maybe<StatisticalResultScoreModel>;
  cognitiveSummaryScore?: Maybe<StatisticalResultScoreModel>;
  overallScore?: Maybe<StatisticalResultScoreModel>;
  projectJobRole: ProjectJobRoleModel;
  reports: Array<StageCandidateStatisticsProjectJobRoleReportModel>;
  rightForTheFutureScore?: Maybe<StatisticalResultScoreModel>;
  rightForTheRoleScore?: Maybe<StatisticalResultScoreModel>;
  rightForUsScore?: Maybe<StatisticalResultScoreModel>;
};

export type StageCandidateStatisticsProjectJobRoleReportModel = {
  __typename?: 'StageCandidateStatisticsProjectJobRoleReportModel';
  blob: MonolithBlobModel;
  projectJobRoleId: Scalars['Int']['output'];
  stageCandidateId: Scalars['Int']['output'];
  subType?: Maybe<ReportSubType>;
  type: ReportType;
};

export enum StageCandidateStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  ManagerCompleted = 'MANAGER_COMPLETED',
  NotStarted = 'NOT_STARTED',
  Processing = 'PROCESSING',
  SignedOff = 'SIGNED_OFF'
}

export enum StageProgressionStatus {
  Pending = 'PENDING',
  Progressed = 'PROGRESSED',
  Rejected = 'REJECTED'
}

/** Interview scheduling state for one candidate at one stage */
export type StageSchedulingRowModel = {
  __typename?: 'StageSchedulingRowModel';
  /** When the booked interview starts */
  bookedStartsAt?: Maybe<Scalars['DateTime']['output']>;
  candidateUserId: Scalars['Int']['output'];
  /** When the candidate declined every offered slot */
  declinedAt?: Maybe<Scalars['DateTime']['output']>;
  linkExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  offerRound?: Maybe<Scalars['Int']['output']>;
  /** How many slots the candidate was offered */
  offeredSlotCount?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['ID']['output']>;
  /** Joins to the candidate row in the candidates table */
  stageCandidateId: Scalars['Int']['output'];
  state: SchedulingInterviewState;
};

export enum StageStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export enum StageType {
  AssessmentStage = 'ASSESSMENT_STAGE',
  ContentStage = 'CONTENT_STAGE',
  InterviewStage = 'INTERVIEW_STAGE',
  OfferStage = 'OFFER_STAGE',
  ShortlistStage = 'SHORTLIST_STAGE'
}

export type StartIntegrityMonitoringSessionInput = {
  browserVersion?: InputMaybe<Scalars['String']['input']>;
  deviceOs?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  screenIsExtended?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type StatisticalGradeBandModel = {
  __typename?: 'StatisticalGradeBandModel';
  displayText: Scalars['String']['output'];
  grade: Grade;
  position: Scalars['Int']['output'];
};

export type StatisticalResultScoreModel = {
  __typename?: 'StatisticalResultScoreModel';
  grade: Grade;
  percentile: Scalars['Float']['output'];
  stenScore: Scalars['Float']['output'];
  zScore: Scalars['Float']['output'];
};

export type SuccessProfile = {
  __typename?: 'SuccessProfile';
  calculationMethod: CalculationMethod;
  confirmedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  gradingMethod: GradingMethod;
  id: Scalars['Int']['output'];
  inputsChangedAt?: Maybe<Scalars['Date']['output']>;
  isConfirmed: Scalars['Boolean']['output'];
  jobRole: JobRoleModel;
  jobRoleId: Scalars['Int']['output'];
  status: SuccessProfileStatus;
  successProfileSoftSkills?: Maybe<Array<SuccessProfileSoftSkill>>;
  successProfileTechnicalSkills?: Maybe<Array<SuccessProfileTechnicalSkill>>;
  templateVersion?: Maybe<SkillsProfileTemplateVersion>;
  templateVersionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type SuccessProfileAdditionalAvailableAssessment = {
  __typename?: 'SuccessProfileAdditionalAvailableAssessment';
  timeRequirementMinutes?: Maybe<Scalars['Int']['output']>;
  timeRequirementMinutesMax?: Maybe<Scalars['Int']['output']>;
  timeRequirementMinutesMin?: Maybe<Scalars['Int']['output']>;
  type: AdditionalAssessmentType;
};

export type SuccessProfileAvailableAssessment = {
  __typename?: 'SuccessProfileAvailableAssessment';
  requirement: SuccessProfileAvailableAssessmentRequirement;
  timeRequirementMinutes: Scalars['Int']['output'];
};

export enum SuccessProfileAvailableAssessmentRequirement {
  Available = 'AVAILABLE',
  Recommended = 'RECOMMENDED',
  Required = 'REQUIRED'
}

export type SuccessProfileAvailableAssessments = {
  __typename?: 'SuccessProfileAvailableAssessments';
  additionalAssessments: Array<SuccessProfileAdditionalAvailableAssessment>;
  inductiveReasoningAssessment?: Maybe<SuccessProfileAvailableAssessment>;
  numericalReasoningAssessment?: Maybe<SuccessProfileAvailableAssessment>;
  personalityAssessment?: Maybe<SuccessProfileAvailableAssessment>;
  verbalReasoningAssessment?: Maybe<SuccessProfileAvailableAssessment>;
};

export type SuccessProfileSelectedAssessments = {
  inductiveReasoningAssessment: Scalars['Boolean']['input'];
  numericalReasoningAssessment: Scalars['Boolean']['input'];
  personalityAssessment: Scalars['Boolean']['input'];
  verbalReasoningAssessment: Scalars['Boolean']['input'];
};

export type SuccessProfileSoftSkill = {
  __typename?: 'SuccessProfileSoftSkill';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  includeInCalibration: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  softSkill: SoftSkill;
  softSkillId: Scalars['Int']['output'];
  source?: Maybe<SkillsProfileSkillSource>;
  successProfile: SuccessProfile;
  successProfileId: Scalars['Int']['output'];
  successProfileSoftSkillDataSources?: Maybe<Array<SuccessProfileSoftSkillDataSource>>;
  successProfileSoftSkillTraits: Array<SuccessProfileSoftSkillTrait>;
  type: SoftSkillType;
  weight: Scalars['Float']['output'];
};

export type SuccessProfileSoftSkillCreateOneArgs = {
  dataSources?: InputMaybe<Array<SuccessProfileSoftSkillDataSourceCreateOneBase>>;
  includeInCalibration?: InputMaybe<Scalars['Boolean']['input']>;
  softSkillId: Scalars['Int']['input'];
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  traits?: InputMaybe<Array<SuccessProfileSoftSkillTraitCreateOneArgs>>;
  type: SoftSkillType;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type SuccessProfileSoftSkillDataSource = {
  __typename?: 'SuccessProfileSoftSkillDataSource';
  dataSourceType: DataSourceType;
  id: Scalars['Int']['output'];
  orientation?: Maybe<Scalars['Int']['output']>;
  softSkillType: SoftSkillType;
  successProfileSoftSkill: SuccessProfileSoftSkill;
  successProfileSoftSkillId: Scalars['Int']['output'];
};

export type SuccessProfileSoftSkillDataSourceCreateOneBase = {
  dataSourceType: DataSourceType;
  softSkillType: SoftSkillType;
};

export type SuccessProfileSoftSkillTrait = {
  __typename?: 'SuccessProfileSoftSkillTrait';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  orientation?: Maybe<Scalars['Int']['output']>;
  softSkill: SoftSkill;
  softSkillId: Scalars['Int']['output'];
  successProfileSoftSkill: SuccessProfileSoftSkill;
  successProfileSoftSkillId: Scalars['Int']['output'];
  trait: Trait;
  traitId: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
};

export type SuccessProfileSoftSkillTraitCreateOneArgs = {
  orientation?: InputMaybe<Scalars['Int']['input']>;
  softSkillId?: InputMaybe<Scalars['Int']['input']>;
  successProfileSoftSkillId?: InputMaybe<Scalars['Int']['input']>;
  traitId: Scalars['Int']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export enum SuccessProfileStatus {
  Complete = 'COMPLETE',
  MissingSoftSkills = 'MISSING_SOFT_SKILLS'
}

export type SuccessProfileTechnicalSkill = {
  __typename?: 'SuccessProfileTechnicalSkill';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  source?: Maybe<SkillsProfileSkillSource>;
  successProfile?: Maybe<SuccessProfile>;
  successProfileId: Scalars['Int']['output'];
  technicalSkill?: Maybe<TechnicalSkill>;
  technicalSkillId: Scalars['Int']['output'];
};

export type SuccessProfileTechnicalSkillCreateOneArgs = {
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId: Scalars['Int']['input'];
};

export type SuccessProfileTechnicalSkillUpdateOneArgs = {
  id: Scalars['Int']['input'];
  successProfileId?: InputMaybe<Scalars['Int']['input']>;
  technicalSkillId?: InputMaybe<Scalars['Int']['input']>;
};

export type SummaryTemplateModel = {
  __typename?: 'SummaryTemplateModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  isReady: Scalars['Boolean']['output'];
  longDescription?: Maybe<Scalars['String']['output']>;
  messages: Array<TemplateMessageModel>;
  modelName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  scope: SummaryTemplateScope;
  sections?: Maybe<Array<TemplateSectionModel>>;
  seed: Scalars['Int']['output'];
  sharedWith?: Maybe<Array<Scalars['Int']['output']>>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  temperature: Scalars['Float']['output'];
  topP: Scalars['Float']['output'];
  type: TemplateType;
  updatedAt: Scalars['Date']['output'];
};

export type SummaryTemplateResponseModel = SummaryTemplateModel | TemplateVerificationErrorModel;

export enum SummaryTemplateScope {
  Company = 'company',
  Personal = 'personal',
  System = 'system'
}

export enum SupportedLocale {
  Bulgarian = 'BULGARIAN',
  Chinese = 'CHINESE',
  ChineseTraditional = 'CHINESE_TRADITIONAL',
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Hungarian = 'HUNGARIAN',
  Indonesian = 'INDONESIAN',
  Italian = 'ITALIAN',
  Korean = 'KOREAN',
  Malay = 'MALAY',
  Polish = 'POLISH',
  PortugueseBrazilian = 'PORTUGUESE_BRAZILIAN',
  SpanishEuropean = 'SPANISH_EUROPEAN',
  SpanishLatinAmerican = 'SPANISH_LATIN_AMERICAN',
  Thai = 'THAI',
  Turkish = 'TURKISH'
}

export enum SzApp {
  AdminApp = 'ADMIN_APP',
  CandidateApp = 'CANDIDATE_APP',
  CompanyApp = 'COMPANY_APP'
}

export enum SzMappedStageType {
  AiInterview = 'AI_INTERVIEW',
  AiShortlist = 'AI_SHORTLIST',
  Assessment = 'ASSESSMENT',
  Interview = 'INTERVIEW',
  Offer = 'OFFER'
}

export type SzSkillsMerge = {
  __typename?: 'SzSkillsMerge';
  category?: Maybe<SkillCategory>;
  categoryId?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<MonolithBlobModel>;
  iconBlobId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  originId: Scalars['Int']['output'];
  skillType: SkillType;
};

export type SzSkillsMergeCreateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name: Scalars['String']['input'];
  originId: Scalars['Int']['input'];
  skillType: SkillType;
};

export type SzSkillsMergeUpdateOneArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iconBlobId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  measurementConstructType?: InputMaybe<MeasurementConstructType>;
  name?: InputMaybe<Scalars['String']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  skillType?: InputMaybe<SkillType>;
};

export type SzSkillsMergeWithAvailability = {
  __typename?: 'SzSkillsMergeWithAvailability';
  alreadyExist: Scalars['Boolean']['output'];
  result?: Maybe<ResultModel>;
  skill: SzSkillsMerge;
};

export type TechnicalSkill = {
  __typename?: 'TechnicalSkill';
  company?: Maybe<Company>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<MonolithBlobModel>;
  iconBlobId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  skillCategory?: Maybe<SkillCategory>;
  skillCategoryId?: Maybe<Scalars['Int']['output']>;
  subId: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type TechnicalSkillFindManyPaginatedFilters = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  skillCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skillCategoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TechnicalSkillFindManyPaginatedOrder = {
  direction?: InputMaybe<SortOption>;
  field?: InputMaybe<TechnicalSkillSortField>;
};

export type TechnicalSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TechnicalSkillSelfAssessmentGradeBandModel = {
  __typename?: 'TechnicalSkillSelfAssessmentGradeBandModel';
  displayText: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel;
};

export enum TechnicalSkillSelfAssessmentProficiencyLevel {
  Beginner = 'BEGINNER',
  Expert = 'EXPERT',
  Intermediate = 'INTERMEDIATE',
  NoKnowledge = 'NO_KNOWLEDGE'
}

export type TechnicalSkillSelfAssessmentScoreModel = {
  __typename?: 'TechnicalSkillSelfAssessmentScoreModel';
  technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel;
};

export type TechnicalSkillSemanticSearchArgs = {
  threshold?: InputMaybe<Scalars['Float']['input']>;
  value: Scalars['String']['input'];
};

export enum TechnicalSkillSortField {
  Name = 'NAME'
}

export type TechnicalSkillUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  skillCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type TemplateMessageArgs = {
  content: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type TemplateMessageModel = {
  __typename?: 'TemplateMessageModel';
  content: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type TemplateSectionArgs = {
  instructions?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type TemplateSectionErrorModel = {
  __typename?: 'TemplateSectionErrorModel';
  index: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateSectionModel = {
  __typename?: 'TemplateSectionModel';
  instructions?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum TemplateType {
  CustomTemplate = 'customTemplate',
  General = 'general',
  HiringManager = 'hiringManager',
  Intake = 'intake',
  Qa = 'qa',
  Recruiter = 'recruiter',
  RetailSalesJunior = 'retailSalesJunior',
  RetailSalesSenior = 'retailSalesSenior',
  SalesManager = 'salesManager',
  SdrInsideSales = 'sdrInsideSales',
  SeniorAccountDirector = 'seniorAccountDirector',
  SpecialistSales = 'specialistSales'
}

export type TemplateVerificationErrorModel = {
  __typename?: 'TemplateVerificationErrorModel';
  error: Scalars['String']['output'];
  invalidSections?: Maybe<Array<TemplateSectionErrorModel>>;
};

export enum TestFullType {
  CognitiveInductive = 'CognitiveInductive',
  CognitiveNumerical = 'CognitiveNumerical',
  CognitiveVerbal = 'CognitiveVerbal',
  Personality = 'Personality',
  TalentReview = 'TalentReview'
}

export enum TestStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export enum TestSubType {
  Inductive = 'INDUCTIVE',
  Numerical = 'NUMERICAL',
  Verbal = 'VERBAL'
}

export enum TestType {
  Cognitive = 'COGNITIVE',
  Personality = 'PERSONALITY',
  TalentReview = 'TALENT_REVIEW'
}

export enum TrCustomEvaluation {
  RisingTalent = 'RISING_TALENT',
  SolidContributor = 'SOLID_CONTRIBUTOR',
  StarTalent = 'STAR_TALENT',
  UnderperformingTalent = 'UNDERPERFORMING_TALENT'
}

export type TrCustomGradeBandModel = {
  __typename?: 'TrCustomGradeBandModel';
  displayText: Scalars['String']['output'];
  evaluation: TrCustomEvaluation;
  position: Scalars['Int']['output'];
};

export type TrCustomResultScoreModel = {
  __typename?: 'TrCustomResultScoreModel';
  evaluation: TrCustomEvaluation;
  score: Scalars['Float']['output'];
};

export type TrItemModel = {
  __typename?: 'TrItemModel';
  isCompleted: Scalars['Boolean']['output'];
  questions: Array<TrQuestionModel>;
  remainingQuestions: Scalars['Int']['output'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  totalQuestions: Scalars['Int']['output'];
};

export type TrOptionModel = {
  __typename?: 'TrOptionModel';
  key: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type TrQuestionModel = {
  __typename?: 'TrQuestionModel';
  options: Array<TrOptionModel>;
  orientation: QuestionOrientation;
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Trait = {
  __typename?: 'Trait';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subId: Scalars['ID']['output'];
  testTypes: Array<TraitTestTypeModel>;
};

export type TraitRoleLevelContent = {
  __typename?: 'TraitRoleLevelContent';
  classification: ContentClassification;
  content?: Maybe<Scalars['String']['output']>;
  developmentContent?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  roleLevel: ContentRoleLevel;
  softSkill: SoftSkill;
  softSkillId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  trait?: Maybe<Trait>;
  traitId?: Maybe<Scalars['Int']['output']>;
};

export type TraitRoleLevelContentPaginatedModel = {
  __typename?: 'TraitRoleLevelContentPaginatedModel';
  count?: Maybe<Scalars['Float']['output']>;
  traitContent?: Maybe<Array<TraitRoleLevelContent>>;
};

export type TraitSoftSkillContextFileUploadLineModel = {
  __typename?: 'TraitSoftSkillContextFileUploadLineModel';
  internalName: Scalars['String']['output'];
  level: Scalars['String']['output'];
  negativeSummary: Scalars['String']['output'];
  positiveSummary: Scalars['String']['output'];
  softSkillId: Scalars['String']['output'];
  traitId: Scalars['String']['output'];
};

export type TraitSoftSkillContextFileUploadModel = {
  __typename?: 'TraitSoftSkillContextFileUploadModel';
  apply: Scalars['Boolean']['output'];
  creates?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  deletes?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorMessages?: Maybe<Array<Scalars['String']['output']>>;
  errors?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  noChanges?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  updates?: Maybe<Array<TraitSoftSkillContextFileUploadLineModel>>;
  warnings: Array<Scalars['String']['output']>;
};

export type TraitSoftSkillContextModel = {
  __typename?: 'TraitSoftSkillContextModel';
  behaviours: Array<BehaviourModel>;
  id: Scalars['Int']['output'];
  softSkillId?: Maybe<Scalars['Int']['output']>;
  traitId: Scalars['Int']['output'];
};

export type TraitTestTypeModel = {
  __typename?: 'TraitTestTypeModel';
  id: Scalars['Int']['output'];
  testSubType?: Maybe<TestSubType>;
  testType: TestType;
  trait?: Maybe<Trait>;
  traitId: Scalars['Int']['output'];
};

export type TraitTestTypesUpdateOneArgs = {
  testSubType?: InputMaybe<TestSubType>;
  testType: TestType;
  traitId: Scalars['Int']['input'];
};

export type TranscriptConfigArgs = {
  generatedAt?: InputMaybe<Scalars['Date']['input']>;
  requestId?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  status: MeetingTranscriptStatus;
};

export type TranscriptConfigModel = {
  __typename?: 'TranscriptConfigModel';
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  locales?: Maybe<Array<Scalars['String']['output']>>;
  requestId?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  status: MeetingTranscriptStatus;
};

export enum TranscriptSpeaker {
  Agent = 'AGENT',
  User = 'USER'
}

export type TranscriptUtterance = {
  __typename?: 'TranscriptUtterance';
  /** Utterance start timestamp in milliseconds from the start */
  from: Scalars['Int']['output'];
  speaker: TranscriptSpeaker;
  text: Scalars['String']['output'];
  /** Utterance end timestamp in milliseconds from the start */
  to: Scalars['Int']['output'];
};


export type TranscriptUtteranceTextArgs = {
  isOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: SupportedLocale;
};

export type TriggerAtsCvUploadForApplicationResultModel = {
  __typename?: 'TriggerAtsCvUploadForApplicationResultModel';
  /** The canonical SDK application id that was processed. */
  applicationId: Scalars['String']['output'];
  /** True when the CV upload was attempted. The mutation forces an upload attempt regardless of whether the project candidate already has a resume; actual upload success/failure is in the logs (look for `Successfully uploaded CV to shortlist stage` or `CV upload failed`). */
  cvUploadAttempted: Scalars['Boolean']['output'];
  /** True when the project candidate was found or created. False means the SDK adapter skipped (e.g., job not linked to project, candidate missing email); see logs for the exact reason. */
  materialised: Scalars['Boolean']['output'];
};

export type UnifiedMeeting = MeetingModel | UpcomingMeetingModel;

export enum UnifiedMeetingKind {
  Meeting = 'meeting',
  UpcomingMeeting = 'upcomingMeeting'
}

export type UnifiedMeetingsFilters = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  kind?: InputMaybe<UnifiedMeetingKind>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<MeetingScope>>;
};

export type UpcomingMeetingModel = {
  __typename?: 'UpcomingMeetingModel';
  attendees: Array<AttendeeModel>;
  botId?: Maybe<Scalars['String']['output']>;
  calendarId: Scalars['String']['output'];
  calendarPlatform: MeetingCalendarPlatform;
  conferencingPlatform: MeetingCalendarPlatform;
  createdAt: Scalars['Date']['output'];
  date: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  externalMeetingId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interviewStageCandidateId?: Maybe<Scalars['Int']['output']>;
  method: Method;
  name: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  projectCandidateId?: Maybe<Scalars['Int']['output']>;
  projectCandidateSubId?: Maybe<Scalars['String']['output']>;
  projectJobRoleId?: Maybe<Scalars['Int']['output']>;
  sharedId?: Maybe<Scalars['String']['output']>;
  type: MeetingScope;
  updatedAt: Scalars['Date']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type UpdateAssessmentStageEmailSettingsInput = {
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  emailCandidateReport?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  projectTeamEmailSettings?: InputMaybe<ProjectTeamEmailSettingsArgs>;
};

export type UpdateAssessmentStageInput = {
  additionalAssessmentTypes?: InputMaybe<Array<AdditionalAssessmentType>>;
  assessmentExpiryOption?: InputMaybe<AssessmentExpiryOptionArgs>;
  autoProgressionThreshold?: InputMaybe<Scalars['Int']['input']>;
  candidateReportId?: InputMaybe<Scalars['Int']['input']>;
  cognitiveMode: CognitiveMode;
  emailSettings?: InputMaybe<UpdateAssessmentStageEmailSettingsInput>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  hasAdjustmentQuestionnaire?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoProgressionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrityMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  managerReportId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateFormFieldByFieldIdArgs = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  fieldId: Scalars['Int']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
};

/** What one interview panel change did */
export type UpdateInterviewPanelResultModel = {
  __typename?: 'UpdateInterviewPanelResultModel';
  /** False only when an added interviewer is busy and the change was not confirmed */
  applied: Scalars['Boolean']['output'];
  /** The added interviewers busy at the interview time; empty when the change was applied */
  busyInterviewerIds: Array<Scalars['Int']['output']>;
  /** The request as committed; its version is unchanged when nothing was written */
  request: SchedulingRequestModel;
};

export type UpdateRespondantFormAnswerArgs = {
  fieldId: Scalars['Int']['input'];
  response: Scalars['String']['input'];
};

export type UploadResult = {
  __typename?: 'UploadResult';
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  companyInfo?: Maybe<Array<UserCompanyInfo>>;
  email: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  groups?: Maybe<Array<UserGroupMemberModel>>;
  id: Scalars['Int']['output'];
  identityVerificationResubmissionReason?: Maybe<Scalars['String']['output']>;
  identityVerificationStatus: VerificationStatus;
  identityVerifiedAt?: Maybe<Scalars['Date']['output']>;
  isInternal: Scalars['Boolean']['output'];
  isPasswordDisabled?: Maybe<Scalars['Boolean']['output']>;
  isPuppet: Scalars['Boolean']['output'];
  /** @deprecated Please use "locale" instead! */
  language: Language;
  lastName: Scalars['String']['output'];
  preferredLocale: UserLocalePreference;
  roles: Array<UserRole>;
  subId: Scalars['String']['output'];
  twoFactorEnabled: Scalars['Boolean']['output'];
};

export enum UserCalendarPlatform {
  GoogleCalendar = 'googleCalendar',
  MicrosoftOutlook = 'microsoftOutlook',
  Zoom = 'zoom'
}

export type UserCompanyInfo = {
  __typename?: 'UserCompanyInfo';
  companyId: Scalars['Int']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customFieldsString?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Date']['output']>;
  hrManagerEmployeeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['Int']['output'];
};

export type UserCompanyInfoCustomFieldsArgs = {
  division?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Scalars['String']['input']>;
  functionGroup?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  office?: InputMaybe<Scalars['String']['input']>;
  officeCountry?: InputMaybe<Scalars['String']['input']>;
  organisationLevel?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupFindManyArgs = {
  companyId: Scalars['Int']['input'];
};

export type UserGroupMemberFindManyArgs = {
  groupSubId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UserGroupMemberModel = {
  __typename?: 'UserGroupMemberModel';
  group?: Maybe<UserGroupModel>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  member?: Maybe<User>;
  memberId?: Maybe<Scalars['Int']['output']>;
  subId: Scalars['String']['output'];
};

export type UserGroupMemberPreview = {
  __typename?: 'UserGroupMemberPreview';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type UserGroupModel = {
  __typename?: 'UserGroupModel';
  companyId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  members?: Maybe<Array<UserGroupMemberModel>>;
  membersCount?: Maybe<Scalars['Int']['output']>;
  membersPreview?: Maybe<Array<UserGroupMemberPreview>>;
  name: Scalars['String']['output'];
  projectsCount?: Maybe<Scalars['Int']['output']>;
  projectsPreview?: Maybe<Array<UserGroupProjectPreview>>;
  subId: Scalars['String']['output'];
};

export type UserGroupPaginatedModel = {
  __typename?: 'UserGroupPaginatedModel';
  data?: Maybe<Array<UserGroupModel>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type UserGroupProjectPreview = {
  __typename?: 'UserGroupProjectPreview';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subId: Scalars['String']['output'];
};

export type UserLocalePreference = {
  __typename?: 'UserLocalePreference';
  locale: SupportedLocale;
  source: UserLocalePreferenceSource;
};

export enum UserLocalePreferenceSource {
  Assigned = 'ASSIGNED',
  Selected = 'SELECTED'
}

export type UserMeetingConfigurationModel = {
  __typename?: 'UserMeetingConfigurationModel';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<MeetingMetadataModel>;
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export type UserModel = {
  __typename?: 'UserModel';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  subId: Scalars['String']['output'];
};

export type UserModelPaginated = {
  __typename?: 'UserModelPaginated';
  data?: Maybe<Array<User>>;
  pageInfo?: Maybe<Pageinfo>;
};

export type UserRole = {
  __typename?: 'UserRole';
  companyRole: CompanyRole;
  companyRoleId: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  user: User;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  id: Scalars['Int']['output'];
  settings?: Maybe<UserSettingsOptions>;
  userId: Scalars['Int']['output'];
};

export type UserSettingsOptions = {
  __typename?: 'UserSettingsOptions';
  CM_lastVisitedModule?: Maybe<Scalars['Boolean']['output']>;
  TR_displayOnboarding?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSettingsOptionsArgs = {
  CM_lastVisitedModule?: InputMaybe<Scalars['Boolean']['input']>;
  TR_displayOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerbalOptionModel = {
  __typename?: 'VerbalOptionModel';
  key: Scalars['Int']['output'];
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type VerbalQuestionModel = {
  __typename?: 'VerbalQuestionModel';
  difficulty: Scalars['Float']['output'];
  options: Array<VerbalOptionModel>;
  subId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type VerbalTestletModel = {
  __typename?: 'VerbalTestletModel';
  isCompleted: Scalars['Boolean']['output'];
  questions: Array<VerbalQuestionModel>;
  remainingQuestions: Scalars['Int']['output'];
  remainingTime: Scalars['Int']['output'];
  /** @deprecated Please use new property `isCompleted` if you wish to know whether the assessment is completed or not! */
  testCandidateStatus: TestStatus;
  text: Scalars['String']['output'];
  timeLimit: Scalars['Int']['output'];
  totalQuestions: Scalars['Int']['output'];
};

export type VerificationSession = {
  __typename?: 'VerificationSession';
  sessionUrl: Scalars['String']['output'];
  status: VerificationStatus;
};

export enum VerificationStatus {
  Abandoned = 'ABANDONED',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  ResubmissionRequested = 'RESUBMISSION_REQUESTED',
  Review = 'REVIEW'
}

export type WrdMerlinBrandedSkillsFeedbackModel = WidgetRenderData & {
  __typename?: 'WRDMerlinBrandedSkillsFeedbackModel';
  candidateFamilyName: Scalars['String']['output'];
  candidateGivenName: Scalars['String']['output'];
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  driveAndDiscoverSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  enjoyTheRideSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  goTogetherSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  jobRoleName: Scalars['String']['output'];
  ownYourCraftSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  projectName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  weCareSoftSkill?: Maybe<WrdMerlinBrandedSkillsFeedbackSoftSkillModel>;
  widgetType: WidgetType;
};

export type WrdMerlinBrandedSkillsFeedbackSoftSkillModel = {
  __typename?: 'WRDMerlinBrandedSkillsFeedbackSoftSkillModel';
  developmentContents: Array<Scalars['String']['output']>;
  internalCandidateContent?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primerValue?: Maybe<Scalars['Float']['output']>;
};

export type WrdStageCandidateSuccessProfileCognitiveSummaryScores = WidgetRenderData & {
  __typename?: 'WRDStageCandidateSuccessProfileCognitiveSummaryScores';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdContextualScore>>;
  cognitiveMode?: Maybe<CognitiveMode>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  scores?: Maybe<Array<WrdSoftSkillScoreWithContent>>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type Widget = {
  __typename?: 'Widget';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reportConfigs?: Maybe<Array<ReportConfig>>;
  screenShotBlob?: Maybe<MonolithBlobModel>;
  screenShotBlobId?: Maybe<Scalars['Int']['output']>;
  type: WidgetType;
  updatedAt: Scalars['Date']['output'];
  widgetOptions?: Maybe<Array<WidgetOption>>;
};

export type WidgetConfig = {
  __typename?: 'WidgetConfig';
  id: Scalars['Int']['output'];
  reportConfig?: Maybe<ReportConfig>;
  reportConfigId: Scalars['Int']['output'];
  settings: Scalars['String']['output'];
  widgetOption?: Maybe<WidgetOption>;
  widgetOptionId: Scalars['Int']['output'];
};

export type WidgetConfigUpdateOneArgs = {
  id: Scalars['Int']['input'];
  settings?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetConfigUpsertOneBatchedWithReportConfigArgs = {
  settings?: InputMaybe<Scalars['String']['input']>;
  widgetOptionId: Scalars['Int']['input'];
};

export type WidgetOption = {
  __typename?: 'WidgetOption';
  defaultValue?: Maybe<Scalars['String']['output']>;
  fieldType: WidgetOptionFieldType;
  id: Scalars['Int']['output'];
  isArchived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
  widget: Widget;
  widgetConfigs?: Maybe<Array<WidgetConfig>>;
  widgetId: Scalars['Int']['output'];
};

export enum WidgetOptionFieldType {
  /** File upload */
  FileUploadField = 'FILE_UPLOAD_FIELD',
  /** Multiple select */
  MultipleSelectField = 'MULTIPLE_SELECT_FIELD',
  /** Short text */
  ShortTextField = 'SHORT_TEXT_FIELD',
  /** Single select */
  SingleSelectField = 'SINGLE_SELECT_FIELD'
}

export type WidgetRender = {
  __typename?: 'WidgetRender';
  newPageBefore: Scalars['Boolean']['output'];
  position: Scalars['Int']['output'];
  type: WidgetType;
  widgetConfigs?: Maybe<Array<WidgetConfig>>;
  widgetRenderData?: Maybe<WidgetRenderData>;
};

export type WidgetRenderData = {
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export enum WidgetType {
  /** Assessment link */
  AssessmentLink = 'ASSESSMENT_LINK',
  /** Assessment links */
  AssessmentLinks = 'ASSESSMENT_LINKS',
  /** Assessment summaries */
  AssessmentSummaries = 'ASSESSMENT_SUMMARIES',
  /** Assessment summary */
  AssessmentSummary = 'ASSESSMENT_SUMMARY',
  BrandedCoverPage = 'BRANDED_COVER_PAGE',
  /** Candidate and company details */
  CandidateCompany = 'CANDIDATE_COMPANY',
  /** (Internal) Contextual score */
  ContextualScore = 'CONTEXTUAL_SCORE',
  MerlinBrandedSkillsFeedback = 'MERLIN_BRANDED_SKILLS_FEEDBACK',
  /** Role level chart */
  RoleLevelChart = 'ROLE_LEVEL_CHART',
  /** Soft skills card */
  SoftSkillCard = 'SOFT_SKILL_CARD',
  /** Soft skills cards */
  SoftSkillCards = 'SOFT_SKILL_CARDS',
  /** Soft skills datasource */
  SoftSkillDataSource = 'SOFT_SKILL_DATA_SOURCE',
  /** Soft skill excluded */
  SoftSkillExcluded = 'SOFT_SKILL_EXCLUDED',
  /** (Internal) Soft skill score */
  SoftSkillScore = 'SOFT_SKILL_SCORE',
  /** (Internal) Soft skill score chart */
  SoftSkillScoreChart = 'SOFT_SKILL_SCORE_CHART',
  /** (Internal) Soft skill score top and bottom */
  SoftSkillScoreTopBottom = 'SOFT_SKILL_SCORE_TOP_BOTTOM',
  /** (Internal) Soft skill score with content */
  SoftSkillScoreWithContent = 'SOFT_SKILL_SCORE_WITH_CONTENT',
  /** Success profile cover page */
  SpCoverPage = 'SP_COVER_PAGE',
  /** Success profile explanation */
  SpExplanation = 'SP_EXPLANATION',
  /** Success profile header and footer */
  SpHeaderFooter = 'SP_HEADER_FOOTER',
  /** Soft skills detail */
  SpSoftSkillDetail = 'SP_SOFT_SKILL_DETAIL',
  /** Soft skills spider chart */
  SpSoftSkillSpider = 'SP_SOFT_SKILL_SPIDER',
  /** Soft skill type explanation */
  SpSoftSkillTypeExplanation = 'SP_SOFT_SKILL_TYPE_EXPLANATION',
  /** Stage results cover page */
  SrCoverPage = 'SR_COVER_PAGE',
  /** Information required for email */
  SrEmailContent = 'SR_EMAIL_CONTENT',
  StageCandidateHeader = 'STAGE_CANDIDATE_HEADER',
  StageCandidateHighlightedScores = 'STAGE_CANDIDATE_HIGHLIGHTED_SCORES',
  /** (Internal) Stage Candidate Soft skill score with content */
  StageCandidateSoftSkillScoreSummaryWithContent = 'STAGE_CANDIDATE_SOFT_SKILL_SCORE_SUMMARY_WITH_CONTENT',
  /** (Internal) Stage Candidate Soft skill score with content */
  StageCandidateSoftSkillScoreWithContent = 'STAGE_CANDIDATE_SOFT_SKILL_SCORE_WITH_CONTENT',
  StageCandidateSuccessProfileCognitiveSummaryScores = 'STAGE_CANDIDATE_SUCCESS_PROFILE_COGNITIVE_SUMMARY_SCORES',
  StageCandidateSuccessProfileScoreFinalScores = 'STAGE_CANDIDATE_SUCCESS_PROFILE_SCORE_FINAL_SCORES',
  StageCandidateSuccessProfileScoreSummaryWithContent = 'STAGE_CANDIDATE_SUCCESS_PROFILE_SCORE_SUMMARY_WITH_CONTENT',
  StageCandidateSuccessProfileScoreWithContent = 'STAGE_CANDIDATE_SUCCESS_PROFILE_SCORE_WITH_CONTENT',
  /** Static */
  Static = 'STATIC',
  /** (Internal) Success profile score */
  SuccessProfileScore = 'SUCCESS_PROFILE_SCORE',
  /** Success profile scores - chart */
  SuccessProfileScoreChart = 'SUCCESS_PROFILE_SCORE_CHART',
  /** Success profile scores - just final scores */
  SuccessProfileScoreFinalScores = 'SUCCESS_PROFILE_SCORE_FINAL_SCORES',
  /** Success profile scores - top and bottom soft skills */
  SuccessProfileScoreTopBottom = 'SUCCESS_PROFILE_SCORE_TOP_BOTTOM',
  /** Success profile scores - with content */
  SuccessProfileScoreWithContent = 'SUCCESS_PROFILE_SCORE_WITH_CONTENT',
  TestingWidget = 'TESTING_WIDGET',
  /** Test summary */
  TestSummary = 'TEST_SUMMARY',
  /** (Internal) trait score */
  TraitScore = 'TRAIT_SCORE',
  /** (Internal) trait score with content */
  TraitScoreWithContent = 'TRAIT_SCORE_WITH_CONTENT',
  /** (Internal) trait score with content and IQ */
  TraitScoreWithIq = 'TRAIT_SCORE_WITH_IQ',
  WidgetExample = 'WIDGET_EXAMPLE'
}

export enum WithDeletedChoice {
  All = 'ALL',
  OnlyArchived = 'ONLY_ARCHIVED',
  OnlyNotArchived = 'ONLY_NOT_ARCHIVED'
}

/** Type of access the user has to a workspace */
export enum WorkspaceAccessType {
  /** User has direct company roles in this workspace */
  DirectMember = 'DIRECT_MEMBER',
  /** User accesses via SZ admin privileges */
  SzAdminAccess = 'SZ_ADMIN_ACCESS'
}

export type WorkspaceModel = {
  __typename?: 'WorkspaceModel';
  accessType: WorkspaceAccessType;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  projectCount?: Maybe<Scalars['Float']['output']>;
};

export type WorkspacesResponse = {
  __typename?: 'WorkspacesResponse';
  count: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  workspaces: Array<WorkspaceModel>;
};

export type WrdAssessmentLink = WidgetRenderData & {
  __typename?: 'WrdAssessmentLink';
  header: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  urlDisplayText: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdAssessmentLinks = WidgetRenderData & {
  __typename?: 'WrdAssessmentLinks';
  assessmentLinks?: Maybe<Array<WrdAssessmentLink>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdAssessmentSummaries = WidgetRenderData & {
  __typename?: 'WrdAssessmentSummaries';
  assessmentSummaries?: Maybe<Array<WrdAssessmentSummary>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdAssessmentSummary = WidgetRenderData & {
  __typename?: 'WrdAssessmentSummary';
  order: Scalars['Int']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  testSummaries: Array<WrdTestSummary>;
  totalTime: Scalars['Int']['output'];
  widgetType: WidgetType;
};

export type WrdBrandedCoverPage = WidgetRenderData & {
  __typename?: 'WrdBrandedCoverPage';
  candidateFamilyName: Scalars['String']['output'];
  candidateGivenName: Scalars['String']['output'];
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['Date']['output']>;
  jobRoleName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdCandidateCompany = WidgetRenderData & {
  __typename?: 'WrdCandidateCompany';
  candidateAvatarUrl?: Maybe<Scalars['String']['output']>;
  candidateInitials: Scalars['String']['output'];
  candidateName: Scalars['String']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdContextualScore = WidgetRenderData & {
  __typename?: 'WrdContextualScore';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdContextualScore>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdIgContent = WidgetRenderData & {
  __typename?: 'WrdIgContent';
  id: Scalars['Int']['output'];
  interviewGuideId: Scalars['Int']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdIgInterviewGuideCategories = WidgetRenderData & {
  __typename?: 'WrdIgInterviewGuideCategories';
  categories?: Maybe<Array<Maybe<WrdIgInterviewGuideCategory>>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdIgInterviewGuideCategory = WidgetRenderData & {
  __typename?: 'WrdIgInterviewGuideCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdIgStep = WidgetRenderData & {
  __typename?: 'WrdIgStep';
  action?: Maybe<Scalars['String']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  interviewGuideId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  staticQuestionName?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdInterviewGuide = WidgetRenderData & {
  __typename?: 'WrdInterviewGuide';
  contents?: Maybe<Array<Maybe<WrdIgContent>>>;
  id: Scalars['Int']['output'];
  steps?: Maybe<Array<Maybe<WrdIgStep>>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdInterviewGuideFlow = WidgetRenderData & {
  __typename?: 'WrdInterviewGuideFlow';
  contents?: Maybe<Array<Maybe<WrdIgContent>>>;
  id: Scalars['Int']['output'];
  steps?: Maybe<Array<Maybe<WrdIgStep>>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdInterviewGuideHowToUse = WidgetRenderData & {
  __typename?: 'WrdInterviewGuideHowToUse';
  contents?: Maybe<Array<Maybe<WrdIgContent>>>;
  id: Scalars['Int']['output'];
  steps?: Maybe<Array<Maybe<WrdIgStep>>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdRoleLevelChart = WidgetRenderData & {
  __typename?: 'WrdRoleLevelChart';
  contentRoleLevelsToDisplay?: Maybe<Array<ContentRoleLevel>>;
  roleLevel: ContentRoleLevel;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillCard = WidgetRenderData & {
  __typename?: 'WrdSoftSkillCard';
  order: Scalars['Int']['output'];
  softSkillDataSources?: Maybe<Array<WrdSoftSkillDataSource>>;
  softSkillId: Scalars['Int']['output'];
  softSkillName: Scalars['String']['output'];
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
  weightRatio: Scalars['Float']['output'];
  widgetType: WidgetType;
};

export type WrdSoftSkillCards = WidgetRenderData & {
  __typename?: 'WrdSoftSkillCards';
  softSkillCards?: Maybe<Array<WrdSoftSkillCard>>;
  softSkillsExcluded?: Maybe<Array<WrdSoftSkillExcluded>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillDataSource = WidgetRenderData & {
  __typename?: 'WrdSoftSkillDataSource';
  dataSourceType: DataSourceType;
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillExcluded = WidgetRenderData & {
  __typename?: 'WrdSoftSkillExcluded';
  category: Scalars['String']['output'];
  companyId: Scalars['Int']['output'];
  softSkillId: Scalars['Int']['output'];
  softSkillName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSoftSkillScore = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScore';
  barSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<WrdTraitScore>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSoftSkillScoreChart = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScoreChart';
  barSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<WrdTraitScore>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSoftSkillScoreTopBottom = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScoreTopBottom';
  barSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSoftSkillScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdSoftSkillScoreWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  description?: Maybe<Scalars['String']['output']>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  feedback?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  headerText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  iqTrait?: Maybe<WrdTraitScoreWithIq>;
  isLowestScoring?: Maybe<Scalars['Boolean']['output']>;
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  softSkillContentHeaderType?: Maybe<SoftSkillContentHeaderType>;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  softSkillType?: Maybe<SoftSkillType>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  widgetType: WidgetType;
};

export type WrdSpCoverPage = WidgetRenderData & {
  __typename?: 'WrdSpCoverPage';
  companyLogo?: Maybe<Scalars['String']['output']>;
  jobRoleName: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  widgetType: WidgetType;
};

export type WrdSpExplanation = WidgetRenderData & {
  __typename?: 'WrdSpExplanation';
  softSkillExplanations?: Maybe<Array<WrdSpSoftSkillDetail>>;
  softSkillTypeExplanations?: Maybe<Array<WrdSpSoftSkillTypeExplanation>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSpHeaderFooter = WidgetRenderData & {
  __typename?: 'WrdSpHeaderFooter';
  companyLogo?: Maybe<Scalars['String']['output']>;
  jobRoleName: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  widgetType: WidgetType;
};

export type WrdSpSoftSkillDetail = WidgetRenderData & {
  __typename?: 'WrdSpSoftSkillDetail';
  description: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  shortDescription: Scalars['String']['output'];
  softSkillId: Scalars['Int']['output'];
  softSkillName: Scalars['String']['output'];
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
  weightRatio: Scalars['Float']['output'];
  widgetType: WidgetType;
};

export type WrdSpSoftSkillSpider = WidgetRenderData & {
  __typename?: 'WrdSpSoftSkillSpider';
  projectName: Scalars['String']['output'];
  spSoftSkillDetails?: Maybe<Array<WrdSpSoftSkillDetail>>;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSpSoftSkillTypeExplanation = WidgetRenderData & {
  __typename?: 'WrdSpSoftSkillTypeExplanation';
  description: Scalars['String']['output'];
  softSkillType: SoftSkillType;
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSrCoverPage = WidgetRenderData & {
  __typename?: 'WrdSrCoverPage';
  candidateAvatarUrl?: Maybe<Scalars['String']['output']>;
  candidateInitials: Scalars['String']['output'];
  candidateName: Scalars['String']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  jobRoleName: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  stageName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  widgetType: WidgetType;
};

export type WrdSrEmailContent = WidgetRenderData & {
  __typename?: 'WrdSrEmailContent';
  candidateAvatarUrl?: Maybe<Scalars['String']['output']>;
  candidateInitials: Scalars['String']['output'];
  candidateName: Scalars['String']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  gradeColor: Scalars['String']['output'];
  gradeColorRGBA: Scalars['String']['output'];
  jobRoleName: Scalars['String']['output'];
  projectId: Scalars['Int']['output'];
  projectName: Scalars['String']['output'];
  score: Scalars['String']['output'];
  stageName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateHeader = WidgetRenderData & {
  __typename?: 'WrdStageCandidateHeader';
  candidateAvatarUrl?: Maybe<Scalars['String']['output']>;
  candidateInitials: Scalars['String']['output'];
  candidateName: Scalars['String']['output'];
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateHighlightedScores = WidgetRenderData & {
  __typename?: 'WrdStageCandidateHighlightedScores';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdContextualScore>>;
  content?: Maybe<Scalars['String']['output']>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdStageCandidateSoftSkillScoreSummaryWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSoftSkillScoreSummaryWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  description?: Maybe<Scalars['String']['output']>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  feedback?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  headerText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  iqTrait?: Maybe<WrdTraitScoreWithIq>;
  isLowestScoring?: Maybe<Scalars['Boolean']['output']>;
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  softSkillContentHeaderType?: Maybe<SoftSkillContentHeaderType>;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  softSkillType?: Maybe<SoftSkillType>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateSoftSkillScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSoftSkillScoreWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Array<WrdTraitScoreWithContent>>;
  description?: Maybe<Scalars['String']['output']>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  feedback?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  headerText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  iqTrait?: Maybe<WrdTraitScoreWithIq>;
  isLowestScoring?: Maybe<Scalars['Boolean']['output']>;
  measurementConstructType?: Maybe<MeasurementConstructType>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  softSkillContentHeaderType?: Maybe<SoftSkillContentHeaderType>;
  softSkillImageType?: Maybe<SoftSkillImageType>;
  softSkillType?: Maybe<SoftSkillType>;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
  widgetType: WidgetType;
};

export type WrdStageCandidateSuccessProfileScoreFinalScores = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSuccessProfileScoreFinalScores';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdSoftSkillScoreChart>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int']['output'];
  manualScores?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdStageCandidateSuccessProfileScoreSummaryWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSuccessProfileScoreSummaryWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdStageCandidateSoftSkillScoreSummaryWithContent>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdStageCandidateSuccessProfileScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdStageCandidateSuccessProfileScoreWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdStageCandidateSoftSkillScoreWithContent>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdStatic = WidgetRenderData & {
  __typename?: 'WrdStatic';
  subId?: Maybe<Scalars['String']['output']>;
  widgetType: WidgetType;
};

export type WrdSuccessProfileScore = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScore';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdSoftSkillScore>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreChart = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreChart';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdSoftSkillScoreChart>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreFinalScores = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreFinalScores';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdSoftSkillScoreChart>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  highlightedScores?: Maybe<Array<WrdSoftSkillScore>>;
  id: Scalars['Int']['output'];
  manualScores?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreTopBottom = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreTopBottom';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdSoftSkillScoreTopBottom>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdSuccessProfileScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdSuccessProfileScoreWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdSoftSkillScoreWithContent>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdTestSummary = WidgetRenderData & {
  __typename?: 'WrdTestSummary';
  name: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  time: Scalars['Int']['output'];
  type: TestType;
  widgetType: WidgetType;
};

export type WrdTraitScore = WidgetRenderData & {
  __typename?: 'WrdTraitScore';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdContextualScore>>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdTraitScoreWithContent = WidgetRenderData & {
  __typename?: 'WrdTraitScoreWithContent';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdContextualScore>>;
  content?: Maybe<Scalars['String']['output']>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdTraitScoreWithIq = WidgetRenderData & {
  __typename?: 'WrdTraitScoreWithIq';
  barSize?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Array<WrdContextualScore>>;
  content?: Maybe<Scalars['String']['output']>;
  displayClassification: Scalars['String']['output'];
  displayScoreType?: Maybe<DisplayScoreType>;
  id: Scalars['Int']['output'];
  iqFeedback?: Maybe<Scalars['String']['output']>;
  iqFooterType: IqFooterType;
  iqHints?: Maybe<Array<Scalars['String']['output']>>;
  iqMainQuestion?: Maybe<Scalars['String']['output']>;
  iqReasonForQuestion?: Maybe<Scalars['String']['output']>;
  iqSubQuestions?: Maybe<Array<Scalars['String']['output']>>;
  iqSummary?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  positionType?: Maybe<ContextualScorePositionType>;
  score: ScoreModel;
  subId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type WrdWidgetExample = WidgetRenderData & {
  __typename?: 'WrdWidgetExample';
  name: Scalars['String']['output'];
  subId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  testType: TestType;
  time: Scalars['Int']['output'];
  widgetType: WidgetType;
};

export type WrdWidgetTesting = WidgetRenderData & {
  __typename?: 'WrdWidgetTesting';
  subId?: Maybe<Scalars['String']['output']>;
  test: Scalars['String']['output'];
  widgetType: WidgetType;
};

export type CompanyReasonableAdjustmentsOptionFragment = { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null };

export type CompanyFragment = { __typename?: 'Company', id: number, name: string, logoUrl?: string | null, usesBehaviouralLabel: boolean, reasonableAdjustmentsOption: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null } };

export type CompanyRoleFragment = { __typename?: 'CompanyRole', companyId: number, companyUuid: string, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null } };

export type DeiStageActionFragment = { __typename?: 'DeiStageActionModel', completedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodivergenceIdentifyField: boolean, hasDisabilityIdentifyField: boolean, hasFreeSchoolMealsField: boolean, hasNeurodiversityField: boolean, hasDisabilityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean } };

export type DeiFieldsFragment = { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodivergenceIdentifyField: boolean, hasDisabilityIdentifyField: boolean, hasFreeSchoolMealsField: boolean, hasNeurodiversityField: boolean, hasDisabilityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean };

export type DeiStageActionCandidateFragment = { __typename?: 'DeiStageActionCandidateModel', createdAt: any, updatedAt: any, status: DeiStageActionCandidateStatus, hasActiveConsent: boolean, stageAction: { __typename?: 'DeiStageActionModel', completedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodivergenceIdentifyField: boolean, hasDisabilityIdentifyField: boolean, hasFreeSchoolMealsField: boolean, hasNeurodiversityField: boolean, hasDisabilityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean } }, stageCandidate: { __typename?: 'SmStageCandidateModel', id: number, companyId?: number | null, doneFor: number, doneBy: number, lastDateOfCandidateAction?: any | null, status: StageCandidateStatus, stage: { __typename?: 'SmStageModel', id: number, name: string, projectId: number } }, responses: { __typename?: 'DeiStageActionCandidateResponsesModel', ageRange?: DeiAgeRange | null, ethnicity?: DeiEthnicity | null, genderIdentity?: DeiGender | null, hasTransgenderIdentity?: DeiYesNo | null, neurodivergenceIdentify?: Array<DeiNeurodivergenceIdentify> | null, neurodivergenceIdentifyOther?: string | null, disabilityIdentify?: Array<DeiDisabilityIdentify> | null, disabilityIdentifyOther?: string | null, freeSchoolMeals?: DeiFreeSchoolMeals | null, hasDisability?: DeiYesNo | null, hasNeurodiversity?: DeiYesNo | null, sexualOrientation?: DeiSexualOrientation | null, religiousBelief?: DeiReligiousBelief | null } };

export type DeiStageActionResponsesFragment = { __typename?: 'DeiStageActionCandidateResponsesModel', ageRange?: DeiAgeRange | null, ethnicity?: DeiEthnicity | null, genderIdentity?: DeiGender | null, hasTransgenderIdentity?: DeiYesNo | null, neurodivergenceIdentify?: Array<DeiNeurodivergenceIdentify> | null, neurodivergenceIdentifyOther?: string | null, disabilityIdentify?: Array<DeiDisabilityIdentify> | null, disabilityIdentifyOther?: string | null, freeSchoolMeals?: DeiFreeSchoolMeals | null, hasDisability?: DeiYesNo | null, hasNeurodiversity?: DeiYesNo | null, sexualOrientation?: DeiSexualOrientation | null, religiousBelief?: DeiReligiousBelief | null };

export type ProjectFragment = { __typename?: 'Project', id: number, name: string, companyId?: number | null, moduleType: ProjectModuleType, idVerificationEnabled: boolean };

export type RespondantFormFragment = { __typename?: 'RespondantForm', isComplete: boolean, submittedFormLogId?: number | null, formType: FormType, formOwnerId: number, associatedId: number, formId: number, respondantFieldWithAnswers: Array<{ __typename?: 'RespondantFieldWithAnswers', answer?: string | null, displayOrder: number, isOptional: boolean, selectOptionAnswerIsFreeText?: boolean | null, field?:
      | { __typename?: 'CompanyEmployeeSelectField', question?: string | null, id: number, isArchived: boolean, name: string, hint?: string | null, fieldType: FieldType, txtData?: string | null, fieldOwnerName?: string | null, fieldOwnerId?: number | null, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
      | { __typename?: 'DateField', question?: string | null, id: number, isArchived: boolean, name: string, hint?: string | null, fieldType: FieldType, txtData?: string | null, fieldOwnerName?: string | null, fieldOwnerId?: number | null, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
      | { __typename?: 'LongTextField', question?: string | null, id: number, isArchived: boolean, name: string, hint?: string | null, fieldType: FieldType, txtData?: string | null, fieldOwnerName?: string | null, fieldOwnerId?: number | null, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
      | { __typename?: 'MultiSelectField', question?: string | null, id: number, isArchived: boolean, name: string, hint?: string | null, fieldType: FieldType, txtData?: string | null, fieldOwnerName?: string | null, fieldOwnerId?: number | null, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
      | { __typename?: 'ShortTextField', question?: string | null, id: number, isArchived: boolean, name: string, hint?: string | null, fieldType: FieldType, txtData?: string | null, fieldOwnerName?: string | null, fieldOwnerId?: number | null, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
      | { __typename?: 'SingleSelectField', question?: string | null, id: number, isArchived: boolean, name: string, hint?: string | null, fieldType: FieldType, txtData?: string | null, fieldOwnerName?: string | null, fieldOwnerId?: number | null, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
     | null }> };

export type ResultFragment = { __typename?: 'ResultModel', id: number, label?: string | null, measurementType: ResultMeasurementType, measurementId: number, scoreType: ResultScoreType, projectId?: number | null, score:
    | { __typename?: 'ExternalAssessmentCodeScoreModel' }
    | { __typename?: 'ExternalAssessmentFinalScoreModel' }
    | { __typename?: 'ExternalAssessmentMcqScoreModel' }
    | { __typename?: 'IgBehaviourResultScoreModel' }
    | { __typename?: 'IgCustomResultScoreModel' }
    | { __typename?: 'IgFinalDecisionResultScoreModel' }
    | { __typename?: 'MotivationResultScoreModel' }
    | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
    | { __typename?: 'StatisticalResultScoreModel' }
    | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
    | { __typename?: 'TrCustomResultScoreModel' }
   };

export type RoleFragment = { __typename?: 'Role', id: number, name: string, description?: string | null };

export type RssAssessmentCandidateFragment = { __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType }, stageCandidate?: { __typename?: 'SmStageCandidateModel', id: number, rssAssessmentCandidates?: Array<{ __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType } }> | null } | null };

export type SoftSkillSelfAssessmentGradeBandFragment = { __typename?: 'SoftSkillSelfAssessmentGradeBandModel', displayText: string, position: number, softSkillProficiency: SoftSkillSelfAssessmentProficiencyLevel };

export type TechnicalSkillSelfAssessmentGradeBandFragment = { __typename?: 'TechnicalSkillSelfAssessmentGradeBandModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel, position: number, displayText: string };

type SoftSkill_BasicBroadSoftSkill_Fragment = { __typename?: 'BasicBroadSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

type SoftSkill_BasicFocusedSoftSkill_Fragment = { __typename?: 'BasicFocusedSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

type SoftSkill_BroadSoftSkill_Fragment = { __typename?: 'BroadSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

type SoftSkill_FocusedSoftSkill_Fragment = { __typename?: 'FocusedSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

export type SoftSkillFragment =
  | SoftSkill_BasicBroadSoftSkill_Fragment
  | SoftSkill_BasicFocusedSoftSkill_Fragment
  | SoftSkill_BroadSoftSkill_Fragment
  | SoftSkill_FocusedSoftSkill_Fragment
;

type SoftSkillWithDescription_BasicBroadSoftSkill_Fragment = { __typename?: 'BasicBroadSoftSkill', id: number, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

type SoftSkillWithDescription_BasicFocusedSoftSkill_Fragment = { __typename?: 'BasicFocusedSoftSkill', id: number, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

type SoftSkillWithDescription_BroadSoftSkill_Fragment = { __typename?: 'BroadSoftSkill', id: number, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

type SoftSkillWithDescription_FocusedSoftSkill_Fragment = { __typename?: 'FocusedSoftSkill', id: number, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
      | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
      | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
      | { __typename?: 'BroadSoftSkill', id: number, name: string }
      | { __typename?: 'FocusedSoftSkill', id: number, name: string }
     | null }> | null };

export type SoftSkillWithDescriptionFragment =
  | SoftSkillWithDescription_BasicBroadSoftSkill_Fragment
  | SoftSkillWithDescription_BasicFocusedSoftSkill_Fragment
  | SoftSkillWithDescription_BroadSoftSkill_Fragment
  | SoftSkillWithDescription_FocusedSoftSkill_Fragment
;

type SoftSkillWithoutCompany_BasicBroadSoftSkill_Fragment = { __typename?: 'BasicBroadSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null };

type SoftSkillWithoutCompany_BasicFocusedSoftSkill_Fragment = { __typename?: 'BasicFocusedSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null };

type SoftSkillWithoutCompany_BroadSoftSkill_Fragment = { __typename?: 'BroadSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null };

type SoftSkillWithoutCompany_FocusedSoftSkill_Fragment = { __typename?: 'FocusedSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null };

export type SoftSkillWithoutCompanyFragment =
  | SoftSkillWithoutCompany_BasicBroadSoftSkill_Fragment
  | SoftSkillWithoutCompany_BasicFocusedSoftSkill_Fragment
  | SoftSkillWithoutCompany_BroadSoftSkill_Fragment
  | SoftSkillWithoutCompany_FocusedSoftSkill_Fragment
;

export type SoftSkillTraitFragment = { __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
    | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
    | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
    | { __typename?: 'BroadSoftSkill', id: number, name: string }
    | { __typename?: 'FocusedSoftSkill', id: number, name: string }
   | null };

export type StageFragment = { __typename?: 'SmStageModel', id: number, kind: AssessmentStageKind, name: string, status: StageStatus, endTime?: any | null, hasAdjustmentQuestionnaire: boolean };

export type StageCandidateFragment = { __typename?: 'SmStageCandidateModel', id: number, status: StageCandidateStatus, hasCompletedAdjustmentQuestionnaire: boolean };

export type SmStageCandidateModelFragment = { __typename?: 'SmStageCandidateModel', id: number, companyId?: number | null, doneFor: number, doneBy: number, lastDateOfCandidateAction?: any | null, status: StageCandidateStatus, stage: { __typename?: 'SmStageModel', id: number, name: string, projectId: number } };

export type TechnicalSkillFragment = { __typename?: 'TechnicalSkill', id: number, name: string };

export type UserFragment = { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, language: Language, isInternal: boolean, identityVerificationStatus: VerificationStatus, identityVerifiedAt?: any | null, identityVerificationResubmissionReason?: string | null, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, companyUuid: string, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null } } }> };

export type UserFullNameFragment = { __typename?: 'User', id: number, firstName: string, lastName: string, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale } };

export type UserRoleFragment = { __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, companyUuid: string, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null } } };

export type InitiateAiInterviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InitiateAiInterviewMutation = { __typename?: 'Mutation', initiateAiInterview: { __typename?: 'AiInterviewAssessmentStageActionCandidate', status: AiInterviewAssessmentStageActionCandidateStatus, conference?: { __typename?: 'Conference', id: string } | null } };

export type JoinConferenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JoinConferenceInput;
}>;


export type JoinConferenceMutation = { __typename?: 'Mutation', joinConference: { __typename?: 'ConferenceToken', token: string } };

export type FinishAiInterviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FinishAiInterviewMutation = { __typename?: 'Mutation', finishAiInterview: { __typename?: 'AiInterviewAssessmentStageActionCandidate', id: string } };

export type SubmitAiInterviewFeedbackMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  feedback: Scalars['JSONObject']['input'];
}>;


export type SubmitAiInterviewFeedbackMutation = { __typename?: 'Mutation', submitAiInterviewFeedback: { __typename?: 'AiInterviewAssessmentStageActionCandidate', id: string } };

export type JoinDemoConferenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: JoinConferenceInput;
}>;


export type JoinDemoConferenceMutation = { __typename?: 'Mutation', joinDemoConference: { __typename?: 'DemoConferenceToken', token: string, remainingDemos: number } };

export type AiInterviewConsentGiveMutationVariables = Exact<{
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID']['input'];
}>;


export type AiInterviewConsentGiveMutation = { __typename?: 'Mutation', AiInterviewConsentGive: { __typename?: 'AiInterviewConsent', isRequired: boolean, status: AiInterviewConsentStatus, consentText: string } };

export type AiInterviewConsentDeclineMutationVariables = Exact<{
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID']['input'];
}>;


export type AiInterviewConsentDeclineMutation = { __typename?: 'Mutation', AiInterviewConsentDecline: { __typename?: 'AiInterviewConsent', isRequired: boolean, status: AiInterviewConsentStatus, consentText: string } };

export type StageCandidatePledgeAnticheatingMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type StageCandidatePledgeAnticheatingMutation = { __typename?: 'Mutation', StageCandidatePledgeAnticheating: boolean };

export type ExchangeAuthCodeMutationVariables = Exact<{
  authCode: Scalars['String']['input'];
  clientType?: InputMaybe<ClientType>;
}>;


export type ExchangeAuthCodeMutation = { __typename?: 'Mutation', ExchangeAuthCode: { __typename?: 'AuthenticationResult', accessToken: string, refreshToken: string } };

export type RequestTokenRefreshMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  clientType?: InputMaybe<ClientType>;
}>;


export type RequestTokenRefreshMutation = { __typename?: 'Mutation', requestTokenRefresh: { __typename?: 'AuthenticationResult', accessToken: string, refreshToken: string } };

export type DeauthenticateMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type DeauthenticateMutation = { __typename?: 'Mutation', deauthenticate: boolean };

export type CreateBrowserSwitchEventMutationVariables = Exact<{
  assessmentSubId: Scalars['String']['input'];
  assessmentTimeSeconds?: InputMaybe<Scalars['Int']['input']>;
  type: AssessmentBrowserSwitchCandidateTrackingEvent;
}>;


export type CreateBrowserSwitchEventMutation = { __typename?: 'Mutation', CreateAssessmentBrowserSwitchCandidateTrackingEvent: boolean };

export type CandidateAcceptIndirectInvitationMutationVariables = Exact<{
  stageId: Scalars['Int']['input'];
  hiringManagers?: InputMaybe<Array<HiringManager> | HiringManager>;
}>;


export type CandidateAcceptIndirectInvitationMutation = { __typename?: 'Mutation', CandidateAcceptIndirectInvitation: { __typename?: 'CandidateAcceptIndirectInvitationResult', stageId: string, role: { __typename?: 'MyRole', id: string } } };

export type StartCoderbyteAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StartCoderbyteAssessmentMutation = { __typename?: 'Mutation', startCoderbyteAssessment: { __typename?: 'CoderbyteAssessmentStageActionCandidateStart', inviteUrl: string } };

export type ContentStageCandidateMarkCompleteMutationVariables = Exact<{
  contentStageCandidateId: Scalars['Int']['input'];
}>;


export type ContentStageCandidateMarkCompleteMutation = { __typename?: 'Mutation', ContentStageCandidateMarkComplete: { __typename?: 'MyRoleContentStage', id: string, contentStageCandidateId: number, status: ContentStageCandidateStatus } };

export type StartEnglishProficiencyAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StartEnglishProficiencyAssessmentMutation = { __typename?: 'Mutation', startEnglishProficiencyAssessment: { __typename?: 'EnglishProficiencyAssessmentStageActionCandidate', id: string, status: EnglishProficiencyAssessmentStageActionCandidateStatus, assessmentId?: string | null, startedAt?: any | null, expiresAt?: any | null } };

export type SaveEnglishProficiencyResponseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  questionIndex: Scalars['Int']['input'];
  selectedAnswerIndex?: InputMaybe<Scalars['Int']['input']>;
  blankAnswers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SaveEnglishProficiencyResponseMutation = { __typename?: 'Mutation', saveEnglishProficiencyResponse: { __typename?: 'EnglishProficiencySavedResponse', saved: boolean, remainingSeconds: number } };

export type SubmitEnglishProficiencyAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SubmitEnglishProficiencyAssessmentMutation = { __typename?: 'Mutation', submitEnglishProficiencyAssessment: boolean };

export type InitiateVerificationMutationVariables = Exact<{ [key: string]: never; }>;


export type InitiateVerificationMutation = { __typename?: 'Mutation', initiateVerification: { __typename?: 'VerificationSession', status: VerificationStatus, sessionUrl: string } };

export type StartAiInterviewIntegrityMonitoringSessionMutationVariables = Exact<{
  aiInterviewAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
}>;


export type StartAiInterviewIntegrityMonitoringSessionMutation = { __typename?: 'Mutation', startAiInterviewIntegrityMonitoringSession: { __typename?: 'IntegrityMonitoringSession', id: string, startedAt: any } };

export type StartCognitiveTestIntegrityMonitoringSessionMutationVariables = Exact<{
  cognitiveTestAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
}>;


export type StartCognitiveTestIntegrityMonitoringSessionMutation = { __typename?: 'Mutation', startCognitiveTestIntegrityMonitoringSession: { __typename?: 'IntegrityMonitoringSession', id: string, startedAt: any } };

export type StartPersonalityTestIntegrityMonitoringSessionMutationVariables = Exact<{
  personalityTestAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
}>;


export type StartPersonalityTestIntegrityMonitoringSessionMutation = { __typename?: 'Mutation', startPersonalityTestIntegrityMonitoringSession: { __typename?: 'IntegrityMonitoringSession', id: string, startedAt: any } };

export type ReportIntegrityEventsMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  events: Array<IntegrityEventInput> | IntegrityEventInput;
}>;


export type ReportIntegrityEventsMutation = { __typename?: 'Mutation', reportIntegrityEvents: boolean };

export type EndIntegrityMonitoringSessionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
}>;


export type EndIntegrityMonitoringSessionMutation = { __typename?: 'Mutation', endIntegrityMonitoringSession: { __typename?: 'IntegrityMonitoringSession', id: string, endedAt?: any | null, flagsCount: number } };

export type StartEnglishProficiencyIntegrityMonitoringSessionMutationVariables = Exact<{
  englishProficiencyAssessmentStageActionCandidateId: Scalars['ID']['input'];
  input: StartIntegrityMonitoringSessionInput;
}>;


export type StartEnglishProficiencyIntegrityMonitoringSessionMutation = { __typename?: 'Mutation', startEnglishProficiencyIntegrityMonitoringSession: { __typename?: 'IntegrityMonitoringSession', id: string, startedAt: any } };

export type QCalcGetNextQuestionMutationVariables = Exact<{
  answers?: InputMaybe<Array<AssessmentDataAnswerGqlModel> | AssessmentDataAnswerGqlModel>;
  assessmentSubId: Scalars['String']['input'];
  nQuestions: Scalars['Int']['input'];
}>;


export type QCalcGetNextQuestionMutation = { __typename?: 'Mutation', QCalcGetNextQuestion:
    | { __typename?: 'InductiveItemModel', isCompleted: boolean, remainingQuestions: number, remainingTime: number, testCandidateStatus: TestStatus, totalQuestions: number, question?: { __typename?: 'InductiveQuestionModel', difficulty: number, imageUrls: Array<string | null>, subId: string, text: string, timeLimit: number, options: Array<{ __typename?: 'InductiveOptionModel', imageUrl: string, key: number, subId: string }> } | null }
    | { __typename?: 'NumericalTestletModel', isCompleted: boolean, imageUrl: string, remainingQuestions: number, remainingTime: number, testCandidateStatus: TestStatus, timeLimit: number, totalQuestions: number, questions: Array<{ __typename?: 'NumericalQuestionModel', difficulty: number, subId: string, text: string, options: Array<{ __typename?: 'NumericalOptionModel', key: number, subId: string, text: string }> }> }
    | { __typename?: 'PersonalityItemModel', isCompleted: boolean, remainingQuestions: number, totalQuestions: number, testCandidateStatus: TestStatus, questions: Array<{ __typename?: 'PersonalityQuestionModel', difficulty: number, orientation: QuestionOrientation, subId: string, text: string, options: Array<{ __typename?: 'PersonalityOptionModel', key: number, subId: string, text: string, value: number }> }> }
    | { __typename?: 'TrItemModel', isCompleted: boolean, remainingQuestions: number, totalQuestions: number, testCandidateStatus: TestStatus, questions: Array<{ __typename?: 'TrQuestionModel', orientation: QuestionOrientation, subId: string, text: string, options: Array<{ __typename?: 'TrOptionModel', key: number, subId: string, text: string }> }> }
    | { __typename?: 'VerbalTestletModel', isCompleted: boolean, text: string, remainingQuestions: number, remainingTime: number, testCandidateStatus: TestStatus, timeLimit: number, totalQuestions: number, questions: Array<{ __typename?: 'VerbalQuestionModel', difficulty: number, subId: string, text: string, options: Array<{ __typename?: 'VerbalOptionModel', key: number, subId: string, text: string }> }> }
   };

export type QuestionnaireSubmitResponsesMutationVariables = Exact<{
  shortlistStageCandidateId: Scalars['Int']['input'];
  responses: Array<QuestionnaireItemResponseGqlInput> | QuestionnaireItemResponseGqlInput;
}>;


export type QuestionnaireSubmitResponsesMutation = { __typename?: 'Mutation', QuestionnaireSubmitResponses: { __typename?: 'MyRoleQuestionnaireStage', id: string, shortlistStageCandidateId: number, status: QuestionnaireCandidateStatus, items: Array<{ __typename?: 'MyRoleQuestionnaireItem', id: string, answer?: boolean | null }> } };

export type StageCandidateSubmitAdjustmentQuestionnaireMutationVariables = Exact<{
  responses: Array<AdjustmentQuestionnaireResponse> | AdjustmentQuestionnaireResponse;
  stageCandidateId: Scalars['Int']['input'];
}>;


export type StageCandidateSubmitAdjustmentQuestionnaireMutation = { __typename?: 'Mutation', StageCandidateSubmitAdjustmentQuestionnaire: { __typename?: 'SmStageCandidateModel', hasCompletedAdjustmentQuestionnaire: boolean, shouldContactUs: boolean } };

export type RespondantFormUpdateMutationVariables = Exact<{
  associatedId: Scalars['Int']['input'];
  formOwnerId: Scalars['Int']['input'];
  formType: FormType;
  answers?: InputMaybe<Array<UpdateRespondantFormAnswerArgs> | UpdateRespondantFormAnswerArgs>;
}>;


export type RespondantFormUpdateMutation = { __typename?: 'Mutation', respondantForm?: { __typename?: 'RespondantForm', isComplete: boolean, submittedFormLogId?: number | null, formType: FormType, formOwnerId: number, associatedId: number, formId: number, respondantFieldWithAnswers: Array<{ __typename?: 'RespondantFieldWithAnswers', displayOrder: number, isOptional: boolean, answer?: string | null, selectOptionAnswerIsFreeText?: boolean | null, field?:
        | { __typename?: 'CompanyEmployeeSelectField', dynamicSelectOptions?: string | null, id: number, question?: string | null, hint?: string | null, isArchived: boolean, fieldType: FieldType, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
        | { __typename?: 'DateField', id: number, question?: string | null, hint?: string | null, isArchived: boolean, fieldType: FieldType, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
        | { __typename?: 'LongTextField', id: number, question?: string | null, hint?: string | null, isArchived: boolean, fieldType: FieldType, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
        | { __typename?: 'MultiSelectField', selectOptions?: string | null, id: number, question?: string | null, hint?: string | null, isArchived: boolean, fieldType: FieldType, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
        | { __typename?: 'ShortTextField', id: number, question?: string | null, hint?: string | null, isArchived: boolean, fieldType: FieldType, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
        | { __typename?: 'SingleSelectField', selectOptions?: string | null, id: number, question?: string | null, hint?: string | null, isArchived: boolean, fieldType: FieldType, settings?: { __typename?: 'FieldSettingsModel', allowFreeText?: boolean | null, searchable?: boolean | null } | null }
       | null }> } | null };

export type ResultCreateManySoftSkillsProfileFromScMutationVariables = Exact<{
  args: Array<ResultSoftSkillProfileCreateOneFromSc> | ResultSoftSkillProfileCreateOneFromSc;
}>;


export type ResultCreateManySoftSkillsProfileFromScMutation = { __typename?: 'Mutation', ResultCreateManySoftSkillsProfileFromSc: Array<{ __typename?: 'ResultModel', id: number, label?: string | null, measurementType: ResultMeasurementType, measurementId: number, scoreType: ResultScoreType, projectId?: number | null, score:
      | { __typename?: 'ExternalAssessmentCodeScoreModel' }
      | { __typename?: 'ExternalAssessmentFinalScoreModel' }
      | { __typename?: 'ExternalAssessmentMcqScoreModel' }
      | { __typename?: 'IgBehaviourResultScoreModel' }
      | { __typename?: 'IgCustomResultScoreModel' }
      | { __typename?: 'IgFinalDecisionResultScoreModel' }
      | { __typename?: 'MotivationResultScoreModel' }
      | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'StatisticalResultScoreModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'TrCustomResultScoreModel' }
     }> };

export type ResultCreateManyTechnicalSkillsProfileFromScMutationVariables = Exact<{
  args: Array<ResultTechnicalSkillProfileCreateOneFromSc> | ResultTechnicalSkillProfileCreateOneFromSc;
}>;


export type ResultCreateManyTechnicalSkillsProfileFromScMutation = { __typename?: 'Mutation', ResultCreateManyTechnicalSkillsProfileFromSc: Array<{ __typename?: 'ResultModel', id: number, label?: string | null, measurementType: ResultMeasurementType, measurementId: number, scoreType: ResultScoreType, projectId?: number | null, score:
      | { __typename?: 'ExternalAssessmentCodeScoreModel' }
      | { __typename?: 'ExternalAssessmentFinalScoreModel' }
      | { __typename?: 'ExternalAssessmentMcqScoreModel' }
      | { __typename?: 'IgBehaviourResultScoreModel' }
      | { __typename?: 'IgCustomResultScoreModel' }
      | { __typename?: 'IgFinalDecisionResultScoreModel' }
      | { __typename?: 'MotivationResultScoreModel' }
      | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'StatisticalResultScoreModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'TrCustomResultScoreModel' }
     }> };

export type RssAssessmentCandidateSubmitOneMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RssAssessmentCandidateSubmitOneMutation = { __typename?: 'Mutation', RssAssessmentCandidateSubmitOne: { __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType }, stageCandidate?: { __typename?: 'SmStageCandidateModel', id: number, rssAssessmentCandidates?: Array<{ __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType } }> | null } | null } };

export type ResultCreateOnePspSoftSkillMutationVariables = Exact<{
  score: ISoftSkillSelfAssessmentScoreModel;
  id: Scalars['Int']['input'];
}>;


export type ResultCreateOnePspSoftSkillMutation = { __typename?: 'Mutation', ResultCreateOnePspSoftSkill: { __typename?: 'ResultModel', measurementId: number, updatedAt: any, score:
      | { __typename?: 'ExternalAssessmentCodeScoreModel' }
      | { __typename?: 'ExternalAssessmentFinalScoreModel' }
      | { __typename?: 'ExternalAssessmentMcqScoreModel' }
      | { __typename?: 'IgBehaviourResultScoreModel' }
      | { __typename?: 'IgCustomResultScoreModel' }
      | { __typename?: 'IgFinalDecisionResultScoreModel' }
      | { __typename?: 'MotivationResultScoreModel' }
      | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'StatisticalResultScoreModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel' }
      | { __typename?: 'TrCustomResultScoreModel' }
     } };

export type ResultCreateOnePspTechnicalSkillMutationVariables = Exact<{
  score: ITechnicalSkillSelfAssessmentScoreModel;
  id: Scalars['Int']['input'];
}>;


export type ResultCreateOnePspTechnicalSkillMutation = { __typename?: 'Mutation', ResultCreateOnePspTechnicalSkill: { __typename?: 'ResultModel', measurementId: number, updatedAt: any, score:
      | { __typename?: 'ExternalAssessmentCodeScoreModel' }
      | { __typename?: 'ExternalAssessmentFinalScoreModel' }
      | { __typename?: 'ExternalAssessmentMcqScoreModel' }
      | { __typename?: 'IgBehaviourResultScoreModel' }
      | { __typename?: 'IgCustomResultScoreModel' }
      | { __typename?: 'IgFinalDecisionResultScoreModel' }
      | { __typename?: 'MotivationResultScoreModel' }
      | { __typename?: 'SoftSkillSelfAssessmentScoreModel' }
      | { __typename?: 'StatisticalResultScoreModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'TrCustomResultScoreModel' }
     } };

export type DeiStageActionCandidateSubmitResponsesMutationVariables = Exact<{
  stageCandidateId: Scalars['Int']['input'];
  responses: DeiStageActionCandidateResponsesInput;
}>;


export type DeiStageActionCandidateSubmitResponsesMutation = { __typename?: 'Mutation', DeiStageActionCandidateSubmitResponses: { __typename?: 'DeiStageActionCandidateModel', status: DeiStageActionCandidateStatus } };

export type DeiStageActionCandidateGiveConsentMutationVariables = Exact<{
  stageCandidateId: Scalars['Int']['input'];
}>;


export type DeiStageActionCandidateGiveConsentMutation = { __typename?: 'Mutation', DeiStageActionCandidateGiveConsent: { __typename?: 'DeiStageActionCandidateModel', status: DeiStageActionCandidateStatus, hasActiveConsent: boolean } };

export type DeiStageActionCandidateDeclineConsentMutationVariables = Exact<{
  stageCandidateId: Scalars['Int']['input'];
}>;


export type DeiStageActionCandidateDeclineConsentMutation = { __typename?: 'Mutation', DeiStageActionCandidateDeclineConsent: { __typename?: 'DeiStageActionCandidateModel', status: DeiStageActionCandidateStatus, hasActiveConsent: boolean } };

export type StartPersonalityTestAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  locale?: InputMaybe<SupportedLocale>;
}>;


export type StartPersonalityTestAssessmentMutation = { __typename?: 'Mutation', startPersonalityTestAssessment: { __typename?: 'PersonalityTestAssessmentStageActionCandidate', id: string, status: PersonalityTestAssessmentStageActionCandidateStatus, assessmentId?: string | null, locale?: SupportedLocale | null } };

export type StartCognitiveTestAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StartCognitiveTestAssessmentMutation = { __typename?: 'Mutation', startCognitiveTestAssessment: { __typename?: 'CognitiveTestAssessmentStageActionCandidate', id: string, status: CognitiveTestAssessmentStageActionCandidateStatus, assessmentId?: string | null } };

export type StartCognitiveTestPracticeAssessmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StartCognitiveTestPracticeAssessmentMutation = { __typename?: 'Mutation', startCognitiveTestPracticeAssessment: { __typename?: 'CognitiveTestPracticeAssessment', assessmentId: string } };

export type UpdateMyLocalePreferenceMutationVariables = Exact<{
  locale: SupportedLocale;
}>;


export type UpdateMyLocalePreferenceMutation = { __typename?: 'Mutation', updateMyLocalePreference: { __typename?: 'User', id: number, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale } } };

export type GetConferenceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConferenceQuery = { __typename?: 'Query', aiInterviewAssessmentStageActionCandidate: { __typename?: 'AiInterviewAssessmentStageActionCandidate', status: AiInterviewAssessmentStageActionCandidateStatus, estimatedDurationMinutes: number, timeModifierPercentage: number, conference?: { __typename?: 'Conference', id: string, remainingDemoCount: number } | null, stageAction: { __typename?: 'AiInterviewAssessmentStageActionNested', isAvatarEnabled: boolean, selectedLocales: Array<SupportedLocale> }, stageCandidate: { __typename?: 'SmStageCandidateModel', id: number, shouldContactUs: boolean }, consent: { __typename?: 'AiInterviewConsent', isRequired: boolean, status: AiInterviewConsentStatus, consentText: string } } };

export type AiInterviewRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiInterviewRoleQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, candidatePortalEnabled: boolean, company: { __typename?: 'MyRoleCompany', id: number, name: string, logoUrl?: string | null } } };

export type AiInterviewRoleStageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AiInterviewRoleStageQuery = { __typename?: 'Query', aiInterviewAssessmentStageActionCandidateRoleStage: { __typename?: 'AiInterviewAssessmentStageActionCandidateRoleStage', roleId: string, stageId: string } };

export type CandidatePortalRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CandidatePortalRoleQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, name: string, candidatePortalEnabled: boolean, coverPhotoUrl?: string | null, candidatePortalTitle?: string | null, candidatePortalIntro?: string | null, deadlineAt?: any | null, company: { __typename?: 'MyRoleCompany', id: number, name: string, logoUrl?: string | null, branding?: { __typename?: 'CompanyBranding', logoUrl?: string | null, accentColor1?: string | null, accentColor2?: string | null, textColor?: string | null, websiteLinkUrl?: string | null, careersLinkUrl?: string | null } | null }, candidateJourney: Array<{ __typename?: 'MyRoleCandidateJourneyStage', stageId?: string | null, stageType: StageType, status: CandidateJourneyStageStatus, title?: string | null, description?: string | null, thumbnailUrl?: string | null, estimatedTimeMinutes?: number | null }>, questionnaireStages: Array<{ __typename?: 'MyRoleQuestionnaireStage', id: string }> } };

export type ContentStageCandidateQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
}>;


export type ContentStageCandidateQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, name: string, candidatePortalEnabled: boolean, company: { __typename?: 'MyRoleCompany', id: number, name: string, logoUrl?: string | null, branding?: { __typename?: 'CompanyBranding', logoUrl?: string | null, accentColor1?: string | null, accentColor2?: string | null, textColor?: string | null, websiteLinkUrl?: string | null, careersLinkUrl?: string | null } | null }, contentStages: Array<{ __typename?: 'MyRoleContentStage', id: string, contentStageCandidateId: number, name: string, description: string, imageUrl?: string | null, estimatedDurationMinutes: number, status: ContentStageCandidateStatus, blocks: Array<{ __typename?: 'ContentStageBlockModel', kind: ContentStageBlockKind, imageUrl?: string | null, videoUrl?: string | null, title?: string | null, paragraph?: string | null }> }> } };

export type GetDeiStageActionCandidateQueryVariables = Exact<{
  stageCandidateId: Scalars['Int']['input'];
}>;


export type GetDeiStageActionCandidateQuery = { __typename?: 'Query', StageCandidateFindById?: { __typename?: 'SmStageCandidateModel', id: number, status: StageCandidateStatus, stage: { __typename?: 'SmStageModel', id: number, status: StageStatus }, deiStageActionCandidate?: { __typename?: 'DeiStageActionCandidateModel', createdAt: any, updatedAt: any, status: DeiStageActionCandidateStatus, hasActiveConsent: boolean, stageAction: { __typename?: 'DeiStageActionModel', completedCount: number, createdAt: any, deletedAt?: any | null, stageId: number, updatedAt: any, fields: { __typename?: 'DeiStageActionFieldsModel', hasAgeRangeField: boolean, hasEthnicityField: boolean, hasGenderIdentityField: boolean, hasNeurodivergenceIdentifyField: boolean, hasDisabilityIdentifyField: boolean, hasFreeSchoolMealsField: boolean, hasNeurodiversityField: boolean, hasDisabilityField: boolean, hasReligiousBeliefsField: boolean, hasSexualOrientationField: boolean } }, stageCandidate: { __typename?: 'SmStageCandidateModel', id: number, companyId?: number | null, doneFor: number, doneBy: number, lastDateOfCandidateAction?: any | null, status: StageCandidateStatus, stage: { __typename?: 'SmStageModel', id: number, name: string, projectId: number } }, responses: { __typename?: 'DeiStageActionCandidateResponsesModel', ageRange?: DeiAgeRange | null, ethnicity?: DeiEthnicity | null, genderIdentity?: DeiGender | null, hasTransgenderIdentity?: DeiYesNo | null, neurodivergenceIdentify?: Array<DeiNeurodivergenceIdentify> | null, neurodivergenceIdentifyOther?: string | null, disabilityIdentify?: Array<DeiDisabilityIdentify> | null, disabilityIdentifyOther?: string | null, freeSchoolMeals?: DeiFreeSchoolMeals | null, hasDisability?: DeiYesNo | null, hasNeurodiversity?: DeiYesNo | null, sexualOrientation?: DeiSexualOrientation | null, religiousBelief?: DeiReligiousBelief | null } } | null } | null };

export type EnglishProficiencyAssessmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnglishProficiencyAssessmentQuery = { __typename?: 'Query', englishProficiencyAssessment: { __typename?: 'EnglishProficiencyAssessment', id: string, remainingSeconds: number, submittedAt?: any | null, questions: Array<
      | { __typename?: 'EnglishProficiencyMultipleChoiceQuestion', index: number, kind: EnglishProficiencyQuestionKind, text: string, instructions: string, category: string, tags: Array<string>, answers: Array<{ __typename?: 'EnglishProficiencyAnswerOption', index: number, text: string }>, passage?: { __typename?: 'EnglishProficiencyPassage', title: string, body: string } | null, asset?: { __typename?: 'EnglishProficiencyAsset', url: string, kind: EnglishProficiencyAssetKind } | null }
      | { __typename?: 'EnglishProficiencyShortAnswerQuestion', blankCount: number, clue: string, index: number, kind: EnglishProficiencyQuestionKind, text: string, instructions: string, category: string, tags: Array<string>, passage?: { __typename?: 'EnglishProficiencyPassage', title: string, body: string } | null, asset?: { __typename?: 'EnglishProficiencyAsset', url: string, kind: EnglishProficiencyAssetKind } | null }
    >, responses: Array<{ __typename?: 'EnglishProficiencyResponse', questionIndex: number, selectedAnswerIndex?: number | null, selectedAnswerText?: string | null, blankAnswers?: Array<string> | null }> } };

export type MyRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MyRoleQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, name: string, candidatePortalEnabled: boolean, company: { __typename?: 'MyRoleCompany', name: string, logoUrl?: string | null }, stages: Array<{ __typename?: 'MyRoleStage', id: string, kind: AssessmentStageKind, name: string, stageStatus: StageStatus, candidateStatus: StageCandidateStatus, endTime?: any | null }> } };

export type MyRoleStageActionsQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
}>;


export type MyRoleStageActionsQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, name: string, candidatePortalEnabled: boolean, company: { __typename?: 'MyRoleCompany', id: number, name: string, logoUrl?: string | null, usesBehaviouralLabel: boolean, isLiveChatEnabled: boolean, branding?: { __typename?: 'CompanyBranding', logoUrl?: string | null, accentColor1?: string | null, accentColor2?: string | null, textColor?: string | null } | null, reasonableAdjustmentsOption?: { __typename?: 'ReasonableAdjustmentsOption', kind: ReasonableAdjustmentsOptionKind, value?: string | null } | null }, stages: Array<{ __typename?: 'MyRoleStage', id: string, stageCandidateId: number, kind: AssessmentStageKind, name: string, stageStatus: StageStatus, candidateStatus: StageCandidateStatus, endTime?: any | null, deadlineAt?: any | null, hasAdjustmentQuestionnaire: boolean, hasCompletedAdjustmentQuestionnaire: boolean, hasPledgedAnticheating: boolean, isIntegrityMonitoringEnabled: boolean, actions: { __typename?: 'MyRoleStageActions', formActions: Array<{ __typename?: 'MyRoleStageFormAction', id: number, formType: FormType, status: FormCandidateStatus }>, personalityTestAction?: { __typename?: 'MyRoleStagePersonalityTestAction', id: string, status: PersonalityTestAssessmentStageActionCandidateStatus, selectedLocales: Array<SupportedLocale>, estimatedTimeSeconds: number } | null, cognitiveTestActions: Array<{ __typename?: 'MyRoleStageCognitiveTestAction', id: string, status: CognitiveTestAssessmentStageActionCandidateStatus, kind: CognitiveKind, allowedTimeSeconds: number, allowedSectionTimeSeconds: number, timeModifierPercentage: number }>, softRssAssessmentAction?: { __typename?: 'MyRoleStageRssAssessmentAction', id: number, status: RssAssessmentCandidateStatus } | null, technicalRssAssessmentAction?: { __typename?: 'MyRoleStageRssAssessmentAction', id: number, status: RssAssessmentCandidateStatus } | null, deiAction?: { __typename?: 'MyRoleStageDeiAction', id: number, status: DeiStageActionCandidateStatus } | null, coderbyteAction?: { __typename?: 'MyRoleStageCoderbyteAction', id: string, status: CoderbyteAssessmentStageActionCandidateStatus, name: string, allowedTimeSeconds?: number | null, estimatedTimeSeconds?: number | null, timeModifierPercentage: number } | null, aiInterviewActions: Array<{ __typename?: 'MyRoleStageAiInterviewAction', id: string, status: AiInterviewAssessmentStageActionCandidateStatus, name: string, duration: number, conferenceId?: string | null }>, englishProficiencyAction?: { __typename?: 'MyRoleStageEnglishProficiencyAction', id: string, status: EnglishProficiencyAssessmentStageActionCandidateStatus, allowedTimeSeconds: number } | null } }> } };

export type MyRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyRolesQuery = { __typename?: 'Query', myRoles: Array<{ __typename?: 'MyRole', id: string, name: string, candidatePortalEnabled: boolean, company: { __typename?: 'MyRoleCompany', id: number, name: string, logoUrl?: string | null, isLiveChatEnabled: boolean } }> };

export type CompanyIdByProjectQueryVariables = Exact<{
  id: Scalars['Float']['input'];
}>;


export type CompanyIdByProjectQuery = { __typename?: 'Query', getCompanyId: { __typename?: 'ProjectCompanyId', companyId: number } };

export type QuestionnaireStageCandidateQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
  stageId: Scalars['ID']['input'];
}>;


export type QuestionnaireStageCandidateQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, name: string, candidatePortalEnabled: boolean, company: { __typename?: 'MyRoleCompany', id: number, name: string, logoUrl?: string | null, branding?: { __typename?: 'CompanyBranding', logoUrl?: string | null, accentColor1?: string | null, accentColor2?: string | null, textColor?: string | null, websiteLinkUrl?: string | null, careersLinkUrl?: string | null } | null }, questionnaireStages: Array<{ __typename?: 'MyRoleQuestionnaireStage', id: string, shortlistStageCandidateId: number, name: string, status: QuestionnaireCandidateStatus, items: Array<{ __typename?: 'MyRoleQuestionnaireItem', id: string, text: string, order: number, answer?: boolean | null }> }> } };

export type RssAssessmentCandidateOpenOneQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RssAssessmentCandidateOpenOneQuery = { __typename?: 'Query', RssAssessmentCandidateOpenOne: { __typename?: 'RssCandidateOpenOneModel', gradeBands: Array<
      | { __typename?: 'IgBehaviourGradeBandModel' }
      | { __typename?: 'InterviewGuideCustomGradeBandModel' }
      | { __typename?: 'InterviewGuideFinalDecisionGradeBandModel' }
      | { __typename?: 'SoftSkillSelfAssessmentGradeBandModel', displayText: string, position: number, softSkillProficiency: SoftSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'StatisticalGradeBandModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentGradeBandModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel, position: number, displayText: string }
      | { __typename?: 'TrCustomGradeBandModel' }
    >, rssAssessmentCandidate: { __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType }, stageCandidate?: { __typename?: 'SmStageCandidateModel', id: number, rssAssessmentCandidates?: Array<{ __typename?: 'RssAssessmentCandidateModel', id: number, status: RssAssessmentCandidateStatus, rssAssessment: { __typename?: 'RssAssessmentModel', id: number, type: RssAssessmentType } }> | null } | null }, skillsWithResults: Array<{ __typename?: 'SkillWithResultModel', result?: { __typename?: 'ResultModel', id: number, label?: string | null, measurementType: ResultMeasurementType, measurementId: number, scoreType: ResultScoreType, projectId?: number | null, score:
          | { __typename?: 'ExternalAssessmentCodeScoreModel' }
          | { __typename?: 'ExternalAssessmentFinalScoreModel' }
          | { __typename?: 'ExternalAssessmentMcqScoreModel' }
          | { __typename?: 'IgBehaviourResultScoreModel' }
          | { __typename?: 'IgCustomResultScoreModel' }
          | { __typename?: 'IgFinalDecisionResultScoreModel' }
          | { __typename?: 'MotivationResultScoreModel' }
          | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
          | { __typename?: 'StatisticalResultScoreModel' }
          | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
          | { __typename?: 'TrCustomResultScoreModel' }
         } | null, skill:
        | { __typename?: 'BroadSoftSkill', id: number, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
              | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
              | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
              | { __typename?: 'BroadSoftSkill', id: number, name: string }
              | { __typename?: 'FocusedSoftSkill', id: number, name: string }
             | null }> | null }
        | { __typename?: 'FocusedSoftSkill', id: number, name: string, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, description?: string | null, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
              | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
              | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
              | { __typename?: 'BroadSoftSkill', id: number, name: string }
              | { __typename?: 'FocusedSoftSkill', id: number, name: string }
             | null }> | null }
        | { __typename?: 'TechnicalSkill', id: number, name: string }
       }> } };

export type SkillsProfileOpenOneSkillsWithResultsFragment = { __typename?: 'SpSkillWithResultModel', skill:
    | { __typename?: 'BroadSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null }
    | { __typename?: 'FocusedSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null }
    | { __typename?: 'TechnicalSkill', id: number, name: string }
  , result: { __typename?: 'ResultModel', id: number, updatedAt: any, score:
      | { __typename?: 'ExternalAssessmentCodeScoreModel' }
      | { __typename?: 'ExternalAssessmentFinalScoreModel' }
      | { __typename?: 'ExternalAssessmentMcqScoreModel' }
      | { __typename?: 'IgBehaviourResultScoreModel' }
      | { __typename?: 'IgCustomResultScoreModel' }
      | { __typename?: 'IgFinalDecisionResultScoreModel' }
      | { __typename?: 'MotivationResultScoreModel' }
      | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'StatisticalResultScoreModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'TrCustomResultScoreModel' }
     } };

export type SkillsProfileOpenOneQueryVariables = Exact<{ [key: string]: never; }>;


export type SkillsProfileOpenOneQuery = { __typename?: 'Query', SkillsProfileOpenOne: { __typename?: 'SkillsProfileOpenOneModel', skillsWithResults: Array<{ __typename?: 'SpSkillWithResultModel', skill:
        | { __typename?: 'BroadSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null }
        | { __typename?: 'FocusedSoftSkill', id: number, name: string, description?: string | null, companyId?: number | null }
        | { __typename?: 'TechnicalSkill', id: number, name: string }
      , result: { __typename?: 'ResultModel', id: number, updatedAt: any, score:
          | { __typename?: 'ExternalAssessmentCodeScoreModel' }
          | { __typename?: 'ExternalAssessmentFinalScoreModel' }
          | { __typename?: 'ExternalAssessmentMcqScoreModel' }
          | { __typename?: 'IgBehaviourResultScoreModel' }
          | { __typename?: 'IgCustomResultScoreModel' }
          | { __typename?: 'IgFinalDecisionResultScoreModel' }
          | { __typename?: 'MotivationResultScoreModel' }
          | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
          | { __typename?: 'StatisticalResultScoreModel' }
          | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
          | { __typename?: 'TrCustomResultScoreModel' }
         } }> } };

export type SzSkillResultAndAvailabilityFragment = { __typename?: 'SzSkillsMergeWithAvailability', alreadyExist: boolean, skill: { __typename?: 'SzSkillsMerge', originId: number, name: string, companyId: number, skillType: SkillType, description?: string | null }, result?: { __typename?: 'ResultModel', score:
      | { __typename?: 'ExternalAssessmentCodeScoreModel' }
      | { __typename?: 'ExternalAssessmentFinalScoreModel' }
      | { __typename?: 'ExternalAssessmentMcqScoreModel' }
      | { __typename?: 'IgBehaviourResultScoreModel' }
      | { __typename?: 'IgCustomResultScoreModel' }
      | { __typename?: 'IgFinalDecisionResultScoreModel' }
      | { __typename?: 'MotivationResultScoreModel' }
      | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'StatisticalResultScoreModel' }
      | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
      | { __typename?: 'TrCustomResultScoreModel' }
     } | null };

export type SzSkillsMergeFreeTextSearchPaginatedQueryVariables = Exact<{
  text?: Scalars['String']['input'];
  take?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
}>;


export type SzSkillsMergeFreeTextSearchPaginatedQuery = { __typename?: 'Query', SzSkillsMergeFreeTextSearchPaginated: { __typename?: 'PaginatedSzSkillsMerge', total: number, skills: Array<{ __typename?: 'SzSkillsMergeWithAvailability', alreadyExist: boolean, skill: { __typename?: 'SzSkillsMerge', originId: number, name: string, companyId: number, skillType: SkillType, description?: string | null }, result?: { __typename?: 'ResultModel', score:
          | { __typename?: 'ExternalAssessmentCodeScoreModel' }
          | { __typename?: 'ExternalAssessmentFinalScoreModel' }
          | { __typename?: 'ExternalAssessmentMcqScoreModel' }
          | { __typename?: 'IgBehaviourResultScoreModel' }
          | { __typename?: 'IgCustomResultScoreModel' }
          | { __typename?: 'IgFinalDecisionResultScoreModel' }
          | { __typename?: 'MotivationResultScoreModel' }
          | { __typename?: 'SoftSkillSelfAssessmentScoreModel', proficiency: SoftSkillSelfAssessmentProficiencyLevel }
          | { __typename?: 'StatisticalResultScoreModel' }
          | { __typename?: 'TechnicalSkillSelfAssessmentScoreModel', technicalProficiency: TechnicalSkillSelfAssessmentProficiencyLevel }
          | { __typename?: 'TrCustomResultScoreModel' }
         } | null }> } };

export type SoftSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type SoftSkillsQuery = { __typename?: 'Query', SoftSkills?: Array<
    | { __typename?: 'BasicBroadSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
          | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
          | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
          | { __typename?: 'BroadSoftSkill', id: number, name: string }
          | { __typename?: 'FocusedSoftSkill', id: number, name: string }
         | null }> | null }
    | { __typename?: 'BasicFocusedSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
          | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
          | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
          | { __typename?: 'BroadSoftSkill', id: number, name: string }
          | { __typename?: 'FocusedSoftSkill', id: number, name: string }
         | null }> | null }
    | { __typename?: 'BroadSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
          | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
          | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
          | { __typename?: 'BroadSoftSkill', id: number, name: string }
          | { __typename?: 'FocusedSoftSkill', id: number, name: string }
         | null }> | null }
    | { __typename?: 'FocusedSoftSkill', id: number, companyId?: number | null, category: SoftSkillCategory, measurementConstructType?: MeasurementConstructType | null, name: string, company?: { __typename?: 'Company', id: number, name: string } | null, softSkillTraits?: Array<{ __typename?: 'SoftSkillTrait', id?: number | null, orientation: Orientation, weight: number, traitId?: number | null, traitName?: string | null, softSkillId?: number | null, softSkillName?: string | null, trait?: { __typename?: 'Trait', id: number, name: string } | null, softSkill?:
          | { __typename?: 'BasicBroadSoftSkill', id: number, name: string }
          | { __typename?: 'BasicFocusedSoftSkill', id: number, name: string }
          | { __typename?: 'BroadSoftSkill', id: number, name: string }
          | { __typename?: 'FocusedSoftSkill', id: number, name: string }
         | null }> | null }
  > | null };

export type StageCandidateFindOneQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type StageCandidateFindOneQuery = { __typename?: 'Query', StageCandidateFindById?: { __typename?: 'SmStageCandidateModel', id: number, companyId?: number | null, doneFor: number, doneBy: number, lastDateOfCandidateAction?: any | null, status: StageCandidateStatus, stage: { __typename?: 'SmStageModel', id: number, name: string, projectId: number } } | null };

export type MyRoleSupportEmailQueryVariables = Exact<{
  roleId: Scalars['ID']['input'];
}>;


export type MyRoleSupportEmailQuery = { __typename?: 'Query', myRole: { __typename?: 'MyRole', id: string, company: { __typename?: 'MyRoleCompany', id: number, supportEmail: string } } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', User: { __typename?: 'User', id: number, subId: string, firstName: string, lastName: string, email: string, avatarUrl?: string | null, externalId?: string | null, language: Language, isInternal: boolean, identityVerificationStatus: VerificationStatus, identityVerifiedAt?: any | null, identityVerificationResubmissionReason?: string | null, preferredLocale: { __typename?: 'UserLocalePreference', source: UserLocalePreferenceSource, locale: SupportedLocale }, roles: Array<{ __typename?: 'UserRole', id: number, userId?: number | null, externalId?: string | null, companyRole: { __typename?: 'CompanyRole', companyId: number, companyUuid: string, twoFactorEnabled: boolean, id: number, role: { __typename?: 'Role', id: number, name: string, description?: string | null } } }> } };

export const CompanyReasonableAdjustmentsOptionFragmentDoc = gql`
    fragment CompanyReasonableAdjustmentsOption on ReasonableAdjustmentsOption {
  kind
  value
}
    `;
export const CompanyFragmentDoc = gql`
    fragment Company on Company {
  id
  name
  logoUrl
  usesBehaviouralLabel
  reasonableAdjustmentsOption {
    ...CompanyReasonableAdjustmentsOption
  }
}
    ${CompanyReasonableAdjustmentsOptionFragmentDoc}`;
export const DeiFieldsFragmentDoc = gql`
    fragment DeiFields on DeiStageActionFieldsModel {
  hasAgeRangeField
  hasEthnicityField
  hasGenderIdentityField
  hasNeurodivergenceIdentifyField
  hasDisabilityIdentifyField
  hasFreeSchoolMealsField
  hasNeurodiversityField
  hasDisabilityField
  hasReligiousBeliefsField
  hasSexualOrientationField
}
    `;
export const DeiStageActionFragmentDoc = gql`
    fragment DeiStageAction on DeiStageActionModel {
  completedCount
  createdAt
  deletedAt
  fields {
    ...DeiFields
  }
  stageId
  updatedAt
}
    ${DeiFieldsFragmentDoc}`;
export const SmStageCandidateModelFragmentDoc = gql`
    fragment SmStageCandidateModel on SmStageCandidateModel {
  id
  companyId
  doneFor
  doneBy
  lastDateOfCandidateAction
  stage {
    id
    name
    projectId
  }
  status
}
    `;
export const DeiStageActionResponsesFragmentDoc = gql`
    fragment DeiStageActionResponses on DeiStageActionCandidateResponsesModel {
  ageRange
  ethnicity
  genderIdentity
  hasTransgenderIdentity
  neurodivergenceIdentify
  neurodivergenceIdentifyOther
  disabilityIdentify
  disabilityIdentifyOther
  freeSchoolMeals
  hasDisability
  hasNeurodiversity
  sexualOrientation
  religiousBelief
}
    `;
export const DeiStageActionCandidateFragmentDoc = gql`
    fragment DeiStageActionCandidate on DeiStageActionCandidateModel {
  createdAt
  updatedAt
  stageAction {
    ...DeiStageAction
  }
  stageCandidate {
    ...SmStageCandidateModel
  }
  status
  hasActiveConsent
  responses {
    ...DeiStageActionResponses
  }
}
    ${DeiStageActionFragmentDoc}
${SmStageCandidateModelFragmentDoc}
${DeiStageActionResponsesFragmentDoc}`;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  id
  name
  companyId
  moduleType
  idVerificationEnabled
}
    `;
export const RespondantFormFragmentDoc = gql`
    fragment RespondantForm on RespondantForm {
  isComplete
  submittedFormLogId
  formType
  formOwnerId
  associatedId
  formId
  respondantFieldWithAnswers {
    answer
    displayOrder
    field {
      question
      id
      isArchived
      name
      hint
      fieldType
      txtData
      settings {
        allowFreeText
        searchable
      }
      fieldOwnerName
      fieldOwnerId
    }
    isOptional
    selectOptionAnswerIsFreeText
  }
}
    `;
export const ResultFragmentDoc = gql`
    fragment Result on ResultModel {
  id
  label
  measurementType
  measurementId
  score {
    ... on SoftSkillSelfAssessmentScoreModel {
      proficiency
    }
    ... on TechnicalSkillSelfAssessmentScoreModel {
      technicalProficiency
    }
  }
  scoreType
  projectId
}
    `;
export const RssAssessmentCandidateFragmentDoc = gql`
    fragment RssAssessmentCandidate on RssAssessmentCandidateModel {
  id
  status
  rssAssessment {
    id
    type
  }
  stageCandidate {
    id
    rssAssessmentCandidates {
      id
      status
      rssAssessment {
        id
        type
      }
    }
  }
}
    `;
export const SoftSkillSelfAssessmentGradeBandFragmentDoc = gql`
    fragment SoftSkillSelfAssessmentGradeBand on SoftSkillSelfAssessmentGradeBandModel {
  displayText
  position
  softSkillProficiency: proficiency
}
    `;
export const TechnicalSkillSelfAssessmentGradeBandFragmentDoc = gql`
    fragment TechnicalSkillSelfAssessmentGradeBand on TechnicalSkillSelfAssessmentGradeBandModel {
  technicalProficiency
  position
  displayText
}
    `;
export const SoftSkillTraitFragmentDoc = gql`
    fragment SoftSkillTrait on SoftSkillTrait {
  id
  orientation
  weight
  traitId
  traitName
  trait {
    id
    name
  }
  softSkillId
  softSkillName
  softSkill {
    id
    name
  }
}
    `;
export const SoftSkillFragmentDoc = gql`
    fragment SoftSkill on SoftSkill {
  id
  companyId
  category
  measurementConstructType
  name
  company {
    id
    name
  }
  softSkillTraits {
    ...SoftSkillTrait
  }
}
    ${SoftSkillTraitFragmentDoc}`;
export const SoftSkillWithDescriptionFragmentDoc = gql`
    fragment SoftSkillWithDescription on SoftSkill {
  id
  name
  companyId
  category
  measurementConstructType
  description
  company {
    id
    name
  }
  softSkillTraits {
    ...SoftSkillTrait
  }
}
    ${SoftSkillTraitFragmentDoc}`;
export const StageFragmentDoc = gql`
    fragment Stage on SmStageModel {
  id
  kind
  name
  status
  endTime
  hasAdjustmentQuestionnaire
}
    `;
export const StageCandidateFragmentDoc = gql`
    fragment StageCandidate on SmStageCandidateModel {
  id
  status
  hasCompletedAdjustmentQuestionnaire
}
    `;
export const RoleFragmentDoc = gql`
    fragment Role on Role {
  id
  name
  description
}
    `;
export const CompanyRoleFragmentDoc = gql`
    fragment CompanyRole on CompanyRole {
  companyId
  companyUuid
  twoFactorEnabled
  role {
    ...Role
  }
  id
}
    ${RoleFragmentDoc}`;
export const UserRoleFragmentDoc = gql`
    fragment UserRole on UserRole {
  id
  userId
  companyRole {
    ...CompanyRole
  }
  externalId
}
    ${CompanyRoleFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  subId
  firstName
  lastName
  email
  avatarUrl
  externalId
  language
  preferredLocale {
    source
    locale
  }
  isInternal
  identityVerificationStatus
  identityVerifiedAt
  identityVerificationResubmissionReason
  roles {
    ...UserRole
  }
}
    ${UserRoleFragmentDoc}`;
export const UserFullNameFragmentDoc = gql`
    fragment UserFullName on User {
  id
  firstName
  lastName
  preferredLocale {
    source
    locale
  }
}
    `;
export const SoftSkillWithoutCompanyFragmentDoc = gql`
    fragment SoftSkillWithoutCompany on SoftSkill {
  id
  name
  description
  companyId
}
    `;
export const TechnicalSkillFragmentDoc = gql`
    fragment TechnicalSkill on TechnicalSkill {
  id
  name
}
    `;
export const SkillsProfileOpenOneSkillsWithResultsFragmentDoc = gql`
    fragment SkillsProfileOpenOneSkillsWithResults on SpSkillWithResultModel {
  skill {
    ... on SoftSkill {
      ...SoftSkillWithoutCompany
    }
    ... on TechnicalSkill {
      ...TechnicalSkill
    }
  }
  result {
    id
    updatedAt
    score {
      ... on SoftSkillSelfAssessmentScoreModel {
        proficiency
      }
      ... on TechnicalSkillSelfAssessmentScoreModel {
        technicalProficiency
      }
    }
  }
}
    ${SoftSkillWithoutCompanyFragmentDoc}
${TechnicalSkillFragmentDoc}`;
export const SzSkillResultAndAvailabilityFragmentDoc = gql`
    fragment SzSkillResultAndAvailability on SzSkillsMergeWithAvailability {
  skill {
    originId
    name
    companyId
    skillType
    description
  }
  result {
    score {
      ... on TechnicalSkillSelfAssessmentScoreModel {
        technicalProficiency
      }
      ... on SoftSkillSelfAssessmentScoreModel {
        proficiency
      }
    }
  }
  alreadyExist
}
    `;
export const InitiateAiInterviewDocument = gql`
    mutation initiateAiInterview($id: ID!) {
  initiateAiInterview(id: $id) {
    conference {
      id
    }
    status
  }
}
    `;
export type InitiateAiInterviewMutationFn = Apollo.MutationFunction<InitiateAiInterviewMutation, InitiateAiInterviewMutationVariables>;

/**
 * __useInitiateAiInterviewMutation__
 *
 * To run a mutation, you first call `useInitiateAiInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateAiInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateAiInterviewMutation, { data, loading, error }] = useInitiateAiInterviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInitiateAiInterviewMutation(baseOptions?: Apollo.MutationHookOptions<InitiateAiInterviewMutation, InitiateAiInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateAiInterviewMutation, InitiateAiInterviewMutationVariables>(InitiateAiInterviewDocument, options);
      }
export type InitiateAiInterviewMutationHookResult = ReturnType<typeof useInitiateAiInterviewMutation>;
export type InitiateAiInterviewMutationResult = Apollo.MutationResult<InitiateAiInterviewMutation>;
export type InitiateAiInterviewMutationOptions = Apollo.BaseMutationOptions<InitiateAiInterviewMutation, InitiateAiInterviewMutationVariables>;
export const JoinConferenceDocument = gql`
    mutation joinConference($id: ID!, $input: JoinConferenceInput!) {
  joinConference(id: $id, input: $input) {
    token
  }
}
    `;
export type JoinConferenceMutationFn = Apollo.MutationFunction<JoinConferenceMutation, JoinConferenceMutationVariables>;

/**
 * __useJoinConferenceMutation__
 *
 * To run a mutation, you first call `useJoinConferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinConferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinConferenceMutation, { data, loading, error }] = useJoinConferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinConferenceMutation(baseOptions?: Apollo.MutationHookOptions<JoinConferenceMutation, JoinConferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinConferenceMutation, JoinConferenceMutationVariables>(JoinConferenceDocument, options);
      }
export type JoinConferenceMutationHookResult = ReturnType<typeof useJoinConferenceMutation>;
export type JoinConferenceMutationResult = Apollo.MutationResult<JoinConferenceMutation>;
export type JoinConferenceMutationOptions = Apollo.BaseMutationOptions<JoinConferenceMutation, JoinConferenceMutationVariables>;
export const FinishAiInterviewDocument = gql`
    mutation finishAiInterview($id: ID!) {
  finishAiInterview(id: $id) {
    id
  }
}
    `;
export type FinishAiInterviewMutationFn = Apollo.MutationFunction<FinishAiInterviewMutation, FinishAiInterviewMutationVariables>;

/**
 * __useFinishAiInterviewMutation__
 *
 * To run a mutation, you first call `useFinishAiInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishAiInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishAiInterviewMutation, { data, loading, error }] = useFinishAiInterviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFinishAiInterviewMutation(baseOptions?: Apollo.MutationHookOptions<FinishAiInterviewMutation, FinishAiInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishAiInterviewMutation, FinishAiInterviewMutationVariables>(FinishAiInterviewDocument, options);
      }
export type FinishAiInterviewMutationHookResult = ReturnType<typeof useFinishAiInterviewMutation>;
export type FinishAiInterviewMutationResult = Apollo.MutationResult<FinishAiInterviewMutation>;
export type FinishAiInterviewMutationOptions = Apollo.BaseMutationOptions<FinishAiInterviewMutation, FinishAiInterviewMutationVariables>;
export const SubmitAiInterviewFeedbackDocument = gql`
    mutation submitAiInterviewFeedback($id: ID!, $feedback: JSONObject!) {
  submitAiInterviewFeedback(id: $id, feedback: $feedback) {
    id
  }
}
    `;
export type SubmitAiInterviewFeedbackMutationFn = Apollo.MutationFunction<SubmitAiInterviewFeedbackMutation, SubmitAiInterviewFeedbackMutationVariables>;

/**
 * __useSubmitAiInterviewFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitAiInterviewFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAiInterviewFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAiInterviewFeedbackMutation, { data, loading, error }] = useSubmitAiInterviewFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      feedback: // value for 'feedback'
 *   },
 * });
 */
export function useSubmitAiInterviewFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAiInterviewFeedbackMutation, SubmitAiInterviewFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAiInterviewFeedbackMutation, SubmitAiInterviewFeedbackMutationVariables>(SubmitAiInterviewFeedbackDocument, options);
      }
export type SubmitAiInterviewFeedbackMutationHookResult = ReturnType<typeof useSubmitAiInterviewFeedbackMutation>;
export type SubmitAiInterviewFeedbackMutationResult = Apollo.MutationResult<SubmitAiInterviewFeedbackMutation>;
export type SubmitAiInterviewFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitAiInterviewFeedbackMutation, SubmitAiInterviewFeedbackMutationVariables>;
export const JoinDemoConferenceDocument = gql`
    mutation joinDemoConference($id: ID!, $input: JoinConferenceInput!) {
  joinDemoConference(id: $id, input: $input) {
    token
    remainingDemos
  }
}
    `;
export type JoinDemoConferenceMutationFn = Apollo.MutationFunction<JoinDemoConferenceMutation, JoinDemoConferenceMutationVariables>;

/**
 * __useJoinDemoConferenceMutation__
 *
 * To run a mutation, you first call `useJoinDemoConferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinDemoConferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinDemoConferenceMutation, { data, loading, error }] = useJoinDemoConferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJoinDemoConferenceMutation(baseOptions?: Apollo.MutationHookOptions<JoinDemoConferenceMutation, JoinDemoConferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinDemoConferenceMutation, JoinDemoConferenceMutationVariables>(JoinDemoConferenceDocument, options);
      }
export type JoinDemoConferenceMutationHookResult = ReturnType<typeof useJoinDemoConferenceMutation>;
export type JoinDemoConferenceMutationResult = Apollo.MutationResult<JoinDemoConferenceMutation>;
export type JoinDemoConferenceMutationOptions = Apollo.BaseMutationOptions<JoinDemoConferenceMutation, JoinDemoConferenceMutationVariables>;
export const AiInterviewConsentGiveDocument = gql`
    mutation AiInterviewConsentGive($aiInterviewAssessmentStageActionCandidateId: ID!) {
  AiInterviewConsentGive(
    aiInterviewAssessmentStageActionCandidateId: $aiInterviewAssessmentStageActionCandidateId
  ) {
    isRequired
    status
    consentText
  }
}
    `;
export type AiInterviewConsentGiveMutationFn = Apollo.MutationFunction<AiInterviewConsentGiveMutation, AiInterviewConsentGiveMutationVariables>;

/**
 * __useAiInterviewConsentGiveMutation__
 *
 * To run a mutation, you first call `useAiInterviewConsentGiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiInterviewConsentGiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiInterviewConsentGiveMutation, { data, loading, error }] = useAiInterviewConsentGiveMutation({
 *   variables: {
 *      aiInterviewAssessmentStageActionCandidateId: // value for 'aiInterviewAssessmentStageActionCandidateId'
 *   },
 * });
 */
export function useAiInterviewConsentGiveMutation(baseOptions?: Apollo.MutationHookOptions<AiInterviewConsentGiveMutation, AiInterviewConsentGiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiInterviewConsentGiveMutation, AiInterviewConsentGiveMutationVariables>(AiInterviewConsentGiveDocument, options);
      }
export type AiInterviewConsentGiveMutationHookResult = ReturnType<typeof useAiInterviewConsentGiveMutation>;
export type AiInterviewConsentGiveMutationResult = Apollo.MutationResult<AiInterviewConsentGiveMutation>;
export type AiInterviewConsentGiveMutationOptions = Apollo.BaseMutationOptions<AiInterviewConsentGiveMutation, AiInterviewConsentGiveMutationVariables>;
export const AiInterviewConsentDeclineDocument = gql`
    mutation AiInterviewConsentDecline($aiInterviewAssessmentStageActionCandidateId: ID!) {
  AiInterviewConsentDecline(
    aiInterviewAssessmentStageActionCandidateId: $aiInterviewAssessmentStageActionCandidateId
  ) {
    isRequired
    status
    consentText
  }
}
    `;
export type AiInterviewConsentDeclineMutationFn = Apollo.MutationFunction<AiInterviewConsentDeclineMutation, AiInterviewConsentDeclineMutationVariables>;

/**
 * __useAiInterviewConsentDeclineMutation__
 *
 * To run a mutation, you first call `useAiInterviewConsentDeclineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiInterviewConsentDeclineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiInterviewConsentDeclineMutation, { data, loading, error }] = useAiInterviewConsentDeclineMutation({
 *   variables: {
 *      aiInterviewAssessmentStageActionCandidateId: // value for 'aiInterviewAssessmentStageActionCandidateId'
 *   },
 * });
 */
export function useAiInterviewConsentDeclineMutation(baseOptions?: Apollo.MutationHookOptions<AiInterviewConsentDeclineMutation, AiInterviewConsentDeclineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiInterviewConsentDeclineMutation, AiInterviewConsentDeclineMutationVariables>(AiInterviewConsentDeclineDocument, options);
      }
export type AiInterviewConsentDeclineMutationHookResult = ReturnType<typeof useAiInterviewConsentDeclineMutation>;
export type AiInterviewConsentDeclineMutationResult = Apollo.MutationResult<AiInterviewConsentDeclineMutation>;
export type AiInterviewConsentDeclineMutationOptions = Apollo.BaseMutationOptions<AiInterviewConsentDeclineMutation, AiInterviewConsentDeclineMutationVariables>;
export const StageCandidatePledgeAnticheatingDocument = gql`
    mutation StageCandidatePledgeAnticheating($id: Int!) {
  StageCandidatePledgeAnticheating(id: $id)
}
    `;
export type StageCandidatePledgeAnticheatingMutationFn = Apollo.MutationFunction<StageCandidatePledgeAnticheatingMutation, StageCandidatePledgeAnticheatingMutationVariables>;

/**
 * __useStageCandidatePledgeAnticheatingMutation__
 *
 * To run a mutation, you first call `useStageCandidatePledgeAnticheatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageCandidatePledgeAnticheatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageCandidatePledgeAnticheatingMutation, { data, loading, error }] = useStageCandidatePledgeAnticheatingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageCandidatePledgeAnticheatingMutation(baseOptions?: Apollo.MutationHookOptions<StageCandidatePledgeAnticheatingMutation, StageCandidatePledgeAnticheatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageCandidatePledgeAnticheatingMutation, StageCandidatePledgeAnticheatingMutationVariables>(StageCandidatePledgeAnticheatingDocument, options);
      }
export type StageCandidatePledgeAnticheatingMutationHookResult = ReturnType<typeof useStageCandidatePledgeAnticheatingMutation>;
export type StageCandidatePledgeAnticheatingMutationResult = Apollo.MutationResult<StageCandidatePledgeAnticheatingMutation>;
export type StageCandidatePledgeAnticheatingMutationOptions = Apollo.BaseMutationOptions<StageCandidatePledgeAnticheatingMutation, StageCandidatePledgeAnticheatingMutationVariables>;
export const ExchangeAuthCodeDocument = gql`
    mutation ExchangeAuthCode($authCode: String!, $clientType: ClientType) {
  ExchangeAuthCode(authCode: $authCode, clientType: $clientType) {
    accessToken
    refreshToken
  }
}
    `;
export type ExchangeAuthCodeMutationFn = Apollo.MutationFunction<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>;

/**
 * __useExchangeAuthCodeMutation__
 *
 * To run a mutation, you first call `useExchangeAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeAuthCodeMutation, { data, loading, error }] = useExchangeAuthCodeMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      clientType: // value for 'clientType'
 *   },
 * });
 */
export function useExchangeAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>(ExchangeAuthCodeDocument, options);
      }
export type ExchangeAuthCodeMutationHookResult = ReturnType<typeof useExchangeAuthCodeMutation>;
export type ExchangeAuthCodeMutationResult = Apollo.MutationResult<ExchangeAuthCodeMutation>;
export type ExchangeAuthCodeMutationOptions = Apollo.BaseMutationOptions<ExchangeAuthCodeMutation, ExchangeAuthCodeMutationVariables>;
export const RequestTokenRefreshDocument = gql`
    mutation RequestTokenRefresh($accessToken: String!, $refreshToken: String!, $clientType: ClientType) {
  requestTokenRefresh(
    accessToken: $accessToken
    refreshToken: $refreshToken
    clientType: $clientType
  ) {
    accessToken
    refreshToken
  }
}
    `;
export type RequestTokenRefreshMutationFn = Apollo.MutationFunction<RequestTokenRefreshMutation, RequestTokenRefreshMutationVariables>;

/**
 * __useRequestTokenRefreshMutation__
 *
 * To run a mutation, you first call `useRequestTokenRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTokenRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTokenRefreshMutation, { data, loading, error }] = useRequestTokenRefreshMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      refreshToken: // value for 'refreshToken'
 *      clientType: // value for 'clientType'
 *   },
 * });
 */
export function useRequestTokenRefreshMutation(baseOptions?: Apollo.MutationHookOptions<RequestTokenRefreshMutation, RequestTokenRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTokenRefreshMutation, RequestTokenRefreshMutationVariables>(RequestTokenRefreshDocument, options);
      }
export type RequestTokenRefreshMutationHookResult = ReturnType<typeof useRequestTokenRefreshMutation>;
export type RequestTokenRefreshMutationResult = Apollo.MutationResult<RequestTokenRefreshMutation>;
export type RequestTokenRefreshMutationOptions = Apollo.BaseMutationOptions<RequestTokenRefreshMutation, RequestTokenRefreshMutationVariables>;
export const DeauthenticateDocument = gql`
    mutation Deauthenticate($accessToken: String!) {
  deauthenticate(accessToken: $accessToken)
}
    `;
export type DeauthenticateMutationFn = Apollo.MutationFunction<DeauthenticateMutation, DeauthenticateMutationVariables>;

/**
 * __useDeauthenticateMutation__
 *
 * To run a mutation, you first call `useDeauthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeauthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deauthenticateMutation, { data, loading, error }] = useDeauthenticateMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useDeauthenticateMutation(baseOptions?: Apollo.MutationHookOptions<DeauthenticateMutation, DeauthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeauthenticateMutation, DeauthenticateMutationVariables>(DeauthenticateDocument, options);
      }
export type DeauthenticateMutationHookResult = ReturnType<typeof useDeauthenticateMutation>;
export type DeauthenticateMutationResult = Apollo.MutationResult<DeauthenticateMutation>;
export type DeauthenticateMutationOptions = Apollo.BaseMutationOptions<DeauthenticateMutation, DeauthenticateMutationVariables>;
export const CreateBrowserSwitchEventDocument = gql`
    mutation CreateBrowserSwitchEvent($assessmentSubId: String!, $assessmentTimeSeconds: Int, $type: AssessmentBrowserSwitchCandidateTrackingEvent!) {
  CreateAssessmentBrowserSwitchCandidateTrackingEvent(
    assessmentSubId: $assessmentSubId
    assessmentTimeSeconds: $assessmentTimeSeconds
    type: $type
  )
}
    `;
export type CreateBrowserSwitchEventMutationFn = Apollo.MutationFunction<CreateBrowserSwitchEventMutation, CreateBrowserSwitchEventMutationVariables>;

/**
 * __useCreateBrowserSwitchEventMutation__
 *
 * To run a mutation, you first call `useCreateBrowserSwitchEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrowserSwitchEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrowserSwitchEventMutation, { data, loading, error }] = useCreateBrowserSwitchEventMutation({
 *   variables: {
 *      assessmentSubId: // value for 'assessmentSubId'
 *      assessmentTimeSeconds: // value for 'assessmentTimeSeconds'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateBrowserSwitchEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrowserSwitchEventMutation, CreateBrowserSwitchEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrowserSwitchEventMutation, CreateBrowserSwitchEventMutationVariables>(CreateBrowserSwitchEventDocument, options);
      }
export type CreateBrowserSwitchEventMutationHookResult = ReturnType<typeof useCreateBrowserSwitchEventMutation>;
export type CreateBrowserSwitchEventMutationResult = Apollo.MutationResult<CreateBrowserSwitchEventMutation>;
export type CreateBrowserSwitchEventMutationOptions = Apollo.BaseMutationOptions<CreateBrowserSwitchEventMutation, CreateBrowserSwitchEventMutationVariables>;
export const CandidateAcceptIndirectInvitationDocument = gql`
    mutation CandidateAcceptIndirectInvitation($stageId: Int!, $hiringManagers: [HiringManager!]) {
  CandidateAcceptIndirectInvitation(
    stageId: $stageId
    hiringManagers: $hiringManagers
  ) {
    role {
      id
    }
    stageId
  }
}
    `;
export type CandidateAcceptIndirectInvitationMutationFn = Apollo.MutationFunction<CandidateAcceptIndirectInvitationMutation, CandidateAcceptIndirectInvitationMutationVariables>;

/**
 * __useCandidateAcceptIndirectInvitationMutation__
 *
 * To run a mutation, you first call `useCandidateAcceptIndirectInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateAcceptIndirectInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateAcceptIndirectInvitationMutation, { data, loading, error }] = useCandidateAcceptIndirectInvitationMutation({
 *   variables: {
 *      stageId: // value for 'stageId'
 *      hiringManagers: // value for 'hiringManagers'
 *   },
 * });
 */
export function useCandidateAcceptIndirectInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CandidateAcceptIndirectInvitationMutation, CandidateAcceptIndirectInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateAcceptIndirectInvitationMutation, CandidateAcceptIndirectInvitationMutationVariables>(CandidateAcceptIndirectInvitationDocument, options);
      }
export type CandidateAcceptIndirectInvitationMutationHookResult = ReturnType<typeof useCandidateAcceptIndirectInvitationMutation>;
export type CandidateAcceptIndirectInvitationMutationResult = Apollo.MutationResult<CandidateAcceptIndirectInvitationMutation>;
export type CandidateAcceptIndirectInvitationMutationOptions = Apollo.BaseMutationOptions<CandidateAcceptIndirectInvitationMutation, CandidateAcceptIndirectInvitationMutationVariables>;
export const StartCoderbyteAssessmentDocument = gql`
    mutation StartCoderbyteAssessment($id: ID!) {
  startCoderbyteAssessment(id: $id) {
    inviteUrl
  }
}
    `;
export type StartCoderbyteAssessmentMutationFn = Apollo.MutationFunction<StartCoderbyteAssessmentMutation, StartCoderbyteAssessmentMutationVariables>;

/**
 * __useStartCoderbyteAssessmentMutation__
 *
 * To run a mutation, you first call `useStartCoderbyteAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCoderbyteAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCoderbyteAssessmentMutation, { data, loading, error }] = useStartCoderbyteAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartCoderbyteAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartCoderbyteAssessmentMutation, StartCoderbyteAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCoderbyteAssessmentMutation, StartCoderbyteAssessmentMutationVariables>(StartCoderbyteAssessmentDocument, options);
      }
export type StartCoderbyteAssessmentMutationHookResult = ReturnType<typeof useStartCoderbyteAssessmentMutation>;
export type StartCoderbyteAssessmentMutationResult = Apollo.MutationResult<StartCoderbyteAssessmentMutation>;
export type StartCoderbyteAssessmentMutationOptions = Apollo.BaseMutationOptions<StartCoderbyteAssessmentMutation, StartCoderbyteAssessmentMutationVariables>;
export const ContentStageCandidateMarkCompleteDocument = gql`
    mutation ContentStageCandidateMarkComplete($contentStageCandidateId: Int!) {
  ContentStageCandidateMarkComplete(
    contentStageCandidateId: $contentStageCandidateId
  ) {
    id
    contentStageCandidateId
    status
  }
}
    `;
export type ContentStageCandidateMarkCompleteMutationFn = Apollo.MutationFunction<ContentStageCandidateMarkCompleteMutation, ContentStageCandidateMarkCompleteMutationVariables>;

/**
 * __useContentStageCandidateMarkCompleteMutation__
 *
 * To run a mutation, you first call `useContentStageCandidateMarkCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContentStageCandidateMarkCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contentStageCandidateMarkCompleteMutation, { data, loading, error }] = useContentStageCandidateMarkCompleteMutation({
 *   variables: {
 *      contentStageCandidateId: // value for 'contentStageCandidateId'
 *   },
 * });
 */
export function useContentStageCandidateMarkCompleteMutation(baseOptions?: Apollo.MutationHookOptions<ContentStageCandidateMarkCompleteMutation, ContentStageCandidateMarkCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContentStageCandidateMarkCompleteMutation, ContentStageCandidateMarkCompleteMutationVariables>(ContentStageCandidateMarkCompleteDocument, options);
      }
export type ContentStageCandidateMarkCompleteMutationHookResult = ReturnType<typeof useContentStageCandidateMarkCompleteMutation>;
export type ContentStageCandidateMarkCompleteMutationResult = Apollo.MutationResult<ContentStageCandidateMarkCompleteMutation>;
export type ContentStageCandidateMarkCompleteMutationOptions = Apollo.BaseMutationOptions<ContentStageCandidateMarkCompleteMutation, ContentStageCandidateMarkCompleteMutationVariables>;
export const StartEnglishProficiencyAssessmentDocument = gql`
    mutation StartEnglishProficiencyAssessment($id: ID!) {
  startEnglishProficiencyAssessment(id: $id) {
    id
    status
    assessmentId
    startedAt
    expiresAt
  }
}
    `;
export type StartEnglishProficiencyAssessmentMutationFn = Apollo.MutationFunction<StartEnglishProficiencyAssessmentMutation, StartEnglishProficiencyAssessmentMutationVariables>;

/**
 * __useStartEnglishProficiencyAssessmentMutation__
 *
 * To run a mutation, you first call `useStartEnglishProficiencyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEnglishProficiencyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEnglishProficiencyAssessmentMutation, { data, loading, error }] = useStartEnglishProficiencyAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartEnglishProficiencyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartEnglishProficiencyAssessmentMutation, StartEnglishProficiencyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEnglishProficiencyAssessmentMutation, StartEnglishProficiencyAssessmentMutationVariables>(StartEnglishProficiencyAssessmentDocument, options);
      }
export type StartEnglishProficiencyAssessmentMutationHookResult = ReturnType<typeof useStartEnglishProficiencyAssessmentMutation>;
export type StartEnglishProficiencyAssessmentMutationResult = Apollo.MutationResult<StartEnglishProficiencyAssessmentMutation>;
export type StartEnglishProficiencyAssessmentMutationOptions = Apollo.BaseMutationOptions<StartEnglishProficiencyAssessmentMutation, StartEnglishProficiencyAssessmentMutationVariables>;
export const SaveEnglishProficiencyResponseDocument = gql`
    mutation SaveEnglishProficiencyResponse($id: ID!, $questionIndex: Int!, $selectedAnswerIndex: Int, $blankAnswers: [String!]) {
  saveEnglishProficiencyResponse(
    id: $id
    questionIndex: $questionIndex
    selectedAnswerIndex: $selectedAnswerIndex
    blankAnswers: $blankAnswers
  ) {
    saved
    remainingSeconds
  }
}
    `;
export type SaveEnglishProficiencyResponseMutationFn = Apollo.MutationFunction<SaveEnglishProficiencyResponseMutation, SaveEnglishProficiencyResponseMutationVariables>;

/**
 * __useSaveEnglishProficiencyResponseMutation__
 *
 * To run a mutation, you first call `useSaveEnglishProficiencyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveEnglishProficiencyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveEnglishProficiencyResponseMutation, { data, loading, error }] = useSaveEnglishProficiencyResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionIndex: // value for 'questionIndex'
 *      selectedAnswerIndex: // value for 'selectedAnswerIndex'
 *      blankAnswers: // value for 'blankAnswers'
 *   },
 * });
 */
export function useSaveEnglishProficiencyResponseMutation(baseOptions?: Apollo.MutationHookOptions<SaveEnglishProficiencyResponseMutation, SaveEnglishProficiencyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveEnglishProficiencyResponseMutation, SaveEnglishProficiencyResponseMutationVariables>(SaveEnglishProficiencyResponseDocument, options);
      }
export type SaveEnglishProficiencyResponseMutationHookResult = ReturnType<typeof useSaveEnglishProficiencyResponseMutation>;
export type SaveEnglishProficiencyResponseMutationResult = Apollo.MutationResult<SaveEnglishProficiencyResponseMutation>;
export type SaveEnglishProficiencyResponseMutationOptions = Apollo.BaseMutationOptions<SaveEnglishProficiencyResponseMutation, SaveEnglishProficiencyResponseMutationVariables>;
export const SubmitEnglishProficiencyAssessmentDocument = gql`
    mutation SubmitEnglishProficiencyAssessment($id: ID!) {
  submitEnglishProficiencyAssessment(id: $id)
}
    `;
export type SubmitEnglishProficiencyAssessmentMutationFn = Apollo.MutationFunction<SubmitEnglishProficiencyAssessmentMutation, SubmitEnglishProficiencyAssessmentMutationVariables>;

/**
 * __useSubmitEnglishProficiencyAssessmentMutation__
 *
 * To run a mutation, you first call `useSubmitEnglishProficiencyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitEnglishProficiencyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitEnglishProficiencyAssessmentMutation, { data, loading, error }] = useSubmitEnglishProficiencyAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitEnglishProficiencyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitEnglishProficiencyAssessmentMutation, SubmitEnglishProficiencyAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitEnglishProficiencyAssessmentMutation, SubmitEnglishProficiencyAssessmentMutationVariables>(SubmitEnglishProficiencyAssessmentDocument, options);
      }
export type SubmitEnglishProficiencyAssessmentMutationHookResult = ReturnType<typeof useSubmitEnglishProficiencyAssessmentMutation>;
export type SubmitEnglishProficiencyAssessmentMutationResult = Apollo.MutationResult<SubmitEnglishProficiencyAssessmentMutation>;
export type SubmitEnglishProficiencyAssessmentMutationOptions = Apollo.BaseMutationOptions<SubmitEnglishProficiencyAssessmentMutation, SubmitEnglishProficiencyAssessmentMutationVariables>;
export const InitiateVerificationDocument = gql`
    mutation InitiateVerification {
  initiateVerification {
    status
    sessionUrl
  }
}
    `;
export type InitiateVerificationMutationFn = Apollo.MutationFunction<InitiateVerificationMutation, InitiateVerificationMutationVariables>;

/**
 * __useInitiateVerificationMutation__
 *
 * To run a mutation, you first call `useInitiateVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateVerificationMutation, { data, loading, error }] = useInitiateVerificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useInitiateVerificationMutation(baseOptions?: Apollo.MutationHookOptions<InitiateVerificationMutation, InitiateVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateVerificationMutation, InitiateVerificationMutationVariables>(InitiateVerificationDocument, options);
      }
export type InitiateVerificationMutationHookResult = ReturnType<typeof useInitiateVerificationMutation>;
export type InitiateVerificationMutationResult = Apollo.MutationResult<InitiateVerificationMutation>;
export type InitiateVerificationMutationOptions = Apollo.BaseMutationOptions<InitiateVerificationMutation, InitiateVerificationMutationVariables>;
export const StartAiInterviewIntegrityMonitoringSessionDocument = gql`
    mutation startAiInterviewIntegrityMonitoringSession($aiInterviewAssessmentStageActionCandidateId: ID!, $input: StartIntegrityMonitoringSessionInput!) {
  startAiInterviewIntegrityMonitoringSession(
    aiInterviewAssessmentStageActionCandidateId: $aiInterviewAssessmentStageActionCandidateId
    input: $input
  ) {
    id
    startedAt
  }
}
    `;
export type StartAiInterviewIntegrityMonitoringSessionMutationFn = Apollo.MutationFunction<StartAiInterviewIntegrityMonitoringSessionMutation, StartAiInterviewIntegrityMonitoringSessionMutationVariables>;

/**
 * __useStartAiInterviewIntegrityMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useStartAiInterviewIntegrityMonitoringSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiInterviewIntegrityMonitoringSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiInterviewIntegrityMonitoringSessionMutation, { data, loading, error }] = useStartAiInterviewIntegrityMonitoringSessionMutation({
 *   variables: {
 *      aiInterviewAssessmentStageActionCandidateId: // value for 'aiInterviewAssessmentStageActionCandidateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiInterviewIntegrityMonitoringSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartAiInterviewIntegrityMonitoringSessionMutation, StartAiInterviewIntegrityMonitoringSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiInterviewIntegrityMonitoringSessionMutation, StartAiInterviewIntegrityMonitoringSessionMutationVariables>(StartAiInterviewIntegrityMonitoringSessionDocument, options);
      }
export type StartAiInterviewIntegrityMonitoringSessionMutationHookResult = ReturnType<typeof useStartAiInterviewIntegrityMonitoringSessionMutation>;
export type StartAiInterviewIntegrityMonitoringSessionMutationResult = Apollo.MutationResult<StartAiInterviewIntegrityMonitoringSessionMutation>;
export type StartAiInterviewIntegrityMonitoringSessionMutationOptions = Apollo.BaseMutationOptions<StartAiInterviewIntegrityMonitoringSessionMutation, StartAiInterviewIntegrityMonitoringSessionMutationVariables>;
export const StartCognitiveTestIntegrityMonitoringSessionDocument = gql`
    mutation startCognitiveTestIntegrityMonitoringSession($cognitiveTestAssessmentStageActionCandidateId: ID!, $input: StartIntegrityMonitoringSessionInput!) {
  startCognitiveTestIntegrityMonitoringSession(
    cognitiveTestAssessmentStageActionCandidateId: $cognitiveTestAssessmentStageActionCandidateId
    input: $input
  ) {
    id
    startedAt
  }
}
    `;
export type StartCognitiveTestIntegrityMonitoringSessionMutationFn = Apollo.MutationFunction<StartCognitiveTestIntegrityMonitoringSessionMutation, StartCognitiveTestIntegrityMonitoringSessionMutationVariables>;

/**
 * __useStartCognitiveTestIntegrityMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useStartCognitiveTestIntegrityMonitoringSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCognitiveTestIntegrityMonitoringSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCognitiveTestIntegrityMonitoringSessionMutation, { data, loading, error }] = useStartCognitiveTestIntegrityMonitoringSessionMutation({
 *   variables: {
 *      cognitiveTestAssessmentStageActionCandidateId: // value for 'cognitiveTestAssessmentStageActionCandidateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartCognitiveTestIntegrityMonitoringSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartCognitiveTestIntegrityMonitoringSessionMutation, StartCognitiveTestIntegrityMonitoringSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCognitiveTestIntegrityMonitoringSessionMutation, StartCognitiveTestIntegrityMonitoringSessionMutationVariables>(StartCognitiveTestIntegrityMonitoringSessionDocument, options);
      }
export type StartCognitiveTestIntegrityMonitoringSessionMutationHookResult = ReturnType<typeof useStartCognitiveTestIntegrityMonitoringSessionMutation>;
export type StartCognitiveTestIntegrityMonitoringSessionMutationResult = Apollo.MutationResult<StartCognitiveTestIntegrityMonitoringSessionMutation>;
export type StartCognitiveTestIntegrityMonitoringSessionMutationOptions = Apollo.BaseMutationOptions<StartCognitiveTestIntegrityMonitoringSessionMutation, StartCognitiveTestIntegrityMonitoringSessionMutationVariables>;
export const StartPersonalityTestIntegrityMonitoringSessionDocument = gql`
    mutation startPersonalityTestIntegrityMonitoringSession($personalityTestAssessmentStageActionCandidateId: ID!, $input: StartIntegrityMonitoringSessionInput!) {
  startPersonalityTestIntegrityMonitoringSession(
    personalityTestAssessmentStageActionCandidateId: $personalityTestAssessmentStageActionCandidateId
    input: $input
  ) {
    id
    startedAt
  }
}
    `;
export type StartPersonalityTestIntegrityMonitoringSessionMutationFn = Apollo.MutationFunction<StartPersonalityTestIntegrityMonitoringSessionMutation, StartPersonalityTestIntegrityMonitoringSessionMutationVariables>;

/**
 * __useStartPersonalityTestIntegrityMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useStartPersonalityTestIntegrityMonitoringSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPersonalityTestIntegrityMonitoringSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPersonalityTestIntegrityMonitoringSessionMutation, { data, loading, error }] = useStartPersonalityTestIntegrityMonitoringSessionMutation({
 *   variables: {
 *      personalityTestAssessmentStageActionCandidateId: // value for 'personalityTestAssessmentStageActionCandidateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPersonalityTestIntegrityMonitoringSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartPersonalityTestIntegrityMonitoringSessionMutation, StartPersonalityTestIntegrityMonitoringSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPersonalityTestIntegrityMonitoringSessionMutation, StartPersonalityTestIntegrityMonitoringSessionMutationVariables>(StartPersonalityTestIntegrityMonitoringSessionDocument, options);
      }
export type StartPersonalityTestIntegrityMonitoringSessionMutationHookResult = ReturnType<typeof useStartPersonalityTestIntegrityMonitoringSessionMutation>;
export type StartPersonalityTestIntegrityMonitoringSessionMutationResult = Apollo.MutationResult<StartPersonalityTestIntegrityMonitoringSessionMutation>;
export type StartPersonalityTestIntegrityMonitoringSessionMutationOptions = Apollo.BaseMutationOptions<StartPersonalityTestIntegrityMonitoringSessionMutation, StartPersonalityTestIntegrityMonitoringSessionMutationVariables>;
export const ReportIntegrityEventsDocument = gql`
    mutation reportIntegrityEvents($sessionId: ID!, $events: [IntegrityEventInput!]!) {
  reportIntegrityEvents(sessionId: $sessionId, events: $events)
}
    `;
export type ReportIntegrityEventsMutationFn = Apollo.MutationFunction<ReportIntegrityEventsMutation, ReportIntegrityEventsMutationVariables>;

/**
 * __useReportIntegrityEventsMutation__
 *
 * To run a mutation, you first call `useReportIntegrityEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportIntegrityEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportIntegrityEventsMutation, { data, loading, error }] = useReportIntegrityEventsMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      events: // value for 'events'
 *   },
 * });
 */
export function useReportIntegrityEventsMutation(baseOptions?: Apollo.MutationHookOptions<ReportIntegrityEventsMutation, ReportIntegrityEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportIntegrityEventsMutation, ReportIntegrityEventsMutationVariables>(ReportIntegrityEventsDocument, options);
      }
export type ReportIntegrityEventsMutationHookResult = ReturnType<typeof useReportIntegrityEventsMutation>;
export type ReportIntegrityEventsMutationResult = Apollo.MutationResult<ReportIntegrityEventsMutation>;
export type ReportIntegrityEventsMutationOptions = Apollo.BaseMutationOptions<ReportIntegrityEventsMutation, ReportIntegrityEventsMutationVariables>;
export const EndIntegrityMonitoringSessionDocument = gql`
    mutation endIntegrityMonitoringSession($sessionId: ID!) {
  endIntegrityMonitoringSession(sessionId: $sessionId) {
    id
    endedAt
    flagsCount
  }
}
    `;
export type EndIntegrityMonitoringSessionMutationFn = Apollo.MutationFunction<EndIntegrityMonitoringSessionMutation, EndIntegrityMonitoringSessionMutationVariables>;

/**
 * __useEndIntegrityMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useEndIntegrityMonitoringSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndIntegrityMonitoringSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endIntegrityMonitoringSessionMutation, { data, loading, error }] = useEndIntegrityMonitoringSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useEndIntegrityMonitoringSessionMutation(baseOptions?: Apollo.MutationHookOptions<EndIntegrityMonitoringSessionMutation, EndIntegrityMonitoringSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndIntegrityMonitoringSessionMutation, EndIntegrityMonitoringSessionMutationVariables>(EndIntegrityMonitoringSessionDocument, options);
      }
export type EndIntegrityMonitoringSessionMutationHookResult = ReturnType<typeof useEndIntegrityMonitoringSessionMutation>;
export type EndIntegrityMonitoringSessionMutationResult = Apollo.MutationResult<EndIntegrityMonitoringSessionMutation>;
export type EndIntegrityMonitoringSessionMutationOptions = Apollo.BaseMutationOptions<EndIntegrityMonitoringSessionMutation, EndIntegrityMonitoringSessionMutationVariables>;
export const StartEnglishProficiencyIntegrityMonitoringSessionDocument = gql`
    mutation startEnglishProficiencyIntegrityMonitoringSession($englishProficiencyAssessmentStageActionCandidateId: ID!, $input: StartIntegrityMonitoringSessionInput!) {
  startEnglishProficiencyIntegrityMonitoringSession(
    englishProficiencyAssessmentStageActionCandidateId: $englishProficiencyAssessmentStageActionCandidateId
    input: $input
  ) {
    id
    startedAt
  }
}
    `;
export type StartEnglishProficiencyIntegrityMonitoringSessionMutationFn = Apollo.MutationFunction<StartEnglishProficiencyIntegrityMonitoringSessionMutation, StartEnglishProficiencyIntegrityMonitoringSessionMutationVariables>;

/**
 * __useStartEnglishProficiencyIntegrityMonitoringSessionMutation__
 *
 * To run a mutation, you first call `useStartEnglishProficiencyIntegrityMonitoringSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEnglishProficiencyIntegrityMonitoringSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEnglishProficiencyIntegrityMonitoringSessionMutation, { data, loading, error }] = useStartEnglishProficiencyIntegrityMonitoringSessionMutation({
 *   variables: {
 *      englishProficiencyAssessmentStageActionCandidateId: // value for 'englishProficiencyAssessmentStageActionCandidateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartEnglishProficiencyIntegrityMonitoringSessionMutation(baseOptions?: Apollo.MutationHookOptions<StartEnglishProficiencyIntegrityMonitoringSessionMutation, StartEnglishProficiencyIntegrityMonitoringSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEnglishProficiencyIntegrityMonitoringSessionMutation, StartEnglishProficiencyIntegrityMonitoringSessionMutationVariables>(StartEnglishProficiencyIntegrityMonitoringSessionDocument, options);
      }
export type StartEnglishProficiencyIntegrityMonitoringSessionMutationHookResult = ReturnType<typeof useStartEnglishProficiencyIntegrityMonitoringSessionMutation>;
export type StartEnglishProficiencyIntegrityMonitoringSessionMutationResult = Apollo.MutationResult<StartEnglishProficiencyIntegrityMonitoringSessionMutation>;
export type StartEnglishProficiencyIntegrityMonitoringSessionMutationOptions = Apollo.BaseMutationOptions<StartEnglishProficiencyIntegrityMonitoringSessionMutation, StartEnglishProficiencyIntegrityMonitoringSessionMutationVariables>;
export const QCalcGetNextQuestionDocument = gql`
    mutation QCalcGetNextQuestion($answers: [AssessmentDataAnswerGQLModel!], $assessmentSubId: String!, $nQuestions: Int!) {
  QCalcGetNextQuestion(
    answers: $answers
    assessmentSubId: $assessmentSubId
    nQuestions: $nQuestions
  ) {
    ... on PersonalityItemModel {
      isCompleted
      questions {
        difficulty
        options {
          key
          subId
          text
          value
        }
        orientation
        subId
        text
      }
      remainingQuestions
      totalQuestions
      testCandidateStatus
    }
    ... on InductiveItemModel {
      isCompleted
      question {
        difficulty
        imageUrls
        options {
          imageUrl
          key
          subId
        }
        subId
        text
        timeLimit
      }
      remainingQuestions
      remainingTime
      testCandidateStatus
      totalQuestions
    }
    ... on NumericalTestletModel {
      isCompleted
      imageUrl
      questions {
        difficulty
        options {
          key
          subId
          text
        }
        subId
        text
      }
      remainingQuestions
      remainingTime
      testCandidateStatus
      timeLimit
      totalQuestions
    }
    ... on VerbalTestletModel {
      isCompleted
      text
      questions {
        difficulty
        options {
          key
          subId
          text
        }
        subId
        text
      }
      remainingQuestions
      remainingTime
      testCandidateStatus
      timeLimit
      totalQuestions
    }
    ... on TrItemModel {
      isCompleted
      questions {
        options {
          key
          subId
          text
        }
        orientation
        subId
        text
      }
      remainingQuestions
      totalQuestions
      testCandidateStatus
    }
  }
}
    `;
export type QCalcGetNextQuestionMutationFn = Apollo.MutationFunction<QCalcGetNextQuestionMutation, QCalcGetNextQuestionMutationVariables>;

/**
 * __useQCalcGetNextQuestionMutation__
 *
 * To run a mutation, you first call `useQCalcGetNextQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQCalcGetNextQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [qCalcGetNextQuestionMutation, { data, loading, error }] = useQCalcGetNextQuestionMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *      assessmentSubId: // value for 'assessmentSubId'
 *      nQuestions: // value for 'nQuestions'
 *   },
 * });
 */
export function useQCalcGetNextQuestionMutation(baseOptions?: Apollo.MutationHookOptions<QCalcGetNextQuestionMutation, QCalcGetNextQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QCalcGetNextQuestionMutation, QCalcGetNextQuestionMutationVariables>(QCalcGetNextQuestionDocument, options);
      }
export type QCalcGetNextQuestionMutationHookResult = ReturnType<typeof useQCalcGetNextQuestionMutation>;
export type QCalcGetNextQuestionMutationResult = Apollo.MutationResult<QCalcGetNextQuestionMutation>;
export type QCalcGetNextQuestionMutationOptions = Apollo.BaseMutationOptions<QCalcGetNextQuestionMutation, QCalcGetNextQuestionMutationVariables>;
export const QuestionnaireSubmitResponsesDocument = gql`
    mutation QuestionnaireSubmitResponses($shortlistStageCandidateId: Int!, $responses: [QuestionnaireItemResponseGQLInput!]!) {
  QuestionnaireSubmitResponses(
    shortlistStageCandidateId: $shortlistStageCandidateId
    responses: $responses
  ) {
    id
    shortlistStageCandidateId
    status
    items {
      id
      answer
    }
  }
}
    `;
export type QuestionnaireSubmitResponsesMutationFn = Apollo.MutationFunction<QuestionnaireSubmitResponsesMutation, QuestionnaireSubmitResponsesMutationVariables>;

/**
 * __useQuestionnaireSubmitResponsesMutation__
 *
 * To run a mutation, you first call `useQuestionnaireSubmitResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuestionnaireSubmitResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [questionnaireSubmitResponsesMutation, { data, loading, error }] = useQuestionnaireSubmitResponsesMutation({
 *   variables: {
 *      shortlistStageCandidateId: // value for 'shortlistStageCandidateId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useQuestionnaireSubmitResponsesMutation(baseOptions?: Apollo.MutationHookOptions<QuestionnaireSubmitResponsesMutation, QuestionnaireSubmitResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuestionnaireSubmitResponsesMutation, QuestionnaireSubmitResponsesMutationVariables>(QuestionnaireSubmitResponsesDocument, options);
      }
export type QuestionnaireSubmitResponsesMutationHookResult = ReturnType<typeof useQuestionnaireSubmitResponsesMutation>;
export type QuestionnaireSubmitResponsesMutationResult = Apollo.MutationResult<QuestionnaireSubmitResponsesMutation>;
export type QuestionnaireSubmitResponsesMutationOptions = Apollo.BaseMutationOptions<QuestionnaireSubmitResponsesMutation, QuestionnaireSubmitResponsesMutationVariables>;
export const StageCandidateSubmitAdjustmentQuestionnaireDocument = gql`
    mutation StageCandidateSubmitAdjustmentQuestionnaire($responses: [AdjustmentQuestionnaireResponse!]!, $stageCandidateId: Int!) {
  StageCandidateSubmitAdjustmentQuestionnaire(
    responses: $responses
    stageCandidateId: $stageCandidateId
  ) {
    hasCompletedAdjustmentQuestionnaire
    shouldContactUs
  }
}
    `;
export type StageCandidateSubmitAdjustmentQuestionnaireMutationFn = Apollo.MutationFunction<StageCandidateSubmitAdjustmentQuestionnaireMutation, StageCandidateSubmitAdjustmentQuestionnaireMutationVariables>;

/**
 * __useStageCandidateSubmitAdjustmentQuestionnaireMutation__
 *
 * To run a mutation, you first call `useStageCandidateSubmitAdjustmentQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStageCandidateSubmitAdjustmentQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stageCandidateSubmitAdjustmentQuestionnaireMutation, { data, loading, error }] = useStageCandidateSubmitAdjustmentQuestionnaireMutation({
 *   variables: {
 *      responses: // value for 'responses'
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useStageCandidateSubmitAdjustmentQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<StageCandidateSubmitAdjustmentQuestionnaireMutation, StageCandidateSubmitAdjustmentQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StageCandidateSubmitAdjustmentQuestionnaireMutation, StageCandidateSubmitAdjustmentQuestionnaireMutationVariables>(StageCandidateSubmitAdjustmentQuestionnaireDocument, options);
      }
export type StageCandidateSubmitAdjustmentQuestionnaireMutationHookResult = ReturnType<typeof useStageCandidateSubmitAdjustmentQuestionnaireMutation>;
export type StageCandidateSubmitAdjustmentQuestionnaireMutationResult = Apollo.MutationResult<StageCandidateSubmitAdjustmentQuestionnaireMutation>;
export type StageCandidateSubmitAdjustmentQuestionnaireMutationOptions = Apollo.BaseMutationOptions<StageCandidateSubmitAdjustmentQuestionnaireMutation, StageCandidateSubmitAdjustmentQuestionnaireMutationVariables>;
export const RespondantFormUpdateDocument = gql`
    mutation RespondantFormUpdate($associatedId: Int!, $formOwnerId: Int!, $formType: FormType!, $answers: [UpdateRespondantFormAnswerArgs!]) {
  respondantForm: RespondantFormUpdate(
    associatedId: $associatedId
    formOwnerId: $formOwnerId
    formType: $formType
    answers: $answers
  ) {
    isComplete
    submittedFormLogId
    formType
    formOwnerId
    associatedId
    formId
    respondantFieldWithAnswers {
      field {
        id
        question
        hint
        settings {
          allowFreeText
          searchable
        }
        isArchived
        fieldType
        ... on CompanyEmployeeSelectField {
          dynamicSelectOptions
        }
        ... on MultiSelectField {
          selectOptions
        }
        ... on SingleSelectField {
          selectOptions
        }
      }
      displayOrder
      isOptional
      answer
      selectOptionAnswerIsFreeText
    }
  }
}
    `;
export type RespondantFormUpdateMutationFn = Apollo.MutationFunction<RespondantFormUpdateMutation, RespondantFormUpdateMutationVariables>;

/**
 * __useRespondantFormUpdateMutation__
 *
 * To run a mutation, you first call `useRespondantFormUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondantFormUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondantFormUpdateMutation, { data, loading, error }] = useRespondantFormUpdateMutation({
 *   variables: {
 *      associatedId: // value for 'associatedId'
 *      formOwnerId: // value for 'formOwnerId'
 *      formType: // value for 'formType'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useRespondantFormUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RespondantFormUpdateMutation, RespondantFormUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondantFormUpdateMutation, RespondantFormUpdateMutationVariables>(RespondantFormUpdateDocument, options);
      }
export type RespondantFormUpdateMutationHookResult = ReturnType<typeof useRespondantFormUpdateMutation>;
export type RespondantFormUpdateMutationResult = Apollo.MutationResult<RespondantFormUpdateMutation>;
export type RespondantFormUpdateMutationOptions = Apollo.BaseMutationOptions<RespondantFormUpdateMutation, RespondantFormUpdateMutationVariables>;
export const ResultCreateManySoftSkillsProfileFromScDocument = gql`
    mutation ResultCreateManySoftSkillsProfileFromSc($args: [ResultSoftSkillProfileCreateOneFromSc!]!) {
  ResultCreateManySoftSkillsProfileFromSc(args: $args) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type ResultCreateManySoftSkillsProfileFromScMutationFn = Apollo.MutationFunction<ResultCreateManySoftSkillsProfileFromScMutation, ResultCreateManySoftSkillsProfileFromScMutationVariables>;

/**
 * __useResultCreateManySoftSkillsProfileFromScMutation__
 *
 * To run a mutation, you first call `useResultCreateManySoftSkillsProfileFromScMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResultCreateManySoftSkillsProfileFromScMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resultCreateManySoftSkillsProfileFromScMutation, { data, loading, error }] = useResultCreateManySoftSkillsProfileFromScMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useResultCreateManySoftSkillsProfileFromScMutation(baseOptions?: Apollo.MutationHookOptions<ResultCreateManySoftSkillsProfileFromScMutation, ResultCreateManySoftSkillsProfileFromScMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResultCreateManySoftSkillsProfileFromScMutation, ResultCreateManySoftSkillsProfileFromScMutationVariables>(ResultCreateManySoftSkillsProfileFromScDocument, options);
      }
export type ResultCreateManySoftSkillsProfileFromScMutationHookResult = ReturnType<typeof useResultCreateManySoftSkillsProfileFromScMutation>;
export type ResultCreateManySoftSkillsProfileFromScMutationResult = Apollo.MutationResult<ResultCreateManySoftSkillsProfileFromScMutation>;
export type ResultCreateManySoftSkillsProfileFromScMutationOptions = Apollo.BaseMutationOptions<ResultCreateManySoftSkillsProfileFromScMutation, ResultCreateManySoftSkillsProfileFromScMutationVariables>;
export const ResultCreateManyTechnicalSkillsProfileFromScDocument = gql`
    mutation ResultCreateManyTechnicalSkillsProfileFromSc($args: [ResultTechnicalSkillProfileCreateOneFromSc!]!) {
  ResultCreateManyTechnicalSkillsProfileFromSc(args: $args) {
    ...Result
  }
}
    ${ResultFragmentDoc}`;
export type ResultCreateManyTechnicalSkillsProfileFromScMutationFn = Apollo.MutationFunction<ResultCreateManyTechnicalSkillsProfileFromScMutation, ResultCreateManyTechnicalSkillsProfileFromScMutationVariables>;

/**
 * __useResultCreateManyTechnicalSkillsProfileFromScMutation__
 *
 * To run a mutation, you first call `useResultCreateManyTechnicalSkillsProfileFromScMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResultCreateManyTechnicalSkillsProfileFromScMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resultCreateManyTechnicalSkillsProfileFromScMutation, { data, loading, error }] = useResultCreateManyTechnicalSkillsProfileFromScMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useResultCreateManyTechnicalSkillsProfileFromScMutation(baseOptions?: Apollo.MutationHookOptions<ResultCreateManyTechnicalSkillsProfileFromScMutation, ResultCreateManyTechnicalSkillsProfileFromScMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResultCreateManyTechnicalSkillsProfileFromScMutation, ResultCreateManyTechnicalSkillsProfileFromScMutationVariables>(ResultCreateManyTechnicalSkillsProfileFromScDocument, options);
      }
export type ResultCreateManyTechnicalSkillsProfileFromScMutationHookResult = ReturnType<typeof useResultCreateManyTechnicalSkillsProfileFromScMutation>;
export type ResultCreateManyTechnicalSkillsProfileFromScMutationResult = Apollo.MutationResult<ResultCreateManyTechnicalSkillsProfileFromScMutation>;
export type ResultCreateManyTechnicalSkillsProfileFromScMutationOptions = Apollo.BaseMutationOptions<ResultCreateManyTechnicalSkillsProfileFromScMutation, ResultCreateManyTechnicalSkillsProfileFromScMutationVariables>;
export const RssAssessmentCandidateSubmitOneDocument = gql`
    mutation RssAssessmentCandidateSubmitOne($id: Int!) {
  RssAssessmentCandidateSubmitOne(id: $id) {
    ...RssAssessmentCandidate
  }
}
    ${RssAssessmentCandidateFragmentDoc}`;
export type RssAssessmentCandidateSubmitOneMutationFn = Apollo.MutationFunction<RssAssessmentCandidateSubmitOneMutation, RssAssessmentCandidateSubmitOneMutationVariables>;

/**
 * __useRssAssessmentCandidateSubmitOneMutation__
 *
 * To run a mutation, you first call `useRssAssessmentCandidateSubmitOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRssAssessmentCandidateSubmitOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rssAssessmentCandidateSubmitOneMutation, { data, loading, error }] = useRssAssessmentCandidateSubmitOneMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRssAssessmentCandidateSubmitOneMutation(baseOptions?: Apollo.MutationHookOptions<RssAssessmentCandidateSubmitOneMutation, RssAssessmentCandidateSubmitOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RssAssessmentCandidateSubmitOneMutation, RssAssessmentCandidateSubmitOneMutationVariables>(RssAssessmentCandidateSubmitOneDocument, options);
      }
export type RssAssessmentCandidateSubmitOneMutationHookResult = ReturnType<typeof useRssAssessmentCandidateSubmitOneMutation>;
export type RssAssessmentCandidateSubmitOneMutationResult = Apollo.MutationResult<RssAssessmentCandidateSubmitOneMutation>;
export type RssAssessmentCandidateSubmitOneMutationOptions = Apollo.BaseMutationOptions<RssAssessmentCandidateSubmitOneMutation, RssAssessmentCandidateSubmitOneMutationVariables>;
export const ResultCreateOnePspSoftSkillDocument = gql`
    mutation ResultCreateOnePspSoftSkill($score: ISoftSkillSelfAssessmentScoreModel!, $id: Int!) {
  ResultCreateOnePspSoftSkill(score: $score, softSkillId: $id) {
    measurementId
    updatedAt
    score {
      ... on SoftSkillSelfAssessmentScoreModel {
        proficiency
      }
    }
  }
}
    `;
export type ResultCreateOnePspSoftSkillMutationFn = Apollo.MutationFunction<ResultCreateOnePspSoftSkillMutation, ResultCreateOnePspSoftSkillMutationVariables>;

/**
 * __useResultCreateOnePspSoftSkillMutation__
 *
 * To run a mutation, you first call `useResultCreateOnePspSoftSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResultCreateOnePspSoftSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resultCreateOnePspSoftSkillMutation, { data, loading, error }] = useResultCreateOnePspSoftSkillMutation({
 *   variables: {
 *      score: // value for 'score'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResultCreateOnePspSoftSkillMutation(baseOptions?: Apollo.MutationHookOptions<ResultCreateOnePspSoftSkillMutation, ResultCreateOnePspSoftSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResultCreateOnePspSoftSkillMutation, ResultCreateOnePspSoftSkillMutationVariables>(ResultCreateOnePspSoftSkillDocument, options);
      }
export type ResultCreateOnePspSoftSkillMutationHookResult = ReturnType<typeof useResultCreateOnePspSoftSkillMutation>;
export type ResultCreateOnePspSoftSkillMutationResult = Apollo.MutationResult<ResultCreateOnePspSoftSkillMutation>;
export type ResultCreateOnePspSoftSkillMutationOptions = Apollo.BaseMutationOptions<ResultCreateOnePspSoftSkillMutation, ResultCreateOnePspSoftSkillMutationVariables>;
export const ResultCreateOnePspTechnicalSkillDocument = gql`
    mutation ResultCreateOnePspTechnicalSkill($score: ITechnicalSkillSelfAssessmentScoreModel!, $id: Int!) {
  ResultCreateOnePspTechnicalSkill(score: $score, technicalSkillId: $id) {
    measurementId
    updatedAt
    score {
      ... on TechnicalSkillSelfAssessmentScoreModel {
        technicalProficiency
      }
    }
  }
}
    `;
export type ResultCreateOnePspTechnicalSkillMutationFn = Apollo.MutationFunction<ResultCreateOnePspTechnicalSkillMutation, ResultCreateOnePspTechnicalSkillMutationVariables>;

/**
 * __useResultCreateOnePspTechnicalSkillMutation__
 *
 * To run a mutation, you first call `useResultCreateOnePspTechnicalSkillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResultCreateOnePspTechnicalSkillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resultCreateOnePspTechnicalSkillMutation, { data, loading, error }] = useResultCreateOnePspTechnicalSkillMutation({
 *   variables: {
 *      score: // value for 'score'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResultCreateOnePspTechnicalSkillMutation(baseOptions?: Apollo.MutationHookOptions<ResultCreateOnePspTechnicalSkillMutation, ResultCreateOnePspTechnicalSkillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResultCreateOnePspTechnicalSkillMutation, ResultCreateOnePspTechnicalSkillMutationVariables>(ResultCreateOnePspTechnicalSkillDocument, options);
      }
export type ResultCreateOnePspTechnicalSkillMutationHookResult = ReturnType<typeof useResultCreateOnePspTechnicalSkillMutation>;
export type ResultCreateOnePspTechnicalSkillMutationResult = Apollo.MutationResult<ResultCreateOnePspTechnicalSkillMutation>;
export type ResultCreateOnePspTechnicalSkillMutationOptions = Apollo.BaseMutationOptions<ResultCreateOnePspTechnicalSkillMutation, ResultCreateOnePspTechnicalSkillMutationVariables>;
export const DeiStageActionCandidateSubmitResponsesDocument = gql`
    mutation DeiStageActionCandidateSubmitResponses($stageCandidateId: Int!, $responses: DeiStageActionCandidateResponsesInput!) {
  DeiStageActionCandidateSubmitResponses(
    stageCandidateId: $stageCandidateId
    responses: $responses
  ) {
    status
  }
}
    `;
export type DeiStageActionCandidateSubmitResponsesMutationFn = Apollo.MutationFunction<DeiStageActionCandidateSubmitResponsesMutation, DeiStageActionCandidateSubmitResponsesMutationVariables>;

/**
 * __useDeiStageActionCandidateSubmitResponsesMutation__
 *
 * To run a mutation, you first call `useDeiStageActionCandidateSubmitResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionCandidateSubmitResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionCandidateSubmitResponsesMutation, { data, loading, error }] = useDeiStageActionCandidateSubmitResponsesMutation({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useDeiStageActionCandidateSubmitResponsesMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionCandidateSubmitResponsesMutation, DeiStageActionCandidateSubmitResponsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionCandidateSubmitResponsesMutation, DeiStageActionCandidateSubmitResponsesMutationVariables>(DeiStageActionCandidateSubmitResponsesDocument, options);
      }
export type DeiStageActionCandidateSubmitResponsesMutationHookResult = ReturnType<typeof useDeiStageActionCandidateSubmitResponsesMutation>;
export type DeiStageActionCandidateSubmitResponsesMutationResult = Apollo.MutationResult<DeiStageActionCandidateSubmitResponsesMutation>;
export type DeiStageActionCandidateSubmitResponsesMutationOptions = Apollo.BaseMutationOptions<DeiStageActionCandidateSubmitResponsesMutation, DeiStageActionCandidateSubmitResponsesMutationVariables>;
export const DeiStageActionCandidateGiveConsentDocument = gql`
    mutation DeiStageActionCandidateGiveConsent($stageCandidateId: Int!) {
  DeiStageActionCandidateGiveConsent(stageCandidateId: $stageCandidateId) {
    status
    hasActiveConsent
  }
}
    `;
export type DeiStageActionCandidateGiveConsentMutationFn = Apollo.MutationFunction<DeiStageActionCandidateGiveConsentMutation, DeiStageActionCandidateGiveConsentMutationVariables>;

/**
 * __useDeiStageActionCandidateGiveConsentMutation__
 *
 * To run a mutation, you first call `useDeiStageActionCandidateGiveConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionCandidateGiveConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionCandidateGiveConsentMutation, { data, loading, error }] = useDeiStageActionCandidateGiveConsentMutation({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useDeiStageActionCandidateGiveConsentMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionCandidateGiveConsentMutation, DeiStageActionCandidateGiveConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionCandidateGiveConsentMutation, DeiStageActionCandidateGiveConsentMutationVariables>(DeiStageActionCandidateGiveConsentDocument, options);
      }
export type DeiStageActionCandidateGiveConsentMutationHookResult = ReturnType<typeof useDeiStageActionCandidateGiveConsentMutation>;
export type DeiStageActionCandidateGiveConsentMutationResult = Apollo.MutationResult<DeiStageActionCandidateGiveConsentMutation>;
export type DeiStageActionCandidateGiveConsentMutationOptions = Apollo.BaseMutationOptions<DeiStageActionCandidateGiveConsentMutation, DeiStageActionCandidateGiveConsentMutationVariables>;
export const DeiStageActionCandidateDeclineConsentDocument = gql`
    mutation DeiStageActionCandidateDeclineConsent($stageCandidateId: Int!) {
  DeiStageActionCandidateDeclineConsent(stageCandidateId: $stageCandidateId) {
    status
    hasActiveConsent
  }
}
    `;
export type DeiStageActionCandidateDeclineConsentMutationFn = Apollo.MutationFunction<DeiStageActionCandidateDeclineConsentMutation, DeiStageActionCandidateDeclineConsentMutationVariables>;

/**
 * __useDeiStageActionCandidateDeclineConsentMutation__
 *
 * To run a mutation, you first call `useDeiStageActionCandidateDeclineConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeiStageActionCandidateDeclineConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deiStageActionCandidateDeclineConsentMutation, { data, loading, error }] = useDeiStageActionCandidateDeclineConsentMutation({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useDeiStageActionCandidateDeclineConsentMutation(baseOptions?: Apollo.MutationHookOptions<DeiStageActionCandidateDeclineConsentMutation, DeiStageActionCandidateDeclineConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeiStageActionCandidateDeclineConsentMutation, DeiStageActionCandidateDeclineConsentMutationVariables>(DeiStageActionCandidateDeclineConsentDocument, options);
      }
export type DeiStageActionCandidateDeclineConsentMutationHookResult = ReturnType<typeof useDeiStageActionCandidateDeclineConsentMutation>;
export type DeiStageActionCandidateDeclineConsentMutationResult = Apollo.MutationResult<DeiStageActionCandidateDeclineConsentMutation>;
export type DeiStageActionCandidateDeclineConsentMutationOptions = Apollo.BaseMutationOptions<DeiStageActionCandidateDeclineConsentMutation, DeiStageActionCandidateDeclineConsentMutationVariables>;
export const StartPersonalityTestAssessmentDocument = gql`
    mutation StartPersonalityTestAssessment($id: ID!, $locale: SupportedLocale) {
  startPersonalityTestAssessment(id: $id, locale: $locale) {
    id
    status
    assessmentId
    locale
  }
}
    `;
export type StartPersonalityTestAssessmentMutationFn = Apollo.MutationFunction<StartPersonalityTestAssessmentMutation, StartPersonalityTestAssessmentMutationVariables>;

/**
 * __useStartPersonalityTestAssessmentMutation__
 *
 * To run a mutation, you first call `useStartPersonalityTestAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPersonalityTestAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPersonalityTestAssessmentMutation, { data, loading, error }] = useStartPersonalityTestAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useStartPersonalityTestAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartPersonalityTestAssessmentMutation, StartPersonalityTestAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPersonalityTestAssessmentMutation, StartPersonalityTestAssessmentMutationVariables>(StartPersonalityTestAssessmentDocument, options);
      }
export type StartPersonalityTestAssessmentMutationHookResult = ReturnType<typeof useStartPersonalityTestAssessmentMutation>;
export type StartPersonalityTestAssessmentMutationResult = Apollo.MutationResult<StartPersonalityTestAssessmentMutation>;
export type StartPersonalityTestAssessmentMutationOptions = Apollo.BaseMutationOptions<StartPersonalityTestAssessmentMutation, StartPersonalityTestAssessmentMutationVariables>;
export const StartCognitiveTestAssessmentDocument = gql`
    mutation StartCognitiveTestAssessment($id: ID!) {
  startCognitiveTestAssessment(id: $id) {
    id
    status
    assessmentId
  }
}
    `;
export type StartCognitiveTestAssessmentMutationFn = Apollo.MutationFunction<StartCognitiveTestAssessmentMutation, StartCognitiveTestAssessmentMutationVariables>;

/**
 * __useStartCognitiveTestAssessmentMutation__
 *
 * To run a mutation, you first call `useStartCognitiveTestAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCognitiveTestAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCognitiveTestAssessmentMutation, { data, loading, error }] = useStartCognitiveTestAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartCognitiveTestAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartCognitiveTestAssessmentMutation, StartCognitiveTestAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCognitiveTestAssessmentMutation, StartCognitiveTestAssessmentMutationVariables>(StartCognitiveTestAssessmentDocument, options);
      }
export type StartCognitiveTestAssessmentMutationHookResult = ReturnType<typeof useStartCognitiveTestAssessmentMutation>;
export type StartCognitiveTestAssessmentMutationResult = Apollo.MutationResult<StartCognitiveTestAssessmentMutation>;
export type StartCognitiveTestAssessmentMutationOptions = Apollo.BaseMutationOptions<StartCognitiveTestAssessmentMutation, StartCognitiveTestAssessmentMutationVariables>;
export const StartCognitiveTestPracticeAssessmentDocument = gql`
    mutation StartCognitiveTestPracticeAssessment($id: ID!) {
  startCognitiveTestPracticeAssessment(id: $id) {
    assessmentId
  }
}
    `;
export type StartCognitiveTestPracticeAssessmentMutationFn = Apollo.MutationFunction<StartCognitiveTestPracticeAssessmentMutation, StartCognitiveTestPracticeAssessmentMutationVariables>;

/**
 * __useStartCognitiveTestPracticeAssessmentMutation__
 *
 * To run a mutation, you first call `useStartCognitiveTestPracticeAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCognitiveTestPracticeAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCognitiveTestPracticeAssessmentMutation, { data, loading, error }] = useStartCognitiveTestPracticeAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStartCognitiveTestPracticeAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<StartCognitiveTestPracticeAssessmentMutation, StartCognitiveTestPracticeAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCognitiveTestPracticeAssessmentMutation, StartCognitiveTestPracticeAssessmentMutationVariables>(StartCognitiveTestPracticeAssessmentDocument, options);
      }
export type StartCognitiveTestPracticeAssessmentMutationHookResult = ReturnType<typeof useStartCognitiveTestPracticeAssessmentMutation>;
export type StartCognitiveTestPracticeAssessmentMutationResult = Apollo.MutationResult<StartCognitiveTestPracticeAssessmentMutation>;
export type StartCognitiveTestPracticeAssessmentMutationOptions = Apollo.BaseMutationOptions<StartCognitiveTestPracticeAssessmentMutation, StartCognitiveTestPracticeAssessmentMutationVariables>;
export const UpdateMyLocalePreferenceDocument = gql`
    mutation UpdateMyLocalePreference($locale: SupportedLocale!) {
  updateMyLocalePreference(locale: $locale) {
    id
    preferredLocale {
      source
      locale
    }
  }
}
    `;
export type UpdateMyLocalePreferenceMutationFn = Apollo.MutationFunction<UpdateMyLocalePreferenceMutation, UpdateMyLocalePreferenceMutationVariables>;

/**
 * __useUpdateMyLocalePreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateMyLocalePreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyLocalePreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyLocalePreferenceMutation, { data, loading, error }] = useUpdateMyLocalePreferenceMutation({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useUpdateMyLocalePreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMyLocalePreferenceMutation, UpdateMyLocalePreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMyLocalePreferenceMutation, UpdateMyLocalePreferenceMutationVariables>(UpdateMyLocalePreferenceDocument, options);
      }
export type UpdateMyLocalePreferenceMutationHookResult = ReturnType<typeof useUpdateMyLocalePreferenceMutation>;
export type UpdateMyLocalePreferenceMutationResult = Apollo.MutationResult<UpdateMyLocalePreferenceMutation>;
export type UpdateMyLocalePreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateMyLocalePreferenceMutation, UpdateMyLocalePreferenceMutationVariables>;
export const GetConferenceDocument = gql`
    query getConference($id: ID!) {
  aiInterviewAssessmentStageActionCandidate(id: $id) {
    conference {
      id
      remainingDemoCount
    }
    status
    estimatedDurationMinutes
    timeModifierPercentage
    stageAction {
      isAvatarEnabled
      selectedLocales
    }
    stageCandidate {
      id
      shouldContactUs
    }
    consent {
      isRequired
      status
      consentText
    }
  }
}
    `;

/**
 * __useGetConferenceQuery__
 *
 * To run a query within a React component, call `useGetConferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConferenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConferenceQuery(baseOptions: Apollo.QueryHookOptions<GetConferenceQuery, GetConferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConferenceQuery, GetConferenceQueryVariables>(GetConferenceDocument, options);
      }
export function useGetConferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConferenceQuery, GetConferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConferenceQuery, GetConferenceQueryVariables>(GetConferenceDocument, options);
        }
export type GetConferenceQueryHookResult = ReturnType<typeof useGetConferenceQuery>;
export type GetConferenceLazyQueryHookResult = ReturnType<typeof useGetConferenceLazyQuery>;
export type GetConferenceQueryResult = Apollo.QueryResult<GetConferenceQuery, GetConferenceQueryVariables>;
export const AiInterviewRoleDocument = gql`
    query AiInterviewRole($id: ID!) {
  myRole(id: $id) {
    id
    candidatePortalEnabled
    company {
      id
      name
      logoUrl
    }
  }
}
    `;

/**
 * __useAiInterviewRoleQuery__
 *
 * To run a query within a React component, call `useAiInterviewRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiInterviewRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiInterviewRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiInterviewRoleQuery(baseOptions: Apollo.QueryHookOptions<AiInterviewRoleQuery, AiInterviewRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiInterviewRoleQuery, AiInterviewRoleQueryVariables>(AiInterviewRoleDocument, options);
      }
export function useAiInterviewRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiInterviewRoleQuery, AiInterviewRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiInterviewRoleQuery, AiInterviewRoleQueryVariables>(AiInterviewRoleDocument, options);
        }
export type AiInterviewRoleQueryHookResult = ReturnType<typeof useAiInterviewRoleQuery>;
export type AiInterviewRoleLazyQueryHookResult = ReturnType<typeof useAiInterviewRoleLazyQuery>;
export type AiInterviewRoleQueryResult = Apollo.QueryResult<AiInterviewRoleQuery, AiInterviewRoleQueryVariables>;
export const AiInterviewRoleStageDocument = gql`
    query AiInterviewRoleStage($id: ID!) {
  aiInterviewAssessmentStageActionCandidateRoleStage(id: $id) {
    roleId
    stageId
  }
}
    `;

/**
 * __useAiInterviewRoleStageQuery__
 *
 * To run a query within a React component, call `useAiInterviewRoleStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiInterviewRoleStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiInterviewRoleStageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAiInterviewRoleStageQuery(baseOptions: Apollo.QueryHookOptions<AiInterviewRoleStageQuery, AiInterviewRoleStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiInterviewRoleStageQuery, AiInterviewRoleStageQueryVariables>(AiInterviewRoleStageDocument, options);
      }
export function useAiInterviewRoleStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiInterviewRoleStageQuery, AiInterviewRoleStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiInterviewRoleStageQuery, AiInterviewRoleStageQueryVariables>(AiInterviewRoleStageDocument, options);
        }
export type AiInterviewRoleStageQueryHookResult = ReturnType<typeof useAiInterviewRoleStageQuery>;
export type AiInterviewRoleStageLazyQueryHookResult = ReturnType<typeof useAiInterviewRoleStageLazyQuery>;
export type AiInterviewRoleStageQueryResult = Apollo.QueryResult<AiInterviewRoleStageQuery, AiInterviewRoleStageQueryVariables>;
export const CandidatePortalRoleDocument = gql`
    query CandidatePortalRole($id: ID!) {
  myRole(id: $id) {
    id
    name
    candidatePortalEnabled
    coverPhotoUrl
    candidatePortalTitle
    candidatePortalIntro
    deadlineAt
    company {
      id
      name
      logoUrl
      branding {
        logoUrl
        accentColor1
        accentColor2
        textColor
        websiteLinkUrl
        careersLinkUrl
      }
    }
    candidateJourney {
      stageId
      stageType
      status
      title
      description
      thumbnailUrl
      estimatedTimeMinutes
    }
    questionnaireStages {
      id
    }
  }
}
    `;

/**
 * __useCandidatePortalRoleQuery__
 *
 * To run a query within a React component, call `useCandidatePortalRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidatePortalRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidatePortalRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCandidatePortalRoleQuery(baseOptions: Apollo.QueryHookOptions<CandidatePortalRoleQuery, CandidatePortalRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidatePortalRoleQuery, CandidatePortalRoleQueryVariables>(CandidatePortalRoleDocument, options);
      }
export function useCandidatePortalRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidatePortalRoleQuery, CandidatePortalRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidatePortalRoleQuery, CandidatePortalRoleQueryVariables>(CandidatePortalRoleDocument, options);
        }
export type CandidatePortalRoleQueryHookResult = ReturnType<typeof useCandidatePortalRoleQuery>;
export type CandidatePortalRoleLazyQueryHookResult = ReturnType<typeof useCandidatePortalRoleLazyQuery>;
export type CandidatePortalRoleQueryResult = Apollo.QueryResult<CandidatePortalRoleQuery, CandidatePortalRoleQueryVariables>;
export const ContentStageCandidateDocument = gql`
    query ContentStageCandidate($roleId: ID!, $stageId: ID!) {
  myRole(id: $roleId) {
    id
    name
    candidatePortalEnabled
    company {
      id
      name
      logoUrl
      branding {
        logoUrl
        accentColor1
        accentColor2
        textColor
        websiteLinkUrl
        careersLinkUrl
      }
    }
    contentStages(id: $stageId) {
      id
      contentStageCandidateId
      name
      description
      imageUrl
      estimatedDurationMinutes
      status
      blocks {
        kind
        imageUrl
        videoUrl
        title
        paragraph
      }
    }
  }
}
    `;

/**
 * __useContentStageCandidateQuery__
 *
 * To run a query within a React component, call `useContentStageCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentStageCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentStageCandidateQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useContentStageCandidateQuery(baseOptions: Apollo.QueryHookOptions<ContentStageCandidateQuery, ContentStageCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentStageCandidateQuery, ContentStageCandidateQueryVariables>(ContentStageCandidateDocument, options);
      }
export function useContentStageCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentStageCandidateQuery, ContentStageCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentStageCandidateQuery, ContentStageCandidateQueryVariables>(ContentStageCandidateDocument, options);
        }
export type ContentStageCandidateQueryHookResult = ReturnType<typeof useContentStageCandidateQuery>;
export type ContentStageCandidateLazyQueryHookResult = ReturnType<typeof useContentStageCandidateLazyQuery>;
export type ContentStageCandidateQueryResult = Apollo.QueryResult<ContentStageCandidateQuery, ContentStageCandidateQueryVariables>;
export const GetDeiStageActionCandidateDocument = gql`
    query GetDeiStageActionCandidate($stageCandidateId: Int!) {
  StageCandidateFindById(id: $stageCandidateId) {
    id
    status
    stage {
      id
      status
    }
    deiStageActionCandidate {
      ...DeiStageActionCandidate
    }
  }
}
    ${DeiStageActionCandidateFragmentDoc}`;

/**
 * __useGetDeiStageActionCandidateQuery__
 *
 * To run a query within a React component, call `useGetDeiStageActionCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeiStageActionCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeiStageActionCandidateQuery({
 *   variables: {
 *      stageCandidateId: // value for 'stageCandidateId'
 *   },
 * });
 */
export function useGetDeiStageActionCandidateQuery(baseOptions: Apollo.QueryHookOptions<GetDeiStageActionCandidateQuery, GetDeiStageActionCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeiStageActionCandidateQuery, GetDeiStageActionCandidateQueryVariables>(GetDeiStageActionCandidateDocument, options);
      }
export function useGetDeiStageActionCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeiStageActionCandidateQuery, GetDeiStageActionCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeiStageActionCandidateQuery, GetDeiStageActionCandidateQueryVariables>(GetDeiStageActionCandidateDocument, options);
        }
export type GetDeiStageActionCandidateQueryHookResult = ReturnType<typeof useGetDeiStageActionCandidateQuery>;
export type GetDeiStageActionCandidateLazyQueryHookResult = ReturnType<typeof useGetDeiStageActionCandidateLazyQuery>;
export type GetDeiStageActionCandidateQueryResult = Apollo.QueryResult<GetDeiStageActionCandidateQuery, GetDeiStageActionCandidateQueryVariables>;
export const EnglishProficiencyAssessmentDocument = gql`
    query EnglishProficiencyAssessment($id: ID!) {
  englishProficiencyAssessment(id: $id) {
    id
    remainingSeconds
    submittedAt
    questions {
      index
      kind
      text
      instructions
      category
      tags
      passage {
        title
        body
      }
      asset {
        url
        kind
      }
      ... on EnglishProficiencyMultipleChoiceQuestion {
        answers {
          index
          text
        }
      }
      ... on EnglishProficiencyShortAnswerQuestion {
        blankCount
        clue
      }
    }
    responses {
      questionIndex
      selectedAnswerIndex
      selectedAnswerText
      blankAnswers
    }
  }
}
    `;

/**
 * __useEnglishProficiencyAssessmentQuery__
 *
 * To run a query within a React component, call `useEnglishProficiencyAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnglishProficiencyAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnglishProficiencyAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnglishProficiencyAssessmentQuery(baseOptions: Apollo.QueryHookOptions<EnglishProficiencyAssessmentQuery, EnglishProficiencyAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnglishProficiencyAssessmentQuery, EnglishProficiencyAssessmentQueryVariables>(EnglishProficiencyAssessmentDocument, options);
      }
export function useEnglishProficiencyAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnglishProficiencyAssessmentQuery, EnglishProficiencyAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnglishProficiencyAssessmentQuery, EnglishProficiencyAssessmentQueryVariables>(EnglishProficiencyAssessmentDocument, options);
        }
export type EnglishProficiencyAssessmentQueryHookResult = ReturnType<typeof useEnglishProficiencyAssessmentQuery>;
export type EnglishProficiencyAssessmentLazyQueryHookResult = ReturnType<typeof useEnglishProficiencyAssessmentLazyQuery>;
export type EnglishProficiencyAssessmentQueryResult = Apollo.QueryResult<EnglishProficiencyAssessmentQuery, EnglishProficiencyAssessmentQueryVariables>;
export const MyRoleDocument = gql`
    query MyRole($id: ID!) {
  myRole(id: $id) {
    id
    name
    candidatePortalEnabled
    company {
      name
      logoUrl
    }
    stages {
      id
      kind
      name
      stageStatus
      candidateStatus
      endTime
    }
  }
}
    `;

/**
 * __useMyRoleQuery__
 *
 * To run a query within a React component, call `useMyRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMyRoleQuery(baseOptions: Apollo.QueryHookOptions<MyRoleQuery, MyRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRoleQuery, MyRoleQueryVariables>(MyRoleDocument, options);
      }
export function useMyRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRoleQuery, MyRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRoleQuery, MyRoleQueryVariables>(MyRoleDocument, options);
        }
export type MyRoleQueryHookResult = ReturnType<typeof useMyRoleQuery>;
export type MyRoleLazyQueryHookResult = ReturnType<typeof useMyRoleLazyQuery>;
export type MyRoleQueryResult = Apollo.QueryResult<MyRoleQuery, MyRoleQueryVariables>;
export const MyRoleStageActionsDocument = gql`
    query MyRoleStageActions($roleId: ID!, $stageId: ID!) {
  myRole(id: $roleId) {
    id
    name
    candidatePortalEnabled
    company {
      id
      name
      logoUrl
      branding {
        logoUrl
        accentColor1
        accentColor2
        textColor
      }
      usesBehaviouralLabel
      isLiveChatEnabled
      reasonableAdjustmentsOption {
        kind
        value
      }
    }
    stages(id: $stageId) {
      id
      stageCandidateId
      kind
      name
      stageStatus
      candidateStatus
      endTime
      deadlineAt
      hasAdjustmentQuestionnaire
      hasCompletedAdjustmentQuestionnaire
      hasPledgedAnticheating
      isIntegrityMonitoringEnabled
      actions {
        formActions {
          id
          formType
          status
        }
        personalityTestAction {
          id
          status
          selectedLocales
          estimatedTimeSeconds
        }
        cognitiveTestActions {
          id
          status
          kind
          allowedTimeSeconds
          allowedSectionTimeSeconds
          timeModifierPercentage
        }
        softRssAssessmentAction {
          id
          status
        }
        technicalRssAssessmentAction {
          id
          status
        }
        deiAction {
          id
          status
        }
        coderbyteAction {
          id
          status
          name
          allowedTimeSeconds
          estimatedTimeSeconds
          timeModifierPercentage
        }
        aiInterviewActions {
          id
          status
          name
          duration
          conferenceId
        }
        englishProficiencyAction {
          id
          status
          allowedTimeSeconds
        }
      }
    }
  }
}
    `;

/**
 * __useMyRoleStageActionsQuery__
 *
 * To run a query within a React component, call `useMyRoleStageActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRoleStageActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRoleStageActionsQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useMyRoleStageActionsQuery(baseOptions: Apollo.QueryHookOptions<MyRoleStageActionsQuery, MyRoleStageActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRoleStageActionsQuery, MyRoleStageActionsQueryVariables>(MyRoleStageActionsDocument, options);
      }
export function useMyRoleStageActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRoleStageActionsQuery, MyRoleStageActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRoleStageActionsQuery, MyRoleStageActionsQueryVariables>(MyRoleStageActionsDocument, options);
        }
export type MyRoleStageActionsQueryHookResult = ReturnType<typeof useMyRoleStageActionsQuery>;
export type MyRoleStageActionsLazyQueryHookResult = ReturnType<typeof useMyRoleStageActionsLazyQuery>;
export type MyRoleStageActionsQueryResult = Apollo.QueryResult<MyRoleStageActionsQuery, MyRoleStageActionsQueryVariables>;
export const MyRolesDocument = gql`
    query MyRoles {
  myRoles {
    id
    name
    candidatePortalEnabled
    company {
      id
      name
      logoUrl
      isLiveChatEnabled
    }
  }
}
    `;

/**
 * __useMyRolesQuery__
 *
 * To run a query within a React component, call `useMyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRolesQuery(baseOptions?: Apollo.QueryHookOptions<MyRolesQuery, MyRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRolesQuery, MyRolesQueryVariables>(MyRolesDocument, options);
      }
export function useMyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRolesQuery, MyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRolesQuery, MyRolesQueryVariables>(MyRolesDocument, options);
        }
export type MyRolesQueryHookResult = ReturnType<typeof useMyRolesQuery>;
export type MyRolesLazyQueryHookResult = ReturnType<typeof useMyRolesLazyQuery>;
export type MyRolesQueryResult = Apollo.QueryResult<MyRolesQuery, MyRolesQueryVariables>;
export const CompanyIdByProjectDocument = gql`
    query CompanyIdByProject($id: Float!) {
  getCompanyId(id: $id) {
    companyId
  }
}
    `;

/**
 * __useCompanyIdByProjectQuery__
 *
 * To run a query within a React component, call `useCompanyIdByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyIdByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyIdByProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyIdByProjectQuery(baseOptions: Apollo.QueryHookOptions<CompanyIdByProjectQuery, CompanyIdByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyIdByProjectQuery, CompanyIdByProjectQueryVariables>(CompanyIdByProjectDocument, options);
      }
export function useCompanyIdByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyIdByProjectQuery, CompanyIdByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyIdByProjectQuery, CompanyIdByProjectQueryVariables>(CompanyIdByProjectDocument, options);
        }
export type CompanyIdByProjectQueryHookResult = ReturnType<typeof useCompanyIdByProjectQuery>;
export type CompanyIdByProjectLazyQueryHookResult = ReturnType<typeof useCompanyIdByProjectLazyQuery>;
export type CompanyIdByProjectQueryResult = Apollo.QueryResult<CompanyIdByProjectQuery, CompanyIdByProjectQueryVariables>;
export const QuestionnaireStageCandidateDocument = gql`
    query QuestionnaireStageCandidate($roleId: ID!, $stageId: ID!) {
  myRole(id: $roleId) {
    id
    name
    candidatePortalEnabled
    company {
      id
      name
      logoUrl
      branding {
        logoUrl
        accentColor1
        accentColor2
        textColor
        websiteLinkUrl
        careersLinkUrl
      }
    }
    questionnaireStages(id: $stageId) {
      id
      shortlistStageCandidateId
      name
      status
      items {
        id
        text
        order
        answer
      }
    }
  }
}
    `;

/**
 * __useQuestionnaireStageCandidateQuery__
 *
 * To run a query within a React component, call `useQuestionnaireStageCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionnaireStageCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionnaireStageCandidateQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      stageId: // value for 'stageId'
 *   },
 * });
 */
export function useQuestionnaireStageCandidateQuery(baseOptions: Apollo.QueryHookOptions<QuestionnaireStageCandidateQuery, QuestionnaireStageCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionnaireStageCandidateQuery, QuestionnaireStageCandidateQueryVariables>(QuestionnaireStageCandidateDocument, options);
      }
export function useQuestionnaireStageCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionnaireStageCandidateQuery, QuestionnaireStageCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionnaireStageCandidateQuery, QuestionnaireStageCandidateQueryVariables>(QuestionnaireStageCandidateDocument, options);
        }
export type QuestionnaireStageCandidateQueryHookResult = ReturnType<typeof useQuestionnaireStageCandidateQuery>;
export type QuestionnaireStageCandidateLazyQueryHookResult = ReturnType<typeof useQuestionnaireStageCandidateLazyQuery>;
export type QuestionnaireStageCandidateQueryResult = Apollo.QueryResult<QuestionnaireStageCandidateQuery, QuestionnaireStageCandidateQueryVariables>;
export const RssAssessmentCandidateOpenOneDocument = gql`
    query RssAssessmentCandidateOpenOne($id: Int!) {
  RssAssessmentCandidateOpenOne(id: $id) {
    gradeBands {
      ...SoftSkillSelfAssessmentGradeBand
      ...TechnicalSkillSelfAssessmentGradeBand
    }
    rssAssessmentCandidate {
      ...RssAssessmentCandidate
    }
    skillsWithResults {
      result {
        ...Result
      }
      skill {
        ...SoftSkillWithDescription
        ...TechnicalSkill
      }
    }
  }
}
    ${SoftSkillSelfAssessmentGradeBandFragmentDoc}
${TechnicalSkillSelfAssessmentGradeBandFragmentDoc}
${RssAssessmentCandidateFragmentDoc}
${ResultFragmentDoc}
${SoftSkillWithDescriptionFragmentDoc}
${TechnicalSkillFragmentDoc}`;

/**
 * __useRssAssessmentCandidateOpenOneQuery__
 *
 * To run a query within a React component, call `useRssAssessmentCandidateOpenOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useRssAssessmentCandidateOpenOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRssAssessmentCandidateOpenOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRssAssessmentCandidateOpenOneQuery(baseOptions: Apollo.QueryHookOptions<RssAssessmentCandidateOpenOneQuery, RssAssessmentCandidateOpenOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RssAssessmentCandidateOpenOneQuery, RssAssessmentCandidateOpenOneQueryVariables>(RssAssessmentCandidateOpenOneDocument, options);
      }
export function useRssAssessmentCandidateOpenOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RssAssessmentCandidateOpenOneQuery, RssAssessmentCandidateOpenOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RssAssessmentCandidateOpenOneQuery, RssAssessmentCandidateOpenOneQueryVariables>(RssAssessmentCandidateOpenOneDocument, options);
        }
export type RssAssessmentCandidateOpenOneQueryHookResult = ReturnType<typeof useRssAssessmentCandidateOpenOneQuery>;
export type RssAssessmentCandidateOpenOneLazyQueryHookResult = ReturnType<typeof useRssAssessmentCandidateOpenOneLazyQuery>;
export type RssAssessmentCandidateOpenOneQueryResult = Apollo.QueryResult<RssAssessmentCandidateOpenOneQuery, RssAssessmentCandidateOpenOneQueryVariables>;
export const SkillsProfileOpenOneDocument = gql`
    query SkillsProfileOpenOne {
  SkillsProfileOpenOne {
    skillsWithResults {
      ...SkillsProfileOpenOneSkillsWithResults
    }
  }
}
    ${SkillsProfileOpenOneSkillsWithResultsFragmentDoc}`;

/**
 * __useSkillsProfileOpenOneQuery__
 *
 * To run a query within a React component, call `useSkillsProfileOpenOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillsProfileOpenOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillsProfileOpenOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useSkillsProfileOpenOneQuery(baseOptions?: Apollo.QueryHookOptions<SkillsProfileOpenOneQuery, SkillsProfileOpenOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillsProfileOpenOneQuery, SkillsProfileOpenOneQueryVariables>(SkillsProfileOpenOneDocument, options);
      }
export function useSkillsProfileOpenOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillsProfileOpenOneQuery, SkillsProfileOpenOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillsProfileOpenOneQuery, SkillsProfileOpenOneQueryVariables>(SkillsProfileOpenOneDocument, options);
        }
export type SkillsProfileOpenOneQueryHookResult = ReturnType<typeof useSkillsProfileOpenOneQuery>;
export type SkillsProfileOpenOneLazyQueryHookResult = ReturnType<typeof useSkillsProfileOpenOneLazyQuery>;
export type SkillsProfileOpenOneQueryResult = Apollo.QueryResult<SkillsProfileOpenOneQuery, SkillsProfileOpenOneQueryVariables>;
export const SzSkillsMergeFreeTextSearchPaginatedDocument = gql`
    query SzSkillsMergeFreeTextSearchPaginated($text: String! = "", $take: Int! = 20, $skip: Int! = 0) {
  SzSkillsMergeFreeTextSearchPaginated(freetext: $text, take: $take, skip: $skip) {
    skills {
      ...SzSkillResultAndAvailability
    }
    total
  }
}
    ${SzSkillResultAndAvailabilityFragmentDoc}`;

/**
 * __useSzSkillsMergeFreeTextSearchPaginatedQuery__
 *
 * To run a query within a React component, call `useSzSkillsMergeFreeTextSearchPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSzSkillsMergeFreeTextSearchPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSzSkillsMergeFreeTextSearchPaginatedQuery({
 *   variables: {
 *      text: // value for 'text'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSzSkillsMergeFreeTextSearchPaginatedQuery(baseOptions?: Apollo.QueryHookOptions<SzSkillsMergeFreeTextSearchPaginatedQuery, SzSkillsMergeFreeTextSearchPaginatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SzSkillsMergeFreeTextSearchPaginatedQuery, SzSkillsMergeFreeTextSearchPaginatedQueryVariables>(SzSkillsMergeFreeTextSearchPaginatedDocument, options);
      }
export function useSzSkillsMergeFreeTextSearchPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SzSkillsMergeFreeTextSearchPaginatedQuery, SzSkillsMergeFreeTextSearchPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SzSkillsMergeFreeTextSearchPaginatedQuery, SzSkillsMergeFreeTextSearchPaginatedQueryVariables>(SzSkillsMergeFreeTextSearchPaginatedDocument, options);
        }
export type SzSkillsMergeFreeTextSearchPaginatedQueryHookResult = ReturnType<typeof useSzSkillsMergeFreeTextSearchPaginatedQuery>;
export type SzSkillsMergeFreeTextSearchPaginatedLazyQueryHookResult = ReturnType<typeof useSzSkillsMergeFreeTextSearchPaginatedLazyQuery>;
export type SzSkillsMergeFreeTextSearchPaginatedQueryResult = Apollo.QueryResult<SzSkillsMergeFreeTextSearchPaginatedQuery, SzSkillsMergeFreeTextSearchPaginatedQueryVariables>;
export const SoftSkillsDocument = gql`
    query SoftSkills {
  SoftSkills {
    ...SoftSkill
  }
}
    ${SoftSkillFragmentDoc}`;

/**
 * __useSoftSkillsQuery__
 *
 * To run a query within a React component, call `useSoftSkillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoftSkillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoftSkillsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSoftSkillsQuery(baseOptions?: Apollo.QueryHookOptions<SoftSkillsQuery, SoftSkillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoftSkillsQuery, SoftSkillsQueryVariables>(SoftSkillsDocument, options);
      }
export function useSoftSkillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoftSkillsQuery, SoftSkillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoftSkillsQuery, SoftSkillsQueryVariables>(SoftSkillsDocument, options);
        }
export type SoftSkillsQueryHookResult = ReturnType<typeof useSoftSkillsQuery>;
export type SoftSkillsLazyQueryHookResult = ReturnType<typeof useSoftSkillsLazyQuery>;
export type SoftSkillsQueryResult = Apollo.QueryResult<SoftSkillsQuery, SoftSkillsQueryVariables>;
export const StageCandidateFindOneDocument = gql`
    query StageCandidateFindOne($id: Int!) {
  StageCandidateFindById(id: $id) {
    ...SmStageCandidateModel
  }
}
    ${SmStageCandidateModelFragmentDoc}`;

/**
 * __useStageCandidateFindOneQuery__
 *
 * To run a query within a React component, call `useStageCandidateFindOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useStageCandidateFindOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStageCandidateFindOneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStageCandidateFindOneQuery(baseOptions: Apollo.QueryHookOptions<StageCandidateFindOneQuery, StageCandidateFindOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StageCandidateFindOneQuery, StageCandidateFindOneQueryVariables>(StageCandidateFindOneDocument, options);
      }
export function useStageCandidateFindOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StageCandidateFindOneQuery, StageCandidateFindOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StageCandidateFindOneQuery, StageCandidateFindOneQueryVariables>(StageCandidateFindOneDocument, options);
        }
export type StageCandidateFindOneQueryHookResult = ReturnType<typeof useStageCandidateFindOneQuery>;
export type StageCandidateFindOneLazyQueryHookResult = ReturnType<typeof useStageCandidateFindOneLazyQuery>;
export type StageCandidateFindOneQueryResult = Apollo.QueryResult<StageCandidateFindOneQuery, StageCandidateFindOneQueryVariables>;
export const MyRoleSupportEmailDocument = gql`
    query MyRoleSupportEmail($roleId: ID!) {
  myRole(id: $roleId) {
    id
    company {
      id
      supportEmail
    }
  }
}
    `;

/**
 * __useMyRoleSupportEmailQuery__
 *
 * To run a query within a React component, call `useMyRoleSupportEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRoleSupportEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRoleSupportEmailQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useMyRoleSupportEmailQuery(baseOptions: Apollo.QueryHookOptions<MyRoleSupportEmailQuery, MyRoleSupportEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRoleSupportEmailQuery, MyRoleSupportEmailQueryVariables>(MyRoleSupportEmailDocument, options);
      }
export function useMyRoleSupportEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRoleSupportEmailQuery, MyRoleSupportEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRoleSupportEmailQuery, MyRoleSupportEmailQueryVariables>(MyRoleSupportEmailDocument, options);
        }
export type MyRoleSupportEmailQueryHookResult = ReturnType<typeof useMyRoleSupportEmailQuery>;
export type MyRoleSupportEmailLazyQueryHookResult = ReturnType<typeof useMyRoleSupportEmailLazyQuery>;
export type MyRoleSupportEmailQueryResult = Apollo.QueryResult<MyRoleSupportEmailQuery, MyRoleSupportEmailQueryVariables>;
export const UserDocument = gql`
    query User {
  User: me {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;